// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23888%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 11L3 6h10l-5 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27%23666%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 11L3 6h10l-5 5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====================================
   P2P Module Styles
   All styles are scoped with .p2p- prefix
   to avoid conflicts with other project CSS
   
   Theme Color: #ffdc88 (Yellow/Gold - Dark Theme), #F4B609 (Yellow - Light Theme)
   Color Palette:
   - Primary (Dark): #ffdc88
   - Primary (Light): #F4B609
   - Primary Dark: #f4b609
   - Primary Light: #bd83cb
   ==================================== */

/* ====================================
   P2P Layout Styles
   ==================================== */

.p2p-layout-wrapper {
  display: flex;
  background-color: #181A20;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.p2p-main-content {
  flex: 1 1;
  margin-left: 320px;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.p2p-main-content.p2p-mobile {
  margin-left: 0;
}

.p2p-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background-color: rgb(23 26 32);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.p2p-hamburger {
  width: 20px;
  height: 30px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.p2p-hamburger:hover {
  background-color: rgba(166, 95, 255, 0.2);
}

.p2p-hamburger-line {
  width: 20px;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
}

.p2p-mobile-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-mobile-logo-icon {
  width: 32px;
  height: 32px;
  background-color: #ffdc88;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-mobile-logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.p2p-page-title {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.p2p-page-content {
  padding: 30px 32px 20px;
  max-width: 100%;
  /* margin: 0 auto; */
  color: #fff;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.p2p-spacer {
  width: 40px;
}

/* ====================================
   P2P Desktop Split Scroll (Header & Sidebar Fixed, Only Right Content Scrolls)
   Matching user_profile/dashboard split scroll behavior
   ==================================== */

@media (min-width: 992px) {

  /* Lock viewport so header and window never scroll */
  html:has(.p2p-layout-wrapper),
  body:has(.p2p-layout-wrapper) {
    overflow: hidden !important;
    height: 100% !important;
  }

  .p2p-layout-wrapper {
    justify-content: flex-start;
    align-items: stretch;
    gap: 0;
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 70px);
    height: calc(100dvh - 70px);
    min-height: calc(100vh - 70px);
    min-height: calc(100dvh - 70px);
    max-height: calc(100vh - 70px);
    max-height: calc(100dvh - 70px);
    overflow: hidden;
    position: relative;
  }

  /* Left sidebar: in-flow column matching row height, stays fixed without scrolling with page */
  .p2p-sidebar {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    align-self: stretch;
    height: 100% !important;
    max-height: none !important;
    min-height: 0 !important;
    flex: 0 0 324px !important;
    width: 324px !important;
    max-width: 324px !important;
    min-width: 324px !important;
    display: flex;
    flex-direction: column;
    overflow: visible !important;
    overscroll-behavior: contain;
    z-index: 10;
    transition:
      width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
      min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
      max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
      flex-basis 0.4s cubic-bezier(0.4, 0, 0.2, 1),
      padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Collapsed rail state (matches dashboard page profile-sidebar.css) */
  .p2p-sidebar.p2p-sidebar--collapsed {
    flex: 0 0 76px !important;
    width: 76px !important;
    min-width: 76px !important;
    max-width: 76px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .p2p-sidebar.p2p-sidebar--collapsed .p2p-sidebar-nav {
    width: 100% !important;
    padding: 20px 0px 32px 0px !important;
  }

  .p2p-sidebar.p2p-sidebar--collapsed .p2p-nav-item {
    justify-content: center !important;
    padding: 14px 10px !important;
    gap: 0 !important;
  }

  .p2p-sidebar .p2p-nav-label,
  .p2p-sidebar .p2p-back-link-text {
    overflow: hidden;
    white-space: nowrap;
    min-width: 0;
    max-width: 260px;
    opacity: 1;
    transition:
      max-width 0.42s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.32s ease,
      margin 0.32s ease;
  }

  .p2p-sidebar.p2p-sidebar--collapsed .p2p-nav-label,
  .p2p-sidebar.p2p-sidebar--collapsed .p2p-back-link-text {
    max-width: 0 !important;
    opacity: 0 !important;
    margin: 0 !important;
    pointer-events: none !important;
    display: none !important;
  }

  .p2p-sidebar.p2p-sidebar--collapsed .p2p-sidebar-footer {
    padding: 16px 0px !important;
  }

  .p2p-sidebar.p2p-sidebar--collapsed .p2p-back-link {
    justify-content: center !important;
    padding: 12px 0px !important;
    gap: 0 !important;
  }

  .p2p-sidebar-nav {
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .p2p-sidebar-footer {
    position: relative !important;
    bottom: auto !important;
    left: auto !important;
    margin-top: auto;
    flex-shrink: 0;
    width: 100% !important;
    max-width: none !important;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
    transition: padding 0.4s ease;
  }

  /* Collapse control button on rail edge — matches Dashboard page (.profile-sidebar-collapse-btn) */
  .p2p-sidebar-collapse-btn {
    position: absolute;
    right: -18px;
    top: 40px;
    z-index: 668;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    border: 1px solid #646464;
    background: #1d1d1d;
    display: none;
    color: #f4f4f4;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    transition:
      color 0.15s ease,
      background-color 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      transform 0.15s ease;
  }

  .p2p-sidebar-collapse-btn:hover {
    color: #fff;
    background-color: #2a2a2a;
  }

  .p2p-sidebar-collapse-btn i {
    font-size: 16px;
    line-height: 1;
  }

  body.light_theme .p2p-sidebar-collapse-btn {
    color: #64748b;
    border: 1px solid #e2e8f0;
    background: #ffffff;
  }

  body.light_theme .p2p-sidebar-collapse-btn:hover {
    color: #1e293b;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  }

  @media (min-width: 992px) {
    .p2p-sidebar-collapse-btn {
      display: flex;
    }
  }

  /* Right-side main content: own independent vertical scrollbar */
  .p2p-main-content {
    flex: 1 1 !important;
    margin-left: 0 !important;
    min-width: 0;
    min-height: 0;
    height: 100% !important;
    max-height: 100% !important;
    width: auto !important;
    max-width: none !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    scroll-behavior: smooth;
  }
}

/* Custom sleek scrollbar for right-side content */
.p2p-main-content::-webkit-scrollbar {
  width: 6px;
}

.p2p-main-content::-webkit-scrollbar-track {
  background: transparent;
}

.p2p-main-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.p2p-main-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

body.light_theme .p2p-main-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
}

body.light_theme .p2p-main-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

@media (max-width: 991.98px) {
  .p2p-layout-wrapper {
    min-height: calc(100vh - 70px);
    height: auto;
    overflow: visible;
  }

  .p2p-main-content {
    margin-left: 0 !important;
    min-height: auto;
    height: auto;
    overflow: visible;
  }

  .p2p-sidebar {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 280px !important;
    z-index: 10000000 !important;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .p2p-sidebar.p2p-open {
    transform: translateX(0);
    background: #000;
  }

  body.light_theme .p2p-sidebar.p2p-open {
    background: #fff;
  }

  .p2p-sidebar-close {
    display: flex;
  }
}

/* ====================================
     P2P Sidebar Styles
     ==================================== */

.p2p-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}


h4.p2p-profile-tab {
  background-color: transparent;
  border: none;
  cursor: default;
  padding: 0px;
  color: #cfcfcf;
}

h4.p2p-profile-tab:hover {
  background-color: transparent;
}

.p2p-sidebar-overlay.p2p-visible {
  opacity: 1;
  visibility: visible;
}

nav.p2p-sidebar-nav.mt-5 {
  margin: 0px !important;
}

.p2p-sidebar {
  position: fixed;
  left: 0;
  top: 70px;
  bottom: 0;
  width: 320px;
  background: transparent;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 999;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
  overflow-y: auto;
}

.p2p-sidebar.p2p-closed {
  transform: translateX(-100%);
}

/* [UNUSED]
.p2p-sidebar-logo {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}
*/

/* [UNUSED]
.p2p-sidebar-logo a {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}
*/

/* [UNUSED]
.p2p-logo-icon {
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
*/

/* [UNUSED]
.p2p-logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}
*/

.p2p-sidebar-nav {
  padding: 20px 0px 32px 20px;
  width: 250px;
  flex: 1 1;
}

.p2p-nav-item {
  border: 1px solid #ffffff00;
  padding: 14px 20px;
  gap: 14px !important;
  color: #fff;
  font-weight: 500;
  box-shadow: 0px 1px 3px #00000000;
  border-radius: 14px !important;
  font-size: 14px;
  margin: 0px;
  line-height: 1.35;
  align-items: center;
  display: flex;
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease, padding 0.4s cubic-bezier(0.4, 0, 0.2, 1), gap 0.35s ease;
}

.p2p-nav-item:hover {
  color: #fff;
}

.p2p-nav-item.active {
  background-color: #2b313d52;
  border: 1px solid #dbdbdd00;
  box-shadow: 0px 1px 3px #00000011;
  color: #fff;
}

body.light_theme .p2p-nav-item.active {
  background-color: #f2f3f7;
  border: 1px solid #dbdbdd;
  color: #020202;
}

.p2p-nav-item.active .p2p-nav-icon {
  color: #020202;
}

.p2p-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: inherit;
  flex-shrink: 0;
}

.p2p-nav-icon img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
  transition: filter 0.2s ease, opacity 0.2s ease;
}

/* In dark theme, SVG icons invert to white */
body.dark_theme .p2p-nav-icon img,
body[data-theme="dark"] .p2p-nav-icon img,
html[data-theme="dark"] .p2p-nav-icon img {
  filter: brightness(0) invert(1);
  opacity: 0.85;
}

body.dark_theme .p2p-nav-item.active .p2p-nav-icon img,
body[data-theme="dark"] .p2p-nav-item.active .p2p-nav-icon img,
html[data-theme="dark"] .p2p-nav-item.active .p2p-nav-icon img {
  filter: brightness(0) invert(1);
  opacity: 1;
}

/* In light theme, inactive icons stay slate, active icon becomes dark */
body.light_theme .p2p-nav-icon img {
  opacity: 0.85;
}

body.light_theme .p2p-nav-item.active .p2p-nav-icon img {
  filter: brightness(0);
  opacity: 1;
}

.p2p-sidebar-close {
  position: absolute;
  top: 16px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: background 0.2s ease;
}

.p2p-sidebar-close:hover {
  background: rgba(255, 220, 136, 0.2);
}

.p2p-sidebar-footer {
  padding: 16px;
  /* border-top: 1px solid rgba(255, 255, 255, 0.04); */
}

.p2p-back-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #9ca3af;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.p2p-back-link:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

/* Sidebar Scrollbar */
.p2p-sidebar::-webkit-scrollbar {
  width: 4px;
}

.p2p-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.p2p-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

/* [UNUSED]
.selectpaymetpop.modal.fade .modal-dialog {
  width: 480px;
  min-width: 480px;
}
*/

.p2p-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* ====================================
     P2P Dashboard Styles
     ==================================== */

.p2p-dashboard-container {
  max-width: 100%;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* Buy/Sell Toggle */
/* [UNUSED]
.p2p-buy-sell-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-toggle-wrapper {
  display: flex;
  background: #2B313C;
  border-radius: 6px;
  padding: 4px;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-toggle-btn {
  padding: 7px 48px;
  border: none;
  width: 136px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  color: #87909F;

}
*/

.p2p-dashboard-container input:focus {
  border: 1px solid #ffffff00 !important;
}

.p2p-dashboard-container select:focus-visible {
  outline: none !important;
}

.binance-chat-input input:focus {
  border: none !important;
}

.p2p-layout-wrapper button:disabled {
  background-color: #181a1f81 !important;
  color: #fff;
}

/* [UNUSED]
.p2p-toggle-btn.p2p-active-buy {
  background: #5EBA89;
  color: #fff;
}
*/

/* [UNUSED]
.p2p-toggle-btn.p2p-active-sell {
  background: #E45561;
  color: #fff;
}
*/

/* [UNUSED]
.p2p-toggle-btn.p2p-active-buy:hover {
  background: #5EBA89;
}
*/

/* [UNUSED]
.p2p-toggle-btn:hover:not(.p2p-active-buy):not(.p2p-active-sell) {
  color: #fff;
  background: rgba(34, 197, 94, 0.1);
}
*/

/* Filter Section */
.p2p-filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 20px;
  padding: 0 8px;
}

.p2p-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-width: 150px;
}

.p2p-filter-label {
  font-size: 12px;
  color: #c9c9c9;
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
}

.p2p-filter-select {
  padding: 12px 16px;
  background: #2B313C;
  border: 1px solid #2B313C;
  border-radius: 8px;
  color: #A2A9B6;
  font-size: 13px;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  padding-right: 40px;
}

.p2p-filter-select:focus {
  outline: none;
  border-color: #ffdc88;
}

.p2p-find-orders-btn {
  padding: 12px 32px;
  background: #2b313c;
  border: 1px solid #2b313c;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.p2p-find-orders-btn:hover {
  background: rgba(255, 220, 136, 0.1);
  border-color: #ffdc88;
}

/* Table Section */
.p2p-orders-table-wrapper {
  background: #2B313C;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #2B313C;
}

.p2p-orders-table {
  width: 100%;
  border-collapse: collapse;
}

.p2p-orders-table thead {
  background: #2B313C;
}

.p2p-orders-table th {
  padding: 10px 10px;
  text-align: left;
  font-size: 13px;
  font-weight: 400;
  color: #949AA4;
  border-bottom: 1px solid #454C59;
}

.p2p-orders-table th:last-child {
  text-align: right;
}

/* [UNUSED]
.p2p-trade-fee-badge {
  background: rgba(255, 220, 136, 0.15);
  color: #F3BB2B;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 8px;
}
*/

.p2p-orders-table tbody tr {
  border-bottom: 1px solid #1e1e2d;
  transition: background 0.2s ease;
  cursor: pointer;
}

.p2p-orders-table tbody tr:hover {
  background: rgba(255, 220, 136, 0.05);
}

.p2p-orders-table tbody tr:last-child {
  border-bottom: none;
}

.p2p-orders-table td {
  padding: 20px;
  vertical-align: middle;
}

/* Advertiser Cell */
/* [UNUSED]
.p2p-advertiser-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-advertiser-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-advertiser-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 4px 0;
}
*/

/* [UNUSED]
.p2p-advertiser-stats {
  font-size: 12px;
  color: #aaa;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-advertiser-rating {
  display: flex;
  align-items: center;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-star-icon {
  color: #fbbf24;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-rating-value {
  font-size: 12px;
  color: #a8b4c4;
  font-weight: 500;
}
*/

/* Price Cell */
/* [UNUSED]
.p2p-price-value {
  font-size: 16px;
  font-weight: 500;
  color: #eaecef;
}
*/

/* Limit Cell */
.p2p-limit-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* [UNUSED]
.p2p-limit-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-limit-label {
  font-size: 12px;
  color: #aaa;
  min-width: 55px;
}
*/

/* [UNUSED]
.p2p-limit-value {
  font-size: 13px;
  color: #eaecef;
}
*/

/* Payment Cell */
.p2p-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-payment-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  font-size: 12px;
  color: #eaecef;
}

/* Trade Cell */
/* [UNUSED]
.p2p-trade-cell {
  text-align: right;
}
*/

/* [UNUSED]
.p2p-buy-btn {
  padding: 10px 24px;
  background: #22c55e;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-buy-btn:hover {
  background: #16a34a;
}
*/

/* [UNUSED]
.p2p-sell-btn {
  padding: 10px 24px;
  background: #ef4444;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-sell-btn:hover {
  background: #dc2626;
}
*/

/* Pagination */
.p2p-pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0px 10px;
  background: none;
  border-top: none;
  flex-wrap: wrap;
}

.p2p-pagination-info {
  font-size: 12px;
  color: #6b7280;
}

.p2p-pagination-buttons,
.p2p-pagination-controls {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

/* [UNUSED]
.p2p-page-current {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #e5e5e5;
  background: rgba(255, 220, 136, 0.2);
  border-radius: 6px;
}
*/

.p2p-page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a24;
  border: 1px solid #2a2a3a;
  border-radius: 6px;
  color: #888;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-page-btn:hover {
  border-color: #ffdc88;
  color: #fff;
}

.p2p-page-btn.p2p-active {
  background: #363c47;
  border-color: #363c47;
  color: #fff;
}

.p2p-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p2p-page-dots {
  color: #aaa;
  padding: 0 8px;
}

/* Expanded Row */
/* .p2p-expanded-row {
    background: #0d0d14 !important;
  } */

/* [UNUSED]
.p2p-expanded-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  padding: 24px;
}
*/

/* [UNUSED]
.p2p-expanded-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
*/

/* [UNUSED]
.p2p-expanded-user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}
*/

/* [UNUSED]
.p2p-expanded-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 18px;
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-expanded-user-details h5 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}
*/

/* [UNUSED]
.p2p-expanded-user-details p {
  font-size: 13px;
  color: #aaa;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-expanded-stats {
  display: flex;
  gap: 24px;
}
*/

/* [UNUSED]
.p2p-stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-stat-value {
  font-size: 15px;
  font-weight: 600;
  color: #a8b4c4;
}
*/

/* [UNUSED]
.p2p-stat-label {
  font-size: 12px;
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-expanded-payments h6 {
  font-size: 13px;
  color: #888;
  margin: 0 0 12px 0;
}
*/

/* [UNUSED]
.p2p-expanded-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-expanded-payment-badge {
  padding: 6px 13px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  font-size: 12px;
  color: #bd83cb;
}
*/

/* [UNUSED]
.p2p-expanded-remarks h6 {
  font-size: 13px;
  color: #888;
  margin: 0 0 8px 0;
}
*/

/* [UNUSED]
.p2p-expanded-remarks p {
  font-size: 13px;
  color: #ccc;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-expanded-right {
  background: transparent;
  border-radius: 12px;
  padding: 0;
  min-width: 320px;
}
*/

/* [UNUSED]
.p2p-expanded-form-group {
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-expanded-form-group.has-error .p2p-input-header {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
}
*/

/* [UNUSED]
.p2p-expanded-form-group.has-error .p2p-expanded-input-wrapper {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}
*/

/* [UNUSED]
.p2p-expanded-form-group.has-error .p2p-payment-selector-full,
.p2p-expanded-form-group.has-error .p2p-payment-selector {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}
*/

/* [UNUSED]
.p2p-input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding: 16px 20px 8px;
  background: #1a1a22;
  border-radius: 12px 12px 0 0;
  border: 1px solid #2a2a3a;
  border-bottom: none;
}
*/

/* [UNUSED]
.p2p-input-header label {
  font-size: 13px;
  color: #888;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-input-range {
  font-size: 12px;
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper {
  display: flex;
  align-items: center;
  background: #1a1a22;
  border: 1px solid #2a2a3a;
  border-top: none;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  padding: 0 20px 16px;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper:focus-within {
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper.p2p-input-error {
  border-color: #ef4444 !important;
  background: rgba(239, 68, 68, 0.05);
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper.p2p-input-error:focus-within {
  border-color: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-payment-selector-full.p2p-input-error,
.p2p-payment-selector.p2p-input-error {
  border-color: #ef4444 !important;
  background: rgba(239, 68, 68, 0.05);
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper input {
  flex: 1;
  padding: 0;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 32px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper input:focus {
  outline: none;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper input::placeholder {
  color: #444;
}
*/

/* Remove number input spinners */
/* [UNUSED]
.p2p-expanded-input-wrapper input[type="number"]::-webkit-outer-spin-button,
.p2p-expanded-input-wrapper input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-expanded-input-wrapper input[type="number"] {
  -moz-appearance: textfield;
}
*/

/* [UNUSED]
.p2p-input-currency {
  padding: 0;
  color: #888;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
}
*/

/* [UNUSED]
.p2p-expanded-input-error {
  font-size: 12px;
  color: #ef4444;
  margin-top: 6px;
  padding-left: 20px;
}
*/

/* [UNUSED]
.p2p-price-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-price-info svg {
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-payment-selector-full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  background: #f59e0b0d;
  border: 1px solid #2a2a3a;
  border-top: none;
  border-radius: 0 0 12px 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-payment-selector-full:hover {
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-payment-selector-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
*/

/* [UNUSED]
.p2p-payment-indicator {
  width: 4px;
  height: 16px;
  background: #f59e0b;
  border-radius: 2px;
}
*/

/* [UNUSED]
.p2p-payment-selector-full svg {
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-expanded-form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}
*/

/* [UNUSED]
.p2p-cancel-btn {
  flex: 1;
  padding: 14px 24px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-cancel-btn:hover {
  background: rgba(255, 220, 136, 0.1);
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-confirm-buy-btn {
  width: 100%;
  padding: 16px 24px;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-confirm-buy-btn:hover {
  background: #16a34a;
}
*/

/* [UNUSED]
.p2p-confirm-sell-btn {
  width: 100%;
  padding: 16px 24px;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-confirm-sell-btn:hover {
  background: #dc2626;
}
*/

/* Mobile Card View */
.p2p-mobile-orders-list {
  display: none;
}

.p2p-mobile-order-card {
  background: #12121a;
  border: 1px solid #1e1e2d;
  border-radius: 12px;
  padding: 16px;
}

.p2p-mobile-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.binance-chat-input .send-btn {
  padding: 0px;
}

.p2p-mobile-card-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* [UNUSED]
.p2p-mobile-card-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}
*/

.p2p-mobile-card-user-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.p2p-mobile-card-user-info p {
  font-size: 12px;
  color: #aaa;
  margin: 0 0 2px 0;
}

/* [UNUSED]
.p2p-mobile-card-user-info .p2p-rating {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #a8b4c4;
}
*/

.p2p-mobile-card-price {
  text-align: right;
}

/* [UNUSED]
.p2p-mobile-card-price .p2p-value {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}
*/

.p2p-mobile-card-price .p2p-currency {
  font-size: 12px;
  color: #aaa;
}

.p2p-mobile-card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-mobile-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-mobile-detail-label {
  font-size: 11px;
  color: #aaa;
}

.p2p-mobile-detail-value {
  font-size: 13px;
  color: #fff;
}

.p2p-mobile-card-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.p2p-mobile-payment-badge {
  padding: 6px 10px;
  background: rgba(255, 220, 136, 0.1);
  border-radius: 4px;
  font-size: 11px;
  color: #bd83cb;
}

/* [UNUSED]
.p2p-mobile-card-action {
  width: 100%;
}
*/

/* [UNUSED]
.p2p-mobile-buy-btn {
  width: 100%;
  padding: 12px;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-mobile-buy-btn:hover {
  background: #16a34a;
}
*/

/* [UNUSED]
.p2p-mobile-sell-btn {
  width: 100%;
  padding: 12px;
  background: #ef4444;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
*/

/* [UNUSED]
.p2p-mobile-sell-btn:hover {
  background: #dc2626;
}
*/

/* [UNUSED]
.p2p-mobile-expanded-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}
*/

/* Payment Modal */
.p2p-modal-content {
  background: #373E4B;
  border: 1px solid #373E4B;
  border-radius: 10px;
}

/* [UNUSED]
.p2p-modal-header {
  border-bottom: 1px solid #404754;
  padding: 20px 24px;
}
*/

/* [UNUSED]
.payment_search_box {
  margin-bottom: 20px;
}
*/

/* [UNUSED]
.payment_search_box input {
  width: 100%;
  padding: 14px 16px;
  background: #4B515D;
  border: 1px solid #4B515D;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
*/

.p2p-modal-body {
  padding: 0px 24px;
}

/* [UNUSED]
.p2p-modal-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-payment-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #4B515D;
  border: 1px solid #4B515D;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-payment-option:hover {
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-payment-option.p2p-selected {
  background: rgba(255, 220, 136, 0.15);
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-payment-option span {
  color: #fff;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-payment-option input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  display: none;
}
*/

/* [UNUSED]
.p2p-payment-option.p2p-selected input[type="checkbox"] {
  display: block;
}
*/

/* [UNUSED]
.button.p2p-submit-button {
  background-color: #fff;
  border: none;
  border-radius: 50px;
  font-size: 15px;
  margin-top: 12px;
}
*/

/* ====================================
     Responsive Styles
     ==================================== */

@media (max-width: 991.98px) {
  .p2p-sidebar {
    transform: translateX(-100%);
  }

  .p2p-sidebar.p2p-open {
    transform: translateX(0);
    background: #000;
  }

  .p2p-sidebar-close {
    display: flex;
  }
}

@media (min-width: 992px) {
  .p2p-sidebar-overlay {
    display: none !important;
  }
}

@media (max-width: 1024px) {
  .p2p-filter-section {
    flex-wrap: wrap;
  }

  .p2p-filter-group {
    min-width: calc(50% - 8px);
  }

  .p2p-find-orders-btn {
    width: 100%;
  }

  .p2p-orders-table th:nth-child(2),
  .p2p-orders-table td:nth-child(2) {
    display: none;
  }
}

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-toggle-btn {
    padding: 10px 32px;
    font-size: 14px;
  }
*/

  .p2p-filter-group {
    min-width: 100%;
  }


  .p2p-orders-table-wrapper {
    overflow-x: auto;
  }

  .p2p-orders-table {
    min-width: 600px;
  }

  /* [UNUSED]
.p2p-expanded-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }
*/

  /* [UNUSED]
.p2p-expanded-right {
    min-width: 100%;
    padding: 0;
  }
*/

  /* [UNUSED]
.p2p-expanded-left {
    padding: 16px;
  }
*/

  /* [UNUSED]
.p2p-input-header {
    padding: 14px 16px 6px;
  }
*/

  /* [UNUSED]
.p2p-expanded-input-wrapper {
    padding: 0 16px 14px;
  }
*/

  /* [UNUSED]
.p2p-expanded-input-wrapper input {
    font-size: 26px;
  }
*/

  /* [UNUSED]
.p2p-payment-selector-full {
    padding: 14px 16px;
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-confirm-buy-btn,
  .p2p-confirm-sell-btn {
    padding: 14px 20px;
    font-size: 14px;
  }
*/

  .p2p-pagination-wrapper {
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 640px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* Mobile expanded row styling */
  .p2p-expanded-row {
    display: block;
  }

  .p2p-expanded-row td {
    padding: 0 !important;
  }

  /* [UNUSED]
.p2p-expanded-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    background: #0d0d14;
    border-radius: 12px;
    margin: 8px 0;
  }
*/

  /* [UNUSED]
.p2p-expanded-left {
    order: 2;
    border-top: 1px solid #2a2a3a;
    padding-top: 16px;
    margin-top: 16px;
  }
*/

  /* [UNUSED]
.p2p-expanded-right {
    order: 1;
  }
*/
}

@media (max-width: 576px) {
  /* [UNUSED]
.p2p-buy-sell-toggle {
    margin-bottom: 16px;
  }
*/




  /* [UNUSED]
.p2p-toggle-wrapper {
    width: 100%;
  }
*/

  /* [UNUSED]
.p2p-toggle-btn {
    flex: 1;
    padding: 10px 16px;
  }
*/

  .p2p-filter-section {
    gap: 12px;
    padding: 0;
  }

  .p2p-orders-table th,
  .p2p-orders-table td {
    padding: 12px;
  }

  /* [UNUSED]
.p2p-advertiser-avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-advertiser-info h4 {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-buy-btn,
  .p2p-sell-btn {
    padding: 8px 16px;
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-expanded-stats {
    flex-wrap: wrap;
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-expanded-form-actions {
    flex-direction: column;
  }
*/

  .p2p-pagination-wrapper.p2p-mobile {
    background: transparent;
    border: none;
    margin-top: 16px;
  }

  /* P2P Expanded Form Mobile Styles */
  /* [UNUSED]
.p2p-expanded-content {
    padding: 12px;
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-expanded-right {
    min-width: 100%;
  }
*/

  /* [UNUSED]
.p2p-expanded-form-group {
    margin-bottom: 10px;
  }
*/

  /* [UNUSED]
.p2p-input-header {
    padding: 12px 14px 4px;
    border-radius: 10px 10px 0 0;
  }
*/

  /* [UNUSED]
.p2p-input-header label {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-input-range {
    font-size: 11px;
  }
*/

  /* [UNUSED]
.p2p-expanded-input-wrapper {
    padding: 0 14px 12px;
    border-radius: 0 0 10px 10px;
  }
*/

  /* [UNUSED]
.p2p-expanded-input-wrapper input {
    font-size: 22px;
  }
*/

  /* [UNUSED]
.p2p-input-currency {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-price-info {
    font-size: 11px;
  }
*/

  /* [UNUSED]
.p2p-payment-selector-full {
    padding: 12px 14px;
    font-size: 13px;
    border-radius: 0 0 10px 10px;
  }
*/

  /* [UNUSED]
.p2p-payment-indicator {
    width: 3px;
    height: 14px;
  }
*/

  /* [UNUSED]
.p2p-expanded-form-actions {
    margin-top: 12px;
  }
*/

  /* [UNUSED]
.p2p-confirm-buy-btn,
  .p2p-confirm-sell-btn {
    padding: 12px 16px;
    font-size: 13px;
    border-radius: 8px;
  }
*/

  /* [UNUSED]
.p2p-expanded-input-error {
    font-size: 11px;
    padding-left: 14px;
  }
*/

  /* Expanded left section mobile */
  /* [UNUSED]
.p2p-expanded-left {
    padding: 12px;
  }
*/

  /* [UNUSED]
.p2p-expanded-avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-expanded-user-details h5 {
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-expanded-user-details p {
    font-size: 11px;
  }
*/

  /* [UNUSED]
.p2p-expanded-stats {
    gap: 12px;
  }
*/

  /* [UNUSED]
.p2p-stat-item {
    min-width: calc(50% - 6px);
  }
*/

  /* [UNUSED]
.p2p-stat-value {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-stat-label {
    font-size: 10px;
  }
*/

  /* [UNUSED]
.p2p-expanded-payments h6,
  .p2p-expanded-remarks h6 {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-expanded-payment-badge {
    font-size: 11px;
    padding: 4px 8px;
  }
*/

  /* [UNUSED]
.p2p-expanded-remarks p {
    font-size: 12px;
  }
*/
}

/* Extra small devices */
@media (max-width: 400px) {
  /* [UNUSED]
.p2p-expanded-input-wrapper input {
    font-size: 20px;
  }
*/

  /* [UNUSED]
.p2p-input-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
*/

  /* [UNUSED]
.p2p-payment-selector-full {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-stat-item {
    min-width: 100%;
  }
*/
}

/* ====================================
     ENHANCED MOBILE RESPONSIVENESS - P2P Dashboard
     ==================================== */

/* Tablet breakpoint (992px - 768px) */
@media (max-width: 992px) and (min-width: 769px) {
  .p2p-dashboard-container {
    padding: 0 12px;
  }

  /* [UNUSED]
.p2p-toggle-btn {
    padding: 12px 36px;
    font-size: 14px;
  }
*/

  .p2p-filter-section {
    gap: 12px;
  }

  .p2p-filter-group {
    min-width: calc(33.333% - 12px);
  }

  .p2p-orders-table th,
  .p2p-orders-table td {
    padding: 16px 12px;
    font-size: 13px;
  }

  /* [UNUSED]
.p2p-price-value {
    font-size: 15px;
  }
*/
}

/* Mobile landscape and small tablets (768px) */
@media (max-width: 768px) {
  .p2p-dashboard-container {
    padding: 0 8px;
  }

  /* Hide desktop table at this breakpoint too */
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .p2p-filter-section {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
    padding: 0 4px;
  }

  .p2p-filter-group {
    min-width: 100%;
    flex: none;
  }

  .p2p-filter-select {
    padding: 14px 16px;
    font-size: 15px;
    border-radius: 10px;
  }

  .p2p-find-orders-btn {
    padding: 14px;
    width: 100%;
    font-size: 15px;
    border-radius: 10px;
    margin-top: 4px;
  }

  /* [UNUSED]
.p2p-buy-sell-toggle {
    margin-bottom: 20px;
    padding: 0 4px;
  }
*/

  /* [UNUSED]
.p2p-toggle-wrapper {
    width: 100%;
    border-radius: 10px;
    padding: 5px;
  }
*/

  /* [UNUSED]
.p2p-toggle-btn {
    flex: 1;
    padding: 14px 20px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 8px;
  }
*/

  /* Mobile order cards improved */
  .p2p-mobile-order-card {
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 0;
  }

  /* [UNUSED]
.p2p-mobile-card-avatar {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
*/

  .p2p-mobile-card-user-info h4 {
    font-size: 15px;
    font-weight: 600;
  }

  .p2p-mobile-card-user-info p {
    font-size: 13px;
    color: #7d8087;
  }

  /* [UNUSED]
.p2p-mobile-card-price .p2p-value {
    font-size: 20px;
    font-weight: 700;
  }
*/

  .p2p-mobile-card-price .p2p-currency {
    font-size: 13px;
  }

  .p2p-mobile-card-details {
    gap: 16px;
    margin-bottom: 16px;
    padding-bottom: 16px;
  }

  .p2p-mobile-detail-label {
    font-size: 12px;
    font-weight: 500;
  }

  .p2p-mobile-detail-value {
    font-size: 14px;
    font-weight: 500;
  }

  .p2p-mobile-payment-badge {
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 6px;
  }

  /* [UNUSED]
.p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 9px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    margin-top: 12px;
  }
*/

  /* Expanded section mobile */
  /* [UNUSED]
.p2p-mobile-expanded-section {
    padding-top: 20px;
    margin-top: 20px;
  }
*/

  .p2p-payment-method-header.mobileview {
    flex-direction: row;
    align-items: center;
  }

  .mobileview .p2p-payment-method-actions {
    width: auto;
  }

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-right {
    padding: 0;
  }
*/

  /* Keep same design as desktop - card style inputs */
  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-form-group {
    margin-bottom: 14px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px 8px;
    background: #1a1a2200;
    border-radius: 10px 10px 0 0;
    border: 1px solid #424251;
    border-bottom: none;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-header label {
    font-size: 13px;
    color: #ffffff;
    margin: 0;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-range {
    font-size: 11px;
    color: #adabab;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    display: flex;
    align-items: center;
    background: #1a1a2200;
    border: 1px solid #424251;
    border-top: none;
    border-radius: 0 0 10px 10px;
    padding: 0 16px 14px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    flex: 1;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: 500;
    padding: 0;
    width: 100%;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input:focus {
    outline: none;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-currency {
    color: #888;
    font-size: 14px;
    font-weight: 500;
    background: transparent;
    padding: 0;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-price-info {
    font-size: 11px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-payment-selector-full,
  .p2p-mobile-expanded-section .p2p-payment-selector {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: #1a1a2200;
    border: 1px solid #424251;
    border-radius: 10px;
    color: #888;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-payment-selector-full:hover,
  .p2p-mobile-expanded-section .p2p-payment-selector:hover {
    border-color: #3a3a4a;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-payment-indicator {
    width: 3px;
    height: 16px;
    background: #22c55e;
    border-radius: 2px;
    margin-right: 10px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-form-actions {
    display: flex;
    gap: 12px;
    margin-top: 20px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-cancel-btn {
    flex: 1;
    padding: 14px;
    background: transparent;
    border: 1px solid #2a2a3a;
    border-radius: 10px;
    color: #8b8b8b;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-cancel-btn:hover {
    background: rgba(255, 255, 255, 0.05);
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    flex: 2;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 10px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-error {
    font-size: 11px;
    color: #ef4444;
    margin-top: 6px;
    padding-left: 16px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-available-balance {
    display: block;
    font-size: 12px;
    color: #aaa;
    margin-top: 6px;
    padding-left: 2px;
  }
*/

  /* [UNUSED]
.payment_method_pop {
    padding-right: 0px !important;
  }
*/

  .modal.fade {
    padding-right: 0px !important;
  }

  /* Pagination mobile */
  .p2p-pagination-wrapper {
    padding: 16px;
    margin-top: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .p2p-pagination-info {
    font-size: 13px;
    order: 2;
  }

  /* [UNUSED]
.p2p-pagination-controls {
    order: 1;
  }
*/

  .p2p-page-btn {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }

  /* Modal mobile */
  .p2p-modal-content {
    margin: 16px;
    max-height: calc(100vh - 32px);
  }

  /* [UNUSED]
.p2p-modal-header {
    padding: 16px;
  }
*/

  /* [UNUSED]
.p2p-modal-title {
    font-size: 16px;
  }
*/

  .p2p-modal-body {
    padding: 16px;
    max-height: calc(100vh - 150px);
    overflow-y: auto;
  }

  /* [UNUSED]
.p2p-payment-option {
    padding: 14px 16px;
  }
*/

  /* [UNUSED]
.p2p-payment-option span {
    font-size: 14px;
  }
*/

  /* Available balance mobile */
  /* [UNUSED]
.p2p-available-balance {
    font-size: 12px;
    margin-top: 8px;
    display: block;
  }
*/
}

/* Mobile portrait (576px and below) */
@media (max-width: 576px) {
  .p2p-dashboard-container {
    padding: 0 4px;
  }

  /* [UNUSED]
.p2p-toggle-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
*/

  .p2p-filter-label {
    font-size: 11px;
  }

  .p2p-filter-select {
    padding: 12px 14px;
    font-size: 14px;
  }

  .p2p-find-orders-btn {
    padding: 12px;
    font-size: 14px;
  }

  .p2p-mobile-order-card {
    padding: 14px;
    border-radius: 12px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 14px;
    flex-wrap: wrap;
    gap: 10px;
  }

  .p2p-mobile-card-user {
    gap: 10px;
  }

  /* [UNUSED]
.p2p-mobile-card-avatar {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
*/

  .p2p-mobile-card-user-info h4 {
    font-size: 14px;
  }

  .p2p-mobile-card-user-info p {
    font-size: 12px;
  }

  /* [UNUSED]
.p2p-mobile-card-price .p2p-value {
    font-size: 18px;
  }
*/

  .p2p-mobile-card-details {
    gap: 10px;
    margin-bottom: 14px;
    padding-bottom: 14px;
  }

  .p2p-mobile-detail-label {
    font-size: 11px;
  }

  .p2p-mobile-detail-value {
    font-size: 13px;
  }

  .p2p-mobile-card-payments {
    gap: 6px;
    margin-bottom: 14px;
  }

  .p2p-mobile-payment-badge {
    padding: 6px 10px;
    font-size: 11px;
  }

  /* [UNUSED]
.p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
  }
*/

  /* Expanded section small mobile */
  /* [UNUSED]
.p2p-mobile-expanded-section {
    padding-top: 16px;
    margin-top: 16px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-header {
    padding: 12px 14px 6px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    padding: 0 14px 12px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    font-size: 22px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-payment-selector-full {
    padding: 12px 14px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-form-actions {
    flex-direction: column;
    gap: 10px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-cancel-btn,
  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    flex: none;
    width: 100%;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    order: -1;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-error {
    font-size: 11px;
    margin-top: 6px;
    padding-left: 14px;
  }
*/

  /* Verification button mobile */
  /* [UNUSED]
.p2p-mobile-verification-btn {
    padding: 12px;
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-mobile-verification-btn i {
    font-size: 16px;
  }
*/

  /* Trade restricted mobile */
  /* [UNUSED]
.p2p-mobile-condition-info {
    font-size: 11px;
    padding: 10px;
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }
*/

  /* Pagination small mobile */
  .p2p-pagination-wrapper.p2p-mobile {
    padding: 12px 0;
  }

  .p2p-page-btn {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  /* Modal small mobile */
  .p2p-modal-content {
    margin: 8px;
    border-radius: 12px;
  }

  /* [UNUSED]
.p2p-payment-option {
    padding: 12px 14px;
  }
*/

  /* No payment methods state */
  /* [UNUSED]
.p2p-no-payment-methods {
    padding: 24px 16px;
    text-align: center;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods i {
    font-size: 40px;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods p {
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-add-payment-btn {
    padding: 12px 20px;
    font-size: 13px;
  }
*/
}

/* Extra small mobile (400px and below) */
@media (max-width: 400px) {
  /* [UNUSED]
.p2p-toggle-wrapper {
    padding: 4px;
  }
*/

  /* [UNUSED]
.p2p-toggle-btn {
    padding: 10px 12px;
    font-size: 13px;
  }
*/

  .p2p-filter-select {
    padding: 10px 12px;
    font-size: 13px;
  }

  .p2p-find-orders-btn {
    padding: 10px;
    font-size: 13px;
  }

  .p2p-mobile-order-card {
    padding: 12px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 12px;
  }

  /* [UNUSED]
.p2p-mobile-card-avatar {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
*/

  .p2p-mobile-card-user-info h4 {
    font-size: 13px;
  }

  .p2p-mobile-card-user-info p {
    font-size: 11px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* [UNUSED]
.p2p-mobile-card-price .p2p-value {
    font-size: 16px;
  }
*/

  .p2p-mobile-card-price .p2p-currency {
    font-size: 11px;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .p2p-mobile-payment-badge {
    padding: 5px 8px;
    font-size: 10px;
  }

  /* [UNUSED]
.p2p-mobile-buy-btn,
  .p2p-mobile-sell-btn {
    padding: 8px 10px;
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-header {
    padding: 7px 12px 5px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-header label {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-range {
    font-size: 10px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {
    padding: 0 12px 10px;
    gap: 5px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {
    font-size: 18px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-input-currency {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-payment-selector-full {
    padding: 10px 12px;
    font-size: 12px;
    margin-top: 14px;

  }
*/

  /* [UNUSED]
.p2p-mobile-expanded-section .p2p-cancel-btn,
  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,
  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {
    padding: 10px;
    font-size: 12px;
  }
*/

  /* Rating on mobile */
  /* [UNUSED]
.p2p-mobile-card-user-info .p2p-rating {
    font-size: 11px;
  }
*/

  /* [UNUSED]
.p2p-mobile-card-user-info .p2p-rating span:first-child {
    font-size: 10px;
    letter-spacing: -1px;
  }
*/
}

/* ====================================
     P2P My Ads Page Styles
     ==================================== */

.p2p-myads-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.p2p-myads-title {
  font-size: 22px;
  font-weight: 600;
  color: #d1d5db;
  margin: 0 0 4px 0;
}

.p2p-myads-subtitle {
  font-size: 13px;
  color: #52525b;
  margin: 0;
}

.p2p-create-ad-btn {
  padding: 10px 20px;
  /* background: rgba(30, 58, 138, 0.4); */
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 8px;
  /* color: #93c5fd; */
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-create-ad-btn:hover {
  background-color: #e7b641;
}

.p2p-payment-method-header {
  gap: 12px;
}

/* Stats Cards Grid */
.p2p-myads-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
  background-color: #373F4D;
  border-radius: 8px;
  overflow: hidden;
  padding: 12px 0px;
}

.p2p-myads-stat-card {
  background: #373F4D;
  border-radius: 0px;
  border: none;
  padding: 3px 20px;
  transition: border-color 0.2s ease;
  border-right: 1px solid #454C59;
}

.p2p-myads-stat-card:hover {
  border-right: 1px solid #454C59;
}

.p2p-filter-section.myadsfillter {
  padding: 0px;
}

.p2p-myads-stats-grid .p2p-myads-stat-card:last-child {
  border-right: none;
}

.p2p-dashboard-container.p2p-profile-container {
  background-color: #2B313C;
  border-radius: 10px;
}

.p2p-profile-container .p2p-profile-header {
  background: none;
  border-radius: 12px;
  border: none;
  padding: 36px;
  margin-bottom: 0px;
}

.p2p-profile-container .p2p-myads-stats-grid {
  grid-template-columns: repeat(2, 1fr);
  background-color: transparent;
  border-radius: 0px;
  gap: 20px;
  padding: 20px 36px;
  overflow: inherit;
  border-bottom: 1px solid #454C59;
  border-top: 1px solid #454C59;
}

.p2p-profile-container .p2p-myads-stat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  justify-content: space-between;
  background: none;
  border-radius: 0px;
  border-right: none;
  padding: 6px 0px;
  border-bottom: 1px solid #454C59;
}

.p2p-profile-container .p2p-myads-stat-card-label {
  color: #fff;
  font-size: 13px;
  border-bottom: none;
}

.p2p-profile-container .p2p-myads-stat-card:nth-child(5) {
  border-bottom: none;
}

.p2p-profile-container .p2p-myads-stat-card:last-child {
  border-bottom: none;
}

.p2p-profile-tabs.paymentprofiletabs {
  padding: 0px 36px 36px;
}

.p2p-profile-container .p2p-empty-state-card {
  background: none;
  border-radius: 0px;
}

.p2p-profile-container .p2p-empty-state-card i {
  font-size: 30px;
  color: #fff;
  margin-bottom: 0px;
}

.myadsfillter .p2p-filter-select {
  background: #373F4D;
  border: 1px solid #373F4D;
}

.myadsfillter .p2p-find-orders-btn {
  background: #373F4D;
  border: 1px solid #373F4D;
}

.p2p-myads-container {
  background-color: #2B313C;
  padding: 24px;
  border-radius: 12px;
}

.p2p-myads-stat-card-label {
  color: #A2A9B6;
  font-size: 13px;
  padding-bottom: 3px;
  margin-bottom: 4px;
  border-bottom: 1px solid #454C59;
  letter-spacing: 0.3px;
}

.p2p-myads-stat-card-value {
  font-size: 16px;
  font-weight: 400;
  color: #e5e5e5;
}

/* Legacy stats (keep for backwards compatibility) */
/* [UNUSED]
.p2p-myads-stats {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: #0d0d14;
  border-radius: 10px;
  border: 1px solid #1e1e2d;
}
*/

/* [UNUSED]
.p2p-myads-stat-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-myads-stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #a1a1aa;
}
*/

/* [UNUSED]
.p2p-myads-stat-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
*/

.p2p-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  min-height: 200px;
}

.p2p-loading-container .spinner-border {
  width: 32px;
  height: 32px;
}

@media (max-width: 768px) {
  .p2p-loading-container {
    padding: 40px 16px;
    min-height: 150px;
  }

  .p2p-loading-container .spinner-border {
    width: 28px;
    height: 28px;
  }
}

/* My Ads Table Specific Styles */
.p2p-myads-asset-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.p2p-myads-side-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.p2p-myads-side-badge.buy {
  background: #5EBA89;
  color: #fff;
}

.p2p-myads-side-badge.sell {
  background: rgba(239, 68, 68, 0.08);
  color: #fca5a5;
}

.p2p-myads-asset-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-empty-state-card .p2p-myads-action-btn {
  padding: 10px 12px;
}

.p2p-myads-asset-name {
  font-size: 14px;
  font-weight: 500;
  color: #d1d5db;
}

.p2p-myads-asset-fiat {
  font-size: 11px;
  color: #6b7280;
}

/* [UNUSED]
.p2p-myads-price {
  font-size: 14px;
  font-weight: 500;
  color: #a1a1aa;
}
*/

/* [UNUSED]
.p2p-myads-price-currency {
  font-size: 11px;
  color: #6b7280;
  margin-left: 4px;
}
*/

/* [UNUSED]
.p2p-myads-volume {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-myads-volume-remaining {
  font-size: 14px;
  font-weight: 500;
  color: #a1a1aa;
}
*/

/* [UNUSED]
.p2p-myads-volume-total {
  font-size: 11px;
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-myads-limits {
  font-size: 13px;
  color: #9ca3af;
}
*/

.p2p-myads-status {
  font-size: 13px;
  font-weight: 500;
}

/* [UNUSED]
.p2p-myads-date {
  font-size: 12px;
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-payment-badge-more {
  padding: 4px 8px;
  background: rgba(107, 114, 128, 0.2);
  border-radius: 4px;
  font-size: 11px;
  color: #9ca3af;
}
*/

/* Empty State */
.p2p-empty-state {
  text-align: center;
  padding: 60px 20px;
}

.p2p-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.p2p-empty-state p {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 20px;
}

.p2p-create-ad-btn-small {
  padding: 10px 20px;
  background: rgba(30, 41, 59, 0.4);
  border: 1px solid rgba(51, 65, 85, 0.5);
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* [UNUSED]
.payment_method_pop.modal.fade .modal-dialog {
  min-width: 540px;
}
*/

.p2p-create-ad-btn-small:hover {
  border-color: rgba(71, 85, 105, 0.8);
  color: #d1d5db;
  background: rgba(30, 41, 59, 0.6);
}

.p2p-empty-state-mobile {
  text-align: center;
  padding: 40px 20px;
  background: #373F4D;
  border-radius: 12px;
  border: 1px solid #373F4D;
}

/* Pagination */
.p2p-pagination-buttons,
.p2p-pagination-controls {
  display: flex;
  gap: 6px;
  align-items: center;
}

@media (max-width: 768px) {
  .p2p-myads-header {
    flex-direction: column;
    align-items: flex-start;
  }

  /* [UNUSED]
.p2p-myads-stats {
    flex-wrap: wrap;
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-myads-stat-item {
    min-width: calc(33% - 12px);
  }
*/

  .p2p-pagination-wrapper {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
}

@media (max-width: 576px) {
  .p2p-myads-title {
    font-size: 18px;
  }

  /* [UNUSED]
.p2p-myads-stats {
    padding: 12px 16px;
  }
*/

  /* [UNUSED]
.p2p-myads-stat-value {
    font-size: 16px;
  }
*/
}

/* My Ads Actions */
.p2p-myads-actions {
  display: flex;
  gap: 8px;
}

.p2p-myads-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: #a1a1aa;
}

.p2p-myads-action-btn i {
  font-size: 14px;
}

.p2p-myads-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
}

.p2p-myads-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Online/Offline Status */
.p2p-myads-status-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-myads-online-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  width: -moz-fit-content;
  width: fit-content;
}

.p2p-myads-online-badge.online {
  background: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.p2p-myads-online-badge.offline {
  background: rgba(255, 255, 255, 0.04);
  color: #6b7280;
}

.p2p-myads-online-badge.small {
  padding: 2px 6px;
  font-size: 10px;
}

.p2p-myads-online-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6b7280;
}

.p2p-myads-online-badge.online .p2p-myads-online-dot {
  background: #4ade80;
  animation: p2p-pulse 2s ease-in-out infinite;
}

.p2p-myads-online-badge.offline .p2p-myads-online-dot {
  background: #6b7280;
  animation: none;
}

@keyframes p2p-pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* [UNUSED]
.p2p-mobile-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
*/

/* .p2p-row-expanded {
    background: rgba(255, 220, 136, 0.03) !important;
  } */

/* Expanded Content */
/* .p2p-myads-expanded-content {
    padding: 20px 24px;
    background: #0a0a0f;
    border-top: 1px solid #1e1e2d;
  } */

.p2p-myads-expanded-section {
  margin-bottom: 24px;
}

.p2p-myads-expanded-section:last-child {
  margin-bottom: 0;
}

.p2p-myads-expanded-title {
  font-size: 13px;
  font-weight: 600;
  color: #9ca3af;
  margin: 0 0 12px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-myads-expanded-count {
  font-size: 11px;
  color: #6b7280;
  font-weight: 400;
}

.p2p-myads-expanded-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.p2p-myads-expanded-grid.mobile {
  grid-template-columns: repeat(3, 1fr);
}

.p2p-myads-expanded-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-myads-expanded-label {
  font-size: 11px;
  color: #6b7280;
}

.p2p-myads-expanded-value {
  font-size: 13px;
  color: #a1a1aa;
  font-weight: 500;
}

.p2p-myads-expanded-value.small {
  font-size: 11px;
  word-break: break-all;
}

.p2p-myads-expanded-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Payment Details Cards */
.p2p-myads-payment-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.p2p-myads-payment-card {
  background: #2f3641;
  border: 1px solid #454C59;
  border-radius: 10px;
  padding: 16px;
}

.p2p-myads-payment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #454C59;
}

.p2p-myads-payment-type {
  font-size: 14px;
  font-weight: 600;
  color: #bd83cb;
}

.p2p-myads-payment-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
  border-radius: 4px;
}

.p2p-myads-payment-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-myads-payment-field {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.p2p-myads-payment-label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.p2p-myads-payment-value {
  font-size: 12px;
  color: #a1a1aa;
  text-align: right;
  word-break: break-all;
}

.p2p-myads-payment-qr {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #454C59;
}

.p2p-myads-payment-qr img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  background: #fff;
  border-radius: 8px;
  padding: 4px;
}

.p2p-myads-no-details {
  font-size: 13px;
  color: #6b7280;
}

/* Closure Information */
.p2p-myads-closure-info {
  background: rgba(107, 114, 128, 0.1);
  border: 1px solid rgba(107, 114, 128, 0.2);
  border-radius: 10px;
  padding: 16px;
}

.p2p-myads-closure-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.p2p-myads-closure-icon {
  font-size: 16px;
}

.p2p-myads-closure-text {
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
}

.p2p-myads-closure-date {
  font-size: 12px;
  color: #6b7280;
}

.p2p-myads-closure-reason {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(107, 114, 128, 0.2);
}

.p2p-myads-closure-reason-label {
  font-size: 12px;
  color: #6b7280;
  margin-right: 8px;
}

.p2p-myads-closure-reason-text {
  font-size: 13px;
  color: #a1a1aa;
  line-height: 1.5;
}

/* Mobile Card Actions */
.p2p-mobile-card-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-card-actions .p2p-myads-action-btn {
  flex: 1 1;
  padding: 10px 16px;
  font-size: 13px;
}

/* Mobile Expanded Details */
.p2p-mobile-expanded-details {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-expanded-details .p2p-myads-expanded-grid {
  grid-template-columns: repeat(2, 1fr);
}

.p2p-mobile-expanded-details .p2p-myads-payment-details {
  grid-template-columns: 1fr;
}

@media (max-width: 1024px) {
  .p2p-myads-expanded-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .p2p-myads-expanded-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-myads-payment-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .p2p-myads-actions {
    flex-direction: column;
  }

  .p2p-myads-action-btn {
    width: 100%;
    text-align: center;
  }

  .p2p-myads-expanded-content {
    padding: 16px;
  }

  .p2p-myads-expanded-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
}

/* Close Ad Modal */
/* .p2p-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
  backdrop-filter: blur(5px);
} */

.p2p-close-ad-modal {
  background: #12121a;
  border: 1px solid #1e1e2d;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

@keyframes p2p-modal-slide-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.p2p-close-ad-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-close-ad-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #d1d5db;
  margin: 0;
}

.p2p-close-ad-modal-close {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  transition: color 0.2s;
}

.p2p-close-ad-modal-close:hover {
  color: #e5e5e5;
}

.p2p-close-ad-modal-body {
  padding: 24px;
  overflow-y: auto;
}

/* Warning Banner */
.p2p-close-ad-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: rgba(120, 113, 108, 0.1);
  border: 1px solid rgba(120, 113, 108, 0.2);
  border-radius: 10px;
  margin-bottom: 20px;
}

.p2p-close-ad-warning-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.p2p-close-ad-warning-content strong {
  display: block;
  font-size: 14px;
  color: #d6d3d1;
  margin-bottom: 4px;
}

.p2p-close-ad-warning-content p {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
}

/* Ad Summary */
.p2p-close-ad-summary {
  background: #0a0a0f;
  border: 1px solid #1e1e2d;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
}

.p2p-close-ad-summary-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-close-ad-summary-pair {
  font-size: 16px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-close-ad-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.p2p-close-ad-summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.p2p-close-ad-summary-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-close-ad-summary-value {
  font-size: 14px;
  color: #d1d5db;
  font-weight: 500;
}

/* Reason Input Group */
.p2p-close-ad-reason-group {
  margin-bottom: 0;
}

.p2p-close-ad-reason-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 10px;
}

.p2p-optional-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(107, 114, 128, 0.2);
  color: #6b7280;
  border-radius: 4px;
}

.p2p-close-ad-reason-input {
  width: 100%;
  background: #0a0a0f;
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  color: #e5e5e5;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.2s;
}

.p2p-close-ad-reason-input:focus {
  outline: none;
  border-color: #ffdc88;
}

.p2p-close-ad-reason-input.error {
  border-color: #ef4444;
}

.p2p-close-ad-reason-input::placeholder {
  color: #4b5563;
}

.p2p-close-ad-reason-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.p2p-close-ad-error {
  font-size: 12px;
  color: #ef4444;
}

.p2p-close-ad-char-count {
  font-size: 11px;
  color: #6b7280;
  margin-left: auto;
}

/* Modal Footer */
.p2p-close-ad-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #1e1e2d;
}

.p2p-close-ad-btn-cancel,
.p2p-close-ad-btn-confirm {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-close-ad-btn-cancel {
  background: transparent;
  border: 1px solid #2a2a3a;
  color: #9ca3af;
}

.p2p-close-ad-btn-cancel:hover:not(:disabled) {
  background: rgba(107, 114, 128, 0.1);
  border-color: #4b5563;
  color: #d1d5db;
}

.p2p-close-ad-btn-confirm {
  background: rgba(153, 27, 27, 0.8);
  border: 1px solid rgba(185, 28, 28, 0.5);
  color: #fecaca;
}

.p2p-close-ad-btn-confirm:hover:not(:disabled) {
  background: rgba(153, 27, 27, 1);
  color: #fff;
}

.p2p-close-ad-btn-cancel:disabled,
.p2p-close-ad-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 576px) {
  .p2p-modal-overlay {
    padding: 16px;
  }

  .p2p-close-ad-modal {
    max-width: 100%;
  }

  .p2p-close-ad-modal-header {
    padding: 16px 20px;
  }

  .p2p-close-ad-modal-body {
    padding: 20px;
  }

  .p2p-close-ad-modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .p2p-close-ad-summary-grid {
    grid-template-columns: 1fr;
  }
}

/* ====================================
     P2P My Ads - ENHANCED Mobile Responsive
     ==================================== */

/* MyAds Header - Mobile Premium Design */
@media (max-width: 768px) {
  .p2p-myads-header {
    padding: 0 4px;
    margin-bottom: 20px;
  }

  .p2p-myads-header>div {
    margin-bottom: 4px;
  }

  .p2p-myads-title {
    font-size: 22px;
    font-weight: 700;
    color: #f5f5f5;
    margin-bottom: 6px;
  }

  .p2p-myads-subtitle {
    font-size: 13px;
    color: #6b7280;
  }

  .p2p-create-ad-btn {
    width: 100%;
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%);
    border: 1px solid rgba(34, 197, 94, 0.3);
    color: #4ade80;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .p2p-create-ad-btn:hover {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.3) 0%, rgba(34, 197, 94, 0.2) 100%);
    border-color: rgba(34, 197, 94, 0.5);
  }
}

/* Stats Grid - Mobile Premium */
@media (max-width: 768px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 20px;
    padding: 20px;
  }

  .p2p-myads-stat-card {
    padding: 14px 12px;
    border-radius: 0px;
    /* background: linear-gradient(145deg, #12121a00 0%, #0d0d1400 100%); */
    /* border: 1px solid #2c2c2c; */
    text-align: left;
  }

  .p2p-profile-container .p2p-myads-stat-card {
    border: none;
    border-bottom: 1px solid #454C59;
  }

  .p2p-myads-stat-card-label {
    font-size: 10px;
    margin-bottom: 6px;
    color: #6b7280;
    letter-spacing: 0.3px;
  }

  .p2p-myads-stat-card-value {
    font-size: 18px;
    font-weight: 700;
    color: #f5f5f5;
  }

  /* [UNUSED]
.selectpaymetpop.modal.fade .modal-dialog {
    width: 100%;
    min-width: 100%;
  }
*/

}

@media (max-width: 480px) {

  .modal.fade .modal-dialog {
    min-width: 100%;
    width: 100%;
    margin: 0 auto;
  }




  /* [UNUSED]
.selectpaymetpop.modal.fade .modal-dialog {
    width: 100%;
    min-width: 100%;
  }
*/

  .myadsheading .p2p-mobile-card-user-info h4 {
    font-size: 12px;
    margin: 0px 0px 1px;
  }

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-myads-stat-card {
    padding: 12px 10px;
  }

  .p2p-myads-stat-card-label {
    font-size: 9px;
  }

  .p2p-myads-stat-card-value {
    font-size: 16px;
  }
}

/* Mobile Order Cards - Premium Design */
@media (max-width: 768px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 4px;
  }

  .p2p-mobile-order-card {
    border: 1px solid rgb(54 54 54);
    border-radius: 16px;
    padding: 18px;
    transition: all 0.2s ease;
  }

  .p2p-mobile-order-card:hover {
    border-color: rgb(54 54 54);
  }

  /* Card Header */
  .p2p-mobile-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .p2p-mobile-card-user {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .p2p-myads-side-badge {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .p2p-myads-side-badge.buy {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.08) 100%);
    color: #4ade80;
    border: 1px solid rgba(34, 197, 94, 0.2);
  }

  .p2p-myads-side-badge.sell {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.08) 100%);
    color: #f87171;
    border: 1px solid rgba(239, 68, 68, 0.2);
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 16px;
    font-weight: 600;
    color: #f5f5f5;
    margin: 0 0 4px 0;
  }

  /* [UNUSED]
.p2p-mobile-status-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
*/

  /* Price Display */
  .p2p-mobile-card-price {
    text-align: right;
  }

  /* [UNUSED]
.p2p-mobile-card-price .p2p-value {
    font-size: 20px;
    font-weight: 700;
    color: #f5f5f5;
    line-height: 1.2;
  }
*/

  .p2p-mobile-card-price .p2p-currency {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
  }

  /* Card Details Grid */
  .p2p-mobile-card-details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-bottom: 16px;
    padding: 16px;
    background: rgba(0, 0, 0, 0);
    border-radius: 12px;
  }

  .p2p-mobile-detail-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .p2p-mobile-detail-label {
    font-size: 11px;
    color: #6b7280;
    letter-spacing: 0.5px;
    font-weight: 500;
  }

  .p2p-mobile-detail-value {
    font-size: 13px;
    color: #e5e5e5;
    font-weight: 500;
  }

  /* Payment Badges */
  .p2p-mobile-card-payments {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
  }

  .p2p-mobile-payment-badge {
    padding: 6px 12px;
    background: rgba(255, 220, 136, 0.1);
    border: 1px solid rgba(255, 220, 136, 0.2);
    border-radius: 6px;
    font-size: 12px;
    color: #bd83cb;
    font-weight: 500;
  }

  /* Action Buttons */
  .p2p-mobile-card-actions {
    display: flex;
    gap: 10px;
    margin-top: 0;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    flex: 1 1;
    padding: 12px 14px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #a1a1aa;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    color: #e5e5e5;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn i {
    font-size: 16px;
  }

  /* Online/Offline Badge */
  .p2p-myads-online-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
  }

  .p2p-myads-online-badge.online {
    background: rgb(34 197 94 / 0%);
    border: 1px solid rgb(34 197 94 / 0%);
    color: #4ade80;
  }

  .p2p-myads-online-badge.offline {
    background: rgba(107, 114, 128, 0.1);
    border: 1px solid rgba(107, 114, 128, 0.2);
    color: #9ca3af;
  }

  .p2p-myads-online-badge.small {
    padding: 3px 8px;
    font-size: 10px;
  }

  .p2p-myads-online-dot {
    width: 6px;
    height: 6px;
  }

  /* Expanded Details */
  .p2p-mobile-expanded-details {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-section {
    margin-bottom: 20px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-title {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    background: rgba(0, 0, 0, 0);
    padding: 0px;
    border-radius: 10px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-item {
    text-align: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-label {
    font-size: 11px;
    color: #828289;
    margin-bottom: 0px;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-value {
    font-size: 12px;
    color: #eaecef;
    font-weight: 500;
  }

  /* Payment Details Cards */
  .p2p-mobile-expanded-details .p2p-myads-payment-details {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-card {
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    padding: 14px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-header {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-type {
    font-size: 14px;
    color: #bd83cb;
  }

  .p2p-mobile-expanded-details .p2p-myads-payment-qr img {
    width: 70px;
    height: 70px;
  }

  /* Closure Info */
  .p2p-mobile-expanded-details .p2p-myads-closure-info {
    background: rgba(107, 114, 128, 0.08);
    border: 1px solid rgba(107, 114, 128, 0.15);
    border-radius: 10px;
    padding: 14px;
  }

  /* Empty State Mobile */
  .p2p-empty-state-mobile {
    text-align: center;
    padding: 48px 24px;
    background: #373F4D;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    margin: 0 4px;
  }

  .p2p-empty-state-mobile .p2p-empty-icon {
    font-size: 56px;
    margin-bottom: 16px;
    opacity: 0.6;
  }

  .p2p-empty-state-mobile p {
    font-size: 16px;
    color: #6b7280;
    margin-bottom: 20px;
  }

  .p2p-empty-state-mobile .p2p-create-ad-btn-small {
    padding: 14px 28px;
    font-size: 14px;
    border-radius: 10px;
  }

  /* Pagination Mobile */
  .p2p-pagination-wrapper.p2p-mobile {
    padding: 16px 4px;
    margin-top: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    background: transparent;
    border: none;
  }

  .p2p-pagination-wrapper .p2p-pagination-info {
    font-size: 13px;
    color: #6b7280;
    order: 2;
  }

  .p2p-pagination-wrapper .p2p-pagination-buttons {
    order: 1;
  }

  .p2p-page-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .p2p-mobile-order-card {
    padding: 14px;
    border-radius: 14px;
  }

  .p2p-mobile-card-header {
    margin-bottom: 14px;
  }

  .p2p-mobile-card-user {
    gap: 10px;
  }

  .p2p-myads-side-badge {
    padding: 5px 10px;
    font-size: 10px;
  }

  .p2p-mobile-card-user-info h4 {
    font-size: 15px;
  }

  /* [UNUSED]
.p2p-mobile-card-price .p2p-value {
    font-size: 18px;
  }
*/

  .p2p-mobile-card-details {
    gap: 12px;
    padding: 14px 0px 0px;
  }

  .p2p-mobile-detail-label {
    font-size: 10px;
  }

  .p2p-mobile-detail-value {
    font-size: 12px;
  }

  .p2p-mobile-payment-badge {
    padding: 5px 10px;
    font-size: 11px;
  }

  .p2p-mobile-card-actions {
    flex-wrap: wrap;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    padding: 10px 12px;
    font-size: 12px;
    min-width: calc(50% - 5px);
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 380px) {
  .p2p-mobile-card-header {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 12px;
  }


  .p2p-mobile-card-user {
    width: 100%;
  }

  .p2p-mobile-card-price {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    flex: 1 1;
    min-width: auto;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: 1fr;
  }

  .p2p-mobile-expanded-details .p2p-myads-expanded-item {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}

/* Close Ad Modal - Mobile Enhanced */
@media (max-width: 576px) {
  .p2p-close-ad-modal {
    border-radius: 20px 20px 0 0;
    max-height: 90vh;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    animation: slideUp 0.3s ease-out;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }

  .p2p-modal-overlay {
    padding: 0;
    align-items: center;
  }

  .p2p-close-ad-modal-header {
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .p2p-close-ad-modal-title {
    font-size: 18px;
  }

  .p2p-close-ad-modal-body {
    padding: 20px;
    max-height: calc(90vh - 180px);
    overflow-y: auto;
  }

  .p2p-close-ad-warning {
    padding: 14px;
    border-radius: 12px;
  }

  .p2p-close-ad-warning-content strong {
    font-size: 14px;
  }

  .p2p-close-ad-warning-content p {
    font-size: 12px;
  }

  .p2p-close-ad-summary {
    border-radius: 12px;
    padding: 14px;
  }

  .p2p-close-ad-summary-header {
    margin-bottom: 14px;
    padding-bottom: 10px;
  }

  .p2p-close-ad-summary-pair {
    font-size: 15px;
  }

  .p2p-myads-container {
    padding: 15px;
  }

  .p2p-myads-title {
    font-size: 17px;
  }

  .p2p-close-ad-summary-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .p2p-close-ad-summary-label {
    font-size: 10px;
  }

  .p2p-close-ad-summary-value {
    font-size: 13px;
  }

  .p2p-close-ad-reason-input {
    min-height: 70px;
    font-size: 14px;
  }

  .p2p-close-ad-modal-footer {
    padding: 16px 20px 24px;
    flex-direction: row;
    gap: 12px;
  }

  .p2p-close-ad-btn-cancel,
  .p2p-close-ad-btn-confirm {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 7px;
  }

  .p2p-close-ad-modal {
    max-width: 90%;
    margin: 0 auto;
  }

}

/* ====================================
     P2P My Ads - Mobile Responsive
     ==================================== */

/* Mobile Header */
@media (max-width: 768px) {
  .p2p-myads-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .p2p-myads-title {
    font-size: 20px;
  }

  .p2p-myads-header .p2p-create-ad-btn {
    width: 100%;
    text-align: center;
    padding: 12px 20px;
    display: flex;
    justify-content: center;
  }
}

/* Mobile Filter Header - Hidden on desktop */
.p2p-mobile-filter-header {
  display: none;
}

/* Mobile Filter Toggle Button */
.p2p-mobile-filter-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #373f4d;
  border: 1px solid #373f4d;
  border-radius: 10px;
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-mobile-filter-toggle:hover {
  background: #373f4d;
  border: 1px solid #373f4d;
}

.p2p-mobile-filter-toggle.active {
  background: #373f4d;
  border-color: #22c55e;
  color: #22c55e;
}

.p2p-mobile-filter-toggle i {
  font-size: 18px;
}

.p2p-mobile-filter-toggle span {
  flex: 1 1;
  text-align: left;
}

.p2p-mobile-active-filters {
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-active-filter-tag {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
}

/* [UNUSED]
.p2p-filter-badge {
  background: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 4px;
}
*/

/* Mobile Filter Section */
@media (max-width: 768px) {

  /* Show mobile filter header */
  .p2p-mobile-filter-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding: 0 4px;
  }

  .p2p-mobile-filter-toggle {
    flex: 1 1;
  }

  /* Hide filter section by default on mobile */
  .p2p-filter-section {
    display: none;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 16px;
    background: #12121a;
    border: 1px solid #2a2a3a;
    border-radius: 12px;
    margin-bottom: 16px;
    animation: slideDown 0.2s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .p2p-filter-section.show {
    display: grid;
  }

  .p2p-filter-group {
    min-width: unset;
  }

  .p2p-filter-section .p2p-find-orders-btn {
    grid-column: 1 / -1;
    width: 100%;
    background: #f3bb2b;
    color: #181a20;
    border: none;
  }

  .p2p-filter-section .p2p-find-orders-btn:hover {
    background: #16a34a;
  }
}

@media (max-width: 480px) {
  .p2p-filter-section.show {
    grid-template-columns: 1fr;
  }

  button.p2p-myads-action-btn {
    padding: 5px 10px !important;
  }

  .p2p-profile-section-desc {
    font-size: 12px !important;
  }

  .p2p-mobile-filter-header {
    flex-wrap: wrap;
  }

  .p2p-mobile-filter-toggle {
    width: 100%;
    flex: none;
    justify-content: flex-start;
  }

  .p2p-mobile-active-filters {
    width: 100%;
    margin-top: 8px;
  }
}

@media (max-width: 400px) {
  .p2p-mobile-filter-toggle {
    padding: 10px 14px;
    font-size: 13px;
  }

  .p2p-active-filter-tag {
    font-size: 11px;
    padding: 3px 8px;
  }
}

/* Hide mobile filter header on desktop */
@media (min-width: 769px) {
  .p2p-mobile-filter-header {
    display: none !important;
  }

  .p2p-filter-section {
    display: flex !important;
  }
}

/* Mobile Stats Cards */
@media (max-width: 768px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .p2p-myads-stat-card {
    padding: 12px 14px;
  }

  .p2p-myads-stat-card-label {
    font-size: 10px;
    margin-bottom: 6px;
  }

  .p2p-myads-stat-card-value {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .p2p-mobile-detail-item {
    flex-direction: row;
    gap: 12px;
  }

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

}

@media (max-width: 400px) {
  .p2p-myads-stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .p2p-myads-stat-card {
    padding: 10px 12px;
  }

  .p2p-myads-stat-card-value {
    font-size: 14px;
  }
}

/* Legacy Mobile Stats Bar */
@media (max-width: 768px) {
  /* [UNUSED]
.p2p-myads-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 14px 16px;
    text-align: center;
  }
*/

  /* [UNUSED]
.p2p-myads-stat-item {
    align-items: center;
  }
*/

  /* [UNUSED]
.p2p-myads-stat-value {
    font-size: 16px;
  }
*/

  /* [UNUSED]
.p2p-myads-stat-label {
    font-size: 10px;
  }
*/
}

/* Mobile Card Improvements */
@media (max-width: 991px) {
  .p2p-orders-table-wrapper {
    display: none;
  }

  .p2p-mobile-orders-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

}

@media (min-width: 992px) {
  .p2p-mobile-orders-list {
    display: none;
  }
}

.p2p-mobile-order-card {
  background: #12121a00;
  border: 1px solid #2c2c2c;
  border-radius: 12px;
  padding: 16px;
  transition: border-color 0.2s;
}

.p2p-mobile-order-card:hover {
  border-color: rgba(55, 65, 81, 0.5);
}

.p2p-mobile-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0px;
  padding-bottom: 14px;
  border-bottom: 1px solid #1e1e2d;
}

.p2p-mobile-card-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* [UNUSED]
button.p2p-mobile-view-btn i {
  color: #535c6b;
}
*/

.p2p-mobile-card-user-info h4 {
  font-size: 13px;
  font-weight: 500;
  color: #d1d5db;
  margin: 0px 0px 2px;
}

.p2p-mobile-card-user-info p {
  margin: 0;
}

/* [UNUSED]
.p2p-mobile-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
*/

.p2p-mobile-card-price {
  text-align: right;
}

/* [UNUSED]
.p2p-mobile-card-price .p2p-value {
  font-size: 16px;
  font-weight: 600;
  color: #a1a1aa;
}
*/

.p2p-mobile-card-price .p2p-currency {
  font-size: 11px;
  color: #6b7280;
}

.p2p-mobile-card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 0px;
  border: none;
}

.p2p-mobile-detail-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-mobile-detail-label {
  font-size: 11px;
  color: #52525b;
  letter-spacing: 0.3px;
}

.p2p-mobile-detail-value {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}

.p2p-mobile-card-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.p2p-mobile-payment-badge {
  padding: 4px 8px;
  background: rgba(55, 65, 81, 0.3);
  border-radius: 4px;
  font-size: 11px;
  color: #9ca3af;
}

.p2p-mobile-card-actions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding-top: 14px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-card-actions .p2p-myads-action-btn {
  flex: unset;
  padding: 10px 8px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
}

@media (max-width: 400px) {
  .p2p-mobile-card-actions {
    grid-template-columns: 1fr 1fr 1fr;
  }

  /* .p2p-mobile-card-actions .p2p-myads-action-btn:first-child {
      grid-column: 1 / -1;
    } */
}

.p2p-myads-action-btn {
  min-height: 32px;
}

/* Mobile Expanded Details */
.p2p-mobile-expanded-details {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #1e1e2d;
}

.p2p-mobile-expanded-details .p2p-myads-expanded-grid {
  grid-template-columns: repeat(1, 1fr);
  gap: 12px;
}

@media (max-width: 480px) {
  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

.p2p-mobile-expanded-details .p2p-myads-payment-details {
  grid-template-columns: 1fr;
}

.p2p-mobile-expanded-details .p2p-myads-payment-card {
  padding: 12px;
}

.p2p-mobile-expanded-details .p2p-myads-payment-qr img {
  width: 60px;
  height: 60px;
}

/* Mobile Pagination */
/* Mobile Pagination */
.p2p-pagination-wrapper.p2p-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin-top: 8px;
  background: rgba(18, 18, 26, 0.6);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-info {
  font-size: 11px;
  color: #6b7280;
  text-align: center;
}

.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-buttons,
.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-controls {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

/* [UNUSED]
.p2p-pagination-wrapper.p2p-mobile .p2p-page-current {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
  background: rgba(255, 220, 136, 0.2);
  border-radius: 6px;
}
*/

.p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {
  min-width: 36px;
  height: 36px;
  font-size: 13px;
}

@media (max-width: 991px) {
  .p2p-pagination-wrapper:not(.p2p-mobile) {
    display: none;
  }

  .p2p-payment-method-qr {
    flex-direction: row-reverse;
    justify-content: space-between;
  }


}

@media (min-width: 992px) {
  .p2p-pagination-wrapper.p2p-mobile {
    display: none;
  }
}

@media (max-width: 400px) {
  .p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {
    min-width: 32px;
    height: 32px;
    font-size: 12px;
  }
}

/* Mobile Empty State */
.p2p-empty-state-mobile {
  text-align: center;
  padding: 48px 20px;
  background: #373F4D;
  border-radius: 12px;
  border: 1px solid #373F4D;
}

.p2p-empty-state-mobile .p2p-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.p2p-empty-state-mobile p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 20px 0;
}

/* Touch-friendly improvements */
@media (max-width: 768px) {
  .p2p-myads-action-btn {
    min-height: 32px;
    min-width: 44px;
  }

  .p2p-filter-select {
    min-height: 44px;
    font-size: 14px;
  }

  .p2p-page-btn {
    min-width: 36px;
    min-height: 36px;
  }

  .p2p-close-ad-reason-input {
    font-size: 16px;
    /* Prevents zoom on iOS */
  }


  .p2p-close-ad-reason-input {
    font-size: 13px;
  }
}

/* ====================================
     P2P Profile Page Styles
     ==================================== */

.p2p-profile-header {
  background: rgba(18, 18, 26, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 24px;
  margin-bottom: 24px;
}

.p2p-profile-header-inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
}

.p2p-profile-user {
  display: flex;
  align-items: center;
  gap: 16px;
}

.p2p-profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  color: #e5e5e5;
  position: relative;
}

.p2p-profile-online-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  background: #4ade80;
  border-radius: 50%;
  border: 2px solid #12121a;
}

.p2p-profile-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.p2p-profile-name {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #e5e5e5;
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-profile-verified-badge {
  display: inline-flex;
  align-items: center;
  color: #bd83cb;
  font-size: 18px;
}

.p2p-profile-verified-badge i {
  font-size: inherit;
}

.p2p-profile-edit-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  font-size: 16px;
  padding: 4px;
  transition: color 0.2s;
}

.p2p-profile-edit-btn:hover {
  color: #e5e5e5;
}

.p2p-profile-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.p2p-profile-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
}

.p2p-profile-badge.verified {
  color: #4ade80;
}

.p2p-profile-funding {
  display: flex;
  align-items: center;
  gap: 24px;
}

/* [UNUSED]
.p2p-profile-funding-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-profile-eye-btn {
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 2px;
}
*/

/* [UNUSED]
.p2p-profile-funding-value {
  color: #9ca3af;
  font-size: 16px;
}
*/

/* Profile Tabs */
.p2p-profile-tabs {
  margin-bottom: 24px;
  overflow-x: auto;
}

.p2p-profile-tabs-inner {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.p2p-profile-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.p2p-profile-tab:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.p2p-profile-tab.active {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

.p2p-profile-tab i {
  font-size: 15px;
}

/* Section Header */
.p2p-profile-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.p2p-profile-section-desc {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

/* Payment Methods Grid */
.p2p-payment-methods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.p2p-payment-method-card {
  background: rgba(18, 18, 26, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
}

.p2p-payment-method-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: none;
  background: rgb(13 13 20 / 14%);
}

.p2p-payment-method-title {
  margin: 0;
  color: #d1d5db;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.p2p-payment-method-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #9ca3af;
  border-radius: 4px;
  font-weight: 500;
}

/* [UNUSED]
.closebtn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  padding: 2px 4px;
}
*/

.p2p-payment-method-actions {
  display: flex;
  gap: 8px;
}

.p2p-payment-method-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
}

.p2p-payment-method-btn.edit {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.1);
  color: #9ca3af;
}

.p2p-payment-method-btn.edit:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e5e5e5;
}

.p2p-payment-method-btn.delete {
  background: rgba(127, 29, 29, 0.15);
  border-color: rgba(153, 27, 27, 0.25);
  color: #fca5a5;
}

.p2p-payment-method-btn.delete:hover {
  background: rgba(127, 29, 29, 0.25);
}

.p2p-payment-method-body {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-payment-method-field {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.p2p-payment-method-label {
  color: #6b7280;
  font-size: 13px;
}

.p2p-payment-method-value {
  color: #d1d5db;
  font-size: 13px;
  text-align: right;
  word-break: break-all;
}

.p2p-payment-method-qr {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-payment-method-qr img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  background: #fff;
  border-radius: 6px;
  padding: 4px;
}

.p2p-payment-method-qr span {
  font-size: 12px;
  color: #6b7280;
}

/* Empty State Card */
.p2p-empty-state-card {
  background: none;
  border-radius: 12px;
  /* border: 1px solid rgba(255, 255, 255, 0.06); */
  padding: 48px 24px;
  text-align: center;
}

.p2p-empty-state-card i {
  font-size: 48px;
  color: #52525b;
  margin-bottom: 16px;
  display: block;
}

.p2p-empty-state-card p {
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 20px 0;
}


@media (max-width: 991px) {

  .p2p-order-status-badge {
    background-color: #333b47 !important;
    color: #878787 !important;
    border-color: #333b47 !important;
  }

  .p2p-order-status-badge.status_complete {
    color: #dddada !important;
  }



  .p2p-profile-avatar {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .p2p-profile-name-row {
    margin-bottom: 0px;
  }

  .p2p-payment-method-card {
    background: rgb(18 18 26 / 0%);
    border: 1px solid #413f3f;
  }

  .p2p-payment-method-body {
    padding: 12px 15px;
  }

  button.p2p-myads-action-btn {
    width: -moz-fit-content;
    width: fit-content;
    align-items: end;
  }

  .rightalien {
    text-align: right;
  }

  .p2p-mobile-card-details {
    grid-template-columns: 1fr;
  }


  .p2p-mobile-detail-item {
    flex-direction: row;
    gap: 12px;
    justify-content: space-between;
  }

  .p2p-mobile-card-details {
    padding: 14px 0px 0px;
  }

  .p2p-mobile-payment-badge {
    padding: 3px 7px;
    margin-left: 4px;
  }

}


@media (max-width: 768px) {
  .p2p-empty-state-card {
    padding: 32px 16px;
    border-radius: 10px;
  }

  .p2p-empty-state-card i {
    font-size: 40px;
    margin-bottom: 12px;
  }

  .p2p-empty-state-card p {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .p2p-mobile-card-price {
    justify-content: end;
  }

}





@media (max-width: 991px) {


  .p2p-layout-wrapper {
    background-color: #181a20;
  }


  .p2p-mobile-detail-label {
    color: #828289;
  }

  /* [UNUSED]
.p2p-mobile-view-btn {
    color: #eaecef;
  }
*/

  .p2p-mobile-detail-value {
    color: #eaecef;
  }

  /* [UNUSED]
.p2p-mobile-view-btn {
    color: #eaecef !important;
  }
*/

  .p2p-mobile-detail-value {
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  /* [UNUSED]
span.p2p-mobile-detail-value.valueprice {
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-mobile-card-avatar {
    width: 36px;
    height: 36px;
  }
*/



}


@media (max-width: 400px) {
  .p2p-empty-state-card {
    padding: 24px 12px;
  }

  .p2p-empty-state-card i {
    font-size: 36px;
  }

  .p2p-empty-state-card p {
    font-size: 12px;
  }
}

/* Add Payment Modal */
.p2p-add-payment-modal {
  background: #12121a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

.p2p-add-payment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.p2p-add-payment-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0;
}

.p2p-modal-close-btn {
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}

.p2p-modal-close-btn:hover {
  color: #e5e5e5;
}

.p2p-add-payment-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1 1;
}

.p2p-add-payment-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  justify-content: flex-end;
}

/* Payment Type List */
.p2p-payment-type-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-payment-type-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-payment-type-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.p2p-payment-type-name {
  font-size: 14px;
  color: #d1d5db;
  font-weight: 500;
}

.p2p-payment-type-item i {
  color: #6b7280;
  font-size: 18px;
}

/* Payment Form */
.p2p-payment-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.p2p-payment-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-payment-form-label {
  font-size: 13px;
  color: #9ca3af;
}

.p2p-required {
  color: #ef4444;
  margin-left: 4px;
}

.p2p-payment-form-input {
  padding: 12px 14px;
  background: rgba(10, 10, 15, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #e5e5e5;
  font-size: 14px;
  transition: border-color 0.2s;
}

.p2p-payment-form-input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.2);
}

.p2p-payment-form-input::placeholder {
  color: #52525b;
}

.p2p-payment-file-input {
  position: relative;
}

.p2p-payment-file-input input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.p2p-payment-file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  background: rgba(10, 10, 15, 0.8);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-payment-file-label:hover {
  border-color: rgba(255, 255, 255, 0.25);
  color: #9ca3af;
}

.p2p-payment-file-label i {
  font-size: 20px;
}

/* Modal Buttons */
.p2p-modal-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.p2p-modal-btn.primary {
  background: rgba(255, 255, 255, 0.1);
  color: #e5e5e5;
}

.p2p-modal-btn.primary:hover {
  background: rgba(255, 255, 255, 0.15);
}

.p2p-modal-btn.secondary {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #9ca3af;
}

.p2p-modal-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.04);
  color: #d1d5db;
}

.p2p-modal-btn.danger {
  background: rgba(153, 27, 27, 0.8);
  color: #fecaca !important;
}

.p2p-modal-btn.danger:hover {
  background: rgba(153, 27, 27, 1);
}

/* Delete Modal */
.p2p-delete-modal {
  background: #12121a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  padding: 32px 24px;
  text-align: center;
  animation: p2p-modal-slide-in 0.2s ease-out;
}

.p2p-delete-modal-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: rgba(127, 29, 29, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-delete-modal-icon i {
  font-size: 28px;
  color: #fca5a5;
}

.p2p-delete-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.p2p-delete-modal-desc {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.p2p-delete-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

/* Profile Mobile Responsive */
@media (max-width: 768px) {
  .p2p-profile-header-inner {
    flex-direction: column;
  }

  .p2p-profile-funding {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .p2p-profile-tabs-inner {
    gap: 8px;
  }

  .p2p-profile-tab {
    padding: 8px 14px;
    font-size: 12px;
  }

  .p2p-profile-section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .p2p-payment-methods-grid {
    grid-template-columns: 1fr;
  }

  .p2p-payment-method-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .p2p-payment-method-actions {
    width: 100%;
  }

  .p2p-payment-method-btn {
    flex: 1 1;
    justify-content: center;
  }

  .p2p-add-payment-modal,
  .p2p-delete-modal {
    margin: 16px;
    max-height: calc(100vh - 32px);
  }
}

/* ============================================
     P2P ORDER DETAILS STYLES
     ============================================ */

/* [UNUSED]
.p2p-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #a8b4c4;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  margin-bottom: 20px;
  transition: color 0.2s;
}
*/

/* [UNUSED]
.p2p-back-btn:hover {
  color: #bd83cb;
}
*/

/* [UNUSED]
.p2p-back-btn i {
  font-size: 20px;
}
*/

/* [UNUSED]
.p2p-order-header {
  background: linear-gradient(135deg, #12121a 0%, #0d0d14 100%);
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  padding: 24px;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-order-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-order-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
*/

/* [UNUSED]
.p2p-order-title {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #22c55e;
}
*/

.p2p-order-status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

/* Timer Styles */
/* [UNUSED]
.p2p-order-timer {
  text-align: center;
}
*/

/* [UNUSED]
.p2p-order-timer.expired {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 12px;
  padding: 12px 20px;
}
*/

/* [UNUSED]
.p2p-timer-label {
  display: block;
  color: #6b7280;
  font-size: 12px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
*/

/* [UNUSED]
.p2p-timer-expired {
  color: #ef4444;
  font-size: 16px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-timer-display {
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-timer-unit {
  text-align: center;
}
*/

/* [UNUSED]
.p2p-timer-digits {
  display: flex;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-timer-digit {
  background: linear-gradient(180deg, #1a1a24 0%, #0d0d14 100%);
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  padding: 10px 14px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  font-family: 'SF Mono', 'Monaco', monospace;
  min-width: 42px;
  text-align: center;
}
*/

/* [UNUSED]
.p2p-timer-unit-label {
  display: block;
  color: #6b7280;
  font-size: 11px;
  margin-top: 4px;
  text-transform: uppercase;
}
*/

/* [UNUSED]
.p2p-timer-separator {
  color: #6b7280;
  font-size: 28px;
  font-weight: 700;
  margin-top: -20px;
}
*/

/* Order Info Row */
/* [UNUSED]
.p2p-order-info-row {
  display: flex;
  gap: 32px;
  padding-top: 20px;
  border-top: 1px solid #1e1e2d;
  flex-wrap: wrap;
}
*/

/* [UNUSED]
.p2p-order-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-order-info-label {
  color: #6b7280;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-order-info-value {
  color: #e5e5e5;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-order-info-value.clickable {
  color: #a8b4c4;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}
*/

/* [UNUSED]
.p2p-order-info-value.clickable:hover {
  color: #bd83cb;
}
*/

/* [UNUSED]
.p2p-order-info-value i {
  font-size: 14px;
}
*/

/* Order Content Layout */
/* [UNUSED]
.p2p-order-content {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(400px, 480px);
  gap: 24px;
}
*/

/* [UNUSED]
.p2p-order-main {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 520px;
}
*/

/* [UNUSED]
.p2p-order-sidebar {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
*/

/* Order Cards */
/* [UNUSED]
.p2p-order-card {
  background: #12121a;
  border-radius: 12px;
  border: 1px solid #1e1e2d;
  padding: 20px;
}
*/

/* [UNUSED]
.p2p-order-card-title {
  margin: 0 0 16px 0;
  color: #e5e5e5;
  font-size: 16px;
  font-weight: 600;
}
*/

/* Order Summary Grid */
/* [UNUSED]
.p2p-order-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}
*/

/* [UNUSED]
.p2p-order-summary-item {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
}
*/

/* [UNUSED]
.p2p-order-summary-item.highlight {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);
  border: 1px solid rgba(34, 197, 94, 0.2);
}
*/

/* [UNUSED]
.p2p-summary-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #e5e5e5;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-summary-value.green {
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-summary-label {
  color: #6b7280;
  font-size: 12px;
}
*/

/* Payment Warning */
/* [UNUSED]
.p2p-payment-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-payment-warning i {
  color: #fbbf24;
  font-size: 18px;
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-payment-warning span {
  color: #fbbf24;
  font-size: 13px;
  line-height: 1.5;
}
*/

/* Payment Method Badges */
/* [UNUSED]
.p2p-payment-method-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
*/

/* Payment Detail Card */
/* [UNUSED]
.p2p-payment-detail-card {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-payment-detail-card:last-child {
  margin-bottom: 0;
}
*/

/* [UNUSED]
.p2p-payment-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-payment-type-badge {
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  color: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-payment-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-payment-qr img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 2px solid #2a2a3a;
  cursor: pointer;
  transition: transform 0.2s;
}
*/

/* [UNUSED]
.p2p-payment-qr img:hover {
  transform: scale(1.05);
}
*/

/* [UNUSED]
.p2p-payment-qr span {
  color: #6b7280;
  font-size: 11px;
}
*/

/* [UNUSED]
.p2p-payment-detail-list {
  display: flex;
  flex-direction: column;
}
*/

/* [UNUSED]
.p2p-payment-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #1e1e2d;
}
*/

/* [UNUSED]
.p2p-payment-detail-row:last-child {
  border-bottom: none;
}
*/

/* [UNUSED]
.p2p-payment-detail-label {
  color: #6b7280;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-payment-detail-value {
  color: #a8b4c4;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}
*/

/* [UNUSED]
.p2p-payment-detail-value:hover {
  color: #bd83cb;
}
*/

/* [UNUSED]
.p2p-payment-detail-value i {
  font-size: 14px;
  opacity: 0.7;
}
*/

/* Order Actions */
/* [UNUSED]
.p2p-order-action-text {
  color: #9ca3af;
  font-size: 14px;
  margin: 0 0 16px 0;
  line-height: 1.6;
}
*/

/* [UNUSED]
.p2p-order-action-text .highlight {
  color: #22c55e;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-order-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
*/

/* [UNUSED]
.p2p-order-actions .p2p-confirm-buy-btn {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-order-actions .p2p-cancel-btn {
  min-width: 140px;
}
*/

/* Order Remarks */
/* [UNUSED]
.p2p-order-remarks {
  color: #9ca3af;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
}
*/

/* User Card */
/* [UNUSED]
.p2p-order-user-card {
  display: flex;
  flex-direction: column;
}
*/

/* [UNUSED]
.p2p-order-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-order-user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-order-user-avatar.buyer {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}
*/

/* [UNUSED]
.p2p-order-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
*/

/* [UNUSED]
.p2p-order-user-avatar span {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-user-online-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #12121a;
}
*/

/* [UNUSED]
.p2p-order-user-info h4 {
  margin: 0 0 2px 0;
  color: #e5e5e5;
  font-size: 15px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-user-role {
  color: #6b7280;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-user-role.buyer {
  color: #22c55e;
}
*/

/* Chat Card */
/* [UNUSED]
.p2p-chat-card {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}
*/

/* [UNUSED]
.p2p-chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-chat-header h4 {
  margin: 0;
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-chat-expand-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-expand-btn:hover {
  background: #1a1a24;
  color: #e5e5e5;
}
*/

/* [UNUSED]
.p2p-chat-preview {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-chat-message {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-chat-preview .p2p-chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c9d1d9;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-chat-bubble {
  background: #1a1a24;
  border-radius: 12px;
  padding: 10px 14px;
  max-width: 85%;
}
*/

/* [UNUSED]
.p2p-chat-bubble p {
  margin: 0;
  color: #d1d5db;
  font-size: 13px;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-chat-time {
  display: block;
  color: #6b7280;
  font-size: 10px;
  margin-top: 4px;
}
*/

/* [UNUSED]
.p2p-chat-input-wrapper {
  display: flex;
  gap: 8px;
  background: #0d0d14;
  border-radius: 8px;
  padding: 8px 12px;
}
*/

/* [UNUSED]
.p2p-chat-input {
  flex: 1;
  background: transparent;
  border: none;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
}
*/

/* [UNUSED]
.p2p-chat-input::placeholder {
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-chat-preview .p2p-chat-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-preview .p2p-chat-send-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);
}
*/

/* Order Details Responsive */
@media (max-width: 1200px) {
  /* [UNUSED]
.p2p-order-content {
    grid-template-columns: minmax(280px, 1fr) minmax(350px, 420px);
  }
*/

  /* [UNUSED]
.p2p-order-main {
    max-width: 100%;
  }
*/


}

@media (max-width: 1024px) {
  /* [UNUSED]
.p2p-order-content {
    display: block;
  }
*/

  /* [UNUSED]
.p2p-order-main {
    max-width: 100%;
  }
*/

  /* [UNUSED]
.p2p-order-sidebar {
    display: flex;
    flex-direction: column;
  }
*/
}

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-order-header {
    padding: 16px;
  }
*/

  /* [UNUSED]
.p2p-order-header-top {
    flex-direction: column;
    align-items: flex-start;
  }
*/

  /* [UNUSED]
.p2p-order-title {
    font-size: 22px;
  }
*/

  /* [UNUSED]
.p2p-order-timer {
    width: 100%;
  }
*/

  /* [UNUSED]
.p2p-timer-display {
    justify-content: center;
  }
*/

  /* [UNUSED]
.p2p-timer-digit {
    padding: 8px 10px;
    font-size: 20px;
    min-width: 36px;
  }
*/

  /* [UNUSED]
.p2p-order-info-row {
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-order-info-item {
    min-width: calc(50% - 8px);
  }
*/

  /* [UNUSED]
.p2p-order-card {
    padding: 16px;
  }
*/

  /* [UNUSED]
.p2p-order-summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
*/

  /* [UNUSED]
.p2p-summary-value {
    font-size: 16px;
  }
*/

  /* [UNUSED]
.p2p-order-actions {
    flex-direction: column;
  }
*/

  /* [UNUSED]
.p2p-order-actions .p2p-confirm-buy-btn,
  .p2p-order-actions .p2p-cancel-btn {
    width: 100%;
    min-width: unset;
  }
*/

  /* [UNUSED]
.p2p-order-sidebar {
    grid-template-columns: 1fr;
  }
*/

  /* [UNUSED]
.p2p-payment-detail-header {
    flex-direction: column;
    gap: 12px;
  }
*/

  /* [UNUSED]
.p2p-payment-qr {
    align-self: flex-start;
  }
*/

  .p2p-main-content.p2p-mobile .p2p-mobile-card-actions .p2p-myads-action-btn {
    min-width: 100%;
  }

}


@media (max-width: 480px) {
  /* [UNUSED]
.p2p-order-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
*/

  .p2p-mobile-card-actions .p2p-myads-action-btn {
    padding: 5px 8px;
    font-size: 11px;
  }

  .p2p-profile-header {
    padding: 16px;
    margin-bottom: 15px;
  }

  .p2p-profile-header-inner.mobileview {
    gap: 15px;
  }


  .p2p-payment-method-title {
    margin: 0;
    font-size: 13px;
    gap: 4px;
  }

  .p2p-payment-method-header.mobileview {
    padding: 12px 15px;
  }

  /* [UNUSED]
.p2p-order-summary-grid {
    grid-template-columns: 1fr;
  }
*/

  /* [UNUSED]
.p2p-timer-digit {
    padding: 6px 8px;
    font-size: 18px;
    min-width: 32px;
  }
*/

  /* [UNUSED]
.p2p-timer-separator {
    font-size: 22px;
  }
*/

  /* [UNUSED]
.p2p-payment-detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
*/
}

/* ============================================
     P2P ORDERS LIST STYLES
     ============================================ */

/* [UNUSED]
.p2p-orders-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-orders-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #e5e5e5;
}
*/

/* [UNUSED]
.p2p-orders-count {
  background: rgba(255, 220, 136, 0.1);
  color: #a8b4c4;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}
*/

/* Order Type Cell */
/* [UNUSED]
.p2p-order-type-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-order-type {
  font-weight: 600;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-order-type.buy {
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-order-type.sell {
  color: #ef4444;
}
*/

/* [UNUSED]
.p2p-order-crypto {
  color: #e5e5e5;
  font-size: 14px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-order-date {
  color: #6b7280;
  font-size: 12px;
}
*/

/* Order ID */
/* [UNUSED]
.p2p-order-id {
  color: #a8b4c4;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}
*/

/* [UNUSED]
.p2p-order-id:hover {
  color: #bd83cb;
}
*/

/* [UNUSED]
.p2p-order-id i {
  font-size: 14px;
  opacity: 0.7;
}
*/

/* Amount Cell */
/* [UNUSED]
.p2p-amount-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-fiat-amount {
  color: #eaecef;
  font-weight: 600;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-crypto-amount {
  color: #9ca3af;
  font-size: 13px;
}
*/

/* Counterparty Cell */
/* [UNUSED]
.p2p-counterparty-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
*/

/* [UNUSED]
.p2p-counterparty-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-counterparty-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
*/

/* [UNUSED]
.p2p-counterparty-avatar span {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-counterparty-name {
  color: #eaecef;
  font-size: 14px;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
*/

/* Order Status Badge */
.p2p-order-status-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background-color: #333b47 !important;
  color: #878787 !important;
  border-color: #333b47 !important;
}

/* Order Action Button */
/* [UNUSED]
.p2p-order-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: rgb(255 220 136 / 0%);
  border: 1px solid rgba(255, 220, 136, 0.2);
  border-radius: 6px;
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
*/

.p2p-order-status-badge.status_complete {
  color: #dddada !important;
}

/* [UNUSED]
.p2p-order-action-btn:hover {
  background: rgba(255, 220, 136, 0.2);
  border-color: rgba(255, 220, 136, 0.4);
}
*/

/* [UNUSED]
.p2p-order-action-btn i {
  font-size: 15px;
}
*/

/* [UNUSED]
.p2p-unread-badge {
  color: #f59e0b;
  font-weight: 600;
  font-size: 12px;
}
*/

/* Table Row Hover */
.p2p-orders-table tbody tr {
  cursor: pointer;
  transition: background 0.2s;
  background: none !important;
  border: none;
}

.volumedatails {
  width: 100%;
  background-color: #2F3641;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #454C59;
}

.volumedatails .p2p-myads-expanded-item {
  flex-direction: row;
  gap: 12px;
}

.p2p-orders-table tbody tr:hover {
  background: #2B313C;
}

/* Mobile Order Card Footer */
/* [UNUSED]
.p2p-mobile-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid #1e1e2d;
}
*/

/* [UNUSED]
.p2p-order-id-mobile {
  color: #eaecef;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-order-id-mobile:hover {
  color: #a8b4c4;
}
*/

/* [UNUSED]
.p2p-order-id-mobile i {
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-mobile-view-btn {
  background: transparent;
  border: none;
  color: #a8b4c4;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
}
*/

/* [UNUSED]
.p2p-mobile-view-btn i {
  font-size: 16px;
}
*/

/* Mobile Card Click Effect */
.p2p-mobile-order-card {
  cursor: pointer;
  transition: all 0.2s;
}

.p2p-mobile-order-card:hover {
  border-color: rgba(255, 220, 136, 0.3);
  background: rgba(255, 220, 136, 0.02);
}

/* Orders Page Responsive */
@media (max-width: 1200px) {
  /* [UNUSED]
.p2p-counterparty-name {
    max-width: 100px;
  }
*/
}

@media (max-width: 992px) {

  .p2p-orders-table th:nth-child(2),
  .p2p-orders-table td:nth-child(2) {
    display: none;
  }

  /* [UNUSED]
.p2p-counterparty-name {
    max-width: 80px;
  }
*/
}

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-orders-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
*/

  /* [UNUSED]
.p2p-orders-title {
    font-size: 20px;
  }
*/
}

/* Order Details - Value Colors */
/* [UNUSED]
.p2p-summary-value.red {
  color: #ef4444 !important;
}
*/

/* [UNUSED]
.p2p-summary-value.green {
  color: #22c55e !important;
}
*/

/* Order Expired Notice */
/* [UNUSED]
.p2p-order-expired-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  color: #ef4444;
  font-size: 14px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-order-expired-notice i {
  font-size: 20px;
}
*/

/* Cancel Button Icon */
/* [UNUSED]
.p2p-cancel-btn i {
  font-size: 16px;
  margin-right: 4px;
}
*/

/* User Payment Method Styles for Sell Orders */
/* [UNUSED]
.p2p-user-payment-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-payment-type-badge {
  background: linear-gradient(135deg, #ffdc88, #f4b609);
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
*/

/* [UNUSED]
.p2p-payment-name {
  font-size: 14px;
  font-weight: 500;
  color: #e2e8f0;
}
*/

/* [UNUSED]
.p2p-payment-detail {
  font-size: 12px;
  color: #94a3b8;
}
*/

/* [UNUSED]
.p2p-no-payment-methods {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-no-payment-methods i {
  font-size: 48px;
  color: #64748b;
  margin-bottom: 8px;
}
*/

/* [UNUSED]
.p2p-no-payment-methods p {
  font-size: 16px;
  font-weight: 500;
  color: #e2e8f0;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-no-payment-methods span {
  font-size: 13px;
  color: #94a3b8;
}
*/

/* [UNUSED]
.p2p-add-payment-btn {
  margin-top: 16px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #ffdc88, #f4b609);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-add-payment-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 220, 136, 0.3);
}
*/

/* Full Payment Option Card (for Sell Orders) */
/* [UNUSED]
.p2p-payment-option-full {
  display: block;
  background: rgba(30, 41, 59, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 12px;
  padding: 0;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-payment-option-full:hover {
  border-color: rgba(255, 220, 136, 0.4);
  background: rgba(30, 41, 59, 0.7);
}
*/

/* [UNUSED]
.p2p-payment-option-full.p2p-selected {
  border-color: #bd83cb;
  background: rgba(255, 220, 136, 0.1);
}
*/

/* [UNUSED]
.p2p-user-payment-card {
  padding: 16px;
}
*/

/* [UNUSED]
.p2p-user-payment-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
}
*/

/* [UNUSED]
.p2p-user-payment-header .p2p-payment-name {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}
*/

/* [UNUSED]
.p2p-user-payment-header input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #bd83cb;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-user-payment-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
*/

/* [UNUSED]
.p2p-payment-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-payment-field-label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
*/

/* [UNUSED]
.p2p-payment-field-value {
  font-size: 14px;
  color: #e2e8f0;
  font-weight: 500;
  word-break: break-all;
}
*/

/* [UNUSED]
.p2p-payment-qr-preview {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  display: flex;
  justify-content: center;
}
*/

/* [UNUSED]
.p2p-payment-qr-preview img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
  padding: 4px;
}
*/

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-payment-option-full {
    border-radius: 10px;
    margin-bottom: 10px;
  }
*/

  /* [UNUSED]
.p2p-user-payment-card {
    padding: 14px;
  }
*/

  /* [UNUSED]
.p2p-user-payment-header {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
*/

  /* [UNUSED]
.p2p-user-payment-header .p2p-payment-name {
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-payment-field-label {
    font-size: 10px;
  }
*/

  /* [UNUSED]
.p2p-payment-field-value {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-payment-qr-preview img {
    width: 70px;
    height: 70px;
  }
*/
}

@media (max-width: 480px) {
  /* [UNUSED]
.p2p-user-payment-details {
    grid-template-columns: 1fr;
  }
*/

  /* [UNUSED]
.p2p-user-payment-card {
    padding: 12px;
  }
*/

  /* [UNUSED]
.p2p-payment-qr-preview img {
    width: 60px;
    height: 60px;
  }
*/
}

/* No Payment Methods State Mobile */
@media (max-width: 768px) {
  /* [UNUSED]
.p2p-no-payment-methods {
    padding: 24px 16px;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods i {
    font-size: 36px;
    margin-bottom: 12px;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods p {
    font-size: 14px;
    margin-bottom: 6px;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods span {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-add-payment-btn {
    padding: 12px 20px;
    font-size: 13px;
    margin-top: 14px;
  }
*/
}

@media (max-width: 400px) {
  /* [UNUSED]
.p2p-no-payment-methods i {
    font-size: 32px;
  }
*/

  /* [UNUSED]
.p2p-no-payment-methods p {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-add-payment-btn {
    padding: 10px 16px;
    font-size: 12px;
    width: 100%;
  }
*/
}

/* ============================================
     P2P ORDER PROGRESS BAR STYLES
     ============================================ */

/* [UNUSED]
.p2p-order-progress-container {
  background: rgba(20, 22, 30, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-order-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
}
*/

/* [UNUSED]
.p2p-progress-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(40, 45, 55, 0.8);
  border: 2px solid rgba(100, 110, 130, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 18px;
  transition: all 0.3s ease;
}
*/

/* [UNUSED]
.p2p-progress-step.active .p2p-progress-icon {
  background: rgba(212, 168, 83, 0.15);
  border-color: #d4a853;
  color: #d4a853;
  box-shadow: 0 0 20px rgba(212, 168, 83, 0.2);
}
*/

/* [UNUSED]
.p2p-progress-step.completed .p2p-progress-icon {
  background: rgba(74, 157, 110, 0.15);
  border-color: #4a9d6e;
  color: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-progress-label {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  max-width: 80px;
  line-height: 1.3;
}
*/

/* [UNUSED]
.p2p-progress-step.active .p2p-progress-label {
  color: #d4a853;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-progress-step.completed .p2p-progress-label {
  color: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-progress-line {
  flex: 1;
  height: 2px;
  background: rgba(100, 110, 130, 0.2);
  margin: 0 -10px;
  margin-bottom: 30px;
  transition: background 0.3s ease;
}
*/

/* [UNUSED]
.p2p-progress-line.completed {
  background: linear-gradient(90deg, #4a9d6e, #4a9d6e);
}
*/

/* Quick Order Info */
/* [UNUSED]
.p2p-order-quick-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
*/

/* [UNUSED]
.p2p-quick-info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-quick-label {
  font-size: 12px;
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-quick-value {
  font-size: 16px;
  font-weight: 600;
  color: #e2e8f0;
}
*/

/* [UNUSED]
.p2p-quick-value.highlight-green {
  color: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-quick-value.highlight-red {
  color: #c75b5b;
}
*/

/* [UNUSED]
.p2p-quick-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.08);
}
*/

/* Progress Responsive */
@media (max-width: 768px) {
  /* [UNUSED]
.p2p-order-progress-container {
    padding: 20px 16px;
  }
*/

  /* [UNUSED]
.p2p-progress-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
*/

  /* [UNUSED]
.p2p-progress-label {
    font-size: 10px;
    max-width: 60px;
  }
*/

  /* [UNUSED]
.p2p-order-quick-info {
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-quick-value {
    font-size: 14px;
  }
*/
}

@media (max-width: 480px) {
  /* [UNUSED]
.p2p-order-progress {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
*/

  /* [UNUSED]
.p2p-progress-line {
    display: none;
  }
*/

  .p2p-payment-type-item {
    padding: 7px 12px;
  }

  .p2p-payment-type-name {
    font-size: 12px;
  }



  /* [UNUSED]
.p2p-progress-step {
    flex: 0 0 calc(50% - 8px);
    padding: 12px;
    background: rgba(30, 35, 45, 0.5);
    border-radius: 12px;
  }
*/

  /* [UNUSED]
.p2p-progress-label {
    max-width: 100%;
  }
*/

  /* [UNUSED]
.p2p-order-quick-info {
    flex-direction: column;
    gap: 12px;
  }
*/

  /* [UNUSED]
.p2p-quick-divider {
    width: 100%;
    height: 1px;
  }
*/

  /* [UNUSED]
.p2p-quick-info-item {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
*/

  .p2p-payment-form-input {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
  }

  .p2p-add-payment-modal-header {
    padding: 10px 18px;
  }

  .p2p-add-payment-modal-title {
    font-size: 15px;
  }

  .p2p-modal-btn {
    gap: 6px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 12px;
  }



}

/* ============================================
     P2P MOBILE TABS FOR ORDER DETAILS
     ============================================ */

/* [UNUSED]
.p2p-mobile-tabs {
  display: none;
  margin-bottom: 20px;
  background: rgba(20, 22, 30, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 6px;
  gap: 6px;
}
*/

/* [UNUSED]
.p2p-mobile-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #8b8b9a;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-mobile-tab i {
  font-size: 18px;
}
*/

/* [UNUSED]
.p2p-mobile-tab:hover {
  background: rgba(255, 255, 255, 0.03);
  color: #c9d1d9;
}
*/

/* [UNUSED]
.p2p-mobile-tab.active {
  background: rgba(74, 157, 110, 0.15);
  color: #4a9d6e;
}
*/

/* Show tabs on tablet and mobile */
@media (max-width: 1024px) {
  /* [UNUSED]
.p2p-mobile-tabs {
    display: flex;
  }
*/

  /* [UNUSED]
.p2p-order-content {
    display: block;
  }
*/

  /* [UNUSED]
.p2p-order-main.mobile-hidden,
  .p2p-order-sidebar.mobile-hidden {
    display: none;
  }
*/

  /* [UNUSED]
.p2p-order-main,
  .p2p-order-sidebar {
    max-width: 100%;
  }
*/

  /* [UNUSED]
.p2p-chat-card {
    height: calc(100vh - 380px);
    min-height: 400px;
    max-height: none;
  }
*/

  /* [UNUSED]
.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 320px);
  }
*/
}

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-mobile-tab {
    padding: 10px 12px;
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-mobile-tab i {
    font-size: 16px;
  }
*/

  /* [UNUSED]
.p2p-chat-card {
    height: calc(100vh - 350px);
    min-height: 350px;
    max-height: none;
  }
*/

  /* [UNUSED]
.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 280px);
  }
*/
}

@media (max-width: 480px) {
  /* [UNUSED]
.p2p-mobile-tabs {
    padding: 4px;
    gap: 4px;
  }
*/

  /* [UNUSED]
.p2p-mobile-tab {
    padding: 10px 8px;
    font-size: 12px;
    gap: 6px;
  }
*/

  /* [UNUSED]
.p2p-mobile-tab i {
    font-size: 15px;
  }
*/

  /* [UNUSED]
.p2p-chat-card {
    height: calc(100vh - 300px);
    min-height: 300px;
    max-height: none;
  }
*/

  /* [UNUSED]
.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {
    height: calc(100vh - 250px);
  }
*/

  /* [UNUSED]
.p2p-chat-messages {
    padding: 12px;
    gap: 10px;
  }
*/
}

/* ============================================
     P2P CHAT USER HEADER STYLES
     ============================================ */

/* [UNUSED]
.p2p-chat-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-chat-user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-chat-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
*/

/* [UNUSED]
.p2p-chat-user-avatar span {
  color: #c9d1d9;
  font-size: 16px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-user-status-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4a9d6e;
  border: 2px solid rgba(20, 22, 30, 1);
}
*/

/* [UNUSED]
.p2p-chat-user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
*/

/* [UNUSED]
.p2p-chat-user-details h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}
*/

/* [UNUSED]
.p2p-chat-user-role {
  font-size: 12px;
  color: #6b7280;
}
*/

/* ============================================
     P2P ORDER DETAILS - PREMIUM CHAT STYLES
     ============================================ */

/* [UNUSED]
.p2p-chat-card {
  display: flex;
  flex-direction: column;
  height: 550px;
  min-height: 500px;
  max-height: 700px;
  padding: 0 !important;
  overflow: hidden;
  flex: 1;
}
*/

/* Ensure chat card children have proper flex behavior */
/* [UNUSED]
.p2p-chat-card>* {
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-chat-card .p2p-chat-messages {
  flex: 1;
  flex-shrink: 1;
  min-height: 200px;
}
*/

/* [UNUSED]
.p2p-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: rgba(20, 20, 30, 0.8);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
*/

/* [UNUSED]
.p2p-chat-header h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #e2e8f0;
}
*/

/* [UNUSED]
.p2p-chat-header h4 i {
  font-size: 18px;
  color: #8b8b9a;
}
*/

/* [UNUSED]
.p2p-chat-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-chat-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-chat-status.online {
  color: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4a9d6e;
  animation: pulse 2s infinite;
}
*/

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* [UNUSED]
.p2p-chat-messages {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: rgba(10, 10, 15, 0.5);
  min-height: 0;
  / * Important for flex child scrolling * /
  scroll-behavior: smooth;
}
*/

/* [UNUSED]
.p2p-chat-messages::-webkit-scrollbar {
  width: 4px;
}
*/

/* [UNUSED]
.p2p-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}
*/

/* [UNUSED]
.p2p-chat-messages::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
*/

/* [UNUSED]
.p2p-chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}
*/

/* [UNUSED]
.p2p-chat-message {
  display: flex;
  gap: 10px;
  max-width: 85%;
}
*/

/* [UNUSED]
.p2p-chat-message.sent {
  align-self: flex-end;
  flex-direction: row-reverse;
}
*/

/* [UNUSED]
.p2p-chat-message.received {
  align-self: flex-start;
}
*/

/* [UNUSED]
.p2p-chat-message.system {
  align-self: center;
  max-width: 90%;
}
*/

/* [UNUSED]
.p2p-chat-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3d4a5c, #2d3748);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c9d1d9;
  font-size: 13px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-chat-bubble {
  background: rgba(30, 35, 45, 0.9);
  border-radius: 16px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}
*/

/* [UNUSED]
.p2p-chat-message.sent .p2p-chat-bubble {
  background: linear-gradient(135deg, rgba(74, 157, 110, 0.2), rgba(74, 157, 110, 0.1));
  border-color: rgba(74, 157, 110, 0.2);
  border-radius: 16px 16px 4px 16px;
}
*/

/* [UNUSED]
.p2p-chat-message.received .p2p-chat-bubble {
  border-radius: 16px 16px 16px 4px;
}
*/

/* [UNUSED]
.p2p-chat-bubble.system {
  background: rgba(139, 139, 154, 0.1);
  border: 1px dashed rgba(139, 139, 154, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
*/

/* [UNUSED]
.p2p-chat-bubble.system i {
  font-size: 18px;
  color: #8b8b9a;
}
*/

/* [UNUSED]
.p2p-chat-bubble p {
  margin: 0;
  color: #c9d1d9;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
}
*/

/* [UNUSED]
.p2p-chat-bubble.system p {
  color: #8b8b9a;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-chat-time {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
  font-size: 11px;
  margin-top: 6px;
}
*/

/* [UNUSED]
.p2p-chat-time i {
  font-size: 12px;
  color: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-chat-image {
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-chat-image img {
  max-width: 200px;
  max-height: 200px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-image img:hover {
  transform: scale(1.02);
}
*/

/* [UNUSED]
.p2p-chat-image-preview {
  position: relative;
  padding: 12px 16px;
  background: rgba(20, 20, 30, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
*/

/* [UNUSED]
.p2p-chat-image-preview img {
  max-width: 120px;
  max-height: 80px;
  border-radius: 8px;
  object-fit: cover;
}
*/

/* [UNUSED]
.p2p-chat-remove-image {
  position: absolute;
  top: 8px;
  left: 120px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(199, 91, 91, 0.9);
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-chat-input-container {
  padding: 12px 16px;
  background: rgba(20, 20, 30, 0.9);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
*/

/* [UNUSED]
.p2p-chat-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(30, 35, 45, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  padding: 6px 8px 6px 12px;
}
*/

/* [UNUSED]
.p2p-chat-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-chat-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #8b8b9a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-action-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #c9d1d9;
}
*/

/* [UNUSED]
.p2p-chat-input {
  flex: 1;
  background: transparent;
  border: none;
  color: #e5e5e5;
  font-size: 14px;
  outline: none;
  padding: 8px 0;
}
*/

/* [UNUSED]
.p2p-chat-input::placeholder {
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-chat-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(74, 157, 110, 0.2);
  border: none;
  color: #6b7280;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-send-btn.active {
  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);
  color: #fff;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-chat-send-btn.active:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);
}
*/

/* Spin animation for loading */
/* [UNUSED]
.p2p-spin {
  animation: p2p-spin 1s linear infinite;
}
*/

@keyframes p2p-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Chat Load More Button */
/* [UNUSED]
.p2p-chat-load-more {
  display: block;
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #8b8b9a;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-chat-load-more:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #c9d1d9;
}
*/

/* [UNUSED]
.p2p-chat-load-more:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
*/

/* Chat Empty State */
/* [UNUSED]
.p2p-chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #6b7280;
  text-align: center;
  padding: 24px;
}
*/

/* [UNUSED]
.p2p-chat-empty i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}
*/

/* [UNUSED]
.p2p-chat-empty p {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #8b8b9a;
}
*/

/* [UNUSED]
.p2p-chat-empty span {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}
*/

/* Chat Typing Indicator */
/* [UNUSED]
.p2p-chat-typing {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 4px 0;
}
*/

/* [UNUSED]
.p2p-typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: rgba(30, 35, 45, 0.9);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}
*/

/* [UNUSED]
.p2p-typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #6b7280;
  animation: typing-bounce 1.4s infinite ease-in-out;
}
*/

/* [UNUSED]
.p2p-typing-indicator span:nth-child(1) {
  animation-delay: 0s;
}
*/

/* [UNUSED]
.p2p-typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}
*/

/* [UNUSED]
.p2p-typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}
*/

@keyframes typing-bounce {

  0%,
  60%,
  100% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-6px);
  }
}

/* Chat Error */
/* [UNUSED]
.p2p-chat-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(199, 91, 91, 0.1);
  border-top: 1px solid rgba(199, 91, 91, 0.2);
  color: #c75b5b;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-chat-error i {
  font-size: 16px;
}
*/

/* Chat Connecting Status */
/* [UNUSED]
.p2p-chat-connecting {
  display: flex;
  align-items: center;
  color: #d4a853;
}
*/

/* [UNUSED]
.p2p-chat-connecting i {
  animation: p2p-spin 1s linear infinite;
}
*/

/* Message Status Icons */
/* [UNUSED]
.p2p-msg-status {
  font-size: 14px;
  margin-left: 4px;
}
*/

/* [UNUSED]
.p2p-msg-status.sending {
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-msg-status.sent {
  color: #8b8b9a;
}
*/

/* [UNUSED]
.p2p-msg-status.delivered {
  color: #8b8b9a;
}
*/

/* [UNUSED]
.p2p-msg-status.read {
  color: #4a9d6e;
}
*/

/* Chat Image Uploading Overlay */
/* [UNUSED]
.p2p-chat-image-uploading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
*/

/* [UNUSED]
.p2p-chat-image-uploading i {
  font-size: 24px;
  color: #fff;
  animation: p2p-spin 1s linear infinite;
}
*/

/* [UNUSED]
.p2p-chat-image {
  position: relative;
}
*/

/* User Status Dot Variants */
/* [UNUSED]
.p2p-user-status-dot.online {
  background: #4a9d6e;
}
*/

/* [UNUSED]
.p2p-user-status-dot.offline {
  background: #6b7280;
}
*/

/* Chat Status Variants */
/* [UNUSED]
.p2p-chat-status.offline {
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-chat-status.offline .p2p-status-dot {
  background: #6b7280;
  animation: none;
}
*/

/* Chat Avatar with image */
/* [UNUSED]
.p2p-chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
*/

/* Emoji Picker */
/* [UNUSED]
.p2p-emoji-container {
  position: relative;
}
*/

/* [UNUSED]
.p2p-emoji-picker {
  position: absolute;
  bottom: 45px;
  left: 0;
  width: 280px;
  max-height: 220px;
  background: rgba(25, 28, 38, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  z-index: 100;
}
*/

/* [UNUSED]
.p2p-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 2px;
  padding: 12px;
  max-height: 200px;
  overflow-y: auto;
}
*/

/* [UNUSED]
.p2p-emoji-grid::-webkit-scrollbar {
  width: 4px;
}
*/

/* [UNUSED]
.p2p-emoji-grid::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
*/

/* [UNUSED]
.p2p-emoji-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.15s;
}
*/

/* [UNUSED]
.p2p-emoji-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.15);
}
*/

/* Premium Order Card Styling */
/* [UNUSED]
.p2p-order-card {
  background: rgba(20, 22, 30, 0.7);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-order-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #c9d1d9;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
*/

/* Chat Responsive */
@media (max-width: 1024px) {
  /* [UNUSED]
.p2p-chat-card {
    height: 480px;
    min-height: 450px;
  }
*/
}

@media (max-width: 768px) {
  /* [UNUSED]
.p2p-chat-card {
    height: 420px;
    min-height: 400px;
  }
*/

  /* [UNUSED]
.p2p-emoji-picker {
    width: 260px;
    left: -50px;
  }
*/

  /* [UNUSED]
.p2p-emoji-grid {
    grid-template-columns: repeat(7, 1fr);
  }
*/
}

@media (max-width: 480px) {
  /* [UNUSED]
.p2p-chat-card {
    height: 380px;
    min-height: 350px;
  }
*/

  /* [UNUSED]
.p2p-chat-header {
    padding: 12px 16px;
  }
*/

  /* [UNUSED]
.p2p-chat-header h4 {
    font-size: 14px;
  }
*/

  /* [UNUSED]
.p2p-emoji-picker {
    width: 240px;
    left: -20px;
  }
*/

  /* [UNUSED]
.p2p-emoji-grid {
    grid-template-columns: repeat(6, 1fr);
  }
*/

  /* [UNUSED]
.p2p-chat-image img {
    max-width: 150px;
    max-height: 150px;
  }
*/
}

/* ====================================
     BINANCE STYLE ORDER DETAILS
     ==================================== */

.binance-order-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.binance-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 16px;
}

.binance-loading p {
  color: #848e9c;
  font-size: 14px;
}

.binance-loading .spinner-border {
  color: #fcd535;
}

/* Order Status Banners */
.order-status-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  animation: bannerSlideIn 0.3s ease-out;
}

@keyframes bannerSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.order-status-banner.success {
  background: linear-gradient(135deg, rgba(14, 203, 129, 0.15) 0%, rgba(14, 203, 129, 0.05) 100%);
  border: 1px solid rgba(14, 203, 129, 0.3);
}

.order-status-banner.cancelled {
  background: linear-gradient(135deg, rgba(246, 70, 93, 0.15) 0%, rgba(246, 70, 93, 0.05) 100%);
  border: 1px solid rgba(246, 70, 93, 0.3);
}

.order-status-banner.disputed {
  background: linear-gradient(135deg, rgba(252, 213, 53, 0.15) 0%, rgba(252, 213, 53, 0.05) 100%);
  border: 1px solid rgba(252, 213, 53, 0.3);
}

.banner-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.order-status-banner.success .banner-icon {
  background: rgba(14, 203, 129, 0.2);
}

.order-status-banner.cancelled .banner-icon {
  background: rgba(246, 70, 93, 0.2);
}

.order-status-banner.disputed .banner-icon {
  background: rgba(252, 213, 53, 0.2);
}

.banner-icon i {
  font-size: 28px;
}

.order-status-banner.success .banner-icon i {
  color: #0ecb81;
}

.order-status-banner.cancelled .banner-icon i {
  color: #f6465d;
}

.order-status-banner.disputed .banner-icon i {
  color: #fcd535;
}

.banner-content {
  flex: 1 1;
}

.banner-content h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
}

.order-status-banner.success .banner-content h3 {
  color: #0ecb81;
}

.order-status-banner.cancelled .banner-content h3 {
  color: #f6465d;
}

.order-status-banner.disputed .banner-content h3 {
  color: #fcd535;
}

.banner-content p {
  margin: 0;
  font-size: 14px;
  color: #848e9c;
  line-height: 1.5;
}

/* Mobile responsive */
@media (max-width: 480px) {
  .order-status-banner {
    padding: 16px;
    gap: 12px;
  }

  .banner-icon {
    width: 40px;
    height: 40px;
  }

  .banner-icon i {
    font-size: 22px;
  }

  .banner-content h3 {
    font-size: 16px;
  }

  .banner-content p {
    font-size: 13px;
  }
}

/* Mobile Tabs */
.binance-mobile-tabs {
  display: none;
  background: #1e2329;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 20px;
  gap: 4px;
}

.binance-tab {
  flex: 1 1;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #848e9c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
}

.binance-tab:hover {
  color: #eaecef;
}

.binance-tab.active {
  background: #2b3139;
  color: #ffffff;
}

.binance-tab i {
  font-size: 18px;
}

/* Main Layout */
.binance-order-layout {
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 24px;
  align-items: start;
}

/* Left Side - Order Details */
.binance-order-details {
  background: #181a20;
  border-radius: 12px;
  padding: 32px;
}

.binance-order-header {
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.header-left {
  flex: 1 1;
}

.binance-order-title {
  font-size: 24px;
  font-weight: 600;
  color: #eaecef;
  margin: 0 0 12px 0;
}

.binance-order-number {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.binance-order-number>span:first-child {
  color: #848e9c;
}

.binance-order-number .order-id {
  color: #eaecef;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.binance-order-number .order-id i {
  color: #848e9c;
  font-size: 16px;
}

.binance-order-number .order-id:hover i {
  color: #fcd535;
}

/* Timer in Header */
.binance-timer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  padding: 12px 16px;
  /* background: rgba(252, 213, 53, 0.1); */
  border: 1px solid rgb(43 49 57);
  border-radius: 8px;
  min-width: 120px;
}

.binance-timer .timer-label {
  font-size: 12px;
  color: #848e9c;
}

.binance-timer .timer-value {
  font-size: 24px;
  font-weight: 700;
  /* color: #fcd535; */
  font-family: 'Roboto Mono', monospace;
  letter-spacing: 1px;
}

.binance-timer.expired {
  background: rgba(246, 70, 93, 0.1);
  border-color: rgba(246, 70, 93, 0.3);
}

.binance-timer .timer-expired {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f6465d;
  font-size: 14px;
  font-weight: 600;
}

.binance-timer .timer-expired i {
  font-size: 18px;
}

/* Progress Steps */
.binance-progress-steps {
  display: flex;
  flex-direction: column;
}

.binance-step {
  display: flex;
  gap: 16px;
}

.step-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32px;
  flex-shrink: 0;
}

.step-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  background: #2b3139;
  color: #848e9c;
  border: 2px solid #2b3139;
}

.binance-step.completed .step-icon {
  background: #0ecb81;
  border-color: #0ecb81;
  color: #181a20;
}

.binance-step.active .step-icon {
  background: #fcd535;
  border-color: #fcd535;
  color: #181a20;
}

.step-line {
  width: 2px;
  flex: 1 1;
  min-height: 24px;
  background: #2b3139;
  margin: 8px 0;
}

.binance-step.completed .step-line {
  background: #0ecb81;
}

.step-content {
  flex: 1 1;
  padding-bottom: 24px;
}

.step-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
  margin: 4px 0 8px 0;
}

.binance-step.pending .step-content h4 {
  color: #848e9c;
}

/* Collapsible Step Header */
.step-header-clickable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 4px 0;
  margin: -4px 0;
}

.step-header-clickable h4 {
  margin: 0;
}

.step-header-clickable i {
  font-size: 20px;
  color: #848e9c;
  transition: transform 0.2s;
}

.step-header-clickable:hover i {
  color: #eaecef;
}

/* Step Dropdown Content */
.step-dropdown-content {
  margin-top: 16px;
  padding: 16px;
  background: #1e2329;
  border-radius: 8px;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Order Info Grid */
.order-info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-info-row .info-label {
  font-size: 14px;
  color: #848e9c;
}

.order-info-row .info-value {
  font-size: 14px;
  color: #eaecef;
  display: flex;
  align-items: center;
  gap: 6px;
}

.order-info-row .info-value.highlight {
  color: #fcd535;
  font-weight: 600;
  font-size: 16px;
}

.order-info-row .info-value.copyable {
  cursor: pointer;
}

.order-info-row .info-value.copyable i {
  color: #848e9c;
  font-size: 14px;
  transition: color 0.2s;
}

.order-info-row .info-value.copyable:hover i {
  color: #fcd535;
}

.step-desc {
  font-size: 14px;
  color: #848e9c;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

/* Payment Card */
.binance-payment-card {
  background: #1e2329;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2b3139;
}

.payment-type {
  background: rgba(252, 213, 53, 0.15);
  color: #fcd535;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.payment-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.payment-qr img {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
}

.payment-qr span {
  font-size: 11px;
  color: #848e9c;
}

.payment-qr:hover span {
  color: #fcd535;
}

.payment-details-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payment-row .label {
  font-size: 14px;
  color: #848e9c;
}

.payment-row .value {
  font-size: 14px;
  color: #eaecef;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.payment-row .value i {
  color: #848e9c;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}

.payment-row .value i {
  opacity: 1;
  /* color: #fcd535; */
}

.payment-row.highlight .value.amount {
  font-size: 18px;
  font-weight: 600;
}

.payment-row .value.amount.green {
  color: #0ecb81;
}

.payment-row .value.amount.red {
  color: #f6465d;
}

.payment-row .value.amount i {
  opacity: 1;
}

.payment-row.buyer-info {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #2b3139;
}

.payment-row .value.name {
  background: #2b3139;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: default;
}

/* Action Buttons */
.binance-action-buttons {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.binance-btn {
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}

.binance-btn.primary {
  background: #fcd535;
  color: #181a20;
}

.binance-btn.primary:hover {
  background: #e5c32e;
}

.binance-btn.primary:disabled {
  background: #5c5424;
  color: #848e9c;
  cursor: not-allowed;
}

.binance-btn i {
  margin-right: 6px;
}

/* Appeal Button */
.binance-btn.appeal {
  background: transparent;
  border: 1px solid #f0b90b;
  color: #f0b90b;
}

.binance-btn.appeal:hover:not(:disabled) {
  background: rgba(240, 185, 11, 0.1);
}

.binance-btn.appeal.disabled,
.binance-btn.appeal:disabled {
  border-color: #848e9c;
  color: #848e9c;
  cursor: not-allowed;
  opacity: 0.7;
}

.binance-btn.appeal-submit {
  background: #f0b90b;
  color: #181a20;
}

.binance-btn.appeal-submit:hover:not(:disabled) {
  background: #d9a80a;
}

.binance-btn.appeal-submit:disabled {
  background: #5c5424;
  color: #848e9c;
  cursor: not-allowed;
}

/* Appeal Modal */
.appeal-modal {
  max-width: 500px;
}

.appeal-modal .binance-modal-header h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f0b90b;
}

.appeal-info {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(240, 185, 11, 0.1);
  border: 1px solid rgba(240, 185, 11, 0.2);
  border-radius: 8px;
  margin-bottom: 16px;
}

.appeal-info i {
  color: #f0b90b;
  font-size: 20px;
  flex-shrink: 0;
}

.appeal-info p {
  color: #eaecef;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

.appeal-form {
  margin-bottom: 16px;
}

.appeal-form label {
  display: block;
  color: #eaecef;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
}

.appeal-textarea {
  width: 100%;
  padding: 12px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  color: #eaecef;
  font-size: 14px;
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.appeal-textarea:focus {
  outline: none;
  border-color: #f0b90b;
}

.appeal-textarea::placeholder {
  color: #5e6673;
}

.char-count {
  text-align: right;
  color: #848e9c;
  font-size: 12px;
  margin-top: 6px;
}

.appeal-warning {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
}

.appeal-warning i {
  color: #ef4444;
  font-size: 20px;
  flex-shrink: 0;
}

.appeal-warning p {
  color: #eaecef;
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 6px 0;
}

.appeal-warning ul {
  margin: 0;
  padding-left: 16px;
  color: #848e9c;
  font-size: 12px;
}

.appeal-warning li {
  margin-bottom: 4px;
}

.appeal-modal .binance-modal-footer {
  display: flex;
  gap: 12px;
}

.appeal-modal .binance-modal-footer .binance-btn {
  flex: 1 1;
}

/* ====================================
     WELCOME P2P POPUP
     ==================================== */
.welcome-modal {
  max-width: 480px;
}

.welcome-modal .binance-modal-header h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fcd535;
}

.welcome-modal .binance-modal-header h3 i {
  font-size: 24px;
}

/* Welcome Tabs */
.welcome-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  background: #181a20;
  padding: 4px;
  border-radius: 8px;
}

.welcome-tab {
  flex: 1 1;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #848e9c;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.welcome-tab:hover {
  color: #eaecef;
}

.welcome-tab.active {
  background: #2b3139;
  color: #fcd535;
}

/* Welcome Content */
.welcome-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* How to Pay Steps */
.welcome-step {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #181a20;
  border-radius: 12px;
}

.welcome-step .step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: linear-gradient(135deg, #fcd535 0%, #f0b90b 100%);
  color: #181a20;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50%;
}

.welcome-step .step-info h6 {
  color: #eaecef;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.welcome-step .step-info p {
  color: #848e9c;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* Things to Note */
.welcome-note {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #181a20;
  border-radius: 12px;
}

.welcome-note .note-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: rgba(252, 213, 53, 0.1);
  border-radius: 10px;
}

.welcome-note .note-icon i {
  font-size: 20px;
  color: #fcd535;
}

.welcome-note .note-info h6 {
  color: #eaecef;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.welcome-note .note-info p {
  color: #848e9c;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
}

/* Welcome Modal Footer */
.welcome-modal .binance-modal-footer {
  padding-top: 16px;
}

.welcome-modal .binance-modal-footer .binance-btn.full-width {
  width: 100%;
}

/* ====================================
     TIME WARNING & PAYMENT RECEIVED POPUPS
     ==================================== */

/* Time Warning Popup */
.time-warning-content {
  text-align: center;
  padding: 20px 0;
}

.warning-icon-large {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: rgba(245, 158, 11, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-icon-large i {
  font-size: 40px;
  color: #f59e0b;
}

.time-warning-content h4 {
  font-size: 24px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.time-warning-content p {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.time-warning-actions {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.2);
  border-radius: 10px;
  padding: 16px;
  margin-top: 20px;
  text-align: left;
}

.warning-action-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #d1d5db;
}

.warning-action-item:last-child {
  margin-bottom: 0;
}

.warning-action-item i {
  font-size: 16px;
  color: #f59e0b;
  flex-shrink: 0;
}

/* Payment Received Popup */
.payment-received-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon-large {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: rgba(34, 197, 94, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon-large i {
  font-size: 40px;
  color: #22c55e;
}

.payment-received-content h4 {
  font-size: 22px;
  font-weight: 600;
  color: #e5e5e5;
  margin: 0 0 12px 0;
}

.payment-received-content p {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 24px 0;
}

.payment-received-content p strong {
  color: #e5e5e5;
  font-weight: 600;
}

.payment-received-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 24px 0;
}

.info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 16px;
  font-weight: 600;
  color: #e5e5e5;
}

.payment-received-warning {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 10px;
  padding: 16px;
  margin-top: 24px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
}

.payment-received-warning i {
  font-size: 20px;
  color: #ef4444;
  flex-shrink: 0;
  margin-top: 2px;
}

.payment-received-warning p {
  margin: 0;
  font-size: 13px;
  color: #fca5a5;
  line-height: 1.6;
}

.payment-received-warning p strong {
  color: #fee2e2;
  font-weight: 600;
}

/* ====================================
     P2P TRADE RESTRICTIONS & BALANCE
     ==================================== */

/* Verification Required Button */
/* [UNUSED]
.p2p-verification-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: rgba(252, 213, 53, 0.15);
  border: 1px solid rgba(252, 213, 53, 0.3);
  border-radius: 6px;
  color: #fcd535;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-verification-btn:hover {
  background: rgba(252, 213, 53, 0.25);
  border-color: #fcd535;
}
*/

/* [UNUSED]
.p2p-verification-btn i {
  font-size: 16px;
}
*/

/* Trade Restricted Container */
/* [UNUSED]
.p2p-trade-restricted {
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-trade-restricted .p2p-buy-btn.disabled,
.p2p-trade-restricted .p2p-sell-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
*/

/* Condition Tooltip */
/* [UNUSED]
.p2p-condition-tooltip {
  position: relative;
  display: flex;
  align-items: center;
  cursor: help;
}
*/

/* [UNUSED]
.p2p-condition-tooltip i {
  font-size: 18px;
  color: #848e9c;
  transition: color 0.2s;
}
*/

/* [UNUSED]
.p2p-condition-tooltip:hover i {
  color: #fcd535;
}
*/

/* [UNUSED]
.p2p-tooltip-content {
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  min-width: 240px;
  padding: 12px;
  background: #1e2329;
  border: 1px solid #2b3139;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: all 0.2s;
  z-index: 100;
}
*/

/* [UNUSED]
.p2p-condition-tooltip:hover .p2p-tooltip-content {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
*/

/* [UNUSED]
.p2p-tooltip-content span {
  display: block;
  font-size: 13px;
  color: #eaecef;
  line-height: 1.4;
}
*/

/* [UNUSED]
.p2p-tooltip-content .p2p-tooltip-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #f6465d;
}
*/

/* Sell with Balance */
/* [UNUSED]
.p2p-sell-with-balance {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-balance-info {
  font-size: 11px;
  color: #848e9c;
  pointer-events: none;
}
*/

/* [UNUSED]
.p2p-available-balance {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
  display: block;
}
*/

/* [UNUSED]
.p2p-sell-fee-display {
  display: block;
  font-size: 11px;
  color: #F3BB2B;
  margin-top: 4px;
}
*/

/* Mobile Styles */
/* [UNUSED]
.p2p-mobile-verification-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: rgba(252, 213, 53, 0.15);
  border: 1px solid rgba(252, 213, 53, 0.3);
  border-radius: 8px;
  color: #fcd535;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-mobile-verification-btn i {
  font-size: 18px;
}
*/

/* [UNUSED]
.p2p-mobile-trade-restricted {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
*/

/* [UNUSED]
.p2p-mobile-trade-restricted .p2p-mobile-buy-btn.disabled,
.p2p-mobile-trade-restricted .p2p-mobile-sell-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
*/

/* [UNUSED]
.p2p-mobile-condition-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(248, 113, 113, 0.1);
  border-radius: 6px;
}
*/

/* [UNUSED]
.p2p-mobile-condition-info i {
  font-size: 16px;
  color: #f6465d;
}
*/

/* [UNUSED]
.p2p-mobile-condition-info span {
  font-size: 12px;
  color: #f6465d;
}
*/

/* [UNUSED]
.p2p-mobile-sell-with-balance {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}
*/

/* [UNUSED]
.p2p-mobile-balance-info {
  font-size: 12px;
  color: #848e9c;
  text-align: center;
  pointer-events: none;
}
*/


.binance-btn.secondary {
  background: transparent;
  color: #848e9c;
  border: 1px solid #2b3139;
}

.binance-btn.secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.binance-expired-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(246, 70, 93, 0.1);
  border: 1px solid rgba(246, 70, 93, 0.3);
  border-radius: 8px;
  margin-top: 16px;
}

.binance-expired-notice i {
  color: #f6465d;
  font-size: 18px;
}

.binance-expired-notice span {
  color: #f6465d;
  font-size: 14px;
}

/* Chat Section */
.binance-chat-section {
  position: sticky;
  top: 24px;
}

.binance-chat-card {
  background: #181a20;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 650px;
}

.binance-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #2b3139;
}

.chat-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chat-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #2b3139;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #eaecef;
  font-size: 18px;
  position: relative;
  overflow: hidden;
}

.chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chat-avatar .status-dot {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #848e9c;
  border: 2px solid #181a20;
}

.chat-avatar .status-dot.online {
  background: #0ecb81;
}

.chat-user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chat-username {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #eaecef;
}

.chat-username .verified {
  color: #11cb81;
  font-size: 16px;
}

.chat-user-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #848e9c;
}

.chat-user-meta .online-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.chat-user-meta .online-status i {
  font-size: 8px;
}

.chat-user-meta .online-status.online {
  color: #0ecb81;
}

.chat-user-meta .divider {
  color: #2b3139;
}

.chat-user-meta .user-role {
  background: rgba(132, 142, 156, 0.15);
  color: #848e9c;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
}

/* [UNUSED]
.chat-user-meta .trades-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}
*/

/* [UNUSED]
.chat-user-meta .trades-link:hover {
  color: #eaecef;
}
*/

/* [UNUSED]
.chat-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
*/

/* [UNUSED]
.chat-menu-btn:hover {
  background: #2b3139;
  color: #eaecef;
}
*/

/* Chat Notice */
.binance-chat-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #2b3139;
  border-bottom: 1px solid #3a3f47;
  position: relative;
}

.binance-chat-notice i {
  color: #ffdc88;
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.binance-chat-notice p {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
  margin: 0;
  flex: 1 1;
}

.notice-close {
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.notice-close:hover {
  color: #eaecef;
}

/* Chat Messages */
.binance-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #0b0e11;
  min-height: 0;
}

.binance-chat-messages::-webkit-scrollbar {
  width: 4px;
}

.binance-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.binance-chat-messages::-webkit-scrollbar-thumb {
  background: #2b3139;
  border-radius: 4px;
}

.load-more-btn {
  background: #2b3139;
  border: none;
  color: #848e9c;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin: 0 auto 8px;
}

.load-more-btn:hover {
  background: #3a3f47;
  color: #eaecef;
}

.chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #848e9c;
  gap: 8px;
}

.chat-empty i {
  font-size: 48px;
  opacity: 0.3;
}

.chat-empty p {
  margin: 0;
  font-size: 14px;
}

/* Chat Messages */
.chat-message {
  display: flex;
  max-width: 85%;
}

.chat-message.sent {
  margin-left: auto;
  justify-content: flex-end;
}

.chat-message.received {
  margin-right: auto;
}

.chat-message.system {
  max-width: 100%;
  justify-content: center;
  margin: 12px 0;
}

.system-bubble {
  background: rgba(30, 35, 41, 0.8);
  padding: 8px 20px;
  border-radius: 20px;
  text-align: center;
  border: 1px dashed rgba(132, 142, 156, 0.3);
}

.system-bubble p {
  margin: 0;
  font-size: 12px;
  color: #848e9c;
  font-style: italic;
}

.message-bubble {
  padding: 10px 14px;
  border-radius: 12px;
  max-width: 100%;
}

.chat-message.sent .message-bubble {
  background: #0ecb81;
  border-bottom-right-radius: 4px;
}

.chat-message.received .message-bubble {
  background: #2b3139;
  border-bottom-left-radius: 4px;
}

.message-bubble p {
  margin: 0;
  font-size: 14px;
  color: #eaecef;
  word-wrap: break-word;
  line-height: 1.4;
}

.chat-message.sent .message-bubble p {
  color: #181a20;
}

.message-image {
  margin-bottom: 8px;
  position: relative;
}

.message-image img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
}

.image-uploading {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.image-uploading i {
  color: #fff;
  font-size: 24px;
}

.message-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
}

.message-time {
  font-size: 11px;
  color: rgba(234, 236, 239, 0.5);
}

.chat-message.sent .message-time {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status {
  font-size: 14px;
}

.msg-status.sending {
  color: rgba(24, 26, 32, 0.4);
}

.msg-status.sent {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status.delivered {
  color: rgba(24, 26, 32, 0.6);
}

.msg-status.read {
  color: #1890ff;
}

/* Typing Indicator */
.typing-bubble {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: #2b3139;
  border-radius: 12px;
  border-bottom-left-radius: 4px;
}

.typing-bubble span {
  width: 8px;
  height: 8px;
  background: #848e9c;
  border-radius: 50%;
  animation: typingBounce 1.4s infinite ease-in-out;
}

.typing-bubble span:nth-child(1) {
  animation-delay: 0s;
}

.typing-bubble span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-bubble span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingBounce {

  0%,
  60%,
  100% {
    transform: translateY(0);
  }

  30% {
    transform: translateY(-6px);
  }
}

/* Chat Error */
.chat-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(246, 70, 93, 0.1);
  color: #f6465d;
  font-size: 12px;
}

.chat-error i {
  font-size: 16px;
}

/* Image Preview */
.image-preview {
  padding: 12px 16px;
  background: #1e2329;
  border-top: 1px solid #2b3139;
  position: relative;
  display: flex;
  align-items: center;
}

.image-preview img {
  max-height: 80px;
  border-radius: 8px;
}

.image-preview button {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 6px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background: rgb(252 212 53 / 62%);
  border: none;
  color: #000000;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chat Input */
.binance-chat-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #1e2329;
  border-top: 1px solid #2b3139;
}

.binance-chat-input input[type="text"] {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #eaecef;
  font-size: 14px;
  padding: 8px 0;
}

.binance-chat-input input[type="text"]::placeholder {
  color: #5e6673;
}

.input-action {
  width: 36px;
  height: 36px;
  padding: 0px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  transition: all 0.2s;
}

.input-action:hover {
  color: #eaecef;
}

.input-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.input-actions-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.emoji-container {
  position: relative;
}

.emoji-picker {
  position: absolute;
  bottom: 48px;
  right: 0;
  width: 280px;
  background: #1e2329;
  border: 1px solid #2b3139;
  border-radius: 12px;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.emoji-picker::-webkit-scrollbar {
  width: 4px;
}

.emoji-picker::-webkit-scrollbar-thumb {
  background: #2b3139;
  border-radius: 4px;
}

.emoji-picker button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s;
}

.emoji-picker button:hover {
  background: #2b3139;
  transform: scale(1.1);
}

.send-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #2b3139;
  border: none;
  color: #5e6673;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
}

.send-btn.active {
  background: #0ecb81;
  color: #181a20;
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Spinning animation */
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ====================================
     BINANCE MODAL STYLES
     ==================================== */

.binance-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.binance-modal {
  background: #1e2329;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.2s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.binance-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #2b3139;
}

.binance-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #eaecef;
}

.modal-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 0px;
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  transition: all 0.2s;
}

.modal-close-btn:hover {
  background: #2b3139;
  color: #eaecef;
}

.binance-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* Cancel Warning */
.cancel-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: rgba(246, 70, 93, 0.1);
  border: 1px solid rgba(246, 70, 93, 0.2);
  border-radius: 8px;
  margin-bottom: 24px;
}

.cancel-warning>i {
  color: #f6465d;
  font-size: 24px;
  flex-shrink: 0;
}

.cancel-warning p {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
}

.cancel-warning span {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.4;
}

/* Cancel Reasons */
.cancel-reasons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reason-label {
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
  margin-bottom: 8px;
}

.reason-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.reason-option:hover {
  border-color: #3a3f47;
}

.reason-option.selected {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.reason-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #3a3f47;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.reason-option.selected .reason-radio {
  background: #fcd535;
  border-color: #fcd535;
}

.reason-radio i {
  color: #181a20;
  font-size: 12px;
  font-weight: bold;
}

.reason-option span {
  font-size: 14px;
  color: #eaecef;
}

/* Custom Reason Input */
.custom-reason-input {
  margin-top: 12px;
  position: relative;
}

.custom-reason-input textarea {
  width: 100%;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  color: #eaecef;
  font-size: 14px;
  resize: none;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
}

.custom-reason-input textarea:focus {
  border-color: #fcd535;
}

.custom-reason-input textarea::placeholder {
  color: #5e6673;
}

.custom-reason-input .char-count {
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 11px;
  color: #5e6673;
}

/* Modal Footer */
.binance-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #2b3139;
}

.binance-modal-footer .binance-btn {
  flex: 1 1;
}

.binance-btn.danger {
  background: #f6465d;
  color: #fff;
}

.binance-btn.danger:hover {
  background: #d83a4f;
}

.binance-btn.danger:disabled {
  background: #5e3a40;
  color: #848e9c;
  cursor: not-allowed;
}

.binance-btn.full-width {
  width: 100%;
}

/* Confirm Checklist */
.confirm-checklist {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.checklist-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.checklist-item i.success {
  color: #0ecb81;
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.checklist-item span {
  font-size: 14px;
  color: #eaecef;
  line-height: 1.5;
}

.checklist-item strong {
  color: #fcd535;
}

/* Payment Proof Section */
.payment-proof-section {
  margin-bottom: 20px;
}

.payment-proof-section label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #eaecef;
  margin-bottom: 4px;
}

.payment-proof-section label .required {
  color: #f6465d;
  margin-left: 2px;
}

.proof-desc {
  font-size: 12px;
  color: #848e9c;
  margin: 0 0 12px 0;
}

.proof-upload-area {
  border: 2px dashed #2b3139;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.proof-upload-area:hover {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #848e9c;
}

.upload-placeholder i {
  font-size: 36px;
}

.upload-placeholder span {
  font-size: 13px;
}

.proof-preview {
  position: relative;
  display: inline-block;
}

.proof-preview img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 8px;
  object-fit: cover;
}

.remove-proof {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  padding: 0px;
  height: 24px;
  border-radius: 50%;
  background: #f6465d;
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

/* Modal Warning */
.modal-warning {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(252, 213, 53, 0.1);
  border: 1px solid rgba(252, 213, 53, 0.2);
  border-radius: 8px;
}

.modal-warning i {
  color: #fcd535;
  font-size: 20px;
  flex-shrink: 0;
}

.modal-warning p {
  margin: 0;
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
}

/* Release Warning */
.release-warning {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #2b3139;
  border-radius: 8px;
  margin-bottom: 20px;
}

.release-warning>i {
  color: #848e9c;
  font-size: 20px;
  flex-shrink: 0;
}

.release-warning p {
  margin: 0 0 4px 0;
  font-size: 14px;
  color: #eaecef;
}

.release-warning span {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.4;
}

/* Release Confirm Checkbox */
.release-confirm-checkbox {
  margin-top: 20px;
}

.checkbox-container {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  transition: all 0.2s;
}

.checkbox-container:hover {
  border-color: #3a3f47;
}

.checkbox-container.checked {
  border-color: #fcd535;
  background: rgba(252, 213, 53, 0.05);
}

.checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #3a3f47;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.checkbox-container.checked .checkbox-box {
  background: #fcd535;
  border-color: #fcd535;
}

.checkbox-box i {
  color: #181a20;
  font-size: 12px;
  font-weight: bold;
}

.checkbox-container span {
  font-size: 14px;
  color: #eaecef;
  line-height: 1.4;
}

.checkbox-container span strong {
  color: #fcd535;
}

/* Mobile Modal */
@media (max-width: 480px) {
  .binance-modal-overlay {
    padding: 0;
    /* align-items: flex-end; */
  }

  /* [UNUSED]
.p2p-mobile-card-user-info .p2p-mobile-status-row {
    flex-wrap: nowrap;
  }
*/

  .binance-modal {
    max-width: 100%;
    max-height: 85vh;
    border-radius: 16px 16px 0 0;
  }

  .binance-modal-header {
    padding: 16px 20px;
  }

  .binance-modal-body {
    padding: 20px;
  }

  .binance-modal-footer {
    padding: 16px 20px;
  }

  .reason-option {
    padding: 10px 14px;
  }
}

/* Mobile Hidden */
.mobile-hidden {
  display: block;
}

/* Responsive */
@media (max-width: 1200px) {
  .binance-order-layout {
    grid-template-columns: 1fr 380px;
    gap: 20px;
  }

  /* [UNUSED]
.p2p-buy-btn {
    padding: 6px 12px;
    white-space: nowrap;
    font-size: 12px;
  }
*/
}

@media (max-width: 1024px) {
  .binance-mobile-tabs {
    display: flex;
  }

  .binance-order-layout {
    display: block;
  }

  .mobile-hidden {
    display: none !important;
  }

  .binance-chat-card {
    height: calc(100vh - 200px);
    min-height: 500px;
  }
}

@media (max-width: 768px) {
  .binance-order-container {
    padding: 16px;
  }

  .binance-order-details {
    padding: 20px;
  }

  .binance-order-header {
    flex-direction: column;
    gap: 16px;
  }

  .binance-timer {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .binance-timer .timer-value {
    font-size: 20px;
  }

  .binance-order-title {
    font-size: 20px;
  }

  .binance-action-buttons {
    flex-direction: column;
  }

  .binance-btn {
    width: 100%;
    text-align: center;
  }

  .binance-chat-card {
    height: calc(100vh - 180px);
  }

  .chat-username span {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .order-info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

@media (max-width: 480px) {
  .binance-order-container {
    padding: 12px;
  }

  .binance-order-details {
    padding: 16px;
  }

  .binance-order-title {
    font-size: 18px;
  }

  .step-content h4 {
    font-size: 14px;
  }

  .binance-payment-card {
    padding: 16px;
  }

  .payment-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .payment-row .value {
    width: 100%;
    justify-content: space-between;
  }

  .payment-row .value i {
    opacity: 1;
  }

  .binance-chat-card {
    height: calc(100vh - 160px);
    min-height: 400px;
  }

  .emoji-picker {
    width: 240px;
    grid-template-columns: repeat(6, 1fr);
    right: -40px;
  }

  .message-image img {
    max-width: 150px;
    max-height: 150px;
  }

  .binance-timer {
    padding: 8px 12px;
  }

  .binance-tab {
    padding: 8px 12px;
    font-size: 13px;
  }

  .p2p-page-content {
    padding: 18px;
  }

  .order-info-row .info-label {
    font-size: 12px;
  }

  .order-info-row .info-value {
    font-size: 12px;
  }

  .payment-row.highlight .value.amount {
    font-size: 14px;
  }

  .binance-expired-notice {
    padding: 8px 12px;
    margin-top: 10px;
  }

  .step-desc {
    font-size: 12px;
  }

  .binance-chat-input {
    gap: 2px;
    padding: 8px 5px;
  }

  .p2p-mobile-header {
    padding: 10px 15px;
    margin-bottom: 10px;
  }
}

/* ====================================
     LIGHT THEME OVERRIDES
     ==================================== */

body.light_theme .p2p-layout-wrapper {
  background-color: #fff;
}

body.light_theme .p2p-main-content {
  color: #000;
}

body.light_theme .p2p-page-content {
  color: #000;
}

body.light_theme .p2p-mobile-header {
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-hamburger:hover {
  background-color: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-hamburger-line {
  background-color: #000;
}

body.light_theme .p2p-mobile-logo-text {
  color: #000;
}

body.light_theme .p2p-page-title {
  color: #333;
}

body.light_theme .p2p-dashboard-container h2,
body.light_theme .p2p-dashboard-container h3,
body.light_theme .p2p-dashboard-container h4,
body.light_theme .p2p-dashboard-container .p2p-section-header,
body.light_theme .p2p-dashboard-container .p2p-orders-title {
  color: #333;
}

body.light_theme .p2p-profile-funding,
body.light_theme .p2p-profile-funding-label,
body.light_theme .p2p-profile-funding-value {
  color: #333;
}

body.light_theme .p2p-sidebar {
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

/* [UNUSED]
body.light_theme .p2p-sidebar-logo {
  border-bottom: 1px solid #e5e5e5;
}
*/

/* [UNUSED]
body.light_theme .p2p-logo-text {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-logo-icon {
  background: #f5f5f5;
}
*/

body.light_theme .p2p-nav-item {
  color: #4E4E4E;
}

body.light_theme .p2p-sidebar-close {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .p2p-sidebar-close:hover {
  background: rgba(244, 182, 9, 0.1);
}

body.light_theme .p2p-sidebar-footer {
  border-top: 1px solid #e5e5e5;
}

body.light_theme .p2p-back-link {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #4E4E4E;
}

body.light_theme .p2p-back-link:hover {
  background: #e5e5e5;
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-sidebar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

body.light_theme .p2p-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

body.light_theme h4.p2p-profile-tab {
  color: #000;
}

/* [UNUSED]
body.light_theme .p2p-toggle-wrapper {
  background: #f5f5f5;
}
*/

/* body.light_theme .p2p-toggle-btn {
    color: #555;
  } */

body.light_theme .p2p-filter-label {
  color: #555;
}

/* body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active) {
    color: #333;
    border: 1px solid #d0d0d0;
    background-color: #f5f5f5;
  }
  
  body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active):hover {
    background-color: #e8e8e8;
    border-color: #c0c0c0;
    color: #000;
  } */

body.light_theme .p2p-filter-select {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right;
}

body.light_theme .p2p-filter-section.myadsfillter .p2p-filter-select {
  background: #e2e2e2;
  border: 1px solid #d5d5d5;
}

body.light_theme .p2p-filter-select:focus {
  border-color: #F4B609;
}

body.light_theme .p2p-find-orders-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-find-orders-btn:hover {
  background: rgba(244, 182, 9, 0.1);
  border-color: #F4B609;
}

body.light_theme .p2p-orders-table-wrapper {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table thead {
  background: #f5f5f5;
}

body.light_theme .p2p-orders-table th {
  color: #333;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table tbody tr {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-orders-table tbody tr:hover {
  background: rgba(244, 182, 9, 0.05);
}

/* [UNUSED]
body.light_theme .p2p-advertiser-info h4 {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-advertiser-stats {
  color: #555;
}
*/

/* [UNUSED]
body.light_theme .p2p-rating-value {
  color: #4E4E4E;
}
*/

/* [UNUSED]
body.light_theme .p2p-price-value {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-limit-label {
  color: #555;
}
*/

/* [UNUSED]
body.light_theme .p2p-limit-value {
  color: #000;
}
*/

body.light_theme .p2p-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
  color: #000;
}

body.light_theme .p2p-pagination-wrapper {
  background: #f5f5f5;
  border-top: 1px solid #e5e5e5;
}

body.light_theme .p2p-pagination-info {
  color: #555;
}

/* [UNUSED]
body.light_theme .p2p-page-current {
  color: #000;
  background: rgba(244, 182, 9, 0.2);
}
*/

body.light_theme .p2p-page-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #333;
}

body.light_theme .p2p-page-btn:hover {
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-page-btn.p2p-active {
  background: #F4B609;
  border-color: #F4B609;
  color: #000;
}

body.light_theme .p2p-page-dots {
  color: #555;
}

/* [UNUSED]
body.light_theme .p2p-order-action-btn {
  color: #D1AA67;
  border-color: rgba(184, 134, 11, 0.4);
}
*/

/* [UNUSED]
body.light_theme .p2p-order-action-btn:hover {
  color: #9a7209;
  background: rgba(244, 182, 9, 0.1);
}
*/

/* [UNUSED]
body.light_theme .p2p-order-action-text {
  color: #555;
}
*/

body.light_theme .p2p-dashboard-container a:not(.p2p-nav-item) {
  color: #D1AA67;
}

body.light_theme .p2p-dashboard-container a:not(.p2p-nav-item):hover {
  color: #9a7209;
}

body.light_theme .p2p-empty-state-card {
  color: #555;
}

/* [UNUSED]
body.light_theme .p2p-expanded-content {
  background: #fff;
  border: 1px solid #e5e5e5;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-user-details h5 {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-user-details p {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-stat-value {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-stat-label {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-payments h6 {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-remarks h6 {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-remarks p {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-input-header {
  border: 1px solid #e5e5e5;
  background: #ececec;
}
*/

/* [UNUSED]
body.light_theme .p2p-input-header label {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-selector-left {
  color: #666;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-fee-breakdown-box {
  background: rgb(236 236 236);
  border: 1px solid #2a2a3a1a;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-fee-breakdown-row span:last-child {
  color: #6f6f6f;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option-full {
  background: rgb(213 213 213 / 50%);
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option-full:hover {
  background-color: rgb(213 213 213 / 50%);
}
*/

/* [UNUSED]
body.light_theme .p2p-user-payment-header .p2p-payment-name {
  color: #6e6e6e;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-field-label {
  color: #646464;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-field-value {
  color: #848484;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-input-wrapper {
  border: 1px solid #e5e5e5;
  background: #fff;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-input-wrapper:focus-within {
  border-color: #F4B609;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-input-wrapper input {
  color: #000;
  background: transparent;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-input-wrapper input::placeholder {
  color: #999;
}
*/

/* [UNUSED]
body.light_theme .p2p-expanded-input-error {
  color: #dc3545;
}
*/

/* [UNUSED]
body.light_theme .p2p-price-info {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-selector-full {
  border: 1px solid #e5e5e5;
  background: #fff;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-selector-full:hover {
  border-color: #F4B609;
}
*/

/* [UNUSED]
body.light_theme .p2p-cancel-btn {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-cancel-btn:hover {
  border-color: #F4B609;
}
*/

body.light_theme .p2p-mobile-order-card {
  border: 1px solid #e5e5e5;
  background: #fff;
}

body.light_theme .p2p-mobile-card-user-info h4 {
  color: #000;
}

body.light_theme .p2p-mobile-card-user-info p {
  color: #aaa;
}

/* [UNUSED]
body.light_theme .p2p-mobile-card-price .p2p-value {
  color: #000;
}
*/

body.light_theme .p2p-mobile-card-price .p2p-currency {
  color: #aaa;
}

body.light_theme .p2p-mobile-card-details {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-mobile-detail-label {
  color: #aaa;
}

body.light_theme .p2p-mobile-detail-value {
  color: #000;
}

body.light_theme .p2p-mobile-payment-badge {
  background: rgba(244, 182, 9, 0.1);
  color: #000;
}

/* [UNUSED]
body.light_theme .p2p-mobile-expanded-section {
  border-top: 1px solid #e5e5e5;
}
*/

body.light_theme .p2p-modal-content {
  background: #ffffffad;
  border: 2px solid #F3F4F6;
}

/* [UNUSED]
body.light_theme .p2p-modal-header {
  border-bottom: 1px solid #e5e5e5;
}
*/

/* [UNUSED]
body.light_theme .p2p-modal-title {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option:hover {
  border-color: #F4B609;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option.p2p-selected {
  background: rgba(244, 182, 9, 0.1);
  border-color: #F4B609;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-option span {
  color: #000;
}
*/

body.light_theme .p2p-dashboard-container {
  color: #000;
}

body.light_theme .p2p-profile-header {
  background: #ececec;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-profile-name {
  color: #000;
}

body.light_theme .p2p-dashboard-container.p2p-profile-container {
  background-color: #f0f0f0;
}

body.light_theme .p2p-myads-stat-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-myads-stat-card-label {
  color: #555;
}

body.light_theme .p2p-myads-stat-card-value {
  color: #000;
}

body.light_theme .p2p-profile-section-desc {
  color: #555;
}

body.light_theme .p2p-payment-methods-grid {
  gap: 16px;
}

body.light_theme .p2p-payment-method-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-payment-method-title {
  color: #000;
}

body.light_theme .p2p-payment-method-label {
  color: #555;
}

body.light_theme .p2p-payment-method-value {
  color: #000;
}

body.light_theme .p2p-empty-state-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #555;
}

body.light_theme .p2p-add-payment-modal {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-add-payment-modal-header {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .p2p-add-payment-modal-title {
  color: #000;
}

body.light_theme .p2p-modal-close-btn {
  color: #aaa;
}

body.light_theme .p2p-modal-close-btn:hover {
  background: #f5f5f5;
  color: #000;
}

body.light_theme .p2p-payment-type-item {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-type-item:hover {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.05);
}

body.light_theme .p2p-payment-type-name {
  color: #000;
}

body.light_theme .p2p-payment-form-label {
  color: #000;
}

body.light_theme .p2p-payment-form-input {
  background: #f5f5f5 !important;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-form-input:focus {
  border-color: #F4B609;
  outline: none;
}

body.light_theme .p2p-payment-file-label {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-payment-file-label:hover {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.05);
}

body.light_theme .p2p-modal-btn.primary {
  background: #F4B609;
  color: #000;
}

body.light_theme .p2p-modal-btn.primary:hover {
  background: #e5a608;
}

body.light_theme .p2p-modal-btn.secondary {
  background: #fff;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .p2p-modal-btn.secondary:hover {
  border-color: #F4B609;
  background: #f5f5f5;
}

body.light_theme .p2p-delete-modal {
  background: #fff;
  border: 1px solid #e5e5e5;
}

body.light_theme .p2p-delete-modal-title {
  color: #000;
}

body.light_theme .p2p-delete-modal-desc {
  color: #aaa;
}

body.light_theme .p2p-modal-btn.danger {
  background: #dc3545;
  color: #fff;
}

body.light_theme .p2p-myads-action-btn {
  background: #F4B609;
  color: #000;
}

body.light_theme .p2p-myads-action-btn:hover {
  background: #e5a608;
}

/* [UNUSED]
body.light_theme .p2p-order-card {
  background: #fff;
  border: 1px solid #e5e5e5;
}
*/

/* [UNUSED]
body.light_theme .p2p-order-card-title {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-order-summary-item {
  background: #f5f5f5;
}
*/

/* [UNUSED]
body.light_theme .p2p-summary-value {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-summary-label {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-detail-card {
  background: #f5f5f5;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-detail-header {
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-detail-value {
  color: #000;
}
*/

body.light_theme .binance-modal {
  background: #fff;
}

body.light_theme .binance-modal-header {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .binance-modal-header h3 {
  color: #000;
}

body.light_theme .modal-close-btn {
  color: #aaa;
}

body.light_theme .modal-close-btn:hover {
  background: #f5f5f5;
  color: #000;
}

/* [UNUSED]
body.light_theme .binance-order-info {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}
*/

body.light_theme .info-label {
  color: #aaa;
}

body.light_theme .info-value {
  color: #000;
}

body.light_theme .payment-row {
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .payment-row .label {
  color: #aaa;
}

body.light_theme .payment-row .value {
  color: #000;
}

/* [UNUSED]
body.light_theme .binance-chat-container {
  background: #fff;
  border: 1px solid #e5e5e5;
}
*/

body.light_theme .binance-chat-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
}

body.light_theme .binance-chat-header h4 {
  color: #000;
}

/* [UNUSED]
body.light_theme .binance-message {
  background: #f5f5f5;
  color: #000;
}
*/

/* [UNUSED]
body.light_theme .binance-message.own {
  background: rgba(244, 182, 9, 0.1);
}
*/

body.light_theme .binance-chat-input {
  background: #ececec;
  border-top: 1px solid #e5e5e5;
}

body.light_theme .binance-chat-section.mobile-hidden .binance-chat-input input {
  background: #f5f5f500;
  border: 1px solid #e5e5e500;
}

body.light_theme .binance-chat-input input {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .binance-chat-input input::placeholder {
  color: #999;
}

body.light_theme .binance-btn.primary {
  background: #F4B609;
  color: #000;
}

body.light_theme .binance-btn.primary:hover {
  background: #e5a608;
}

body.light_theme .chat-username {
  color: #636363;
}

body.light_theme .system-bubble {
  background: rgb(222 222 222);
}

body.light_theme .cancel-warning {
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.2);
}

body.light_theme .cancel-warning p {
  color: #000;
}

body.light_theme .cancel-warning span {
  color: #aaa;
}

body.light_theme .appeal-info {
  background: rgba(244, 182, 9, 0.1);
  border: 1px solid rgba(244, 182, 9, 0.2);
}

body.light_theme .appeal-info p {
  color: #000;
}

body.light_theme .appeal-form label {
  color: #000;
}

body.light_theme .appeal-textarea {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  color: #000;
}

body.light_theme .appeal-textarea::placeholder {
  color: #999;
}

body.light_theme .binance-tab {
  color: #aaa;
}

body.light_theme .binance-tab.active {
  color: #F4B609;
  border-bottom-color: #F4B609;
}

body.light_theme .step-desc {
  color: #aaa;
}

body.light_theme .p2p-loading-container {
  color: #aaa;
}

/* P2P Create Post Styles */
/* [UNUSED]
.p2p-create-post-container {
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 24px;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}
*/

@media (max-width: 1023px) {
  /* [UNUSED]
.p2p-create-post-container {
    grid-template-columns: 1fr;
  }
*/
}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-container {
    gap: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-form-card {
  background: #2B313C;
  border-radius: 12px;
  border: 1px solid #2B313C;
  padding: 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  position: relative;
}
*/

@media (max-width: 1023px) {
  /* [UNUSED]
.p2p-create-post-form-card {
    padding: 24px;
  }
*/
}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-form-card {
    border-radius: 12px;
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-header {
  margin-bottom: 32px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-header {
    margin-bottom: 20px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px 0;
}
*/



/* [UNUSED]
.p2p-create-post-subtitle {
  color: #949AA4;
  font-size: 14px;
  margin: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-subtitle {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-stepper {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 32px;
  gap: 0;
  width: 100%;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-stepper {
    margin-bottom: 20px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 400;
  background: transparent;
  border: 1px solid #ffffff60;
  color: #ffffff60;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-step-circle {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-step-circle.active {
  background: #F3BB2B;
  border-color: #F3BB2B;
  color: #000;
}
*/

/* [UNUSED]
.p2p-create-post-step-circle.completed {
  background: #F3BB2B;
  border-color: #F3BB2B;
  color: #000;
}
*/

/* [UNUSED]
.p2p-create-post-step-line {
  width: 310px;
  height: 1px;
  background: #ffffff60;
  transition: all 0.3s ease;
}
*/

@media (max-width: 1023px) {
  /* [UNUSED]
.p2p-create-post-step-line {
    width: 80px;
  }
*/
}

@media (max-width: 480px) {
  /* [UNUSED]
.p2p-create-post-step-line {
    width: 60px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-step-line.completed {
  background: #F3BB2B;
}
*/

/* [UNUSED]
.p2p-create-post-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 20px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-section-title {
    font-size: 14px;
    margin-bottom: 16px;
  }
*/

  .p2p-nav-item {
    gap: 10px;
    padding: 10px 12px 10px 20px;
    font-size: 13px;
  }



  /* [UNUSED]
.pricehigh_box_item_title {
    font-size: 18px;
  }
*/

  /* [UNUSED]
.pricehigh_box_item_title span {
    font-size: 10px;
  }
*/

}

/* [UNUSED]
.p2p-create-post-section-icon {
  color: #ffdc88;
}
*/

/* Buy/Sell tabs - Create Post */
/* [UNUSED]
.p2p-create-post-tabs-container {
  display: flex;
  gap: 0;
  margin-bottom: 32px;
  border-bottom: 1px solid #2a2a3a;
}
*/

/* [UNUSED]
.p2p-create-post-tab-btn {
  background: transparent;
  border: none;
  color: #888;
  font-size: 16px;
  font-weight: 400;
  padding: 14px 20px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}
*/

/* [UNUSED]
.p2p-create-post-tab-btn.active {
  color: #fff;
  font-weight: 500;
  border-bottom: 2px solid #fff;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-tabs-container {
    margin-bottom: 24px;
  }
*/

  /* [UNUSED]
.p2p-create-post-tab-btn {
    font-size: 14px;
    padding: 12px 16px;
  }
*/
}

/* Market price info box (USDT/INR block) - Create Post */
/* [UNUSED]
.p2p-create-post-info-box {
  background: #373f4d;
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
}
*/

/* [UNUSED]
.p2p-create-post-market-loading {
  text-align: center;
  padding: 10px;
}
*/

/* [UNUSED]
.p2p-create-post-market-loading span {
  color: #666;
}
*/

/* [UNUSED]
.p2p-create-post-market-pair {
  color: #9ca3af;
  font-size: 14px;
  margin-bottom: 10px;
}
*/

/* [UNUSED]
.p2p-create-post-market-row {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 6px;
}
*/

/* [UNUSED]
.p2p-create-post-market-row:last-child {
  margin-bottom: 0;
}
*/

/* [UNUSED]
.p2p-create-post-market-bullet {
  margin-right: 6px;
}
*/

/* [UNUSED]
.p2p-create-post-market-error {
  color: #d97706;
  font-size: 13px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-info-box {
    padding: 12px;
  }
*/

  /* [UNUSED]
.p2p-create-post-market-pair {
    font-size: 13px;
  }
*/

  /* [UNUSED]
.p2p-create-post-market-row {
    font-size: 12px;
  }
*/
}

/* Section spacing (steps) */
/* [UNUSED]
.p2p-create-post-section-spacing {
  margin-top: 32px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-section-spacing {
    margin-top: 24px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-field-error-with-margin {
  margin-top: -12px;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-create-post-select-with-icon {
  padding-left: 36px;
}
*/

/* [UNUSED]
.p2p-create-post-section-title-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}
*/

/* [UNUSED]
.p2p-create-post-section-icon-inline {
  color: #F3BB2B;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-section-title-inline {
    font-size: 14px;
    margin-bottom: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-payment-required-error {
  color: #ef4444;
  font-size: 12px;
  font-weight: 400;
  margin-left: 8px;
}
*/

/* [UNUSED]
.p2p-create-post-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  flex-shrink: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-checkbox {
    width: 18px;
    height: 18px;
  }
*/
}

/* Preview Card */
/* [UNUSED]
.p2p-preview-card {
  background: #12121a;
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  position: sticky;
  top: 20px;
}
*/

@media (max-width: 991px) {
  /* [UNUSED]
.p2p-preview-card {
    position: relative;
    top: 0;
  }
*/
}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card {
    border-radius: 12px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}
*/

/* [UNUSED]
.p2p-preview-card-header-buy {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);
}
*/

/* [UNUSED]
.p2p-preview-card-header-sell {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-header {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
*/

/* [UNUSED]
.p2p-preview-card-ad-label {
  color: #888;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-preview-card-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-title {
    font-size: 18px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-preview-card-badge-buy {
  color: #22c55e;
  background: rgba(34, 197, 94, 0.2);
}
*/

/* [UNUSED]
.p2p-preview-card-badge-sell {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.2);
}
*/

/* [UNUSED]
.p2p-preview-card-price-block {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  text-align: center;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-price-block {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-price-label {
  color: #666;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-preview-card-price-value {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -1px;
}
*/

/* [UNUSED]
.p2p-preview-card-price-value-buy {
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-preview-card-price-value-sell {
  color: #ef4444;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-price-value {
    font-size: 28px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-price-fiat {
  font-size: 16px;
  color: #888;
}
*/

/* [UNUSED]
.p2p-preview-card-market {
  color: #666;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}
*/

/* [UNUSED]
.p2p-preview-card-details {
  padding: 20px 24px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-details {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-preview-card-grid-item {
  background: #0d0d14;
  padding: 12px;
  border-radius: 10px;
}
*/

/* [UNUSED]
.p2p-preview-card-grid-label {
  color: #666;
  font-size: 11px;
  display: block;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-preview-card-grid-value {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-preview-card-grid-value-muted {
  color: #888;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-preview-card-payment-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-preview-card-payment-time-label {
  color: #666;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-preview-card-payment-time-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-preview-card-block {
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-preview-card-section-label {
  color: #666;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}
*/

/* [UNUSED]
.p2p-preview-card-badges-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-preview-card-badge-pm {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-preview-card-empty-pm {
  color: #666;
  font-size: 12px;
  padding: 6px 12px;
  background: #0d0d14;
  border-radius: 6px;
  border: 1px dashed #2a2a3a;
}
*/

/* [UNUSED]
.p2p-preview-card-badge-kyc {
  padding: 6px 12px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: 6px;
  color: #4ade80;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-preview-card-badge-days {
  padding: 6px 12px;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 6px;
  color: #fbbf24;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-preview-card-remarks {
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
  border-left: 3px solid #ffdc88;
}
*/

/* [UNUSED]
.p2p-preview-card-remarks-title {
  color: #666;
  font-size: 11px;
  display: block;
  margin-bottom: 6px;
}
*/

/* [UNUSED]
.p2p-preview-card-remarks-text {
  color: #aaa;
  font-size: 13px;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-preview-card-footer {
  padding: 16px 24px;
  border-top: 1px solid #1e1e2d;
  background: #0a0a0f;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-preview-card-footer {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-preview-card-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
*/

/* [UNUSED]
.p2p-preview-card-footer-fee {
  color: #666;
  font-size: 11px;
}
*/

/* [UNUSED]
.p2p-preview-card-footer-note {
  color: #888;
  font-size: 11px;
}
*/

/* [UNUSED]
.p2p-mobile-preview-toggle {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 1px solid #2a2a3a;
}
*/

@media (max-width: 991px) {
  /* [UNUSED]
.p2p-mobile-preview-toggle {
    display: flex;
  }
*/
}

/* [UNUSED]
.p2p-mobile-preview-toggle-text {
  color: #888;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-preview-highlight-buy {
  color: #22c55e;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-preview-highlight-sell {
  color: #ef4444;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-mobile-preview-view {
  color: #ffdc88;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-create-post-mobile-preview-wrap {
  margin-bottom: 16px;
}
*/

/* Sell modal (Add Payment Method) */
/* [UNUSED]
.p2p-sell-modal .modal-content {
  background: #12121a;
  border: 1px solid #2a2a3a;
  border-radius: 16px;
}
*/

/* [UNUSED]
.p2p-sell-modal .modal-header {
  border-bottom: 1px solid #2a2a3a;
  padding: 20px 24px;
}
*/

/* [UNUSED]
.p2p-sell-modal .modal-header .modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
*/

/* [UNUSED]
.p2p-sell-modal .modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}
*/

/* [UNUSED]
.p2p-sell-modal-tips {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
*/

/* [UNUSED]
.p2p-sell-modal-tips-icon {
  color: #f59e0b;
}
*/

/* [UNUSED]
.p2p-sell-modal-tips-text {
  color: #d4a574;
  font-size: 13px;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-sell-modal-label {
  color: #888;
  font-size: 13px;
  margin-bottom: 8px;
  display: block;
}
*/

/* [UNUSED]
.p2p-sell-modal-spinner-wrap {
  text-align: center;
  padding: 20px;
}
*/

/* [UNUSED]
.p2p-sell-modal-methods-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-sell-modal-methods-grid {
    grid-template-columns: 1fr;
  }
*/
}

/* [UNUSED]
.p2p-sell-modal-method-card {
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
*/

/* [UNUSED]
.p2p-sell-modal-method-card:hover {
  border-color: #ffdc88;
}
*/

/* [UNUSED]
.p2p-sell-modal-method-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
*/

/* [UNUSED]
.p2p-sell-modal-method-name {
  color: #fff;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-sell-modal-method-badge {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
}
*/

/* [UNUSED]
.p2p-sell-modal-back-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #2a2a3a;
}
*/

/* [UNUSED]
.p2p-sell-modal-back-btn {
  background: transparent;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
}
*/

/* [UNUSED]
.p2p-sell-modal-back-title {
  color: #ffdc88;
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-sell-modal-kyc-warning {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #d4a574;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-sell-modal-input-wrap {
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-sell-modal-input {
  width: 100%;
  padding: 12px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
}
*/

/* [UNUSED]
.p2p-sell-modal-input.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
*/

/* [UNUSED]
.p2p-sell-modal-input-bg {
  width: 100%;
  padding: 12px 16px;
  background: #1a1a2e;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  cursor: not-allowed;
  opacity: 0.6;
}
*/

/* [UNUSED]
.p2p-sell-modal-small {
  color: #666;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}
*/

/* [UNUSED]
.p2p-sell-modal-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-zone {
  border: 2px dashed #2a2a3a;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-zone.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-zone.disabled .p2p-sell-modal-file-input {
  cursor: not-allowed;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-preview {
  max-width: 100px;
  max-height: 100px;
  border-radius: 8px;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-placeholder-icon {
  color: #666;
  font-size: 24px;
  margin-bottom: 8px;
}
*/

/* [UNUSED]
.p2p-sell-modal-file-placeholder-text {
  color: #888;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-sell-modal-warning-box {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 10px;
  padding: 12px 16px;
  margin-top: 8px;
}
*/

/* [UNUSED]
.p2p-sell-modal-warning-text {
  color: #f87171;
  font-size: 12px;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-sell-modal-label-optional {
  color: #666;
}
*/

/* [UNUSED]
.p2p-sell-modal-label-required {
  color: #ef4444;
}
*/

/* [UNUSED]
.p2p-sell-modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}
*/

/* [UNUSED]
.p2p-sell-modal-btn-cancel {
  flex: 1;
  padding: 12px 20px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-sell-modal-btn-confirm {
  flex: 1;
  padding: 12px 20px;
  background: #ffdc88;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-sell-modal-btn-confirm:disabled,
.p2p-sell-modal-btn-confirm.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
*/

/* [UNUSED]
.p2p-sell-modal-spinner-lg {
  text-align: center;
  padding: 40px;
}
*/

/* [UNUSED]
.p2p-buyer-modal-desc {
  color: #888;
  margin-bottom: 20px;
}
*/

/* [UNUSED]
.p2p-buyer-modal-spinner-wrap {
  text-align: center;
  padding: 20px;
}
*/

/* [UNUSED]
.p2p-confirm-post-fee {
  color: #F3BB2B;
}
*/

/* [UNUSED]
.p2p-create-post-input-group {
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-input-group {
    margin-bottom: 10px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-label {
  display: block;
  color: #A2A9B6;
  font-size: 13px;
  margin-bottom: 5px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-label {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-select-wrap {
  position: relative;
  width: 100%;
}
*/

/* [UNUSED]
.p2p-create-post-select-wrap .p2p-create-post-select-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}
*/

/* [UNUSED]
.p2p-create-post-select-wrap .p2p-create-post-select-icon img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
}
*/

/* [UNUSED]
.p2p-create-post-select-wrap .p2p-create-post-select-icon-fiat {
  font-size: 16px;
  font-weight: 600;
  color: #F3BB2B;
}
*/

/* [UNUSED]
.p2p-create-post-select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 12px 44px 12px 36px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  color: #A2A9B6;
  font-size: 13px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23888' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px 12px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-select {
    padding: 12px 40px 12px 14px;
    font-size: 13px;
    background-position: right 12px center;
  }
*/
}

/* [UNUSED]
.p2p-create-post-select.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-input {
  width: 100%;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-input {
    padding: 12px 14px;
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-input.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-input-with-suffix {
  display: flex;
  align-items: center;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
*/

/* [UNUSED]
.p2p-create-post-input-with-suffix.error {
  border: 1px solid #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-input-inner {
  flex: 1;
  padding: 14px 16px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  min-width: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-input-inner {
    padding: 12px 14px;
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.pricehigh_box {
  width: 100%;
  background-color: #373D4B;
  padding: 24px;
  border-radius: 12px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}
*/

/* [UNUSED]
.pricehigh_box_item_title {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 24px;
  font-weight: 600;
}
*/

/* [UNUSED]
.pricehigh_box_item_container {
  gap: 90px;
}
*/

/* [UNUSED]
.helpguide {
  font-size: 12px;
}
*/

/* [UNUSED]
.helpguide i {
  font-size: 16px;
}
*/

/* [UNUSED]
.btnnextback {
  margin-top: 24px;
  gap: 24px;
}
*/

/* [UNUSED]
.btnnextback button {
  font-size: 16px;
  color: #fff;
  padding: 16px 20px;
  width: 100%;
  border-radius: 4px;
  border: none;
  background-color: #3C424C;
  font-weight: 500;
}
*/

/* [UNUSED]
.btnnextback button.nextbtn {
  background-color: #5EBA89;
}
*/

/* [UNUSED]
.btnnextback button.backbtn {
  width: 40%;
}
*/

/* [UNUSED]
.pricehigh_box_item_title span {
  font-size: 12px;
  font-weight: 300;
}
*/

/* [UNUSED]
.p2p-create-post-input-suffix {
  padding: 14px 16px;
  color: #b9b9b9;
  font-size: 14px;
  border-left: 1px solid #585858;
  white-space: nowrap;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-input-suffix {
    padding: 12px 10px;
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-available-text {
  color: #22c55e;
  font-size: 12px;
  margin-left: 8px;
  margin-right: 8px;
  display: inline;
}
*/

/* [UNUSED]
.p2p-create-post-tab-btn:hover {
  background-color: transparent;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-tab-btn.active {
  color: #5a5a5a;
  border-bottom: 2px solid #676464;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-available-text {
    font-size: 10px;
    display: none;
  }
*/
}

/* [UNUSED]
.p2p-create-post-fee-box {
  background: linear-gradient(90deg, rgba(34, 197, 94, 0.1) 0%, transparent 100%);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 10px;
  padding: 12px 16px;
  color: #22c55e;
  font-size: 14px;
  margin-top: 20px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-fee-box {
    padding: 10px 14px;
    font-size: 13px;
    margin-top: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-info-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-info-box {
    padding: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-pair-text {
  color: #f59e0b;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-pair-text {
    font-size: 14px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-info-text {
  color: #a8b4c4;
  font-size: 13px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 4px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-info-text {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-payment-method {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-payment-method {
    padding: 12px 14px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-payment-method.active {
  border-color: #ffdc88;
  background: rgba(255, 220, 136, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-payment-method.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #ffdc88;
  flex-shrink: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-checkbox {
    width: 18px;
    height: 18px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-add-method-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffdc88;
  background: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-add-method-btn {
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-textarea {
  width: 100%;
  padding: 14px 16px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  outline: none;
  min-height: 100px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-textarea {
    padding: 12px 14px;
    font-size: 13px;
    min-height: 80px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #ccc;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 16px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-checkbox-label {
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-button-group {
  display: flex;
  gap: 12px;
  margin-top: 32px;
  flex-direction: row;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-button-group {
    margin-top: 24px;
    flex-direction: column-reverse;
  }
*/
}

/* [UNUSED]
.p2p-create-post-btn-primary {
  flex: 1;
  padding: 14px 24px;
  background: #22c55e;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: auto;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-btn-primary {
    flex: unset;
    padding: 14px 20px;
    font-size: 14px;
    width: 100%;
  }
*/
}

/* [UNUSED]
.p2p-create-post-btn-secondary {
  padding: 14px 24px;
  background: transparent;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: auto;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-btn-secondary {
    padding: 14px 20px;
    font-size: 14px;
    width: 100%;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-card {
  background: #12121a;
  border-radius: 16px;
  border: 1px solid #1e1e2d;
  position: sticky;
  top: 20px;
}
*/

@media (max-width: 1023px) {
  /* [UNUSED]
.p2p-create-post-preview-card {
    position: relative;
    top: 0;
  }
*/
}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-card {
    border-radius: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-header {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-header {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-title {
  font-size: 16px;
  color: #888;
  margin: 0;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-title {
    font-size: 14px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-highlight {
  font-weight: 600;
}
*/

/* [UNUSED]
.p2p-create-post-preview-highlight.buy {
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-create-post-preview-highlight.sell {
  color: #ef4444;
}
*/

/* [UNUSED]
.p2p-create-post-preview-body {
  padding: 24px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-body {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-row {
    margin-bottom: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-label {
  color: #aaa;
  font-size: 14px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-label {
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-value {
    font-size: 13px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}
*/

/* [UNUSED]
.p2p-create-post-preview-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  color: #a8b4c4;
  font-size: 12px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-badge {
    padding: 4px 10px;
    font-size: 11px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-remarks {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #1e1e2d;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-remarks {
    margin-top: 16px;
    padding-top: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-remarks-title {
  color: #888;
  font-size: 13px;
  margin-bottom: 8px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-remarks-title {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.pricehigh_box_item_container {
    gap: 24px;
  }
*/

}

/* [UNUSED]
.p2p-create-post-preview-remarks-text {
  color: #ccc;
  font-size: 13px;
  line-height: 1.5;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-remarks-text {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-agreement-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-agreement-box {
    padding: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-agreement-box.error {
  background: rgba(239, 68, 68, 0.05);
  border: 1px solid #ef4444;
}
*/

/* [UNUSED]
.p2p-create-post-helper-text {
  color: #949AA4;
  font-size: 12px;
  margin-top: 6px;
}
*/

/* [UNUSED]
.p2p-create-post-fee-total-box {
  margin-top: 6px;
}
*/

/* [UNUSED]
.p2p-create-post-fee-total-box .p2p-create-post-helper-text {
  margin-top: 4px;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-box {
  margin-top: 12px;
  background: rgba(42, 42, 58, 0.5);
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  padding: 12px 14px;
  max-width: 320px;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #949AA4;
  padding: 4px 0;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-row span:last-child {
  color: #fff;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-total {
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px solid #2a2a3a;
  color: #F3BB2B;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-total span:last-child {
  color: #F3BB2B;
}
*/

/* [UNUSED]
.p2p-create-post-fee-breakdown-box .p2p-create-post-insufficient-funds {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(239, 68, 68, 0.3);
}
*/

/* [UNUSED]
.p2p-create-post-total-required {
  color: #F3BB2B;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-create-post-insufficient-funds {
  color: #ef4444;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-fee-breakdown-box {
    padding: 10px 12px;
    margin-top: 10px;
  }
*/

  /* [UNUSED]
.p2p-create-post-fee-breakdown-row {
    font-size: 11px;
  }
*/
}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-helper-text {
    font-size: 11px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-mobile-preview-toggle {
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #0d0d14;
  border-radius: 10px;
  margin-bottom: 16px;
  cursor: pointer;
  border: 1px solid #2a2a3a;
}
*/

@media (max-width: 1023px) {
  /* [UNUSED]
.p2p-create-post-mobile-preview-toggle {
    display: flex;
  }
*/
}

/* [UNUSED]
.p2p-create-post-grid-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-grid-two-col {
    grid-template-columns: 1fr;
    gap: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-payment-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-payment-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-field-error {
  color: #ef4444;
  font-size: 12px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-field-error {
    font-size: 11px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-header-gradient {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-header-gradient {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-header-gradient.buy {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);
}
*/

/* [UNUSED]
.p2p-create-post-preview-header-gradient.sell {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);
}
*/

/* [UNUSED]
.p2p-create-post-preview-price-section {
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
  text-align: center;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-price-section {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-price-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-price-value {
  font-size: 32px;
  font-weight: 700;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-price-value {
    font-size: 28px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-price-value.buy {
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-create-post-preview-price-value.sell {
  color: #ef4444;
}
*/

/* [UNUSED]
.p2p-create-post-preview-price-currency {
  font-size: 16px;
  color: #888;
}
*/

/* [UNUSED]
.p2p-create-post-preview-market-price {
  color: #aaa;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}
*/

/* [UNUSED]
.p2p-create-post-preview-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 20px 24px;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-stats-grid {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-stat-box {
  background: #0d0d14;
  padding: 12px;
  border-radius: 10px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-stat-label {
  color: #aaa;
  font-size: 11px;
  display: block;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-stat-value {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-stat-value {
    font-size: 15px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-stat-currency {
  color: #888;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #1e1e2d;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-payment-time {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-payment-time-label {
  color: #aaa;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-time-value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-methods {
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-methods-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-methods-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-method-badge {
  padding: 6px 12px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.3);
  border-radius: 6px;
  color: #a8b4c4;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-payment-methods-empty {
  color: #aaa;
  font-size: 12px;
  padding: 6px 12px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-counterparty-label {
  color: #aaa;
  font-size: 12px;
  display: block;
  margin-bottom: 8px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-counterparty-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-counterparty-badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-counterparty-badge.kyc {
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #22c55e;
}
*/

/* [UNUSED]
.p2p-create-post-preview-counterparty-badge.registered {
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #f59e0b;
}
*/

/* [UNUSED]
.p2p-create-post-preview-remarks-box {
  padding: 12px;
  background: #0d0d14;
  border-radius: 10px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-remarks-label {
  color: #aaa;
  font-size: 11px;
  display: block;
  margin-bottom: 6px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-remarks-content {
  color: #aaa;
  font-size: 13px;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-create-post-preview-footer {
  padding: 16px 24px;
  border-top: 1px solid #1e1e2d;
  background: #0a0a0f;
}
*/

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-preview-footer {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-preview-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
*/

/* [UNUSED]
.p2p-create-post-preview-footer-fee {
  color: #aaa;
  font-size: 11px;
}
*/

/* [UNUSED]
.p2p-create-post-preview-footer-available {
  color: #888;
  font-size: 11px;
}
*/

/* Radio Button Styles */
/* [UNUSED]
.p2p-radio-group {
  margin-top: 8px;
}
*/

/* [UNUSED]
.p2p-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
*/

/* [UNUSED]
.p2p-radio-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 5px solid #aaa;
  border-radius: 50%;
  margin: 0;
  margin-right: 12px;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-radio-input:checked {
  border-color: #D9D9D9;
  background-color: transparent;
}
*/

/* [UNUSED]
.p2p-radio-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #222;
}
*/

/* [UNUSED]
.p2p-radio-input:hover {
  border-color: #999;
}
*/

/* [UNUSED]
.p2p-radio-input:checked:hover {
  border-color: #fff;
}
*/

/* [UNUSED]
.p2p-radio-text {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
*/

/* Light Theme Radio Button */
/* [UNUSED]
body.light_theme .p2p-radio-input {
  border-color: #ccc;
}
*/

/* [UNUSED]
body.light_theme .p2p-radio-input:checked {
  border-color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-radio-input:checked::after {
  background-color: #f5f5f5;
}
*/

/* [UNUSED]
body.light_theme .p2p-radio-input:hover {
  border-color: #999;
}
*/

/* [UNUSED]
body.light_theme .p2p-radio-input:checked:hover {
  border-color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-radio-text {
  color: #333;
}
*/

/* Payment Method Styles */
/* [UNUSED]
.p2p-payment-methods-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
*/

.p2p-payment-method-card {
  background: #373f4d;
  border: 1px solid #373f4d;
  border-radius: 10px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

@media (min-width: 768px) {
  .p2p-payment-method-card {
    padding: 16px;
  }
}

.p2p-payment-method-card.selected {
  border-color: #ffdc88;
  background: rgba(255, 220, 136, 0.1);
}

.p2p-payment-method-card.error {
  border-color: rgba(239, 68, 68, 0.5);
}

.p2p-payment-method-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

/* [UNUSED]
.p2p-payment-method-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-payment-method-name {
  color: #ffdc88;
  font-size: 14px;
  font-weight: 600;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-name {
    font-size: 15px;
  }
*/
}

.p2p-payment-method-type-badge {
  color: #aaa;
  font-size: 11px;
  background: #373f4d;
  padding: 2px 8px;
  border-radius: 4px;
}

/* [UNUSED]
.p2p-payment-method-fields-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-fields-grid {
    grid-template-columns: 1fr 1fr;
  }
*/
}

.p2p-payment-method-field {
  font-size: 12px;
}

/* [UNUSED]
.p2p-payment-method-field-label {
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-payment-method-field-value {
  color: #aaa;
}
*/

/* [UNUSED]
.p2p-payment-method-qr-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #2a2a3a40;
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-payment-method-qr-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 4px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-qr-image {
    width: 80px;
    height: 80px;
  }
*/
}

/* [UNUSED]
.p2p-payment-method-qr-label {
  color: #aaa;
  font-size: 11px;
}
*/

/* [UNUSED]
.p2p-payment-methods-empty {
  color: #888;
  font-size: 13px;
  padding: 20px;
  text-align: center;
  background: #373f4d;
  border-radius: 10px;
  border: 1px solid #373f4d;
}
*/

/* [UNUSED]
.p2p-payment-methods-empty.error {
  border-color: #ef4444;
}
*/

/* [UNUSED]
.p2p-payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}
*/

/* [UNUSED]
.p2p-payment-method-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-item {
    padding: 14px 16px;
  }
*/
}

/* [UNUSED]
.p2p-payment-method-item.selected {
  border-color: #FFFFFF60;
}
*/

/* [UNUSED]
.p2p-payment-method-item.error {
  border-color: rgba(239, 68, 68, 0.5);
}
*/

/* [UNUSED]
.p2p-payment-method-item-text {
  color: #fff;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-payment-method-item input[type="checkbox"] {
  display: none;
  accent-color: #303234 !important;
}
*/

/* [UNUSED]
.p2p-payment-method-item.selected input[type="checkbox"] {
  display: block;
}
*/

/* [UNUSED]
.p2p-add-method-button {
  color: #fff;
}
*/

/* [UNUSED]
.p2p-add-method-button:hover {
  background-color: transparent;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-item-text {
    font-size: 14px;
    color: #A2A9B6;
  }
*/
}

/* [UNUSED]
.p2p-payment-method-error {
  color: #ef4444;
  font-size: 11px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-payment-method-error {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-add-method-button {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 300;
  color: #fff;
  background: transparent;
  border: none;
  font-size: 13px;
  cursor: pointer;
  padding: 8px 0;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-add-method-button {
    font-size: 14px;
  }
*/
}

/* [UNUSED]
.p2p-add-method-button-icon {
  font-size: 18px;
}
*/

/* Light Theme Payment Method Styles */
body.light_theme .p2p-payment-method-card {
  background: #ececec;
  border-color: #E0E0E0;
}

body.light_theme .p2p-payment-method-btn.delete {
  color: #ae4e4e;
}

body.light_theme button.p2p-profile-edit-btn:hover {
  background-color: transparent;
  color: #9b9b9b;
  ;
}

body.light_theme .p2p-payment-method-card.selected {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.1);
}

/* [UNUSED]
body.light_theme .p2p-payment-method-name {
  color: #F4B609;
}
*/

body.light_theme .p2p-payment-method-type-badge {
  color: #aaa;
  background: #E8E8E8;
}

/* [UNUSED]
body.light_theme .p2p-payment-method-field-label {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-method-field-value {
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-method-qr-label {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-methods-empty {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-method-item {
  background: #f5f5f5;
  border-color: #E0E0E0;
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-method-item.selected {
  border-color: #F4B609;
  background: rgba(244, 182, 9, 0.1);
}
*/

/* [UNUSED]
body.light_theme .p2p-payment-method-item-text {
  color: #333;
}
*/

/* Step 3 Styles */
/* [UNUSED]
.p2p-create-post-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 16px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-section-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-section-icon {
  color: #F3BB2B;
}
*/

/* [UNUSED]
.p2p-create-post-textarea {
  width: 100%;
  padding: 12px 14px;
  background: #373F4D;
  border: 1px solid #ffffff40;
  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  outline: none;
  min-height: 80px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: inherit;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-textarea {
    padding: 14px 16px;
    font-size: 14px;
    min-height: 130px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-step3-section {
  margin-top: 24px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-step3-section {
    margin-top: 32px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ccc;
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 16px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-checkbox-label {
    font-size: 14px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-checkbox-label-wrap {
  flex-wrap: wrap;
}
*/

/* [UNUSED]
.p2p-create-post-checkbox-label-no-margin {
  margin-bottom: 0;
}
*/

/* [UNUSED]
.p2p-create-post-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #f3bb2b;
  flex-shrink: 0;
  margin-top: 2px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-checkbox {
    width: 20px;
    height: 20px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-registered-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 0;
  margin-top: 8px;
  width: 100%;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-registered-input-wrapper {
    margin-left: 8px;
    margin-top: 0;
    width: auto;
  }
*/
}

/* [UNUSED]
.p2p-create-post-registered-input {
  width: 80px;
  padding: 8px 12px;
  background: #373F4D;
  border: 1px solid #373F4D;
  border-radius: 10px;
  color: #a1a1a1;
  text-align: center;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
*/

/* [UNUSED]
.p2p-create-post-registered-input.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}
*/

/* [UNUSED]
.p2p-create-post-registered-label {
  color: #D0D0D0;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-create-post-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-create-post-radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
*/

/* [UNUSED]
.p2p-create-post-radio-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #D9D9D9;
  background-color: #000 !important;
  border-radius: 50%;
  margin: 0;
  margin-right: 12px;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-create-post-radio-input:checked {
  border-color: #fff;
  background-color: transparent !important;
}
*/

/* [UNUSED]
.p2p-create-post-step3-section .p2p-create-post-radio-group {
  flex-direction: row;
  gap: 48px;
}
*/

/* [UNUSED]
.p2p-layout-wrapper .p2p-create-post-radio-input:focus {
  border: 5px solid #ffffff !important;
}
*/

/* [UNUSED]
.userprofile_pop .modal-content {
  background-color: #373E4B;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi li {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  position: relative;
  font-weight: 300;
  font-size: 13px;
  color: #ffffff9e;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi li span {
  color: #fff;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi li span.text-danger {
  color: #ef4444;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi li span.text-success {
  color: #22c55e;
}
*/

/* [UNUSED]
.userprofile_pop.btnnextback button {
  background-color: #474D59;
}
*/

/* [UNUSED]
.userprofile_pop ul.list_upi li::before {
  position: absolute;
  left: -15px;
  top: 0px;
  content: "";
  width: 10px;
}
*/

/* [UNUSED]
.p2p-create-post-radio-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #222;
}
*/

/* [UNUSED]
.p2p-create-post-radio-input:hover {
  border-color: #999;
}
*/

/* [UNUSED]
.p2p-create-post-radio-input:checked:hover {
  border-color: #fff;
}
*/

/* [UNUSED]
.p2p-create-post-radio-text {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-create-post-agreement-box {
  background: #0d0d14;
  border-radius: 10px;
  padding: 12px;
  margin-top: 16px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-agreement-box {
    padding: 16px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-agreement-text {
  font-size: 12px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-agreement-text {
    font-size: 14px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-field-error {
  color: #ef4444;
  font-size: 11px;
  margin-top: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-field-error {
    font-size: 12px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-field-error-agreement {
  margin-top: -12px;
}
*/

/* [UNUSED]
.p2p-create-post-button-group {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}
*/

@media (min-width: 768px) {
  /* [UNUSED]
.p2p-create-post-button-group {
    margin-top: 32px;
  }
*/
}

/* [UNUSED]
.p2p-create-post-btn-secondary {
  flex: 1;
  padding: 12px 20px;
  background: #0d0d14;
  border: 1px solid #2a2a3a;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-create-post-btn-secondary:hover {
  background: #1a1a2a;
  border-color: #3a3a4a;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary {
  flex: 1;
  padding: 12px 20px;
  background: #22c55e;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary:hover {
  background: #20b855;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary-sell {
  background: #ef4444;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary-sell:hover {
  background: #dc2626;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary-buy {
  background: #22c55e;
}
*/

/* [UNUSED]
.p2p-create-post-btn-primary-buy:hover {
  background: #20b855;
}
*/

/* Light Theme Step 3 Styles */
/* [UNUSED]
body.light_theme .p2p-create-post-section-title {
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-section-icon {
  color: #F4B609;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-textarea {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-checkbox-label {
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-registered-input {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-registered-label {
  color: #aaa;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-radio-input {
  border-color: #ccc;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-radio-input:checked {
  border-color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-radio-input:checked::after {
  background-color: #f5f5f5;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-radio-text {
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-agreement-box {
  background: #f5f5f5;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-btn-secondary {
  background: #f5f5f5;
  border-color: #E0E0E0;
  color: #333;
}
*/

/* [UNUSED]
body.light_theme .p2p-create-post-btn-secondary:hover {
  background: #E8E8E8;
}
*/

/* P2P My Ads Table Styles */
.p2p-orders-table td {
  padding: 12px 10px;
}

.p2p-orders-table td.p2p-myads-actions-cell {
  text-align: right;
}

.p2p-row-expanded {
  background: rgba(255, 220, 136, 0.03) !important;
}

.p2p-myads-asset-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-myads-side-badge {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.p2p-myads-asset-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-asset-name {
  font-size: 15px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-table-cell-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-myads-table-cell-content-gap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-myads-price-text {
  font-size: 14px;
  font-weight: 500;
  color: #e5e5e5;
}

.p2p-myads-volume-text {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-limits-text {
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-payment-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.p2p-payment-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: rgba(255, 220, 136, 0.1);
  border: 1px solid rgba(255, 220, 136, 0.2);
}

.p2p-payment-badge-count {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  background: #5EBA8920;
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.2);
}

.p2p-myads-status-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.p2p-myads-status {
  font-size: 13px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  display: inline-block;
}

.p2p-myads-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.p2p-myads-action-btn {
  padding: 3px 12px;
  min-height: 24px;
  border-radius: 6px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  color: #a1a1aa;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.p2p-myads-action-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #e5e5e5;
}

.p2p-myads-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p2p-myads-action-btn-view {
  background: rgba(255, 255, 255, 0.04);
}

.p2p-myads-action-btn-view.active {
  background: rgba(255, 220, 136, 0.2);
}

.p2p-myads-action-btn-view:hover {
  background: rgba(255, 220, 136, 0.15);
  border-color: rgba(255, 220, 136, 0.3);
  color: #e5e5e5;
}

.p2p-myads-action-btn-view.active:hover {
  background: rgba(255, 220, 136, 0.2);
  border-color: rgba(255, 255, 255, 0.1);
}

.p2p-myads-action-btn-close {
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.2);
}

.p2p-myads-action-btn-close:hover {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.3);
}

.p2p-myads-action-btn-icon {
  font-size: 14px;
}

.p2p-myads-action-btn-icon-online {
  color: #4ade80;
}

/* Expanded Row Styles */
.p2p-myads-expanded-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

.p2p-myads-expanded-section {
  margin-bottom: 20px;
}

.p2p-myads-expanded-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-expanded-title-count {
  font-size: 12px;
  color: #6b7280;
  margin-left: 6px;
  font-weight: 400;
}

.p2p-myads-expanded-content-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-myads-expanded-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
}

.p2p-myads-expanded-item-label {
  font-size: 12px;
  color: #9ca3af;
}

.p2p-myads-expanded-item-value {
  font-size: 14px;
  color: #e5e5e5;
  font-weight: 500;
}

.p2p-myads-expanded-item-value-small {
  font-size: 12px;
  color: #e5e5e5;
  font-family: monospace;
}

.p2p-myads-fee-value {
  color: #F3BB2B;
  font-weight: 500;
  font-size: 12px;
}

/* [UNUSED]
.p2p-orders-fee-value {
  color: #F3BB2B;
  font-weight: 500;
  font-size: 12px;
}
*/

.p2p-myads-expanded-payments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.p2p-payment-badge-expanded {
  font-size: 12px;
  padding: 6px 10px;
}

.p2p-myads-expanded-section-border {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.p2p-myads-expanded-title-large {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #e5e5e5;
}

.p2p-myads-online-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
}

.p2p-myads-online-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.p2p-myads-online-badge.online .p2p-myads-online-dot {
  background: #4ade80;
}

.p2p-myads-online-badge.offline .p2p-myads-online-dot {
  background: #6b7280;
}

/* Light Theme Table Styles */
body.light_theme .p2p-myads-asset-name {
  color: #333;
}

body.light_theme .p2p-myads-price-text,
body.light_theme .p2p-myads-volume-text,
body.light_theme .p2p-myads-limits-text {
  color: #333;
}

body.light_theme .p2p-myads-status {
  background: rgba(0, 0, 0, 0.05);
}

body.light_theme .p2p-myads-action-btn {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.1);
  color: #aaa;
}

body.light_theme .p2p-myads-action-btn:hover {
  background: rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.15);
  color: #333;
}

body.light_theme .p2p-myads-action-btn-view.active {
  background: rgba(244, 182, 9, 0.2);
}

body.light_theme .p2p-myads-action-btn-view:hover {
  background: rgba(244, 182, 9, 0.15);
  border-color: rgba(244, 182, 9, 0.3);
}

body.light_theme .p2p-myads-expanded-title {
  color: #333;
}

body.light_theme .p2p-myads-expanded-item {
  background: rgba(0, 0, 0, 0.03);
}

body.light_theme .p2p-myads-expanded-item-label {
  color: #aaa;
}

body.light_theme .p2p-myads-expanded-item-value {
  color: #333;
}

body.light_theme .p2p-myads-expanded-item-value-small {
  color: #333;
}

body.light_theme .p2p-myads-expanded-section-border {
  border-top-color: rgba(0, 0, 0, 0.1);
}

body.light_theme .p2p-row-expanded {
  background: rgba(244, 182, 9, 0.03) !important;
}

@media (max-width: 1200px) {

  /* [UNUSED]
.p2p-create-post-container {
    grid-template-columns: 1fr 80px;
  }
*/

  .p2p-myads-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }


}


@media (max-width:767px) {

  /* [UNUSED]
.payment_method_pop.modal.fade .modal-dialog {
    min-width: 100%;
  }
*/

  /* [UNUSED]
.userprofile_pop ul.list_upi li {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.userprofile_pop ul.list_upi {
    gap: 10px;
  }
*/

  /* [UNUSED]
.p2p-create-post-container {
    grid-template-columns: 1fr 0px;
    gap: 0px;
  }
*/

  /* [UNUSED]
.p2p-payment-method-item {
    margin-bottom: 5px;
    padding: 8px 12px;
  }
*/

  /* [UNUSED]
.pricehigh_box_item_title {
    font-size: 18px;
  }
*/

  /* [UNUSED]
.pricehigh_box_item_title span {
    font-size: 10px;
  }
*/


  /* [UNUSED]
.btnnextback button {
    font-size: 13px;
    padding: 10px 15px;
  }
*/

  .p2p-profile-container .p2p-profile-header {
    padding: 20px;
  }

  .p2p-profile-tabs.paymentprofiletabs {
    padding: 0px 15px 20px;
  }

  .rightalien {
    text-align: center;
  }

  .p2p-profile-container .p2p-empty-state-card i {
    font-size: 26px;
  }

  .p2p-profile-name {
    font-size: 18px;
  }

  .p2p-myads-stat-card {
    border-right: none;
    padding: 10px 5px;
  }

  .p2p-empty-state-mobile {
    margin: 0px;
  }

  .p2p-empty-state-mobile .p2p-create-ad-btn-small {
    padding: 10px 24px;
    font-size: 12px;
    margin: 0 auto;
  }

  .p2p-filter-section.myadsfillter {
    background: #3f4856;
    padding: 20px;
  }

}

@media (max-width: 767px) {
  /* [UNUSED]
.p2p-create-post-title {
    font-size: 18px;
  }
*/

  /* [UNUSED]
.p2p-create-post-radio-text {
    font-size: 12px;
  }
*/

  /* [UNUSED]
.p2p-create-post-radio-input {
    width: 16px;
    height: 16px;
  }
*/

}


@media (max-width: 660px) {

  /* [UNUSED]
.pricehigh_box_item_title {
    font-size: 18px;
  }
*/

  /* [UNUSED]
.pricehigh_box_item_title span {
    font-size: 10px;
  }
*/

  .p2p-myads-stat-card-value {
    font-size: 13px;
  }

  .p2p-profile-container .p2p-myads-stats-grid {
    gap: 10px;
    padding: 10px 15px;
  }

  .p2p-profile-container .p2p-myads-stat-card-label {
    font-size: 11px;
    text-align: left;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .p2p-myads-stat-card-value {
    font-size: 11px;
  }


  /* [UNUSED]
.pricehigh_box {
    padding: 15px;
    margin-top: 15px;
    align-items: start;
    gap: 12px;
    flex-direction: column;
  }
*/
}


/* ==================== 1. HERO SECTION ==================== */
.p2p-hero-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(136deg, rgb(240 249 255 / 75%) 0%, rgba(255, 255, 255, 1) 52%, rgb(239 246 255 / 77%) 100%);
  padding: 40px 90px;
  border-radius: 16px;
  margin-bottom: 30px;
  min-height: 350px;
}

body.dark_theme .p2p-hero-section,
body[data-theme="dark"] .p2p-hero-section,
html[data-theme="dark"] .p2p-hero-section {
  background: linear-gradient(135deg, #1e2329 0%, #181a20 100%);
  border: 1px solid #2b313a;
}

.p2p-hero-content {
  max-width: 50%;
}

.p2p-hero-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 16px;
}

.p2p-hero-title-dark {
  color: #111827;
}

body.dark_theme .p2p-hero-title-dark,
body[data-theme="dark"] .p2p-hero-title-dark,
html[data-theme="dark"] .p2p-hero-title-dark {
  color: #ffffff;
}

.p2p-hero-title-gold {
  color: #D1AA67;
}

.p2p-hero-desc {
  font-size: 18px;
  line-height: 140%;
  color: #6B7280;
  margin-bottom: 24px;
}

body.dark_theme .p2p-hero-desc,
body[data-theme="dark"] .p2p-hero-desc,
html[data-theme="dark"] .p2p-hero-desc {
  color: #848e9c;
}

.p2p-hero-actions {
  display: flex;
  gap: 16px;
}

.p2p-hero-btn {
  padding: 16px 32px;
  min-width: 210px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.p2p-hero-buy-btn {
  background-color: #1a1a1a;
  color: #ffffff;
}

body.dark_theme .p2p-hero-buy-btn,
body[data-theme="dark"] .p2p-hero-buy-btn,
html[data-theme="dark"] .p2p-hero-buy-btn {
  background-color: #d1aa67;
}

.p2p-hero-sell-btn {
  background-color: #e5e7eb;
  color: #4b5563;
}

body.dark_theme .p2p-hero-sell-btn,
body[data-theme="dark"] .p2p-hero-sell-btn,
html[data-theme="dark"] .p2p-hero-sell-btn {
  background-color: #2b313a;
  color: #eaecef;
}

.p2p-hero-image img {
  object-fit: contain;
}

.p2p-hero-image {
  max-width: 320px;
}

/* ==================== 2. MAIN TRADING CARD & TABS ==================== */
.p2p-trading-card {
  background-color: transparent;
  margin-bottom: 30px;
}

body.dark_theme .p2p-trading-card,
body[data-theme="dark"] .p2p-trading-card,
html[data-theme="dark"] .p2p-trading-card {
  background-color: transparent;
}

.p2p-tabs-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #E4E4E4;
  border-radius: 16px 16px 0px 0px;
  padding: 24px 32px;
  margin-bottom: 4px;
  background-color: #F9F9F9;
}

button.p2p-switch-btn.sellbtn {
  color: #EC6072;
}

button.p2p-switch-btn.sellbtn.active-sell {
  color: #fff;
}

button.p2p-switch-btn.buybtn {
  color: #2BC287;
}

body.dark_theme .p2p-tabs-bar,
body[data-theme="dark"] .p2p-tabs-bar,
html[data-theme="dark"] .p2p-tabs-bar {
  background-color: #1e2026;
  border-color: #2b313a;
}

.p2p-token-tabs {
  display: flex;
  gap: 24px;
  align-items: center;
}

.p2p-token-tab {
  background: none;
  border: none;
  font-size: 18px;
  position: relative;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: #5F5F5F;
  cursor: pointer;
}

body.dark_theme .p2p-token-tab:hover,
body[data-theme="dark"] .p2p-token-tab:hover,
html[data-theme="dark"] .p2p-token-tab:hover {
  color: #ffffff;
}

.p2p-token-tab.active {
  color: #D1AA67;
}

.p2p-token-tab.active::after {
  content: '';
  position: absolute;
  bottom: -46px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #D1AA67;
}

.p2p-token-more-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
}

body.dark_theme .p2p-token-more-btn,
body[data-theme="dark"] .p2p-token-more-btn,
html[data-theme="dark"] .p2p-token-more-btn {
  color: #848e9c;
}

.p2p-buysell-switch {
  display: flex;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 4px;
  border: 1px solid #e5e7eb;
}

body.dark_theme .p2p-buysell-switch,
body[data-theme="dark"] .p2p-buysell-switch,
html[data-theme="dark"] .p2p-buysell-switch {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-switch-btn {
  padding: 14px 48px;
  border-radius: 50px;
  font-size: 15px;
  border: none;
  background: transparent;
  box-shadow: none;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s;
}

body.dark_theme .p2p-switch-btn,
body[data-theme="dark"] .p2p-switch-btn,
html[data-theme="dark"] .p2p-switch-btn {
  color: #848e9c;
}

button.p2p-switch-btn.buybtn.active-buy {
  color: #fff;
}

body button.p2p-switch-btn.active-buy {
  background-color: #2BC287;
  color: #ffffff;
  box-shadow: inset 2px 4px 6px rgba(0, 0, 0, 0.2);
}

.p2p-switch-btn.active-sell {
  background-color: #EC6072;
  color: #ffffff;
  box-shadow: inset 2px 4px 6px rgba(0, 0, 0, 0.2);
}

/* ==================== 3. FILTER CONTROLS BAR ==================== */
.p2p-filter-bar {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 0px 0px 16px 16px;
  padding: 24px;
  background-color: #F9F9F9;
}

body.dark_theme .p2p-filter-bar,
body[data-theme="dark"] .p2p-filter-bar,
html[data-theme="dark"] .p2p-filter-bar {
  background-color: #1e2026;
  border-color: #2b313a;
}

.p2p-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.p2p-filter-group label {
  font-size: 18px;
  color: #5F5F5F;
}

body.dark_theme .p2p-filter-group label,
body[data-theme="dark"] .p2p-filter-group label,
html[data-theme="dark"] .p2p-filter-group label {
  color: #848e9c;
}

.p2p-amount-input-wrap {
  display: flex;
  background-color: #F0F0F0;
  min-height: 48px;
  border: 1px solid #e5e7eb;
  border-radius: 50px;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
}

body.dark_theme .p2p-amount-input-wrap,
body[data-theme="dark"] .p2p-amount-input-wrap,
html[data-theme="dark"] .p2p-amount-input-wrap {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-amount-input-wrap input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  color: #5F5F5F;
  font-size: 15px;
}

body.dark_theme .p2p-amount-input-wrap input,
body[data-theme="dark"] .p2p-amount-input-wrap input,
html[data-theme="dark"] .p2p-amount-input-wrap input {
  color: #ffffff;
}

body.dark_theme .p2p-amount-input-wrap input::placeholder,
body[data-theme="dark"] .p2p-amount-input-wrap input::placeholder,
html[data-theme="dark"] .p2p-amount-input-wrap input::placeholder {
  color: #5f6672;
}

.p2p-custom-select-container {
  position: relative;
  display: inline-block;
  width: 140px;
}

.p2p-custom-select-container.full-width-dropdown {
  width: 100%;
}

.p2p-custom-select-header {
  background-color: #F0F0F0;
  border: 1px solid #e5e7eb;
  border-radius: 50px;
  padding: 8px 30px 8px 12px;
  width: 100%;
  font-size: 14px;
  min-height: 48px;
  color: #707070;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-user-select: none;
  user-select: none;
}

body.dark_theme .p2p-custom-select-header,
body[data-theme="dark"] .p2p-custom-select-header,
html[data-theme="dark"] .p2p-custom-select-header {
  background-color: #181a20;
  border-color: #2b313a;
  color: #eaecef;
}

.p2p-custom-select-header i {
  position: absolute;
  right: 12px;
  transition: transform 0.3s;
}

.p2p-custom-select-header i.open {
  transform: rotate(180deg);
}

.p2p-custom-select-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  z-index: 100;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
}

body.dark_theme .p2p-custom-select-list,
body[data-theme="dark"] .p2p-custom-select-list,
html[data-theme="dark"] .p2p-custom-select-list {
  background-color: #1e2026;
  border-color: #2b313a;
}

.p2p-custom-select-item {
  padding: 8px 16px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s;
}

body.dark_theme .p2p-custom-select-item,
body[data-theme="dark"] .p2p-custom-select-item,
html[data-theme="dark"] .p2p-custom-select-item {
  color: #eaecef;
}

.p2p-custom-select-item:hover,
.p2p-custom-select-item.selected {
  background-color: #1a56db;
  color: #ffffff;
}

body.dark_theme .p2p-custom-select-item:hover,
body.dark_theme .p2p-custom-select-item.selected,
body[data-theme="dark"] .p2p-custom-select-item:hover,
body[data-theme="dark"] .p2p-custom-select-item.selected,
html[data-theme="dark"] .p2p-custom-select-item:hover,
html[data-theme="dark"] .p2p-custom-select-item.selected {
  background-color: #2b313a;
  color: #f0b90b;
}

.p2p-currency-select {
  position: relative;
  display: flex;
  align-items: center;
  border-left: 1px solid #e5e7eb;
}

body.dark_theme .p2p-currency-select,
body[data-theme="dark"] .p2p-currency-select,
html[data-theme="dark"] .p2p-currency-select {
  border-color: #2b313a;
}

.p2p-currency-dropdown {
  width: 95px;
}

.p2p-currency-dropdown .p2p-custom-select-header {
  border: none;
  background: transparent;
  min-height: auto;
  font-weight: 600;
  padding: 0px 19px 0px 12px;
}

.p2p-filter-input-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F0F0F0;
  border: 1px solid #e5e7eb;
  border-radius: 50px;
  padding: 8px 12px;
  width: 56px;
  height: 56px;
}

.p2p-filter-input-wrap img {
  height: 18px;
}

body.dark_theme .p2p-filter-input-wrap,
body[data-theme="dark"] .p2p-filter-input-wrap,
html[data-theme="dark"] .p2p-filter-input-wrap {
  background-color: #181a20;
  border-color: #2b313a;
}

body.dark_theme .p2p-filter-input-wrap img,
body[data-theme="dark"] .p2p-filter-input-wrap img,
html[data-theme="dark"] .p2p-filter-input-wrap img {
  filter: brightness(0) invert(1);
  opacity: 0.75;
}

.p2p-filter-input-wrap input {
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
}

body.dark_theme .p2p-filter-input-wrap input,
body[data-theme="dark"] .p2p-filter-input-wrap input,
html[data-theme="dark"] .p2p-filter-input-wrap input {
  color: #fff;
}

.p2p-icon-btn,
.p2p-refresh-btn {
  background-color: #F0F0F0;
  border: 1px solid rgb(95 95 95 / 20%);
  border-radius: 50px;
  padding: 17px 12px;
  font-weight: 500;
  min-width: 160px;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5F5F5F;
}

body.dark_theme .p2p-icon-btn,
body[data-theme="dark"] .p2p-icon-btn,
html[data-theme="dark"] .p2p-icon-btn,
body.dark_theme .p2p-refresh-btn,
body[data-theme="dark"] .p2p-refresh-btn,
html[data-theme="dark"] .p2p-refresh-btn {
  background-color: #181a20;
  border-color: #2b313a;
  color: #eaecef;
}

body.dark_theme .p2p-refresh-btn:hover,
body[data-theme="dark"] .p2p-refresh-btn:hover,
html[data-theme="dark"] .p2p-refresh-btn:hover {
  background-color: #2b313a;
  color: #ffffff;
}

.p2p-filter-refresh {
  margin-left: auto;
}

/* ==================== 4. ADVERTISERS TABLE & PAGINATION ==================== */
.p2p-table-container {
  overflow-x: auto;
  border-radius: 14px;
  background-color: #f9f9f9;
}

body.dark_theme .p2p-table-container,
body[data-theme="dark"] .p2p-table-container,
html[data-theme="dark"] .p2p-table-container {
  background-color: #1e2026;
  border: 1px solid #2b313a;
}

.p2p-table {
  width: 100%;
}

.p2p-table th {
  text-align: left;
  padding: 16px;
  font-size: 15px;
  color: #9CA3AF;
  background-color: #E2E2E2;
  font-weight: 500;
}

body.dark_theme .p2p-table th,
body[data-theme="dark"] .p2p-table th,
html[data-theme="dark"] .p2p-table th {
  background-color: #181a20 !important;
  color: #848e9c !important;
  border-bottom: 1px solid #2b313a !important;
}

.p2p-table tbody tr {
  background-color: #F9F9F9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

body.dark_theme .p2p-table tbody tr,
body[data-theme="dark"] .p2p-table tbody tr,
html[data-theme="dark"] .p2p-table tbody tr {
  background-color: #1e2026 !important;
  box-shadow: none !important;
  border-bottom: 1px solid #2b313a !important;
}

body.dark_theme .p2p-table tbody tr:hover,
body[data-theme="dark"] .p2p-table tbody tr:hover,
html[data-theme="dark"] .p2p-table tbody tr:hover {
  background-color: #23272e !important;
}

.p2p-table td {
  padding: 18px;
  background-color: #F9F9F9;
  border-bottom: 1px solid #E4E4E4;
}

body.dark_theme .p2p-table td,
body[data-theme="dark"] .p2p-table td,
html[data-theme="dark"] .p2p-table td {
  background-color: transparent !important;
  border-bottom: 1px solid #2b313a !important;
  color: #eaecef !important;
}

.p2p-table td:first-child {
  border-radius: 8px 0 0 8px;
}

.p2p-table td:last-child {
  border-radius: 0 8px 8px 0;
}

.p2p-adv-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-adv-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #fff;
}

.p2p-adv-avatar.dark-avatar {
  background-color: #454545;
}

body.dark_theme .p2p-adv-avatar.dark-avatar,
body[data-theme="dark"] .p2p-adv-avatar.dark-avatar,
html[data-theme="dark"] .p2p-adv-avatar.dark-avatar {
  background-color: #2b313a;
  color: #ffffff;
}

.p2p-adv-info h4 {
  margin: 0 0 2px;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

body.dark_theme .p2p-adv-info h4,
body[data-theme="dark"] .p2p-adv-info h4,
html[data-theme="dark"] .p2p-adv-info h4 {
  color: #fff;
}

.p2p-adv-info span {
  font-size: 12px;
  color: #6b7280;
}

body.dark_theme .p2p-adv-info span,
body[data-theme="dark"] .p2p-adv-info span,
html[data-theme="dark"] .p2p-adv-info span {
  color: #848e9c;
}

.p2p-price-cell {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

body.dark_theme .p2p-price-cell,
body[data-theme="dark"] .p2p-price-cell,
html[data-theme="dark"] .p2p-price-cell {
  color: #fff;
}

.p2p-limit-val {
  font-size: 16px;
  color: #374151;
  margin-bottom: 0px;
  font-weight: 500;
}

body.dark_theme .p2p-limit-val,
body[data-theme="dark"] .p2p-limit-val,
html[data-theme="dark"] .p2p-limit-val {
  color: #ffffff;
}

.p2p-limit-range {
  font-size: 14px;
  color: #9CA3AF;
}

body.dark_theme .p2p-limit-range,
body[data-theme="dark"] .p2p-limit-range,
html[data-theme="dark"] .p2p-limit-range {
  color: #848e9c;
}

.p2p-payment-badges {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.p2p-payment-tag {
  background-color: #F3F4F6;
  color: #374151;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 6px;
}

body.dark_theme .p2p-payment-tag,
body[data-theme="dark"] .p2p-payment-tag,
html[data-theme="dark"] .p2p-payment-tag {
  background-color: #2b313a;
  color: #eaecef;
  border: 1px solid #373d48;
}

.p2p-action-btn {
  padding: 12px 32px;
  border-radius: 50px;
  border: none;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.p2p-action-btn.btn-buy {
  background-color: #2BC287;
}

.p2p-action-btn.btn-sell {
  background-color: #EC6072;
}

body.dark_theme .p2p-page-num,
body[data-theme="dark"] .p2p-page-num,
html[data-theme="dark"] .p2p-page-num,
body.dark_theme .p2p-page-arrow,
body[data-theme="dark"] .p2p-page-arrow,
html[data-theme="dark"] .p2p-page-arrow {
  color: #848e9c;
}

body.dark_theme .p2p-page-num.active,
body[data-theme="dark"] .p2p-page-num.active,
html[data-theme="dark"] .p2p-page-num.active {
  background-color: #2b313a !important;
  color: #f0b90b !important;
}

.p2p-pagination-center {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 24px 0px;
}

.p2p-page-num,
.p2p-page-arrow {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}

.p2p-page-num.active {
  background-color: #f3f4f6;
  color: #111827;
  font-weight: 600;
}

body.dark_theme .p2p-page-num.active,
body[data-theme="dark"] .p2p-page-num.active {
  background-color: #374151;
  color: #fff;
}

.p2p-page-dots {
  color: #6b7280;
}

/* ==================== 5. TRADING TUTORIAL SECTION ==================== */
.p2p-tutorial-section {
  margin: 60px 0px 40px;
  background-color: #FAFAFA;
  padding: 42px;
  border-radius: 24px;
}

body.dark_theme .p2p-tutorial-section,
body[data-theme="dark"] .p2p-tutorial-section,
html[data-theme="dark"] .p2p-tutorial-section {
  background-color: #1e2026;
  border: 1px solid #2b313a;
}

.p2p-section-header {
  margin-bottom: 24px;
}

.p2p-section-header h2 {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 8px;
}

body.dark_theme .p2p-section-header h2,
body[data-theme="dark"] .p2p-section-header h2,
html[data-theme="dark"] .p2p-section-header h2 {
  color: #ffffff;
}

.p2p-section-header p {
  color: #6b7280;
  font-size: 18px;
  margin-top: 5px;
}

body.dark_theme .p2p-section-header p,
body[data-theme="dark"] .p2p-section-header p,
html[data-theme="dark"] .p2p-section-header p {
  color: #848e9c;
}

.p2p-tutorial-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding-top: 8px;
}

.p2p-tutorial-card {
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
}

body.dark_theme .p2p-tutorial-card,
body[data-theme="dark"] .p2p-tutorial-card,
html[data-theme="dark"] .p2p-tutorial-card {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-tut-img-wrap {
  height: 188px;
  background: #F1E5D0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

body.dark_theme .p2p-tut-img-wrap,
body[data-theme="dark"] .p2p-tut-img-wrap,
html[data-theme="dark"] .p2p-tut-img-wrap {
  background: linear-gradient(135deg, #3a2e13 0%, #2a210d 100%);
}

.p2p-tut-img-wrap img {
  max-height: 100%;
}

.p2p-tut-content {
  padding: 20px;
}

.p2p-tut-content h4 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
}

body.dark_theme .p2p-tut-content h4,
body[data-theme="dark"] .p2p-tut-content h4,
html[data-theme="dark"] .p2p-tut-content h4 {
  color: #ffffff;
}

.p2p-tut-content p {
  font-size: 16px;
  color: #6B7280;
  margin-bottom: 16px;
  min-height: 40px;
}

body.dark_theme .p2p-tut-content p,
body[data-theme="dark"] .p2p-tut-content p,
html[data-theme="dark"] .p2p-tut-content p {
  color: #848e9c;
}

.p2p-tut-link {
  color: #D1AA67;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s, transform 0.2s;
}

.p2p-tut-link:hover {
  color: #b89350;
  text-decoration: underline;
  transform: translateX(3px);
}

/* ==================== 6. FAQ ACCORDION SECTION ==================== */
.p2p-faq-section {
  margin-bottom: 40px;
}

.p2p-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-accordion-item {
  background-color: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 20px;
  overflow: hidden;
}

body.dark_theme .p2p-accordion-item,
body[data-theme="dark"] .p2p-accordion-item,
html[data-theme="dark"] .p2p-accordion-item {
  background-color: #1e2026;
  border-color: #2b313a;
}

.p2p-accordion-button {
  width: 100%;
  text-align: left;
  padding: 28px;
  background: none;
  border: none;
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

h2.p2p-accordion-header {
  margin: 0px;
}

body.dark_theme .p2p-accordion-button,
body[data-theme="dark"] .p2p-accordion-button,
html[data-theme="dark"] .p2p-accordion-button {
  color: #ffffff;
}

.p2p-acc-icon {
  color: #9ca3af;
  font-size: 20px;
  width: 38px;
  height: 38px;
  min-width: 38;
  background-color: #F3F4F6;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.dark_theme .p2p-acc-icon,
body[data-theme="dark"] .p2p-acc-icon,
html[data-theme="dark"] .p2p-acc-icon {
  background-color: #2b313a;
  color: #848e9c;
}

.p2p-accordion-body {
  padding: 0 28px 20px;
  color: #35373a;
  font-size: 18px;
  line-height: 1.5;
}

body.dark_theme .p2p-accordion-body,
body[data-theme="dark"] .p2p-accordion-body,
html[data-theme="dark"] .p2p-accordion-body {
  color: #848e9c;
}

/* ==================== 6. BUY/SELL MODAL ==================== */
.p2p-modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  background-color: rgb(0 0 0 / 42%);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 999999999 !important;
}

body.light_theme .p2p-modal-overlay {
  background-color: rgb(255 255 255 / 42%);
}

.p2p-modal-content {
  background-color: #0000005e;
  border-radius: 24px;
  width: 1150px;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border: 2px solid #bdbdbd;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.2);
  position: relative;
}

body.dark_theme .p2p-modal-content,
body[data-theme="dark"] .p2p-modal-content {
  background-color: rgb(0 0 0 / 30%);
  border: 2px solid #181818;
}

.p2p-modal-body {
  display: flex;
  flex-direction: row;
}

/* Left Side: Seller Info */
.p2p-modal-left {
  width: 35%;
  padding: 40px 35px 30px 10px;
  border-right: 1px solid #F3F4F6;
}

body.dark_theme .p2p-modal-left,
body[data-theme="dark"] .p2p-modal-left {
  border-right-color: #333;
}

.p2p-modal-seller-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.p2p-modal-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #8B4513;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.p2p-modal-seller-info h3 {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

body.dark_theme .p2p-modal-seller-info h3,
body[data-theme="dark"] .p2p-modal-seller-info h3 {
  color: #fff;
}

.p2p-modal-badges {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.p2p-badge-green {
  font-size: 9px;
  color: #10B981;
  display: flex;
  align-items: center;
  gap: 2px;
  font-weight: 400;
}

.p2p-modal-last-online {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

.p2p-modal-stats-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.p2p-modal-stat-box {
  flex: 1 1;
  flex-direction: column;
  background-color: #F2F2F250;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: start;
  gap: 3px;
  border: 1px solid #E5E7EB;
}

.d-flex.twop2p {
  gap: 8px;
  margin-bottom: 4px;
}

.p2p-modal-stat-box p {
  margin-bottom: 0px;
  color: #6B7280;
}

body.dark_theme .p2p-modal-stat-box,
body[data-theme="dark"] .p2p-modal-stat-box {
  background-color: rgb(0 0 0 / 50%);
  border-color: #272727;
}

.p2p-stat-icon {
  color: #D1AA67;
  font-size: 14px;
  background-color: #D1AA6720;
  padding: 1px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.p2p-stat-val strong {
  display: block;
  font-size: 20px;
  color: #111827;
}

body.dark_theme .p2p-stat-val strong,
body[data-theme="dark"] .p2p-stat-val strong {
  color: #fff;
}

.p2p-stat-val p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.p2p-modal-about,
.p2p-modal-remarks,
.p2p-modal-payments {
  margin-bottom: 24px;
}

.p2p-modal-about h4,
.p2p-modal-remarks h4,
.p2p-modal-payments h4 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

body.dark_theme .p2p-modal-left h4,
body[data-theme="dark"] .p2p-modal-left h4 {
  color: #fff;
}

.p2p-modal-about p {
  margin: 0 0 8px;
  font-size: 13px;
  color: #4b5563;
}

body.dark_theme .p2p-modal-about p,
body[data-theme="dark"] .p2p-modal-about p {
  color: #ccc;
}

.p2p-remarks-box {
  background-color: #F5F6F7;
  border-radius: 8px;
  padding: 16px;
  font-size: 13px;
  color: #6b7280;
}

body.dark_theme .p2p-remarks-box,
body[data-theme="dark"] .p2p-remarks-box {
  background-color: #2a2a36;
}

.p2p-payment-icons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.p2p-pay-icon {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px 9px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  font-size: 11px;
  color: #374151;
  background: #fff;
  font-weight: 500;
}

body.dark_theme .p2p-pay-icon,
body[data-theme="dark"] .p2p-pay-icon {
  background-color: #1a1a24;
  border-color: #444;
  color: #ccc;
}

.p2p-payment-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  color: #6b7280;
  font-size: 16px;
}

body.dark_theme .p2p-payment-more,
body[data-theme="dark"] .p2p-payment-more {
  border-color: #444;
}

/* Right Side: Transaction Details */
.p2p-modal-right {
  width: 65%;
  padding: 40px;
  position: relative;
}

.p2p-modal-close {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  z-index: 10;
}

.p2p-modal-action-header {
  margin-bottom: 24px;
}

.p2p-action-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-token-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #26A17B;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.p2p-action-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}

body.dark_theme .p2p-action-title h2,
body[data-theme="dark"] .p2p-action-title h2 {
  color: #fff;
}

.p2p-price-secure-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.p2p-price-rate {
  font-size: 14px;
  color: #b0b0b0;
  background-color: #ecfdf512;
  padding: 7px 15px;
  border-radius: 6px;
}

body.light_theme .p2p-price-rate {
  color: #6b7280;
  background-color: #ECFDF550;
}

.p2p-secure-badge {
  background-color: #ECFDF5;
  color: #059669;
  padding: 8px 15px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #D1FAE5;
}

body.dark_theme .p2p-secure-badge,
body[data-theme="dark"] .p2p-secure-badge {
  background-color: rgba(16, 185, 129, 0.1);
}

.p2p-secure-badge span {
  color: #6b7280;
  font-weight: 400;
}

.p2p-input-group {
  margin-bottom: 24px;
}

.p2p-input-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

body.dark_theme .p2p-input-group label,
body[data-theme="dark"] .p2p-input-group label {
  color: #ccc;
}

.p2p-amount-box {
  display: flex;
  align-items: center;
  background-color: #F2F2F250;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 12px 16px;
}

body.dark_theme .p2p-amount-box,
body[data-theme="dark"] .p2p-amount-box {
  background-color: rgb(0 0 0 / 50%);
  border-color: #272727;
}

.p2p-currency-symbol,
.p2p-token-circle-sm {
  font-size: 18px;
  color: #6b7280;
  margin-right: 12px;
}

.p2p-token-circle-sm {
  color: #26A17B;
}

.p2p-amount-box input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 22px;
  font-weight: 700;
  color: #707070;
}

body.dark_theme .p2p-amount-box input,
body[data-theme="dark"] .p2p-amount-box input {
  color: #fff;
}

.p2p-currency-dropdown-sm {
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #ffffff85;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}

body.dark_theme .p2p-currency-dropdown-sm,
body[data-theme="dark"] .p2p-currency-dropdown-sm {
  background-color: #374151;
  border-color: #444;
  color: #fff;
}

.p2p-limit-hint {
  font-size: 12px;
  color: #9CA3AF;
  font-weight: 300;
  margin-top: 8px;
}

.p2p-limit-hint span {
  color: #10B981;
  font-weight: 600;
}

.p2p-payment-select-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F9F9F9;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
}

body.dark_theme .p2p-payment-select-box,
body[data-theme="dark"] .p2p-payment-select-box {
  background-color: rgb(0 0 0 / 50%);
  border-color: #272727;
}

.p2p-pay-sel-left {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #374151;
  font-weight: 500;
}

.p2p-pay-sel-left i {
  color: #D1AA67;
  font-size: 18px;
  background-color: #D1AA6720;
  width: 32px;
  height: 32px;
  line-height: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.dark_theme .p2p-pay-sel-left,
body[data-theme="dark"] .p2p-pay-sel-left {
  color: #ccc;
}

.p2p-payment-dropdown-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: hidden;
}

body.dark_theme .p2p-payment-dropdown-list,
body[data-theme="dark"] .p2p-payment-dropdown-list {
  background-color: #2a2a36;
  border-color: #444;
}

.p2p-payment-dropdown-item {
  padding: 12px 16px;
  font-size: 15px;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.p2p-payment-dropdown-item i {
  color: #D1AA67;
  font-size: 18px;
  background-color: #D1AA6720;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.p2p-payment-dropdown-item:hover {
  background-color: #f3f4f6;
}

body.dark_theme .p2p-payment-dropdown-item,
body[data-theme="dark"] .p2p-payment-dropdown-item {
  color: #ccc;
}

body.dark_theme .p2p-payment-dropdown-item:hover,
body[data-theme="dark"] .p2p-payment-dropdown-item:hover {
  background-color: #374151;
}


.p2p-escrow-info {
  display: flex;
  gap: 16px;
  background: #F2F2F280;
  padding: 22px;
  border-radius: 12px;
  margin-bottom: 22px;
}

body.dark_theme .p2p-escrow-info,
body[data-theme="dark"] .p2p-escrow-info {
  background: rgba(16, 185, 129, 0.1);
}

.p2p-escrow-info i {
  color: #10B981;
  font-size: 24px;
}

.p2p-escrow-info strong {
  display: block;
  font-size: 14px;
  color: #111827;
  margin-bottom: 4px;
}

body.dark_theme .p2p-escrow-info strong,
body[data-theme="dark"] .p2p-escrow-info strong {
  color: #fff;
}

.p2p-escrow-info p {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.p2p-terms-check {
  margin-bottom: 24px;
}

.p2p-terms-check label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
}

.p2p-terms-check a {
  color: #10B981;
  text-decoration: underline;
}

.p2p-submit-buy-btn {
  width: 100%;
  background-color: #2BC287;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  padding: 16px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.p2p-submit-buy-btn:hover {
  background-color: #21a16e;
}

@media (max-width: 991px) {

  .p2p-post-ad-header h2 {
    font-size: 26px;
  }



  .p2p-hero-content {
    max-width: 100%;
    margin-bottom: 24px;
  }

  .p2p-tutorial-grid {
    grid-template-columns: 1fr;
  }

  .p2p-filter-bar {
    flex-direction: column;
    align-items: stretch;
  }

  /* Modal Responsive */

  .p2p-modal-left {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .p2p-modal-right {
    width: 100%;
    border-radius: 0 0 24px 24px;
  }
}

/* ==================== 7. TRADING REQUIREMENT MODAL ==================== */
.p2p-req-modal-content {
  background-color: #ffffff50;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border-radius: 16px;
  width: 620px;
  max-width: 90vw;
  box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 3px solid #E1E1E150;
  position: relative;
}

body.dark_theme .p2p-req-modal-content,
body[data-theme="dark"] .p2p-req-modal-content {
  background-color: rgb(0 0 0 / 30%);
  border: 3px solid #e1e1e112;
}

.p2p-req-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px;
}

.p2p-req-modal-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

body.dark_theme .p2p-req-modal-header h2,
body[data-theme="dark"] .p2p-req-modal-header h2 {
  color: #fff;
}

.p2p-modal-close-req {
  background: none;
  border: none;
  font-size: 20px;
  color: #111827;
  cursor: pointer;
}

body.dark_theme .p2p-modal-close-req,
body[data-theme="dark"] .p2p-modal-close-req {
  color: #fff;
}

.p2p-req-modal-body {
  padding: 0 24px;
}

.p2p-req-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}

.p2p-req-item:last-child {
  border-bottom: none;
}

body.dark_theme .p2p-req-item,
body[data-theme="dark"] .p2p-req-item {
  border-bottom-color: #333;
}

.p2p-req-text {
  font-size: 16px;
  color: #636363;
}

body.dark_theme .p2p-req-text,
body[data-theme="dark"] .p2p-req-text {
  color: #ccc;
}

.p2p-req-verify-btn {
  background-color: #D1AA67;
  color: #fff;
  border: none;
  padding: 7px 32px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.p2p-req-done {
  color: #10B981;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.p2p-req-modal-footer {
  display: flex;
  gap: 12px;
  padding: 24px;
}

.p2p-req-cancel-btn {
  flex: 1 1;
  background-color: #E2E8F0;
  color: #4b5563;
  border: none;
  padding: 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

body.dark_theme .p2p-req-cancel-btn,
body[data-theme="dark"] .p2p-req-cancel-btn {
  background-color: #374151;
  color: #ccc;
}

.p2p-req-get-verified-btn {
  flex: 1 1;
  background-color: #333333;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

body.dark_theme .p2p-req-get-verified-btn,
body[data-theme="dark"] .p2p-req-get-verified-btn {
  background-color: #444;
}

/* ==================== 8. P2P TUTORIAL MODAL ==================== */
.p2p-tutorial-modal-content {
  width: 720px !important;
  max-width: 92vw !important;
  max-height: 85vh !important;
  display: flex !important;
  flex-direction: column !important;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  border: 1px solid #e5e7eb;
}

body.dark_theme .p2p-tutorial-modal-content,
body[data-theme="dark"] .p2p-tutorial-modal-content {
  background-color: rgb(26 26 26 / 20%);
  border: 1px solid #232323;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
}

.p2p-tut-modal-header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-tut-modal-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  color: #D1AA67;
  background: rgba(209, 170, 103, 0.12);
  padding: 3px 10px;
  border-radius: 20px;
  width: -moz-fit-content;
  width: fit-content;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.p2p-tut-modal-body {
  overflow-y: auto !important;
  max-height: calc(85vh - 165px) !important;
  padding: 18px 24px !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.p2p-tut-modal-intro {
  font-size: 14.5px;
  line-height: 1.6;
  color: #4b5563;
  background: #f9fafb;
  padding: 14px 16px;
  border-radius: 12px;
  border-left: 3px solid #D1AA67;
  margin: 0;
}

body.dark_theme .p2p-tut-modal-intro,
body[data-theme="dark"] .p2p-tut-modal-intro {
  background: rgb(255 255 255 / 5%);
  color: #d1d5db;
}

.p2p-tut-modal-steps {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-tut-step-card {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 14px;
  background: #fcfcfd;
  border: 1px solid #edf0f3;
  transition: all 0.2s ease;
}

.p2p-tut-step-card:hover {
  border-color: #d1aa67;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

body.dark_theme .p2p-tut-step-card,
body[data-theme="dark"] .p2p-tut-step-card {
  background: rgb(51 51 51 / 10%);
  border-color: #242424;
}

body.dark_theme .p2p-tut-step-card:hover,
body[data-theme="dark"] .p2p-tut-step-card:hover {
  background: #252533;
  border-color: #d1aa67;
}

.p2p-tut-step-num {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d1aa67 0%, #b88f4c 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(209, 170, 103, 0.35);
}

.p2p-tut-step-content {
  flex: 1 1;
}

.p2p-tut-step-content h4 {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 6px 0;
}

body.dark_theme .p2p-tut-step-content h4,
body[data-theme="dark"] .p2p-tut-step-content h4 {
  color: #f3f4f6;
}

.p2p-tut-step-content p {
  font-size: 13.5px;
  line-height: 1.55;
  color: #6b7280;
  margin: 0;
}

body.dark_theme .p2p-tut-step-content p,
body[data-theme="dark"] .p2p-tut-step-content p {
  color: #9ca3af;
}

.p2p-tut-safety-box {
  background: #fdfaf3;
  border: 1px solid #fae8c8;
  border-radius: 12px;
  padding: 14px 16px;
}

body.dark_theme .p2p-tut-safety-box,
body[data-theme="dark"] .p2p-tut-safety-box {
  background: #252016;
  border-color: #4a3c20;
}

.p2p-tut-safety-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b88f4c;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
}

.p2p-tut-safety-box ul {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.p2p-tut-safety-box li {
  font-size: 13px;
  line-height: 1.5;
  color: #6b7280;
}

body.dark_theme .p2p-tut-safety-box li,
body[data-theme="dark"] .p2p-tut-safety-box li {
  color: #c7c1b5;
}

.p2p-tut-gotit-btn {
  background-color: #D1AA67 !important;
  color: #fff !important;
}

.p2p-tut-gotit-btn:hover {
  background-color: #b88f4c !important;
}

/* ==================== 8. P2P ORDER DETAILS PAGE ==================== */
.p2p-order-details-container {
  max-width: 100%;
}

/* Top Header */
.p2p-od-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}

.p2p-od-header-left h2 {
  font-size: 36px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.p2p-od-header-left p {
  color: #6b7280;
  font-size: 17px;
  margin: 12px 0 12px;
}

.p2p-od-escrow-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #D1AA67;
  font-size: 15px;
  font-weight: 500;

}

.p2p-od-header-right {
  display: flex;
  gap: 16px;
  background-color: #1e2026;
  padding: 22px;
  border: 1px solid #303030;
  border-radius: 15px;
  box-shadow: 0px 1px 3px rgb(0 0 0 / 5%);
}

body.light_theme .p2p-od-header-right {
  background-color: #F5F6F7;
  border: 1px solid #EAEAEA;
}

.p2p-od-timer-box,
.p2p-od-info-box {
  padding: 0px;
}

.p2p-od-timer-box {
  width: 240px;
  border-right: 1px solid #434343;
  margin-right: 20px;
}

body.light_theme .p2p-od-timer-box {
  border-right: 1px solid #EAEAEA;
}

.p2p-od-box-label {
  display: block;
  font-size: 14px;
  color: #6B6F75;
  margin-bottom: 2px;
}

.p2p-od-timer-val {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.p2p-od-timer-val span {
  margin: 0 2px;
}

.p2p-od-timer-val small {
  font-size: 12px;
  color: #6B6F75;
  font-weight: 400;
}

.p2p-od-info-box {
  display: flex;
  gap: 32px;
}

.p2p-od-info-col {
  min-width: 240px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #434343;
  padding-right: 20px;
  padding-left: 20px;
}

body.light_theme .p2p-od-info-col {
  border-right: 1px solid #EAEAEA;
}

.p2p-od-info-col:last-child {
  border-right: none;
}

.p2p-od-info-col strong {
  font-size: 16px;
  color: #18181B;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-od-info-col i {
  color: #6b7280;
  cursor: pointer;
}

/* Stepper */
.p2p-od-stepper-container {
  display: flex;
  align-items: center;
  background: #F5F6F7;
  border: 1px solid #EAEAEA;
  padding: 32px;
  border-radius: 14px;
  margin-bottom: 32px;
}

.p2p-od-step {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-od-step-circle {
  width: 48px;
  height: 48px;
  background: #3A3939;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
}

.p2p-od-step.current .p2p-od-step-text-only {
  width: 48px;
  min-width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  display: flex;
  border: 3px solid #F1F1F1;
  font-size: 18px;
  font-weight: 700;
  color: #6B6F75;
  margin-right: 8px;
}

.p2p-od-step.pending .p2p-od-step-text-only {
  width: 48px;
  min-width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  display: flex;
  border: 3px solid #F1F1F1;
  font-size: 18px;
  font-weight: 700;
  color: #6B6F75;
  margin-right: 8px;
}

.p2p-od-step-text h4 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #111827;
}

.p2p-od-step.pending .p2p-od-step-text h4 {
  color: #9ca3af;
}

.p2p-od-step-text p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #6B6F75;
}

.p2p-od-step-line {
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
  margin: 0 24px;
}

.p2p-od-step-line.dashed {
  border-top: 1px dashed #d1d5db;
  background: none;
}

/* Main Body Layout */
.p2p-od-main-body {
  display: flex;
  gap: 24px;
}

.p2p-od-left-col {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.p2p-od-right-col {
  flex: 1 1;
}

.p2p-od-card {
  background: #F5F6F7;
  border: 1px solid #EAEAEA;
  border-radius: 14px;
}

.p2p-od-card h3 {
  font-size: 24px;
  font-weight: 700;
  color: #18181B;
  margin: 0px;
}

.header_card_top {
  padding: 28px;
}

.p2p-od-card.p2p-od-payment-card .p2p-od-payment-desc {
  margin: 12px 0px 0px;
}

/* Order Details Grid */
.p2p-od-details-grid {
  display: flex;
  justify-content: space-around;
  gap: 18px;
  border-top: 1px solid #353535;
  padding: 28px;
}

body.light_theme .p2p-od-details-grid {
  border-top: 1px solid #EAEAEA;
}

.p2p-od-detail-item {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
}

.p2p-od-detail-item strong {
  font-size: 17px;
  color: #18181B;
  font-weight: 700;
}

.p2p-od-detail-item span {
  font-size: 15px;
  color: #6B6F75;
}

.p2p-od-buy-tag {
  color: #22C55E !important;
  font-weight: 700;
}

.payment_method_bl {
  width: 100%;
  border-top: 1px solid #353535;
  padding: 28px;
}

body.light_theme .payment_method_bl {
  border-top: 1px solid #EAEAEA;
}

/* Payment Card */
.p2p-od-payment-desc {
  font-size: 15px;
  color: #6b7280;
  margin-bottom: 16px;
  line-height: 1.5;
}

.p2p-od-warning-note {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #FFF9E6;
  border: 1px solid #FED7AA;
  color: #C28E27;
  padding: 20px;
  font-weight: 500;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 32px;
  margin-top: 4px;
}

.p2p-od-warning-icon {
  font-size: 18px;
}

.p2p-od-payment-split {
  display: flex;
  gap: 82px;
}

.p2p-od-payment-options {
  max-width: 254px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.p2p-od-radio-label {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #dfdfdf;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #374151;
  background: none;
  transition: all 0.2s;
}

.p2p-od-radio-label.active {
  border-color: #D1AA67;
  background: #fff;
  color: #18181B;
}

.p2p-od-radio-label input[type="radio"] {
  display: none;
}

.p2p-od-radio-label i {
  font-size: 18px;
  color: #6b7280;
}

.p2p-od-radio-label.active i {
  color: #D1AA67;
}

.radio-custom {
  width: 16px;
  height: 16px;
  border: 1px solid #d1d5db;
  border-radius: 50%;
}

.p2p-od-radio-label.active .radio-custom {
  border: 4px solid #D1AA67;
}

.p2p-od-payment-details {
  flex: 1 1;
  background: #F1F1F1;
  border: 1px solid #363636;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

body.light_theme .p2p-od-payment-details {
  border: 1px solid #EAEAEA;
}

.p2p-od-pay-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}

.p2p-od-pay-row span {
  color: #6b7280;
}

.p2p-od-pay-row strong {
  color: #111827;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.p2p-od-pay-row i {
  color: #9ca3af;
  cursor: pointer;
}

/* Next Step */
.p2p-od-next-step h3 {
  font-size: 24px;
  color: #111827;
  margin: 0 0 12px;
  font-weight: 700;
}

.p2p-od-next-step p {
  font-size: 17px;
  color: #6B7280;
  margin: 0 0 8px;
}

.p2p-od-subtext {
  color: #6B7280;
  font-size: 16px !important;
  margin-bottom: 20px !important;
}

.p2p-od-action-btns {
  display: flex;
  gap: 16px;
  margin: 24px 0px 5px;
}

.p2p-od-action-btns button {
  border: none;
  padding: 18px 32px;
  border-radius: 30px;
  font-weight: 700;
  font-size: 18px;
  width: 100%;
}

.p2p-od-paid-btn {
  background: #D1AA67;
  color: #fff;
  cursor: pointer;
}

.p2p-od-cancel-btn {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 700;
  cursor: pointer;
}

/* Description Card */
.p2p-od-desc-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p2p-od-desc-content ul {
  margin: 0;
  color: #bebebe;
  font-size: 17px;
  margin-top: 15px;
  flex-direction: column;
  gap: 6px;
  display: flex;
  line-height: 1.8;
}

body.light_theme .p2p-od-desc-content ul {
  color: #6b7280;
}

.p2p-od-desc-image {
  width: 315px;
}

/* Right Column - Chat */
.p2p-od-chat-card {
  background: #F5F6F7;
  border: 1px solid #EAEAEA;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.p2p-od-chat-header {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.p2p-od-chat-user {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.p2p-od-chat-avatar {
  width: 54px;
  height: 54px;
  background: #00D8FF;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
}

.p2p-od-chat-info h4 {
  margin: 0 0 4px;
  font-size: 19px;
  font-weight: 700;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 4px;
}

.p2p-od-chat-info h4 i {
  color: #22C55E;
  font-size: 14px;
}

.p2ptop_right {
  display: flex;
  gap: 24px;
}

.p2p-od-chat-rating {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.p2p-od-chat-rating .stars {
  color: #C28E27;
  display: flex;
  gap: 2px;
}

.p2p-od-chat-stats {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}

.p2p-od-chat-stats>div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.p2p-od-chat-stats span {
  font-size: 12px;
  color: #9ca3af;
}

.p2p-od-chat-stats strong {
  font-size: 17px;
  color: #111827;
}

.p2p-od-chat-badges {
  display: flex;
  gap: 12px;
  justify-content: space-around;
  margin-top: 10px;
}

.p2p-od-chat-badges span {
  font-size: 12px;
  color: #6B6F75;
}

.p2p-od-chat-body {
  flex: 1 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
}

.p2p-od-msg-row {
  display: flex;
  gap: 12px;
}

.p2p-od-msg-row.sent {
  justify-content: flex-end;
}

.p2p-od-msg-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #00d8ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.p2p-od-msg-avatar.me {
  background: #22C55E;
}

.p2p-od-msg-bubble {
  background: #f3f4f6;
  padding: 12px 16px;
  border-radius: 0 12px 12px 12px;
  font-size: 13px;
  color: #374151;
  max-width: 80%;
}

.p2p-od-msg-row.sent .p2p-od-msg-bubble {
  background: #E8F5E9;
  border-radius: 12px 0 12px 12px;
}

.p2p-od-msg-bubble p {
  margin: 0 0 8px;
  line-height: 1.5;
}

.p2p-od-msg-time {
  font-size: 11px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
}

.p2p-od-msg-time i {
  color: #10B981;
}

.p2p-od-msg-bubble.system-msg {
  background: #E8F5E9;
  border-radius: 12px;
  max-width: 100%;
  margin: 0 auto;
}

.p2p-od-chat-footer {
  padding: 18px;
  background-color: #fff;
  /* border-top: 1px solid #e5e7eb; */
  display: flex;
  align-items: center;
  border-radius: 12px;
  gap: 12px;
  width: 90%;
  max-width: 100%;
  margin: 20px auto;
}

.p2p-od-card.p2p-od-desc-card {
  margin: 46px 0px 30px;
  padding: 30px 48px;
}

.p2p-od-chat-footer input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 15px;
}

.p2p-od-chat-attach,
.p2p-od-chat-send {
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  font-size: 18px;
}

.p2p-od-chat-send {
  color: #C28E27;
}

/* Dark Theme Overrides */
body.dark_theme .p2p-od-header-left h2,
body.dark_theme .p2p-od-timer-val,
body.dark_theme .p2p-od-info-col strong,
body.dark_theme .p2p-od-step.current .p2p-od-step-text-only,
body.dark_theme .p2p-od-step-text h4,
body.dark_theme .p2p-od-card h3,
body.dark_theme .p2p-od-detail-item strong,
body.dark_theme .p2p-od-pay-row strong,
body.dark_theme .p2p-od-next-step h3,
body.dark_theme .p2p-od-chat-info h4,
body.dark_theme .p2p-od-chat-stats strong {
  color: #fff;
}

body.dark_theme .p2p-od-stepper-container,
body.dark_theme .p2p-od-card,
body.dark_theme .p2p-od-chat-card {
  background: #1e2026;
  border-color: #303030;
}

body.dark_theme .p2p-od-step-line,
body.dark_theme .p2p-od-step-line.dashed {
  border-color: #444;
  background: #444;
}

body.dark_theme .p2p-od-step-line.dashed {
  background: none;
}

body.dark_theme .p2p-od-radio-label {
  background: #2a2a36;
  border-color: #444;
  color: #ccc;
}

body.dark_theme .p2p-od-radio-label.active {
  background: #D1AA6710;
  border-color: #D1AA67;
}

body.dark_theme .p2p-od-payment-details,
body.dark_theme .p2p-od-msg-bubble {
  background: #28292f;
  color: #bfbfbf;
}

body.dark_theme .p2p-od-msg-row.sent .p2p-od-msg-bubble {
  background: #10B98120;
}

body.dark_theme .p2p-od-msg-bubble.system-msg {
  background: #10B98120;
}

body.dark_theme .p2p-od-cancel-btn {
  background: #333;
  color: #ccc;
}

body.dark_theme .p2p-od-chat-header,
body.dark_theme .p2p-od-chat-footer {
  border-color: #333;
}

body.dark_theme .p2p-od-chat-footer input {
  color: #fff;
}

@media (max-width: 991px) {
  .p2p-od-header-row {
    flex-direction: column;
    gap: 20px;
  }

  button.p2p-sidebar-collapse-btn {
    background-color: transparent;
    border: none;
    color: #fff;
    padding: 0px;
  }

  button.p2p-sidebar-collapse-btn i {
    display: none;
  }

  .p2p-sidebar-nav {
    padding: 20px 0px 32px 10px;
  }

  .p2p-od-main-body {
    flex-direction: column;
  }

  .p2p-od-payment-split {
    flex-direction: column;
  }

  .p2p-od-info-box {
    flex-direction: column;
    gap: 16px;
  }

  .p2p-od-stepper-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .p2p-od-step-line {
    display: none;
  }
}

/* ==================== 9. CREATE P2P AD PAGE ==================== */
/* [UNUSED]
.p2p-cp-container {
  max-width: 100%;
}
*/

/* Top Header */
/* [UNUSED]
.p2p-cp-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}
*/

/* [UNUSED]
.p2p-cp-header-text h2 {
  font-size: 40px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}
*/

/* [UNUSED]
.p2p-cp-header-text p {
  color: #6b7280;
  font-size: 18px;
  margin: 0 0 16px;
}
*/

/* [UNUSED]
.p2p-cp-escrow-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #D1AA67;
  font-size: 15px;
  font-weight: 400;
}
*/

/* [UNUSED]
.p2p-cp-header-stats {
  display: flex;
  gap: 32px;
}
*/

/* [UNUSED]
.p2p-cp-stat {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #99999920;
  padding-right: 24px;
}
*/

/* [UNUSED]
.p2p-cp-stat:last-child {
  border-right: none;
  padding-right: 0px;
}
*/

/* [UNUSED]
.p2p-cp-stat strong {
  font-size: 15px;
  color: #111827;
  font-weight: 700;
}
*/

/* [UNUSED]
.p2p-cp-stat span {
  font-size: 12px;
  color: #9ca3af;
}
*/

/* Main Layout */
/* [UNUSED]
.p2p-cp-main {
  display: flex;
  gap: 32px;
}
*/

/* [UNUSED]
.p2p-cp-left {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
*/

/* [UNUSED]
.p2p-cp-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
*/

/* Form Steps */
/* [UNUSED]
.p2p-cp-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
*/

/* [UNUSED]
.p2p-cp-step-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-cp-step-num {
  width: 28px;
  height: 28px;
  background: #111827;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}
*/

/* [UNUSED]
.p2p-cp-step-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}
*/

.text-muted {
  color: #9ca3af;
  font-weight: 400;
}

.text-green {
  color: #2BC287 !important;
}

.text-gold {
  color: #D1AA67 !important;
}

/* Form Fields */
/* [UNUSED]
.p2p-cp-form-row {
  display: grid;
  gap: 20px;
}
*/

/* [UNUSED]
.p2p-cp-form-row.three-col {
  grid-template-columns: 1fr 1fr 1fr;
}
*/

/* [UNUSED]
.p2p-cp-form-row.two-col {
  grid-template-columns: 1fr 1fr;
}
*/

/* [UNUSED]
.p2p-cp-form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
*/

/* [UNUSED]
.p2p-cp-form-group label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 300;
}
*/

/* [UNUSED]
.p2p-cp-form-group select,
.p2p-cp-form-group input[type="text"],
.p2p-cp-textarea-wrap textarea {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  font-size: 17px;
  font-weight: 600;
  color: #111827;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}
*/

/* [UNUSED]
.p2p-cp-form-group select:focus,
.p2p-cp-form-group input[type="text"]:focus,
.p2p-cp-textarea-wrap textarea:focus {
  border-color: #D1AA67;
  background: #fff;
}
*/

/* [UNUSED]
.p2p-cp-select-wrapper {
  position: relative;
}
*/

/* [UNUSED]
.p2p-cp-select-wrapper select.has-icon {
  padding-left: 40px;
}
*/

/* [UNUSED]
.p2p-cp-select-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}
*/

/* [UNUSED]
.p2p-cp-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
*/

/* [UNUSED]
.p2p-cp-input-wrap input {
  padding-right: 80px;
}
*/

/* [UNUSED]
.p2p-cp-input-suffix {
  position: absolute;
  right: 16px;
  color: #9ca3af;
  font-size: 14px;
  pointer-events: none;
}
*/

/* [UNUSED]
.p2p-cp-form-group small {
  font-size: 12px;
  color: #9ca3af;
}
*/

/* Tabs */
/* [UNUSED]
.p2p-cp-tabs {
  display: flex;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}
*/

/* [UNUSED]
.p2p-cp-tab {
  flex: 1 1;
  text-align: center;
  padding: 14px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 400;
}
*/

/* [UNUSED]
.p2p-cp-tab.active {
  background: #D1AA67;
  color: #fff;
}
*/

/* Notice */
/* [UNUSED]
.p2p-cp-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  font-size: 13px;
}
*/

/* [UNUSED]
.p2p-cp-notice.yellow {
  background: #FFF9ED;
  color: #4B5563;
  border: 1px solid #D1AA6720;
}
*/

/* [UNUSED]
.p2p-cp-notice i {
  font-size: 18px;
  color: #D1AA67;
}
*/

/* [UNUSED]
.p2p-cp-notice strong {
  display: block;
  font-size: 14px;
  margin-bottom: 4px;
}
*/

/* [UNUSED]
.p2p-cp-notice p {
  margin: 0;
}
*/

/* Payment Methods Grid */
/* [UNUSED]
.p2p-cp-pm-grid {
  display: flex;
  gap: 16px;
}
*/

/* [UNUSED]
.p2p-cp-pm-item {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-cp-pm-item.active {
  background: #FFFdf7;
  border-color: #D1AA67;
}
*/

/* [UNUSED]
.p2p-cp-pm-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
*/

/* [UNUSED]
.p2p-cp-pm-item i {
  font-size: 20px;
}
*/

/* [UNUSED]
.p2p-cp-pm-add-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #D1AA67;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-cp-step-header h3 .text-muted {
  font-weight: 600;
}
*/

/* Textarea */
/* [UNUSED]
.p2p-cp-textarea-wrap {
  position: relative;
}
*/

/* [UNUSED]
.p2p-cp-textarea-wrap textarea {
  height: 120px;
  resize: none;
}
*/

/* [UNUSED]
.p2p-cp-textarea-count {
  position: absolute;
  bottom: 16px;
  right: 16px;
  font-size: 12px;
  color: #9ca3af;
}
*/

/* Conditions */
/* [UNUSED]
.p2p-cp-conditions {
  display: flex;
  gap: 32px;
}
*/

/* [UNUSED]
.p2p-cp-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #4b5563;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-cp-checkbox input[type="checkbox"] {
  display: none;
}
*/

/* [UNUSED]
.p2p-cp-checkbox .check-box {
  width: 20px;
  height: 20px;
  border: 2px solid #D1AA67;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
  transition: all 0.2s;
}
*/

/* [UNUSED]
.p2p-cp-checkbox input[type="checkbox"]:checked+.check-box {
  background: #D1AA67;
  color: #fff;
}
*/

/* [UNUSED]
.p2p-cp-days-input {
  width: 50px;
  padding: 4px 8px;
  text-align: center;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin: 0 4px;
}
*/

/* Important Notes */
/* [UNUSED]
.p2p-cp-notes {
  margin-top: 20px;
}
*/

/* [UNUSED]
.p2p-cp-notes h4 {
  font-size: 19px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 16px;
}
*/

/* [UNUSED]
.p2p-cp-notes ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
*/

/* [UNUSED]
.p2p-cp-notes li {
  font-size: 14px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* [UNUSED]
.p2p-cp-notes li i {
  color: #D1AA67;
}
*/

/* Ad Preview Card */
/* [UNUSED]
.p2p-cp-preview-card {
  background: #f9fafb;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
*/

/* [UNUSED]
.p2p-cp-preview-header-section {
  background: #0F172A;
  padding: 24px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
*/

/* [UNUSED]
.p2p-cp-preview-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
*/

/* [UNUSED]
.p2p-cp-preview-header span:first-child {
  font-size: 16px;
  font-weight: 700;
}
*/

/* [UNUSED]
.p2p-cp-badge-buy {
  background: #14532D50;
  color: #4ADE80;
  border: 1px solid #14532D30;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
}
*/

/* [UNUSED]
.p2p-cp-preview-graphic {
  margin: 10px 0;
}
*/

/* [UNUSED]
.p2p-cp-preview-body {
  padding: 32px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
*/

/* [UNUSED]
.p2p-cp-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f3f4f6;
}
*/

/* [UNUSED]
.p2p-cp-preview-row.pm-row {
  border-bottom: none;
}
*/

/* [UNUSED]
.p2p-cp-preview-row .label {
  color: #6b7280;
  font-size: 16px;
}
*/

/* [UNUSED]
.p2p-cp-preview-row .value {
  color: #111827;
}
*/

/* [UNUSED]
.p2p-cp-preview-row .value strong {
  font-size: 16px;
}
*/

/* [UNUSED]
.p2p-cp-preview-row .value small {
  color: #9ca3af;
}
*/

/* [UNUSED]
.pm-icons {
  display: flex;
  gap: 8px;
  align-items: center;
}
*/

/* [UNUSED]
.pm-pill {
  font-size: 12px;
  color: #111827;
  font-weight: 600;
}
*/

/* [UNUSED]
.pm-dots {
  color: #9ca3af;
}
*/

/* [UNUSED]
.p2p-cp-remarks-box-preview {
  background: #f9fafb;
  border-radius: 8px;
  padding: 16px;
}
*/

/* [UNUSED]
.p2p-cp-remarks-box-preview h4 {
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
*/

/* [UNUSED]
.p2p-cp-remarks-box-preview p {
  margin: 0;
  font-size: 13px;
  background-color: #fff;
  padding: 12px;
  border-radius: 6px;
  color: #6b7280;
  line-height: 1.5;
}
*/

/* [UNUSED]
.p2p-cp-safe-notice {
  display: flex;
  gap: 12px;
  background: #F0FDF4;
  color: #6e6e6e;
  padding: 16px;
  border-radius: 8px;
  font-size: 12px;
}
*/

/* [UNUSED]
.p2p-cp-safe-notice i {
  font-size: 16px;
}
*/

/* [UNUSED]
.p2p-cp-safe-notice p {
  margin: 0;
}
*/

/* [UNUSED]
.p2p-cp-agree-check {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
  color: #4b5563;
  margin-top: 8px;
  cursor: pointer;
}
*/

/* [UNUSED]
.p2p-cp-agree-check input {
  display: none;
}
*/

/* [UNUSED]
.p2p-cp-agree-check .check-box {
  width: 18px;
  height: 18px;
  border: 2px solid #111827;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
  transition: all 0.2s;
  flex-shrink: 0;
}
*/

/* [UNUSED]
.p2p-cp-agree-check input:checked+.check-box {
  background: #111827;
  color: #fff;
}
*/

/* [UNUSED]
.p2p-cp-submit-btn {
  width: 100%;
  background: #D1AA67;
  color: #fff;
  border: none;
  padding: 18px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 12px;
}
*/

/* Help Card */

/* [UNUSED]
.notes_help_bl.d-flex {
  width: 100%;
  justify-content: space-between;
  gap: 32px;
  border-top: 1px solid #F3F4F6;
  margin-top: 30px;
  padding-top: 50px;
}
*/

/* [UNUSED]
.p2p-cp-help-card {
  background: #F9FAFB;
  width: 458px;
  max-width: 100%;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #F3F4F6;
}
*/

/* [UNUSED]
.p2p-cp-help-icon {
  width: 48px;
  height: 48px;
  background: #111827;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 16px;
}
*/

/* [UNUSED]
.p2p-cp-help-card h4 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #111827;
  font-weight: 700;
}
*/

/* [UNUSED]
.p2p-cp-help-card p {
  margin: 0 0 24px;
  font-size: 14px;
  color: #6b7280;
}
*/

/* [UNUSED]
.p2p-cp-help-btn {
  background: #fff;
  border: 1px solid #D48806;
  color: #D48806;
  padding: 10px 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
*/

/* Dark Mode Overrides */
/* [UNUSED]
body.dark_theme .p2p-cp-header-text h2,
body.dark_theme .p2p-cp-stat strong,
body.dark_theme .p2p-cp-step-header h3,
body.dark_theme .p2p-cp-form-group label,
body.dark_theme .p2p-cp-pm-name,
body.dark_theme .p2p-cp-notes h4,
body.dark_theme .p2p-cp-preview-row .value,
body.dark_theme .p2p-cp-remarks-box-preview h4,
body.dark_theme .p2p-cp-help-card h4,
body.dark_theme .pm-pill {
  color: #fff;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-step-num {
  background: #fff;
  color: #111827;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-form-group select,
body.dark_theme .p2p-cp-form-group input[type="text"],
body.dark_theme .p2p-cp-textarea-wrap textarea {
  background: #1a1a24;
  border-color: #333;
  color: #fff;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-form-group select:focus,
body.dark_theme .p2p-cp-form-group input[type="text"]:focus,
body.dark_theme .p2p-cp-textarea-wrap textarea:focus {
  background: #2a2a36;
  border-color: #D1AA67;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-tabs,
body.dark_theme .p2p-cp-pm-item,
body.dark_theme .p2p-cp-preview-card,
body.dark_theme .p2p-cp-help-card {
  background: #1a1a24;
  border-color: #333;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-preview-body {
  background: #1a1a24;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-preview-row {
  border-color: #333;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-remarks-box-preview {
  background: #2a2a36;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-safe-notice {
  background: #10B98120;
  color: #10B981;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-agree-check .check-box {
  border-color: #fff;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-agree-check input:checked+.check-box {
  background: #fff;
  color: #111827;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-help-icon {
  background: #fff;
  color: #111827;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-pm-item.active {
  background: #D1AA6710;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-agree-check {
  color: #ccc;
}
*/

/* [UNUSED]
body.dark_theme .p2p-cp-days-input {
  background: #1a1a24;
  border-color: #333;
  color: #fff;
}
*/

@media (max-width: 991px) {
  /* [UNUSED]
.p2p-cp-header {
    flex-direction: column;
    gap: 24px;
  }
*/

  /* [UNUSED]
.p2p-cp-main {
    flex-direction: column;
  }
*/

  /* [UNUSED]
.p2p-cp-form-row.three-col,
  .p2p-cp-form-row.two-col,
  .p2p-cp-pm-grid {
    grid-template-columns: 1fr;
    display: grid;
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-cp-conditions {
    flex-direction: column;
    gap: 16px;
  }
*/

  /* [UNUSED]
.p2p-cp-header-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    width: 100%;
  }
*/
}

/* ==========================================================================
   P2P MY ORDERS PAGE (ORDERS LISTING - EXACT SCREENSHOT DESIGN)
   ========================================================================== */

.p2p-my-orders-container {
  padding: 0px 5px 48px;
  width: 100%;
  max-width: 100%;
}

.p2p-my-orders-header {
  margin-bottom: 24px;
}

.p2p-my-orders-header h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1E2329;
  letter-spacing: -0.5px;
  margin-bottom: 6px;
}

body.dark_theme .p2p-my-orders-header h2,
body[data-theme="dark"] .p2p-my-orders-header h2 {
  color: #ffffff;
}

.p2p-my-orders-header p {
  font-size: 17px;
  color: #707A8A;
  margin: 0;
}

body.dark_theme .p2p-my-orders-header p,
body[data-theme="dark"] .p2p-my-orders-header p {
  color: #9ca3af;
}

/* 2. Top Navigation Tabs */
.p2p-mo-top-nav {
  display: flex;
  gap: 36px;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 24px;
}

body.dark_theme .p2p-mo-top-nav,
body[data-theme="dark"] .p2p-mo-top-nav {
  border-bottom-color: #2e2e3d;
}

.p2p-mo-top-tab {
  background: none;
  border: none;
  padding: 13px 0;
  font-size: 16px;
  font-weight: 500;
  color: #707A8A;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;
}

.p2p-mo-top-tab:hover {
  color: #111827;
}

body.dark_theme .p2p-mo-top-tab:hover,
body[data-theme="dark"] .p2p-mo-top-tab:hover {
  color: #ffffff;
}

.p2p-mo-top-tab.active {
  color: #111827;
  font-weight: 700;
}

body.dark_theme .p2p-mo-top-tab.active,
body[data-theme="dark"] .p2p-mo-top-tab.active {
  color: #ffffff;
}

.p2p-mo-top-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  margin: 0 auto;
  left: 0;
  max-width: 50%;
  right: 0;
  height: 2.5px;
  background-color: #111827;
}

body.dark_theme .p2p-mo-top-tab.active::after,
body[data-theme="dark"] .p2p-mo-top-tab.active::after {
  background-color: #ffffff;
}

/* 3. Sub-filter Pills & Action Icons */
.p2p-mo-subnav-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.p2p-mo-pill-group {
  display: inline-flex;
  background-color: #F0F0F0;
  border-radius: 50px;
  padding: 4px;
  gap: 4px;
}

body.dark_theme .p2p-mo-pill-group,
body[data-theme="dark"] .p2p-mo-pill-group {
  background-color: #20202c;
}

.p2p-mo-pill-btn {
  background: transparent;
  border: none;
  padding: 8px 24px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 500;
  color: #707A8A;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-mo-pill-btn,
body[data-theme="dark"] .p2p-mo-pill-btn {
  color: #9ca3af;
}

.p2p-mo-pill-btn:hover {
  color: #111827;
}

body.dark_theme .p2p-mo-pill-btn:hover,
body[data-theme="dark"] .p2p-mo-pill-btn:hover {
  color: #ffffff;
}

.p2p-mo-pill-btn.active {
  background-color: #111827;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

body.dark_theme .p2p-mo-pill-btn.active,
body[data-theme="dark"] .p2p-mo-pill-btn.active {
  background-color: #323244;
  color: #ffffff;
}

.p2p-mo-action-icons {
  display: flex;
  gap: 10px;
}

.p2p-mo-icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  background-color: #ffffff;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 17px;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-mo-icon-btn,
body[data-theme="dark"] .p2p-mo-icon-btn {
  background-color: #1c1c26;
  border-color: #2b2b3a;
  color: #9ca3af;
}

.p2p-mo-icon-btn:hover {
  border-color: #D1AA67;
  color: #D1AA67;
  transform: translateY(-1px);
}

/* 4. Summary Stats Cards */
.p2p-mo-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-bottom: 24px;
}

.p2p-mo-stat-card {
  background-color: #F0F0F0;
  border: 1px solid #EAECEF;
  border-radius: 18px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.p2p-mo-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
}

body.dark_theme .p2p-mo-stat-card,
body[data-theme="dark"] .p2p-mo-stat-card {
  background-color: #1e2026;
  border-color: #2b2b3a;
}

.p2p-mo-stat-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #707A8A;
  margin-bottom: 12px;
}

body.dark_theme .p2p-mo-stat-header,
body[data-theme="dark"] .p2p-mo-stat-header {
  color: #9ca3af;
}

.p2p-mo-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
}

.p2p-mo-dot.blue {
  background-color: #3B82F6;
}

.p2p-mo-dot.green {
  background-color: #10B981;
}

.p2p-mo-dot.red {
  background-color: #EF4444;
}

.p2p-mo-dot.purple {
  background-color: #8B5CF6;
}

.p2p-mo-stat-val {
  font-size: 34px;
  font-weight: 800;
  color: #1E2329;
  line-height: 1;
  letter-spacing: -0.5px;
}

body.dark_theme .p2p-mo-stat-val,
body[data-theme="dark"] .p2p-mo-stat-val {
  color: #ffffff;
}

.p2p-mo-stat-badge {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.p2p-mo-stat-badge.yellow {
  background-color: #FEFCE8;
  color: #FCD535;
}

.p2p-mo-stat-badge.green {
  background-color: #F0FDF4;
  color: #0ECB81;
}

.p2p-mo-stat-badge.red {
  background-color: #FEF2F2;
  color: #F6465D;
}

.p2p-mo-stat-badge.purple {
  background-color: #FAF5FF;
  color: #A855F7;
}

body.dark_theme .p2p-mo-stat-badge.yellow,
body[data-theme="dark"] .p2p-mo-stat-badge.yellow {
  background-color: rgba(217, 119, 6, 0.18);
  color: #FBBF24;
}

body.dark_theme .p2p-mo-stat-badge.green,
body[data-theme="dark"] .p2p-mo-stat-badge.green {
  background-color: rgba(16, 185, 129, 0.18);
  color: #34D399;
}

body.dark_theme .p2p-mo-stat-badge.red,
body[data-theme="dark"] .p2p-mo-stat-badge.red {
  background-color: rgba(239, 68, 68, 0.18);
  color: #F87171;
}

body.dark_theme .p2p-mo-stat-badge.purple,
body[data-theme="dark"] .p2p-mo-stat-badge.purple {
  background-color: rgba(139, 92, 246, 0.18);
  color: #A78BFA;
}

/* 5. Second Filter Row */
.p2p-mo-filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 22px;
  flex-wrap: wrap;
}

.p2p-mo-filter-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.p2p-mo-select-wrap {
  background-color: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 8px 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  position: relative;
}

body.dark_theme .p2p-mo-select-wrap,
body[data-theme="dark"] .p2p-mo-select-wrap {
  background-color: transparent;
  border-color: #2b2b3a;
}

.p2p-mo-select-wrap label {
  color: #9CA3AF;
  font-size: 13.5px;
  font-weight: 400;
  margin: 0;
}

.p2p-mo-native-select {
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
  padding-right: 4px;
  appearance: none;
}

body.dark_theme .p2p-mo-native-select,
body[data-theme="dark"] .p2p-mo-native-select {
  color: #ffffff;
  background-color: #1c1c26;
}

.p2p-mo-select-wrap i {
  font-size: 16px;
  color: #6b7280;
  pointer-events: none;
}

.p2p-mo-date-wrap {
  background-color: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

body.dark_theme .p2p-mo-date-wrap,
body[data-theme="dark"] .p2p-mo-date-wrap {
  background-color: transparent;
  border-color: #2b2b3a;
  color: #ffffff;
}

.p2p-mo-date-wrap i {
  color: #9CA3AF;
  font-size: 16px;
}

.p2p-mo-filter-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.p2p-mo-search-box {
  background-color: #FAFAFA;
  border: 1px solid #EAECEF;
  border-radius: 9px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 250px;
}

body.dark_theme .p2p-mo-search-box,
body[data-theme="dark"] .p2p-mo-search-box {
  background-color: transparent;
  border-color: #2b2b3a;
}

.p2p-mo-search-box i {
  color: #9CA3AF;
  font-size: 16px;
}

.p2p-mo-search-box input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: #111827;
  width: 100%;
}

body.dark_theme .p2p-mo-search-box input,
body[data-theme="dark"] .p2p-mo-search-box input {
  color: #ffffff;
}

.p2p-mo-search-box input::placeholder {
  color: #9CA3AF;
}

.p2p-mo-reset-btn {
  background-color: #1E2329;
  color: #ffffff;
  border: none;
  border-radius: 9px;
  padding: 10px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.p2p-mo-reset-btn:hover {
  background-color: #374151;
}

body.dark_theme .p2p-mo-reset-btn,
body[data-theme="dark"] .p2p-mo-reset-btn {
  background-color: #2E2E3E;
  color: #ffffff;
}

body.dark_theme .p2p-mo-reset-btn:hover,
body[data-theme="dark"] .p2p-mo-reset-btn:hover {
  background-color: #3E3E52;
}

/* 6. Orders Table Card */
.p2p-mo-table-card {
  background-color: rgb(255 255 255 / 10%);
  border: 1px solid #EAECEF;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
}

body.dark_theme .p2p-mo-table-card,
body[data-theme="dark"] .p2p-mo-table-card {
  background-color: #1e2026;
  border-color: #2b2b3a;
}

.p2p-mo-table-responsive {
  width: 100%;
  overflow-x: auto;
}

.p2p-mo-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.p2p-mo-table th {
  padding: 18px 24px;
  font-size: 14px;
  font-weight: 400;
  color: #6C6969;
  border-bottom: 1px solid #EFEFEF;
  background-color: #ffffff;
  white-space: nowrap;
}

body.dark_theme .p2p-mo-table th,
body[data-theme="dark"] .p2p-mo-table th {
  background-color: #1c1c26;
  color: #9CA3AF;
  border-bottom-color: #2b2b3a;
}

.p2p-mo-table td {
  padding: 20px 24px;
  font-size: 14px;
  border-bottom: 1px solid #F3F4F6;
  vertical-align: middle;
}

body.dark_theme .p2p-mo-table td,
body[data-theme="dark"] .p2p-mo-table td {
  border-bottom-color: #262635;
}

.p2p-mo-table tbody tr:last-child td {
  border-bottom: none;
}

.p2p-mo-table tbody tr:hover td {
  background-color: rgba(0, 0, 0, 0.012);
}

body.dark_theme .p2p-mo-table tbody tr:hover td,
body[data-theme="dark"] .p2p-mo-table tbody tr:hover td {
  background-color: rgba(255, 255, 255, 0.02);
}

/* Row elements */
.p2p-mo-type-cell {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.p2p-mo-type-line {
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px;
}

.p2p-mo-side.buy {
  color: #2BC287;
}

.p2p-mo-side.sell {
  color: #EC6072;
}

.p2p-mo-asset {
  color: #111827;
  font-weight: 700;
}

body.dark_theme .p2p-mo-asset,
body[data-theme="dark"] .p2p-mo-asset {
  color: #ffffff;
}

.p2p-mo-date-line {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  color: #9CA3AF;
}

.p2p-mo-date-line i {
  font-size: 13px;
}

.p2p-mo-order-id-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.p2p-mo-order-num {
  font-size: 14px;
  font-weight: 500;
  color: #1E2329;
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: -0.2px;
}

body.dark_theme .p2p-mo-order-num,
body[data-theme="dark"] .p2p-mo-order-num {
  color: #ffffff;
}

.p2p-mo-copy-btn {
  background: none;
  border: none;
  color: #9CA3AF;
  cursor: pointer;
  padding: 0;
  font-size: 15px;
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}

.p2p-mo-copy-btn:hover {
  color: #D1AA67;
}

.p2p-mo-price-val {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

body.dark_theme .p2p-mo-price-val,
body[data-theme="dark"] .p2p-mo-price-val {
  color: #ffffff;
}

.p2p-mo-amount-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.p2p-mo-fiat-val {
  font-size: 14.5px;
  font-weight: 700;
  color: #111827;
}

body.dark_theme .p2p-mo-fiat-val,
body[data-theme="dark"] .p2p-mo-fiat-val {
  color: #ffffff;
}

.p2p-mo-crypto-val {
  font-size: 12.5px;
  color: #9CA3AF;
}

.p2p-mo-counterparty-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.p2p-mo-user-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  text-decoration: underline;
  cursor: pointer;
}

body.dark_theme .p2p-mo-user-name,
body[data-theme="dark"] .p2p-mo-user-name {
  color: #ffffff;
}

.p2p-mo-chat-pill {
  display: inline-block;
  background-color: #ffffff;
  border: 1px solid #EAECEF;
  border-radius: 4px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 500;
  color: #707A8A;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-mo-chat-pill,
body[data-theme="dark"] .p2p-mo-chat-pill {
  background-color: #242432;
  border-color: #353548;
  color: #D1D5DB;
}

.p2p-mo-chat-pill:hover {
  border-color: #D1AA67;
  color: #D1AA67;
}

.p2p-mo-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.p2p-mo-status-badge {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 500;
}

.p2p-mo-status-badge.cancelled {
  background-color: #FFEDF1;
  color: #F6465D;
}

.p2p-mo-status-badge.completed {
  background-color: #D1FAE5;
  color: #10B981;
}

.p2p-mo-status-badge.processing {
  background-color: #FEF3C7;
  color: #D97706;
}

.p2p-mo-status-badge.appeal {
  background-color: #EDE9FE;
  color: #8B5CF6;
}

body.dark_theme .p2p-mo-status-badge.cancelled,
body[data-theme="dark"] .p2p-mo-status-badge.cancelled {
  background-color: rgba(239, 68, 68, 0.18);
  color: #F87171;
}

body.dark_theme .p2p-mo-status-badge.completed,
body[data-theme="dark"] .p2p-mo-status-badge.completed {
  background-color: rgba(16, 185, 129, 0.18);
  color: #34D399;
}

body.dark_theme .p2p-mo-status-badge.processing,
body[data-theme="dark"] .p2p-mo-status-badge.processing {
  background-color: rgba(217, 119, 6, 0.18);
  color: #FBBF24;
}

body.dark_theme .p2p-mo-status-badge.appeal,
body[data-theme="dark"] .p2p-mo-status-badge.appeal {
  background-color: rgba(139, 92, 246, 0.18);
  color: #A78BFA;
}

.p2p-mo-appeal-link {
  font-size: 12.5px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  transition: color 0.2s ease;
}

.p2p-mo-appeal-link:hover {
  color: #111827;
  text-decoration: underline;
}

body.dark_theme .p2p-mo-appeal-link,
body[data-theme="dark"] .p2p-mo-appeal-link {
  color: #9CA3AF;
}

body.dark_theme .p2p-mo-appeal-link:hover,
body[data-theme="dark"] .p2p-mo-appeal-link:hover {
  color: #ffffff;
}

.p2p-mo-empty-row {
  text-align: center;
  padding: 60px 20px !important;
}

.p2p-mo-empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #9CA3AF;
}

.p2p-mo-empty-content i {
  font-size: 40px;
}

.p2p-mo-empty-content p {
  font-size: 14.5px;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .p2p-mo-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .p2p-my-orders-container {
    padding: 20px 16px 36px;
  }

  .p2p-mo-stats-grid {
    grid-template-columns: 1fr;
  }

  .p2p-mo-filter-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .p2p-mo-filter-left,
  .p2p-mo-filter-right {
    width: 100%;
  }

  .p2p-mo-search-box {
    width: 100%;
  }
}

/* ==========================================================================
   P2P POST NORMAL AD (3-STEP MULTI-STEP FORM & CONFIRMATION MODAL)
   ========================================================================== */

.p2p-post-ad-page {
  padding: 0px 5px 50px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.p2p-post-ad-header {
  margin-bottom: 28px;
}

.p2p-post-ad-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -1px;
  margin-bottom: 6px;
}

body.dark_theme .p2p-post-ad-header h2,
body[data-theme="dark"] .p2p-post-ad-header h2 {
  color: #ffffff;
}

.p2p-post-ad-header p {
  font-size: 22px;
  color: #514535;
  margin: 0;
}

body.dark_theme .p2p-post-ad-header p,
body[data-theme="dark"] .p2p-post-ad-header p {
  color: #9CA3AF;
}

/* 2. Stepper Bar (Exact Match with Screenshot) */
.p2p-post-stepper-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  margin-bottom: 36px;
}

.p2p-stepper-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.p2p-stepper-node-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  height: 38px;
}

.p2p-stepper-spacer {
  flex: 1 1;
}

.p2p-stepper-line-half {
  flex: 1 1;
  height: 2px;
  background-color: #E2E8F0;
  position: relative;
  overflow: hidden;
}

body.dark_theme .p2p-stepper-line-half,
body[data-theme="dark"] .p2p-stepper-line-half {
  background-color: #2D2D3E;
}

.p2p-stepper-line-fill {
  height: 100%;
  background-color: #CAA368;
  transition: width 0.3s ease;
}

.p2p-stepper-circle {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  background-color: #EEF1F5;
  color: #3F3F3F;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  z-index: 2;
}

body.dark_theme .p2p-stepper-circle,
body[data-theme="dark"] .p2p-stepper-circle {
  background-color: #262636;
  color: #9CA3AF;
}

.p2p-stepper-circle.gold {
  background-color: #CAA368;
  color: #ffffff;
}

.p2p-stepper-circle.step-3-circle {
  background-color: #EEF2F6;
  color: #1F2937;
  font-weight: 700;
}

body.dark_theme .p2p-stepper-circle.step-3-circle,
body[data-theme="dark"] .p2p-stepper-circle.step-3-circle {
  background-color: #262636;
  color: #E2E8F0;
}

.p2p-stepper-label {
  text-align: center;
  margin-top: 22px;
  padding: 0 8px;
}

.p2p-stepper-label h4 {
  font-size: 20px;
  font-weight: 500;
  color: #171C22;
  margin: 0 0 7px 0;
}

body.dark_theme .p2p-stepper-label h4,
body[data-theme="dark"] .p2p-stepper-label h4 {
  color: #ffffff;
}

.p2p-stepper-label p {
  font-size: 18px;
  color: #656565;
  margin: 0;
}

body.dark_theme .p2p-stepper-label p,
body[data-theme="dark"] .p2p-stepper-label p {
  color: #9CA3AF;
}

/* Step 3 Notice Box */
.p2p-post-notice-box {
  background-color: #FFF9EB;
  border: 1px solid #FDE6B5;
  border-radius: 18px;
  padding: 24px;
  margin-bottom: 32px;
}

body.dark_theme .p2p-post-notice-box,
body[data-theme="dark"] .p2p-post-notice-box {
  background-color: #262118;
  border-color: #483A20;
}

.p2p-post-notice-box h4 {
  font-size: 20px;
  font-weight: 500;
  color: #1A1A1A;
  margin: 0 0 6px;
  line-height: 1.4;
}

body.dark_theme .p2p-post-notice-box h4,
body[data-theme="dark"] .p2p-post-notice-box h4 {
  color: #FBBF24;
}

.p2p-post-notice-box p {
  font-size: 17px;
  color: #666666;
  margin: 0;
  line-height: 1.5;
}

body.dark_theme .p2p-post-notice-box p,
body[data-theme="dark"] .p2p-post-notice-box p {
  color: #D1B888;
}

/* 4. Form Card */
.p2p-post-form-card {
  /* background-color: #ffffff; */
  border: 1px solid #DEE3EB;
  border-radius: 22px;
  padding: 42px;
  margin-bottom: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
}

body.dark_theme .p2p-post-form-card,
body[data-theme="dark"] .p2p-post-form-card {
  background-color: #1e2026;
  border-color: #272733;
}

/* Buy / Sell Pill Toggle */
.p2p-post-pill-toggle {
  display: inline-flex;
  background-color: #F0F0F0;
  border-radius: 50px;
  padding: 5px;
  margin-bottom: 24px;
}

body.dark_theme .p2p-post-pill-toggle,
body[data-theme="dark"] .p2p-post-pill-toggle {
  background-color: #262636;
}

.p2p-post-toggle-btn {
  background: transparent;
  border: none;
  border-radius: 50px;
  padding: 12px 32px;
  font-size: 18px;
  font-weight: 500;
  color: #646464;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-post-toggle-btn,
body[data-theme="dark"] .p2p-post-toggle-btn {
  color: #9CA3AF;
}

.p2p-post-toggle-btn.active {
  background-color: #111827;
  color: #ffffff;
  /* font-weight: 700; */
  box-shadow: 0 3px 0px #d1aa67;
}

body.dark_theme .p2p-post-toggle-btn.active,
body[data-theme="dark"] .p2p-post-toggle-btn.active {
  background-color: #374151;
  color: #ffffff;
}

/* Form Row & Fields */
.p2p-post-row {
  display: flex;
  gap: 20px;
}

.p2p-post-row.two-col>* {
  flex: 1 1;
}

.p2p-post-field {
  margin-bottom: 24px;
}

.p2p-post-field label {
  display: block;
  font-size: 18px;
  font-weight: 500;
  color: #171C22;
  margin-bottom: 6px;
}

body.dark_theme .p2p-post-field label,
body[data-theme="dark"] .p2p-post-field label {
  color: #D1D5DB;
}

.p2p-info-icon {
  font-size: 14px;
  color: #9CA3AF;
  vertical-align: middle;
  cursor: pointer;
}

/* Select Box */
.p2p-post-select-box {
  background-color: #F5F6F7;
  border: 1.80px solid #DEE3EB;
  border-radius: 14px;
  padding: 15px 16px;
  min-height: 72px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  transition: border-color 0.2s ease;
}

body.dark_theme .p2p-post-select-box,
body[data-theme="dark"] .p2p-post-select-box {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-select-box select {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 400;
  color: #171C22;
  outline: none;
  cursor: pointer;
  appearance: none;
}

body.dark_theme .p2p-post-select-box select,
body[data-theme="dark"] .p2p-post-select-box select {
  color: #ffffff;
}

.p2p-post-select-box i {
  color: #6B7280;
  font-size: 16px;
  pointer-events: none;
}

.p2p-time-icon {
  font-size: 18px !important;
  color: #9CA3AF !important;
}

/* Coin Icons */
.p2p-post-coin-icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: #ffffff;
}

.p2p-post-coin-icon.usdt {
  background-color: #26A17B;
}

.p2p-post-coin-icon.inr {
  background-color: #F59E0B;
}

/* Price Type Grid */
.p2p-post-price-type-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.p2p-post-price-card {
  border: 1.80px solid #E5E7EB;
  border-radius: 14px;
  padding: 15px 24px;
  min-height: 72px;
  background-color: #F8F9FA;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-post-price-card,
body[data-theme="dark"] .p2p-post-price-card {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-price-card span {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

body.dark_theme .p2p-post-price-card span,
body[data-theme="dark"] .p2p-post-price-card span {
  color: #D1D5DB;
}

.p2p-post-price-card.active {
  background-color: #C9A86A;
  border-color: #C9A86A;
}

.p2p-post-price-card.active span {
  color: #ffffff;
}

.p2p-post-radio-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #9CA3AF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-post-price-card.active .p2p-post-radio-circle {
  border-color: #ffffff;
}

.p2p-post-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffffff;
}

/* Fixed Price Stepper */
.p2p-post-stepper-input {
  background-color: #F5F6F7;
  border: 1.80px solid #DEE3EB;
  border-radius: 14px;
  padding: 15px 16px;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

body.dark_theme .p2p-post-stepper-input,
body[data-theme="dark"] .p2p-post-stepper-input {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-step-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  font-weight: 300;
  color: #6B7280;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.p2p-post-step-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #111827;
}

body.dark_theme .p2p-post-step-btn:hover,
body[data-theme="dark"] .p2p-post-step-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.p2p-post-num-input {
  border: none;
  background: transparent;
  font-size: 36px;
  font-weight: 700;
  color: #171C22;
  text-align: center;
  width: 250px;
  outline: none;
}

body.dark_theme .p2p-post-num-input,
body[data-theme="dark"] .p2p-post-num-input {
  color: #ffffff;
}

.p2p-post-field-hint {
  font-size: 18px;
  color: #514535;
  display: block;
  margin: 15px 0px 20px;
}

body.dark_theme .p2p-post-field-hint,
body[data-theme="dark"] .p2p-post-field-hint {
  color: #9CA3AF;
}

/* Price Summary Box */
.p2p-post-summary-card {
  background-color: #FDFBF7;
  border: 1px solid #F5ECD8;
  border-radius: 14px;
  padding: 22px 28px;
  display: flex;
  gap: 40px;
  margin-top: 24px;
}

body.dark_theme .p2p-post-summary-card,
body[data-theme="dark"] .p2p-post-summary-card {
  background-color: #26272d;
  border-color: #35332f;
}

.p2p-post-summary-col {
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 100%;
}

.p2p-post-summary-label {
  font-size: 19px;
  color: #514535;
}

body.dark_theme .p2p-post-summary-label,
body[data-theme="dark"] .p2p-post-summary-label {
  color: #9CA3AF;
}

.p2p-post-summary-val {
  font-size: 38px;
  font-weight: 800;
  color: #171C22;
}

body.dark_theme .p2p-post-summary-val,
body[data-theme="dark"] .p2p-post-summary-val {
  color: #ffffff;
}

/* Step 2: Total Amount */
.p2p-post-amount-wrap {
  background-color: #F5F6F7;
  border: 1.80px solid #DEE3EB;
  border-radius: 14px;
  padding: 15px 16px;
  min-height: 72px;
  display: flex;
  align-items: center;
  gap: 12px;
}

body.dark_theme .p2p-post-amount-wrap,
body[data-theme="dark"] .p2p-post-amount-wrap {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-amount-wrap input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 400;
  color: #171C22;
  outline: none;
}

body.dark_theme .p2p-post-amount-wrap input,
body[data-theme="dark"] .p2p-post-amount-wrap input {
  color: #ffffff;
}

.p2p-post-amount-curr {
  font-size: 20px;
  font-weight: 500;
  color: #111827;
}

body.dark_theme .p2p-post-amount-curr,
body[data-theme="dark"] .p2p-post-amount-curr {
  color: #ffffff;
}

.p2p-post-amount-all {
  background: none;
  border: none;
  color: #D1AA67;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
}

.p2p-post-amount-subtext {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 17px;
  color: #6B7280;
}

body.dark_theme .p2p-post-amount-subtext,
body[data-theme="dark"] .p2p-post-amount-subtext {
  color: #9CA3AF;
}

.p2p-post-avail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Order Limits */
.p2p-post-limits-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.p2p-post-limit-box {
  flex: 1 1;
  background-color: #F8F9FA;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
}

body.dark_theme .p2p-post-limit-box,
body[data-theme="dark"] .p2p-post-limit-box {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-limit-label {
  font-size: 15px;
  color: #6B7280;
  margin-bottom: 4px;
}

body.dark_theme .p2p-post-limit-label,
body[data-theme="dark"] .p2p-post-limit-label {
  color: #9CA3AF;
}

.p2p-post-limit-box input {
  border: none;
  background: transparent;
  font-size: 18px;
  font-weight: 400;
  color: #111827;
  outline: none;
  padding: 0;
}

body.dark_theme .p2p-post-limit-box input,
body[data-theme="dark"] .p2p-post-limit-box input {
  color: #ffffff;
}

.p2p-post-limit-hint {
  font-size: 15px;
  color: #606060;
  margin-top: 4px;
}

.p2p-post-limit-sep {
  font-size: 18px;
  color: #9CA3AF;
}

/* Textareas (Remarks & Auto Reply) */
.p2p-post-textarea-wrap {
  background-color: #F5F6F7;
  border: 1.80px solid #DEE3EB;
  border-radius: 14px;
  padding: 15px 16px;
  position: relative;
}

body.dark_theme .p2p-post-textarea-wrap,
body[data-theme="dark"] .p2p-post-textarea-wrap {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-textarea-wrap textarea {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  resize: vertical;
  min-height: 90px;
  font-size: 20px;
  font-weight: 400;
  color: #171C22;
  line-height: 1.5;
}

body.dark_theme .p2p-post-textarea-wrap textarea,
body[data-theme="dark"] .p2p-post-textarea-wrap textarea {
  color: #ffffff;
}

.p2p-post-char-count {
  display: block;
  text-align: right;
  font-size: 16px;
  color: #9CA3AF;
  margin-top: 6px;
}

/* Counterparty Conditions */
.p2p-post-conditions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
}

.p2p-post-field label.p2p-post-checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: #374151;
  font-weight: 400;
  cursor: pointer;
}

body.dark_theme .p2p-post-checkbox-item,
body[data-theme="dark"] .p2p-post-checkbox-item {
  color: #D1D5DB;
}

.p2p-post-inline-num {
  width: 60px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  text-align: center;
  background: #ffffff;
  outline: none;
}

body.dark_theme .p2p-post-inline-num,
body[data-theme="dark"] .p2p-post-inline-num {
  background: #222230;
  border-color: #2E2E40;
  color: #ffffff;
}

/* Status Radio Cards */
.p2p-post-status-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.p2p-post-status-card {
  border: 1px solid #E5E7EB;
  border-radius: 18px;
  padding: 16px 18px;
  background-color: #F8F9FA;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-post-status-card,
body[data-theme="dark"] .p2p-post-status-card {
  background-color: #1f2026;
  border-color: #2d2d33;
}

.p2p-post-status-card.active {
  background-color: #FFF9EB;
  border: 3px solid #D1AA67;
}

body.dark_theme .p2p-post-status-card.active,
body[data-theme="dark"] .p2p-post-status-card.active {
  border-color: #C9A86A;
  background-color: #262118;
}

.p2p-post-status-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.p2p-post-status-head strong {
  font-size: 18px;
  color: #1A1A1A;
}

body.dark_theme .p2p-post-status-head strong,
body[data-theme="dark"] .p2p-post-status-head strong {
  color: #ffffff;
}

.p2p-post-status-dot.online {
  color: #10B981;
}

.p2p-post-status-dot.offline {
  color: #6B7280;
}

.p2p-post-status-dot.private {
  color: #3B82F6;
}

.p2p-post-status-card p {
  font-size: 16px;
  color: #666666;
  margin: 0;
}

body.dark_theme .p2p-post-status-card p,
body[data-theme="dark"] .p2p-post-status-card p {
  color: #9CA3AF;
}

/* 5. Help Strip */
.p2p-post-help-strip {
  background-color: #F0F4FC;
  border-radius: 22px;
  min-height: 120px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 36px 0px;
}

body.dark_theme .p2p-post-help-strip,
body[data-theme="dark"] .p2p-post-help-strip {
  background-color: #1D232C;
}

.p2p-post-help-left {
  display: flex;
  flex-direction: column;
  gap: 0px;
  font-size: 18px;
  color: #374151;
}

.p2p-post-help-left strong {
  font-weight: 500;
}

body.dark_theme .p2p-post-help-left,
body[data-theme="dark"] .p2p-post-help-left {
  color: #D1D5DB;
}

.p2p-post-guide-link {
  color: #2563EB;
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  margin-right: 5px;
}

.p2p-post-guide-link:hover {
  text-decoration: underline;
}

/* 6. Bottom Action Bar */
.p2p-post-bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p2p-post-fee-note {
  font-size: 18px;
  color: #4B5563;
}

.p2p-post-fee-note strong {
  font-weight: 700;
  color: #fff;
}

body.light_theme .p2p-post-fee-note strong {
  color: #111827;
}

body.dark_theme .p2p-post-fee-note,
body[data-theme="dark"] .p2p-post-fee-note {
  color: #9CA3AF;
}

.p2p-post-action-btns {
  display: flex;
  gap: 24px;
}

.p2p-post-cancel-btn,
.p2p-post-prev-btn {
  background-color: #DDDDDD;
  color: #374151;
  border: none;
  border-radius: 50px;
  padding: 14px 48px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

body.dark_theme .p2p-post-cancel-btn,
body[data-theme="dark"] .p2p-post-cancel-btn,
body.dark_theme .p2p-post-prev-btn,
body[data-theme="dark"] .p2p-post-prev-btn {
  background-color: #2B2B3A;
  color: #D1D5DB;
}

.p2p-post-next-btn {
  background-color: #1E2329;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  padding: 14px 48px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.p2p-post-next-btn:hover {
  background-color: #374151;
}

/* 7. Confirm to Post Modal */
.p2p-post-confirm-modal {
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);
  border-radius: 24px;
  width: 700px;
  max-width: 92vw;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

body.dark_theme .p2p-post-confirm-modal,
body[data-theme="dark"] .p2p-post-confirm-modal {
  background-color: rgb(0 0 0 / 30%);
  border-color: #1b1b1b;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
}

.p2p-pcm-header {
  padding: 24px 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #F3F4F6;
}

body.dark_theme .p2p-pcm-header,
body[data-theme="dark"] .p2p-pcm-header {
  border-bottom-color: #262636;
}

.p2p-pcm-title-wrap h3 {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px;
}

body.dark_theme .p2p-pcm-title-wrap h3,
body[data-theme="dark"] .p2p-pcm-title-wrap h3 {
  color: #ffffff;
}

.p2p-pcm-title-wrap p {
  font-size: 13.5px;
  color: #6B7280;
  margin: 0;
}

body.dark_theme .p2p-pcm-title-wrap p,
body[data-theme="dark"] .p2p-pcm-title-wrap p {
  color: #9CA3AF;
}

.p2p-pcm-close-btn {
  background: none;
  border: none;
  font-size: 22px;
  color: #6B7280;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.p2p-pcm-close-btn:hover {
  background-color: #F3F4F6;
  color: #111827;
}

body.dark_theme .p2p-pcm-close-btn:hover,
body[data-theme="dark"] .p2p-pcm-close-btn:hover {
  background-color: #2B2B3A;
  color: #ffffff;
}

.p2p-pcm-body {
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.p2p-pcm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dotted #E5E7EB;
}

body.dark_theme .p2p-pcm-row,
body[data-theme="dark"] .p2p-pcm-row {
  border-bottom-color: #1a1a1c;
}

.p2p-pcm-row.solid-divider {
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 4px;
}

body.dark_theme .p2p-pcm-row.solid-divider,
body[data-theme="dark"] .p2p-pcm-row.solid-divider {
  border-bottom-color: #2E2E40;
}

.p2p-pcm-row:last-child {
  border-bottom: none;
}

.p2p-pcm-label {
  font-size: 13.5px;
  color: #6B7280;
}

body.dark_theme .p2p-pcm-label,
body[data-theme="dark"] .p2p-pcm-label {
  color: #9CA3AF;
}

.p2p-pcm-val {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

body.dark_theme .p2p-pcm-val,
body[data-theme="dark"] .p2p-pcm-val {
  color: #ffffff;
}

.p2p-pcm-status-pill.online {
  background-color: #DCFCE7;
  color: #16A34A;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

body.dark_theme .p2p-pcm-status-pill.online,
body[data-theme="dark"] .p2p-pcm-status-pill.online {
  background-color: rgba(16, 185, 129, 0.18);
  color: #34D399;
}

.p2p-pcm-footer {
  padding: 20px 28px 24px;
  display: flex;
  gap: 14px;
}

.p2p-pcm-cancel-btn {
  flex: 1 1;
  background-color: #E5E7EB;
  color: #374151;
  border: none;
  border-radius: 50px;
  padding: 15px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

body.dark_theme .p2p-pcm-cancel-btn,
body[data-theme="dark"] .p2p-pcm-cancel-btn {
  background-color: #2B2B3A;
  color: #D1D5DB;
}

.p2p-pcm-submit-btn {
  flex: 1 1;
  background-color: #1E2329;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  padding: 15px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.p2p-pcm-submit-btn:hover {
  background-color: #374151;
}

/* 8. Successful Ad Posted Modal */
.p2p-post-success-modal {
  text-align: center;
}

.p2p-psm-body {
  padding: 24px 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.p2p-psm-thumb-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
}

.p2p-psm-thumb-circle {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);
  border: 3px solid #10B981;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.25);
  margin-bottom: 16px;
  position: relative;
  animation: p2pThumbBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

body.dark_theme .p2p-psm-thumb-circle,
body[data-theme="dark"] .p2p-psm-thumb-circle {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(16, 185, 129, 0.3) 100%);
  border-color: #10B981;
  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.35);
}

@keyframes p2pThumbBounce {
  0% {
    transform: scale(0.4) rotate(-15deg);
    opacity: 0;
  }

  60% {
    transform: scale(1.1) rotate(5deg);
    opacity: 1;
  }

  100% {
    transform: scale(1) rotate(0deg);
  }
}

.p2p-psm-headline {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px;
}

body.dark_theme .p2p-psm-headline,
body[data-theme="dark"] .p2p-psm-headline {
  color: #ffffff;
}

.p2p-psm-subheadline {
  font-size: 14px;
  color: #6B7280;
  margin: 0;
  max-width: 440px;
  line-height: 1.5;
}

body.dark_theme .p2p-psm-subheadline,
body[data-theme="dark"] .p2p-psm-subheadline {
  color: #9CA3AF;
}

.p2p-psm-summary-card {
  width: 100%;
  background: rgba(249, 250, 251, 0.75);
  border-radius: 16px;
  padding: 12px 20px;
  border: 1px solid #E5E7EB;
  margin-top: 8px;
  box-sizing: border-box;
  text-align: left;
}

body.dark_theme .p2p-psm-summary-card,
body[data-theme="dark"] .p2p-psm-summary-card {
  background: rgba(26, 26, 36, 0.6);
  border-color: #2E2E40;
}

/* Responsive */
@media (max-width: 768px) {
  .p2p-post-ad-page {
    padding: 20px 16px 40px;
  }

  .p2p-post-stepper-wrap {
    flex-direction: column;
    gap: 16px;
  }

  /* [UNUSED]
.p2p-stepper-line {
    display: none;
  }
*/

  /* [UNUSED]
.p2p-stepper-step {
    flex-direction: row;
    gap: 12px;
    text-align: left;
  }
*/

  .p2p-post-form-card {
    padding: 20px 18px;
  }

  .p2p-post-row {
    flex-direction: column;
    gap: 16px;
  }

  .p2p-post-price-type-grid,
  .p2p-post-status-grid {
    grid-template-columns: 1fr;
  }

  .p2p-post-summary-card {
    flex-direction: column;
    gap: 16px;
  }
}

/* ==========================================================================
   P2P MY ADS PAGE STYLES
   ========================================================================== */

.p2p-my-ads-page {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0px 0px 50px;
  /* background-color: #ffffff; */
  color: #111827;
  box-sizing: border-box;
}

body[data-theme="dark"] .p2p-my-ads-page {
  color: #f3f4f6;
}

/* 1. Top Header */
.p2p-my-ads-top-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
}

.p2p-my-ads-header-info h2 {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.3px;
  margin: 0 0 6px;
}

body.dark_theme .p2p-my-ads-header-info h2,
body[data-theme="dark"] .p2p-my-ads-header-info h2 {
  color: #ffffff;
}

.p2p-my-ads-header-info p {
  font-size: 15px;
  color: #6b7280;
  margin: 0;
}

body.dark_theme .p2p-my-ads-header-info p,
body[data-theme="dark"] .p2p-my-ads-header-info p {
  color: #9ca3af;
}

.p2p-post-new-ad-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #1e2026;
  color: #ffffff;
  border: none;
  border-radius: 9999px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.p2p-post-new-ad-btn:hover {
  background-color: #374151;
  transform: translateY(-1px);
}

.p2p-post-new-ad-btn i {
  font-size: 18px;
  font-weight: 600;
}

body.dark_theme .p2p-post-new-ad-btn,
body[data-theme="dark"] .p2p-post-new-ad-btn {
  background-color: #d1aa67;
  color: #111827;
}

body.dark_theme .p2p-post-new-ad-btn:hover,
body[data-theme="dark"] .p2p-post-new-ad-btn:hover {
  background-color: #dfa724;
}

/* 2. Category Tabs Bar */
.p2p-my-ads-tabs-bar {
  display: flex;
  align-items: center;
  gap: 28px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;
  position: relative;
}

body.dark_theme .p2p-my-ads-tabs-bar,
body[data-theme="dark"] .p2p-my-ads-tabs-bar {
  border-bottom-color: #262638;
}

.p2p-my-ads-tab-btn {
  background: transparent;
  border: none;
  padding: 10px 2px 14px;
  font-size: 16px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  position: relative;
  transition: color 0.15s ease;
  outline: none;
}

.p2p-my-ads-tab-btn:hover {
  color: #111827;
}

body.dark_theme .p2p-my-ads-tab-btn,
body[data-theme="dark"] .p2p-my-ads-tab-btn {
  color: #9ca3af;
}

body.dark_theme .p2p-my-ads-tab-btn:hover,
body[data-theme="dark"] .p2p-my-ads-tab-btn:hover {
  color: #ffffff;
}

.p2p-my-ads-tab-btn.active {
  color: #111827;
  font-weight: 700;
}

body.dark_theme .p2p-my-ads-tab-btn.active,
body[data-theme="dark"] .p2p-my-ads-tab-btn.active {
  color: #ffffff;
}

.p2p-my-ads-tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  width: 50%;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #111827;
}

body.dark_theme .p2p-my-ads-tab-btn.active::after,
body[data-theme="dark"] .p2p-my-ads-tab-btn.active::after {
  background-color: #d1aa67;
}

/* 3. Filter Controls Bar */
.p2p-my-ads-filters-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
}

.p2p-my-ads-filters-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.p2p-my-ads-filter-dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 0 32px 0 15px;
  gap: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.p2p-my-ads-filter-dropdown:hover {
  border-color: #cbd5e1;
}

body.dark_theme .p2p-my-ads-filter-dropdown,
body[data-theme="dark"] .p2p-my-ads-filter-dropdown {
  background-color: transparent;
  border-color: #2e2e42;
}

.p2p-filter-prefix {
  font-size: 13.5px;
  color: #6b7280;
  font-weight: 400;
  white-space: nowrap;
  pointer-events: none;
}

body.dark_theme .p2p-filter-prefix,
body[data-theme="dark"] .p2p-filter-prefix {
  color: #9ca3af;
}

.p2p-my-ads-filter-dropdown select {
  border: none;
  background: transparent;
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  padding: 0;
  margin: 0;
}

body.dark_theme .p2p-my-ads-filter-dropdown select,
body[data-theme="dark"] .p2p-my-ads-filter-dropdown select {
  color: #ffffff;
  background-color: #1a1a26;
}

.p2p-my-ads-filter-dropdown i {
  position: absolute;
  right: 10px;
  color: #9ca3af;
  font-size: 16px;
  pointer-events: none;
}

/* Date Range Box */
.p2p-my-ads-date-range-box {
  display: inline-flex;
  align-items: center;
  height: 40px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0 12px;
  gap: 8px;
}

body.dark_theme .p2p-my-ads-date-range-box,
body[data-theme="dark"] .p2p-my-ads-date-range-box {
  background-color: transparent;
  border-color: #2e2e42;
}

.p2p-my-ads-date-range-box input {
  border: none;
  background: transparent;
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  outline: none;
  width: 215px;
  cursor: default;
}

body.dark_theme .p2p-my-ads-date-range-box input,
body[data-theme="dark"] .p2p-my-ads-date-range-box input {
  color: #ffffff;
}

.p2p-date-icon {
  color: #9ca3af;
  font-size: 16px;
}

/* Reset Button */
.p2p-my-ads-reset-btn {
  height: 40px;
  background-color: #F0F0F0;
  border: 1px solid #E5E7EB;
  border-radius: 9999px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
}

.p2p-my-ads-reset-btn:hover {
  background-color: #e5e7eb;
  color: #111827;
}

body.dark_theme .p2p-my-ads-reset-btn,
body[data-theme="dark"] .p2p-my-ads-reset-btn {
  background-color: #262638;
  color: #d1d5db;
  border: 1px solid #373737;
}

body.dark_theme .p2p-my-ads-reset-btn:hover,
body[data-theme="dark"] .p2p-my-ads-reset-btn:hover {
  background-color: #323248;
  color: #ffffff;
}

/* Ad History Button */
.p2p-ad-history-btn {
  height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #F0F0F0;
  border: 1px solid #E5E7EB;
  border-radius: 9999px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
}

.p2p-ad-history-btn:hover {
  background-color: #e5e7eb;
  color: #111827;
}

body.dark_theme .p2p-ad-history-btn,
body[data-theme="dark"] .p2p-ad-history-btn {
  background-color: #262638;
  color: #d1d5db;
  border: 1px solid #373737;
}

body.dark_theme .p2p-ad-history-btn:hover,
body[data-theme="dark"] .p2p-ad-history-btn:hover {
  background-color: #323248;
  color: #ffffff;
}

.p2p-ad-history-btn i {
  font-size: 15px;
}

/* 4. Batch Actions Bar */
.p2p-my-ads-batch-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}

.p2p-my-ads-select-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: #374151;
  -webkit-user-select: none;
          user-select: none;
}

body.dark_theme .p2p-my-ads-select-all,
body[data-theme="dark"] .p2p-my-ads-select-all {
  color: #d1d5db;
}

.p2p-my-ads-select-all input[type="checkbox"],
.p2p-my-ads-table input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  accent-color: #111827;
  cursor: pointer;
}

body.dark_theme .p2p-my-ads-select-all input[type="checkbox"],
body.dark_theme .p2p-my-ads-table input[type="checkbox"],
body[data-theme="dark"] .p2p-my-ads-select-all input[type="checkbox"],
body[data-theme="dark"] .p2p-my-ads-table input[type="checkbox"] {
  accent-color: #f3ba2f;
}

.p2p-batch-publish-btn {
  background-color: rgb(209 170 103 / 20%);
  color: #111827;
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.p2p-batch-publish-btn:hover {
  background-color: #f5e4c8;
}

body.dark_theme .p2p-batch-publish-btn,
body[data-theme="dark"] .p2p-batch-publish-btn {
  background-color: #433519;
  color: #fdd87e;
}

.p2p-batch-offline-btn {
  background-color: #ffffff;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.p2p-batch-offline-btn:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
}

body.dark_theme .p2p-batch-offline-btn,
body[data-theme="dark"] .p2p-batch-offline-btn {
  background-color: #1a1a26;
  border-color: #2e2e42;
  color: #d1d5db;
}

/* 5. Ads Table */
.p2p-my-ads-table-container {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 24px;
}

.p2p-my-ads-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.p2p-my-ads-table thead tr {
  background-color: #F9FAFB;
  border-top: 1px solid #e5e7eb;
}

body.dark_theme .p2p-my-ads-table thead tr,
body[data-theme="dark"] .p2p-my-ads-table thead tr {
  background-color: #1e1e2d;
  border-bottom-color: #2a2a3e;
}

.p2p-my-ads-table th {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  line-height: 1.4;
  vertical-align: top;
}

body.dark_theme .p2p-my-ads-table th,
body[data-theme="dark"] .p2p-my-ads-table th {
  color: #9ca3af;
}

.p2p-my-ads-table th.th-checkbox,
.p2p-my-ads-table td.td-checkbox {
  width: 36px;
  padding-left: 14px;
  padding-right: 0;
  vertical-align: middle;
}

.p2p-my-ads-table th .th-sub {
  font-size: 11px;
  font-weight: 400;
  color: #9ca3af;
  display: block;
}

.p2p-my-ads-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}

.p2p-my-ads-table tbody tr:hover {
  background-color: #fcfcfd;
}

body.dark_theme .p2p-my-ads-table tbody tr,
body[data-theme="dark"] .p2p-my-ads-table tbody tr {
  border-bottom-color: #242436;
}

body.dark_theme .p2p-my-ads-table tbody tr:hover,
body[data-theme="dark"] .p2p-my-ads-table tbody tr:hover {
  background-color: #1c1c2a;
}

.p2p-my-ads-table td {
  padding: 16px 16px;
  vertical-align: middle;
  font-size: 14px;
}

.p2p-ad-number {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
}

body.dark_theme .p2p-ad-number,
body[data-theme="dark"] .p2p-ad-number {
  color: #ffffff;
}

.p2p-ad-subtext {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
}

body.dark_theme .p2p-ad-subtext,
body[data-theme="dark"] .p2p-ad-subtext {
  color: #9ca3af;
}

.p2p-amount-val {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
}

body.dark_theme .p2p-amount-val,
body[data-theme="dark"] .p2p-amount-val {
  color: #ffffff;
}

.p2p-price-val {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
}

body.dark_theme .p2p-price-val,
body[data-theme="dark"] .p2p-price-val {
  color: #ffffff;
}

/* Payment Methods */
.p2p-payments-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.p2p-pm-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.p2p-pm-bar {
  width: 5px;
  height: 13px;
  border-radius: 2px;
  display: inline-block;
  flex-shrink: 0;
}

.p2p-pm-text {
  font-size: 13px;
  font-weight: 400;
  color: #111827;
}

body.dark_theme .p2p-pm-text,
body[data-theme="dark"] .p2p-pm-text {
  color: #e5e7eb;
}

/* Times */
.p2p-updated-time {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
}

body.dark_theme .p2p-updated-time,
body[data-theme="dark"] .p2p-updated-time {
  color: #ffffff;
}

/* Status Pills */
.p2p-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.p2p-status-pill.online {
  background-color: #F0FDF4;
  color: #10B981;
  border: 1px solid #DCFCE7;
}

body.dark_theme .p2p-status-pill.online,
body[data-theme="dark"] .p2p-status-pill.online {
  background-color: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.35);
  color: #34d399;
}

.p2p-status-pill.offline {
  background-color: #f3f4f6;
  color: #9ca3af;
  border: 1px solid #e5e7eb;
}

body.dark_theme .p2p-status-pill.offline,
body[data-theme="dark"] .p2p-status-pill.offline {
  background-color: rgba(156, 163, 175, 0.15);
  border-color: rgba(156, 163, 175, 0.35);
  color: #9ca3af;
}

/* 6. Footer / Pagination */
.p2p-my-ads-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 12px;
}

.p2p-my-ads-footer-left span {
  font-size: 13px;
  color: #6b7280;
}

body.dark_theme .p2p-my-ads-footer-left span,
body[data-theme="dark"] .p2p-my-ads-footer-left span {
  color: #9ca3af;
}

.p2p-my-ads-pagination {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.p2p-pag-arrow-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #9ca3af;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.p2p-pag-arrow-btn:hover:not(:disabled) {
  border-color: #cbd5e1;
  color: #111827;
}

.p2p-pag-arrow-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

body.dark_theme .p2p-pag-arrow-btn,
body[data-theme="dark"] .p2p-pag-arrow-btn {
  background-color: #1a1a26;
  border-color: #2e2e42;
  color: #6b7280;
}

.p2p-pag-num-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13.5px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

.p2p-pag-num-btn.active {
  background-color: #1e2026;
  border-color: #1e2026;
  color: #ffffff;
  font-weight: 600;
}

body.dark_theme .p2p-pag-num-btn.active,
body[data-theme="dark"] .p2p-pag-num-btn.active {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #111827;
}

.p2p-page-size-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 24px 0 10px;
}

body.dark_theme .p2p-page-size-select,
body[data-theme="dark"] .p2p-page-size-select {
  background-color: #1a1a26;
  border-color: #2e2e42;
}

.p2p-page-size-select select {
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
}

body.dark_theme .p2p-page-size-select select,
body[data-theme="dark"] .p2p-page-size-select select {
  color: #d1d5db;
  background-color: #1a1a26;
}

.p2p-page-size-select i {
  position: absolute;
  right: 6px;
  color: #9ca3af;
  font-size: 14px;
  pointer-events: none;
}

/* Responsive */
@media (max-width: 991px) {
  .p2p-my-ads-page {
    padding: 20px 16px 40px;
  }

  .p2p-my-ads-filters-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .p2p-my-ads-filters-left {
    flex-wrap: wrap;
  }
}

/* ==========================================================================
   FIND AN AD MODAL (POPUP)
   ========================================================================== */
.p2p-fam-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: p2pFamFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

body.light_theme .p2p-fam-overlay {
  background-color: rgba(255, 255, 255, 0.45);
}

@keyframes p2pFamFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes p2pFamScaleUp {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.p2p-fam-card {
  width: 100%;
  max-width: 720px;
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);
  border-radius: 24px;
  padding: 24px 15px;
  position: relative;
  box-sizing: border-box;
  animation: p2pFamScaleUp 0.24s cubic-bezier(0.16, 1, 0.3, 1);
}

body.dark_theme .p2p-fam-card,
body[data-theme="dark"] .p2p-fam-card {
  background-color: #1e2026;
  border: 1px solid #2b313a;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
}

/* Header */
.p2p-fam-header {
  margin-bottom: 22px;
}

.p2p-fam-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.p2p-fam-title {
  font-size: 22px;
  color: #111827;
  margin: 0;
  letter-spacing: -0.3px;
}

body.dark_theme .p2p-fam-title,
body[data-theme="dark"] .p2p-fam-title {
  color: #ffffff;
}

.p2p-fam-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: all 0.15s ease;
  padding: 0;
}

.p2p-fam-close-btn:hover {
  background-color: #f3f4f6;
  color: #111827;
}

body.dark_theme .p2p-fam-close-btn:hover,
body[data-theme="dark"] .p2p-fam-close-btn:hover {
  background-color: #2b313a;
  color: #ffffff;
}

.p2p-fam-subtitle {
  font-size: 15px;
  line-height: 1.5;
  color: #6b7280;
  margin: 6px 0 0;
  font-weight: 400;
}

body.dark_theme .p2p-fam-subtitle,
body[data-theme="dark"] .p2p-fam-subtitle {
  color: #9ca3af;
}

/* Form Groups */
.p2p-fam-field-group {
  margin-bottom: 18px;
}

.p2p-fam-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #1e2329;
  margin-bottom: 8px;
}

body.dark_theme .p2p-fam-label,
body[data-theme="dark"] .p2p-fam-label {
  color: #e5e7eb;
}

.p2p-fam-row-two {
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 12px;
}

/* Dropdown wrap */
.p2p-fam-dropdown-wrap {
  position: relative;
  width: 100%;
}

.p2p-fam-dropdown-wrap.full-width {
  width: 100%;
}

.p2p-fam-select-box {
  width: 100%;
  height: 48px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
  outline: none;
}

body.dark_theme .p2p-fam-select-box,
body[data-theme="dark"] .p2p-fam-select-box {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-fam-select-box:hover {
  border-color: #cbd5e1;
}

body.dark_theme .p2p-fam-select-box:hover,
body[data-theme="dark"] .p2p-fam-select-box:hover {
  border-color: #474d57;
}

.p2p-fam-select-box.active {
  border-color: #2b2f38;
}

body.dark_theme .p2p-fam-select-box.active,
body[data-theme="dark"] .p2p-fam-select-box.active {
  border-color: #f0b90b;
}

.p2p-fam-select-val {
  font-size: 14.5px;
  font-weight: 500;
  color: #111827;
}

body.dark_theme .p2p-fam-select-val,
body[data-theme="dark"] .p2p-fam-select-val {
  color: #f3f4f6;
}

.p2p-fam-chevron {
  color: #6b7280;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.p2p-fam-chevron.rotate {
  transform: rotate(180deg);
  border: none;
  width: auto;
}

.p2p-fam-coin-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.p2p-fam-coin-svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Dropdown Menu */
.p2p-fam-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  z-index: 60;
  max-height: 220px;
  overflow-y: auto;
  padding: 6px;
  list-style: none;
  margin: 0;
  animation: p2pFamFadeIn 0.15s ease;
}

body.dark_theme .p2p-fam-dropdown-menu,
body[data-theme="dark"] .p2p-fam-dropdown-menu {
  background-color: #1e2026;
  border-color: #2b313a;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
}

.p2p-fam-menu-item {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.15s ease;
}

body.dark_theme .p2p-fam-menu-item,
body[data-theme="dark"] .p2p-fam-menu-item {
  color: #d1d5db;
}

.p2p-fam-menu-item:hover {
  background-color: #f3f4f6;
}

body.dark_theme .p2p-fam-menu-item:hover,
body[data-theme="dark"] .p2p-fam-menu-item:hover {
  background-color: #2b313a;
}

.p2p-fam-menu-item.selected {
  background-color: #f1f5f9;
  font-weight: 600;
  color: #111827;
}

body.dark_theme .p2p-fam-menu-item.selected,
body[data-theme="dark"] .p2p-fam-menu-item.selected {
  background-color: rgba(240, 185, 11, 0.12);
  color: #f0b90b;
}

/* Amount & Currency Container */
.p2p-fam-amount-box {
  height: 48px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.15s ease;
}

body.dark_theme .p2p-fam-amount-box,
body[data-theme="dark"] .p2p-fam-amount-box {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-fam-amount-box:focus-within {
  border-color: #2b2f38;
  box-shadow: 0 0 0 2px rgba(43, 47, 56, 0.08);
}

body.dark_theme .p2p-fam-amount-box:focus-within,
body[data-theme="dark"] .p2p-fam-amount-box:focus-within {
  border-color: #f0b90b;
  box-shadow: 0 0 0 2px rgba(240, 185, 11, 0.15);
}

.p2p-fam-amount-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14.5px;
  color: #111827;
  padding: 0;
  font-weight: 500;
  min-width: 0;
}

body.dark_theme .p2p-fam-amount-input,
body[data-theme="dark"] .p2p-fam-amount-input {
  color: #ffffff;
}

.p2p-fam-amount-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.p2p-fam-currency-wrap {
  position: relative;
  margin-left: 8px;
}

.p2p-fam-currency-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s ease;
}

.p2p-fam-currency-btn:hover {
  background-color: #f3f4f6;
}

body.dark_theme .p2p-fam-currency-btn:hover,
body[data-theme="dark"] .p2p-fam-currency-btn:hover {
  background-color: #2b313a;
}

.p2p-fam-currency-code {
  font-size: 14.5px;
  font-weight: 600;
  color: #111827;
}

body.dark_theme .p2p-fam-currency-code,
body[data-theme="dark"] .p2p-fam-currency-code {
  color: #ffffff;
}

.p2p-fam-currency-menu {
  right: 0;
  left: auto;
  min-width: 120px;
}

/* Submit Button */
.p2p-fam-submit-btn {
  width: 100%;
  height: 50px;
  background-color: #2b2f38;
  color: #ffffff;
  border: none;
  border-radius: 9999px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 24px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.18s ease;
  box-shadow: 0 4px 12px rgba(43, 47, 56, 0.18);
}

.p2p-fam-submit-btn:hover {
  background-color: #1a1c22;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(43, 47, 56, 0.25);
}

.p2p-fam-submit-btn:active {
  transform: translateY(0);
}

/* 3-Step Process Guide */
.p2p-fam-steps-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px;
  border-radius: 16px;
  background-color: rgb(0 0 0 / 10%);
}

body.light_theme .p2p-fam-steps-container {
  background-color: rgb(249 250 251 / 70%);
}

.p2p-fam-step-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 160px;
}

.p2p-fam-step-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 12px;
}

.p2p-fam-step-icon-wrap.step-1-bg {
  background-color: #FFF8E7;
}

.p2p-fam-step-icon-wrap.step-2-bg {
  background-color: #ECFDF5;
}

.p2p-fam-step-icon-wrap.step-3-bg {
  background-color: #F3E8FF;
}

body.dark_theme .p2p-fam-step-icon-wrap.step-1-bg,
body[data-theme="dark"] .p2p-fam-step-icon-wrap.step-1-bg {
  background-color: rgba(245, 158, 11, 0.15);
}

body.dark_theme .p2p-fam-step-icon-wrap.step-2-bg,
body[data-theme="dark"] .p2p-fam-step-icon-wrap.step-2-bg {
  background-color: rgba(16, 185, 129, 0.15);
}

body.dark_theme .p2p-fam-step-icon-wrap.step-3-bg,
body[data-theme="dark"] .p2p-fam-step-icon-wrap.step-3-bg {
  background-color: rgba(139, 92, 246, 0.15);
}

.p2p-fam-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-fam-badge.step-1-badge {
  background-color: #ffffff;
  border: 1px solid #fde68a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

body.dark_theme .p2p-fam-badge.step-1-badge,
body[data-theme="dark"] .p2p-fam-badge.step-1-badge {
  background-color: #1e2026;
  border-color: rgba(245, 158, 11, 0.4);
}

.p2p-fam-badge.step-2-badge,
.p2p-fam-badge.step-3-badge {
  background-color: #10b981;
  border: 4px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

body.dark_theme .p2p-fam-badge.step-2-badge,
body[data-theme="dark"] .p2p-fam-badge.step-2-badge,
body.dark_theme .p2p-fam-badge.step-3-badge,
body[data-theme="dark"] .p2p-fam-badge.step-3-badge {
  border-color: #1e2026;
}

.p2p-fam-step-arrow {
  margin-top: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.p2p-fam-step-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px;
}

body.dark_theme .p2p-fam-step-title,
body[data-theme="dark"] .p2p-fam-step-title {
  color: #ffffff;
}

.p2p-fam-step-desc {
  font-size: 11.5px;
  line-height: 1.35;
  color: #6b7280;
  margin: 0;
  max-width: 200px;
}

body.dark_theme .p2p-fam-step-desc,
body[data-theme="dark"] .p2p-fam-step-desc {
  color: #9ca3af;
}

/* Modal Responsive */
@media (max-width: 600px) {
  .p2p-fam-card {
    padding: 24px 20px 28px;
    border-radius: 20px;
  }

  .p2p-fam-title {
    font-size: 20px;
  }

  .p2p-fam-subtitle {
    font-size: 12.5px;
  }

  .p2p-fam-row-two {
    grid-template-columns: 1fr;
  }

  .p2p-fam-step-col {
    width: 95px;
  }

  .p2p-fam-step-desc {
    max-width: 90px;
    font-size: 10.5px;
  }

  .p2p-fam-step-title {
    font-size: 12px;
  }

  .p2p-fam-step-icon-wrap {
    width: 44px;
    height: 44px;
  }
}

/* ==========================================================================
   P2P PROFILE PAGE
   ========================================================================== */
.p2p-profile-page-main {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0px 32px 48px;
  box-sizing: border-box;
}

/* 1. Profile Hero Card (Dual-tone Curved Banner) */
.p2p-profile-hero-card {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background-color: #F0F0F0;
  border: 1px solid #eef0f3;
  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.10);
  margin-bottom: 24px;
  min-height: 145px;
}

body.dark_theme .p2p-profile-hero-card,
body[data-theme="dark"] .p2p-profile-hero-card {
  background-color: #1e202600;
  border-color: #2b313a;
}

.p2p-profile-hero-curve {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.p2p-empty-state-card .p2p-myads-action-btn i {
  margin: 0px;
  font-size: 24px;
}

.p2p-profile-hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 42px;
  min-height: 125px;
  gap: 24px;
  box-sizing: border-box;
}

/* Left user info (On black curved background) */
.p2p-profile-hero-user {
  display: flex;
  align-items: center;
  gap: 18px;
}

.p2p-profile-hero-avatar {
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #2c3545;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 600;
  color: #ffffff;
  flex-shrink: 0;
}

.p2p-profile-hero-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.p2p-profile-hero-online-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #10B981;
  border: 3px solid #000000;
}

.p2p-profile-hero-details {
  display: flex;
  flex-direction: column;
}

.p2p-profile-username-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.p2p-profile-username {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.2px;
  line-height: 1.2;
}



.p2p-profile-verified-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.p2p-profile-edit-btn {
  background: transparent;
  border: none;
  padding: 2px 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  transition: opacity 0.15s ease;
}

.p2p-profile-edit-btn:hover {
  opacity: 0.8;
}

.p2p-profile-badges-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.p2p-profile-badge-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  font-weight: 500;
  color: #D1D5DB;
}

/* Right funding value (On white background) */
.p2p-profile-funding-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.p2p-profile-funding-top {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 18px;
  font-weight: 400;
  color: #9CA3AF;
  margin-bottom: 6px;
}

body.dark_theme .p2p-profile-funding-top,
body[data-theme="dark"] .p2p-profile-funding-top {
  color: #9ca3af;
}

.p2p-profile-eye-toggle {
  background: transparent;
  border: none;
  color: #848e9c;
  cursor: pointer;
  padding: 0;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  transition: color 0.15s ease;
}

.p2p-profile-eye-toggle:hover {
  color: #111827;
}

body.dark_theme .p2p-profile-eye-toggle:hover,
body[data-theme="dark"] .p2p-profile-eye-toggle:hover {
  color: #ffffff;
}

.p2p-profile-funding-val {
  font-size: 28px;
  font-weight: 700;
  color: #070808;
  letter-spacing: -0.3px;
  margin-bottom: 2px;
  line-height: 1.2;
}

body.dark_theme .p2p-profile-funding-val,
body[data-theme="dark"] .p2p-profile-funding-val {
  color: #ffffff;
}

.p2p-profile-funding-usd {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 18px;
  font-weight: 400;
  color: #9CA3AF;
  cursor: pointer;
  transition: color 0.15s ease;
}

.p2p-profile-funding-usd:hover {
  color: #111827;
}

body.dark_theme .p2p-profile-funding-usd,
body[data-theme="dark"] .p2p-profile-funding-usd {
  color: #9ca3af;
}

body.dark_theme .p2p-profile-funding-usd:hover,
body[data-theme="dark"] .p2p-profile-funding-usd:hover {
  color: #ffffff;
}

/* 2. Stats Grid (5 Cards Row) */
.p2p-profile-stats-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 22px;
  margin: 42px 0px;
}

.p2p-profile-stat-card {
  background-color: #F4F4F4;
  border-radius: 18px;
  padding: 24px;
  border: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  min-height: 150px;
  justify-content: center;
}

body.dark_theme .p2p-profile-stat-card,
body[data-theme="dark"] .p2p-profile-stat-card {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-profile-stat-label {
  font-size: 16px;
  color: #6B7280;
  font-weight: 400;
  margin-bottom: 6px;
  white-space: nowrap;
}

body.dark_theme .p2p-profile-stat-label,
body[data-theme="dark"] .p2p-profile-stat-label {
  color: #9ca3af;
}

.p2p-profile-stat-value {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 100%;
  margin-top: 8px;
}

.p2p-profile-stat-num {
  font-size: 26px;
  font-weight: 700;
  color: #374151;
}

body.dark_theme .p2p-profile-stat-num,
body[data-theme="dark"] .p2p-profile-stat-num {
  color: #ffffff;
}

.p2p-profile-stat-unit {
  font-size: 16px;
  font-weight: 400;
  color: #6B7280;
}

body.dark_theme .p2p-profile-stat-unit,
body[data-theme="dark"] .p2p-profile-stat-unit {
  color: #9ca3af;
}

/* 3. Tabs Navigation */
.p2p-profile-tabs-bar {
  display: flex;
  align-items: center;
  gap: 32px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;
  overflow-x: auto;
  white-space: nowrap;
}

body.dark_theme .p2p-profile-tabs-bar,
body[data-theme="dark"] .p2p-profile-tabs-bar {
  border-color: #2b313a;
}

.p2p-profile-tab-item {
  background: transparent;
  border: none;
  font-size: 17px;
  font-weight: 500;
  color: #6B7280;
  padding: 0 0 14px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  font-family: inherit;
  transition: color 0.15s ease;
}

.p2p-profile-tab-item:hover {
  color: #111827;
}

body.dark_theme .p2p-profile-tab-item,
body[data-theme="dark"] .p2p-profile-tab-item {
  color: #9ca3af;
}

body.dark_theme .p2p-profile-tab-item:hover,
body[data-theme="dark"] .p2p-profile-tab-item:hover {
  color: #ffffff;
}

.p2p-profile-tab-item.active {
  color: #111827;
  font-weight: 600;
}

body.dark_theme .p2p-profile-tab-item.active,
body[data-theme="dark"] .p2p-profile-tab-item.active {
  color: #ffffff;
}

.p2p-profile-tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #111827;
}

.p2p-profile-verified-badge i {
  color: #F3C740;
  font-size: 14px;
}

body.dark_theme .p2p-profile-tab-item.active::after,
body[data-theme="dark"] .p2p-profile-tab-item.active::after {
  background-color: #d1aa67;
}

/* 4. Feedback Card (Matching Screenshot Content Box) */
.p2p-profile-feedback-card {
  background-color: #eff6ff;
  border-radius: 16px;
  padding: 26px 30px;
  border: 1px solid rgba(219, 234, 254, 0.7);
}

body.dark_theme .p2p-profile-feedback-card,
body[data-theme="dark"] .p2p-profile-feedback-card {
  background-color: rgb(0 0 0 / 0%);
  border-color: rgb(88 88 88 / 25%);
}

.p2p-profile-feedback-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 14px;
}

body.dark_theme .p2p-profile-feedback-title,
body[data-theme="dark"] .p2p-profile-feedback-title {
  color: #ffffff;
}

.p2p-profile-feedback-desc {
  font-size: 14px;
  line-height: 1.65;
  color: #374151;
  margin: 0 0 16px;
}

body.dark_theme .p2p-profile-feedback-desc,
body[data-theme="dark"] .p2p-profile-feedback-desc {
  color: #d1d5db;
}

.p2p-profile-feedback-desc:last-child {
  margin-bottom: 0;
}

/* Tab Panels */
.p2p-profile-tab-panel {
  padding: 8px 0;
}

.p2p-profile-empty-state {
  text-align: center;
  padding: 48px 24px;
  background-color: #f9fafb;
  border-radius: 16px;
  border: 1px dashed #e5e7eb;
}

body.dark_theme .p2p-profile-empty-state,
body[data-theme="dark"] .p2p-profile-empty-state {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-profile-empty-state i {
  font-size: 40px;
  color: #9ca3af;
  margin-bottom: 12px;
  display: inline-block;
}

.p2p-profile-empty-state.good-status i {
  color: #10b981;
}

.p2p-profile-empty-state h4 {
  font-size: 17px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
}

body.dark_theme .p2p-profile-empty-state h4,
body[data-theme="dark"] .p2p-profile-empty-state h4 {
  color: #ffffff;
}

.p2p-profile-empty-state p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

body.dark_theme .p2p-profile-empty-state p,
body[data-theme="dark"] .p2p-profile-empty-state p {
  color: #9ca3af;
}

/* Notifications Card */
.p2p-profile-notifications-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 24px 28px;
}

body.dark_theme .p2p-profile-notifications-card,
body[data-theme="dark"] .p2p-profile-notifications-card {
  background-color: #181a20;
  border-color: #2b313a;
}

.p2p-profile-notif-title {
  font-size: 17px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 20px;
}

body.dark_theme .p2p-profile-notif-title,
body[data-theme="dark"] .p2p-profile-notif-title {
  color: #ffffff;
}

.p2p-profile-notif-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

body.dark_theme .p2p-profile-notif-row,
body[data-theme="dark"] .p2p-profile-notif-row {
  border-color: #2b313a;
}

.p2p-profile-notif-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.p2p-profile-notif-row h5 {
  font-size: 14.5px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px;
}

body.dark_theme .p2p-profile-notif-row h5,
body[data-theme="dark"] .p2p-profile-notif-row h5 {
  color: #ffffff;
}

.p2p-profile-notif-row p {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

body.dark_theme .p2p-profile-notif-row p,
body[data-theme="dark"] .p2p-profile-notif-row p {
  color: #9ca3af;
}

/* Switch Toggle */
.p2p-profile-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.p2p-profile-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.p2p-profile-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #cbd5e1;
  transition: 0.2s;
  border-radius: 24px;
}

.p2p-profile-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.2s;
  border-radius: 50%;
}

.p2p-profile-switch input:checked+.p2p-profile-slider {
  background-color: #10b981;
}

.p2p-profile-switch input:checked+.p2p-profile-slider:before {
  transform: translateX(20px);
}

@media (max-width: 1440px) {

  .p2p-hero-title {
    font-size: 42px;
  }

  .p2p-section-header h2 {
    font-size: 36px;
  }

  .p2p-post-ad-header h2 {
    font-size: 42px;
  }

}

@media (max-width: 1376px) {

  .p2p-hero-section {
    padding: 24px 50px;
    min-height: 300px;
  }

  .p2p-section-header h2 {
    font-size: 32px;
  }

  .p2p-accordion-button {
    padding: 20px;
    font-size: 18px;
  }

  .p2p-post-ad-header h2 {
    font-size: 36px;
  }

  .p2p-post-summary-val {
    font-size: 32px;
  }


  .p2p-od-payment-split {
    gap: 38px;
  }

  .p2p-od-header-row {
    flex-direction: column;
    gap: 32px;
  }

}

@media (max-width: 1200px) {
  .p2p-sidebar {
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;
  }

  .p2p-hero-title {
    font-size: 36px;
  }

  .p2p-post-ad-header h2 {
    font-size: 32px;
  }

  .p2p-stepper-label h4 {
    font-size: 16px;
  }

  .p2p-stepper-label p {
    font-size: 15px;
  }

  .p2p-post-ad-header p {
    font-size: 18px;
  }

  .p2p-post-summary-val {
    font-size: 24px;
  }

  .p2p-post-num-input {
    font-size: 28px;
  }

  .p2p-profile-hero-content {
    padding: 30px;
  }

  .p2p-profile-hero-avatar {
    width: 66px;
    font-size: 24px;
    height: 66px;
  }

  .p2p-profile-username {
    font-size: 26px;
  }

  .p2p-profile-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

}

@media (max-width: 1024px) {

  .p2p-hero-image {
    max-width: 200px;
  }

  .p2p-profile-funding-val {
    font-size: 20px;
  }

  .p2p-profile-funding-top {
    font-size: 15px;
  }

  .p2p-profile-badge-item {
    font-size: 15px;
  }

  .p2p-profile-username {
    font-size: 22px;
  }

  .p2p-profile-hero-content {
    padding: 24px;
  }

  .p2p-hero-section {
    padding: 18px 32px;
    min-height: 300px;
  }

  .p2p-hero-btn {
    padding: 12px 32px;
    min-width: 170px;
    font-size: 14px;
  }

  .p2p-hero-desc {
    font-size: 15px;
    margin-bottom: 18px;
  }

  .p2p-tabs-bar {
    padding: 15px 18px;
  }

  .p2p-token-tabs {
    gap: 15px;
  }

  .p2p-token-tab {
    font-size: 15px;
  }

  .p2p-switch-btn {
    padding: 10px 36px;
    font-size: 14px;
  }

  .p2p-token-tab.active::after {
    bottom: -33px;
  }

  .p2p-filter-group label {
    font-size: 14px;
  }

  .p2p-filter-group {
    min-width: auto;
  }

  .p2p-amount-input-wrap input {
    width: 100px;
  }

  .p2p-icon-btn,
  .p2p-refresh-btn {
    padding: 13px 12px;
    min-width: 110px;
    font-size: 13px;
  }

  .p2p-filter-input-wrap {
    width: 48px;
    height: 48px;
  }

  .p2p-section-header h2 {
    font-size: 26px;
  }

}

/* Responsive adjustments */
@media (max-width: 991px) {

  .p2p-hero-section {
    padding: 30px 20px;
  }

  .p2p-sidebar-nav {
    width: 220px;
  }

  .p2p-modal-body {
    max-height: calc(100vh - 0px);
  }

  .p2p-post-ad-header h2 {
    font-size: 26px;
  }

  .p2p-profile-stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .p2p-modal-left {
    width: 100%;
    padding: 20px 15px 20px 15px;
  }

  .p2p-od-header-right {
    width: 100%;
  }

  .p2p-od-header-left h2 {
    font-size: 28px;
  }

  .p2p-modal-right {
    padding: 20px 15px;
  }

  .p2p-amount-box input {
    font-size: 15px;
  }

  .p2p-submit-buy-btn {
    padding: 12px;
    font-size: 14px;
  }

  .p2p-escrow-info {
    padding: 15px;
    margin-bottom: 15px;
  }

  .p2p-page-content {
    padding: 20px 12px 20px;
  }

}

@media (max-width: 768px) {
  .p2p-profile-page-main {
    padding: 16px 16px 36px;
  }

  .p2p-profile-hero-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }

  .p2p-profile-funding-wrap {
    align-items: flex-start;
    text-align: left;
    margin-top: 12px;
  }

  .p2p-profile-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {

  .p2p-req-modal-header h2 {
    font-size: 18px;
  }

  .p2p-od-header-left h2 {
    font-size: 22px;
  }

  .p2p-req-cancel-btn {
    padding: 10px;
    font-size: 13px;
  }

  .p2p-my-orders-container {
    padding: 0px 0px 16px;
  }

  .p2p-od-header-left p {
    font-size: 14px;
  }

  .p2p-my-orders-header h2 {
    font-size: 22px;
  }

  .p2p-post-notice-box h4 {
    font-size: 16px;
  }

  .p2p-post-notice-box p {
    font-size: 14px;
  }

  .p2p-post-textarea-wrap textarea {
    font-size: 14px;
  }

  .p2p-post-char-count {
    font-size: 13px;
  }

  .p2p-post-field label.p2p-post-checkbox-item {
    font-size: 14px;
  }

  .p2p-post-confirm-modal {
    border-radius: 20px 20px 0px 0px;
    width: 100%;
    max-width: 100%;
  }

  .p2p-pcm-submit-btn {
    padding: 10px 16px;
    font-size: 14px;
  }

  .p2p-post-status-card p {
    font-size: 13px;
  }

  .p2p-my-orders-header p {
    font-size: 14px;
  }

  .p2p-mo-top-tab {
    padding: 10px 0;
    font-size: 13px;
  }

  .p2p-mo-top-nav {
    gap: 18px;
    margin-bottom: 15px;
  }

  .p2p-mo-pill-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .p2p-mo-stat-val {
    font-size: 24px;
  }

  .p2p-mo-stat-header {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .p2p-od-escrow-badge {
    font-size: 14px;
  }

  body.light_theme .p2p-profile-username {
    color: #000;
  }

  body.light_theme .p2p-profile-badge-item {
    color: #494949;
  }

  .p2p-my-ads-page {
    padding: 0px 0px 20px;
  }

  .p2p-od-header-right {
    padding: 18px;
  }

  .p2p-my-ads-header-info h2 {
    font-size: 22px;
  }

  .p2p-post-new-ad-btn {
    padding: 7px 13px;
    gap: 2px;
    white-space: nowrap;
    font-size: 12px;
  }

  .p2p-my-ads-tab-btn {
    font-size: 14px;
  }

  .p2p-my-ads-tabs-bar {
    gap: 12px;
    margin-bottom: 20px;
  }

  .p2p-od-info-col strong {
    font-size: 14px;
  }

  .p2p-od-stepper-container {
    padding: 22px;
    margin-bottom: 24px;
  }

  .p2p-od-step-circle {
    width: 28px;
    min-width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .p2p-od-step .p2p-od-step-text-only {
    width: 28px;
    min-width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .p2p-profile-page-main {
    padding: 0px;
  }

  .p2p-modal-overlay {
    align-items: end !important;
  }

  .p2p-profile-stat-card {
    min-height: 100%;
  }

  .p2p-profile-tab-item {
    font-size: 15px;
  }

  .p2p-profile-tabs-bar {
    gap: 20px;
    margin-bottom: 18px;
  }

  .p2p-profile-hero-curve {
    display: none;
  }

  .p2p-profile-hero-avatar {
    width: 48px;
    font-size: 18px;
    height: 48px;
    min-width: 48px;
  }

  .p2p-req-modal-header {
    padding: 18px 15px 16px;
  }

  .p2p-profile-hero-online-dot {
    width: 16px;
    height: 16px;
    border: 2px solid #000000;
  }

  .p2p-profile-badge-item {
    font-size: 13px;
  }

  .p2p-profile-stats-grid {
    margin: 24px 0px;
  }

  .p2p-req-modal-body {
    padding: 0 15px;
  }

  .p2p-req-modal-footer {
    padding: 18px 15px;
  }

  .p2p-req-modal-content {
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .p2p-modal-content {
    border-radius: 18px 18px 0px 0px;
    width: 100%;
    max-width: 100%;
    margin: 0px;
  }

  .p2p-modal-right {
    padding: 0px 0px;
    position: inherit;
  }

  .p2p-modal-close {
    top: 10px;
    right: 10px;
  }

  .p2p-modal-avatar {
    width: 36px;
    min-width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .p2p-action-title h2 {
    font-size: 18px;
  }

  .p2p-modal-action-header {
    margin-bottom: 12px;
    margin-top: 14px;
  }

  .p2p-price-rate {
    font-size: 12px;
  }

  .p2p-req-text {
    font-size: 14px;
  }

  .p2p-modal-left {
    padding: 0px;
  }

  .p2p-modal-body {
    flex-direction: column;
  }

  .p2p-modal-seller-info h3 {
    font-size: 18px;
    width: 90%;
  }

  .p2p-req-get-verified-btn {
    padding: 10px;
    font-size: 13px;
  }

  .p2p-hero-title {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .p2p-hero-title br {
    display: none;
  }

  .p2p-hero-section {
    padding: 20px;
    min-height: 100%;
    margin-bottom: 20px;
  }

  .p2p-hero-btn {
    padding: 10px 24px;
    white-space: nowrap;
    min-width: auto;
  }

  .p2p-token-tab {
    font-size: 14px;
  }

  .p2p-token-tabs {
    gap: 5px;
  }

  .p2p-filter-refresh {
    width: 100%;
  }

  .p2p-tutorial-section {
    margin: 30px 0px 30px;
    padding: 24px;
    border-radius: 18px;
  }

  .p2p-section-header h2 {
    font-size: 22px;
  }

  .p2p-fam-overlay {
    align-items: end;
    padding: 0px;
  }

  .p2p-section-header p {
    font-size: 15px;
  }

  .p2p-fam-card {
    padding: 24px;
    border-radius: 20px 20px 0px 0px;
    min-height: 25vh;
    max-height: 85vh;
    overflow: scroll;
  }

  .p2p-post-ad-page {
    padding: 0px 0px 20px;
  }

  .p2p-post-ad-header h2 {
    font-size: 22px;
  }

  .p2p-post-ad-header p {
    font-size: 14px;
  }

  .p2p-stepper-label p {
    font-size: 14px;
  }

  .p2p-stepper-label h4 {
    font-size: 15px;
  }

  .p2p-stepper-circle {
    width: 42px;
    height: 42px;
    min-width: 42px;
    font-size: 15px;
  }

  .p2p-post-toggle-btn {
    padding: 8px 22px;
    font-size: 15px;
  }

  .p2p-post-toggle-btn.active {
    box-shadow: 0 1px 0px #d1aa67;
  }

  .p2p-post-select-box select {
    font-size: 15px;
  }

  .p2p-post-select-box {
    border-radius: 10px;
    padding: 12px 16px;
    min-height: 54px;
  }

  .p2p-post-price-card {
    border-radius: 12px;
    padding: 12px 18px;
    min-height: 54px;
  }

  .p2p-post-num-input {
    font-size: 20px;
    width: 150px;
  }

  .p2p-post-stepper-input {
    border-radius: 12px;
    padding: 12px 14px;
    min-height: 54px;
  }

  .p2p-post-summary-label {
    font-size: 15px;
  }

  .p2p-post-summary-card {
    border-radius: 12px;
    padding: 16px 22px;
    margin-top: 18px;
  }

  .p2p-post-help-left {
    font-size: 15px;
  }

  .p2p-post-guide-link {
    white-space: nowrap;
    font-size: 14px;
  }

  .p2p-post-help-strip {
    margin: 18px 0px;
  }

  .p2p-post-next-btn {
    padding: 9px 36px;
    font-size: 14px;
  }

  .p2p-post-cancel-btn,
  .p2p-post-prev-btn {
    padding: 9px 36px;
    font-size: 14px;
  }

  .p2p-post-field label {
    font-size: 14px;
  }

  .p2p-post-field-hint {
    font-size: 14px;
  }

  .p2p-post-amount-wrap input {
    font-size: 15px;
  }

  .p2p-post-amount-all {
    font-size: 14px;
  }

  .p2p-post-amount-wrap {
    border-radius: 12px;
    padding: 12px 16px;
    min-height: 54px;
  }

  .p2p-post-amount-subtext {
    font-size: 13px;
  }

  .p2p-post-limit-label {
    font-size: 13px;
  }

  .p2p-post-limits-row {
    flex-direction: column;
  }

  .p2p-post-limit-box {
    width: 100%;
  }

  .p2p-post-fee-note {
    font-size: 13px;
  }

  .p2p-post-action-btns {
    gap: 12px;
  }

  .p2p-post-amount-curr {
    font-size: 14px;
  }

  .p2p-tut-content p {
    font-size: 15px;
    margin-bottom: 12px;
    min-height: 100%;
  }

  .p2p-tut-link {
    font-size: 14px;
  }

  .p2p-accordion-button {
    padding: 16px;
    font-size: 15px;
  }

  .p2p-acc-icon {
    font-size: 15px;
    width: 28px;
    height: 28px;
    min-width: 28px;
  }

  .p2p-accordion-body {
    padding: 0 20px 20px;
    font-size: 14px;
  }

  .p2p-page-content {
    padding: 10px 12px 20px;
  }

  .p2p-table th {
    padding: 13px;
    font-size: 13px;
  }

  .p2p-adv-avatar {
    width: 28px;
    min-width: 28px;
    height: 28px;
  }

  .p2p-adv-info h4 {
    font-size: 14px;
  }

  .p2p-price-cell {
    font-size: 13px;
  }

  .p2p-limit-val {
    font-size: 13px;
  }

  .p2p-limit-range {
    font-size: 12px;
  }

  .p2p-section-header {
    margin-bottom: 10px;
  }

  .p2p-payment-tag {
    font-size: 12px;
    padding: 4px 10px;
    white-space: nowrap;
  }

  .p2p-action-btn {
    padding: 7px 24px;
  }

  .p2p-table td {
    padding: 13px;
  }

}

@media (max-width: 580px) {

  .p2p-hero-section {
    flex-direction: column;
  }

  .p2p-token-tab {
    font-size: 13px;
    padding: 5px 7px;
  }

  .p2p-tabs-bar {
    padding: 12px 14px;
  }

  .p2p-token-more-btn {
    white-space: nowrap;
    font-size: 12px;
  }

  .p2p-token-tab.active::after {
    bottom: 0px;
    height: 2px;
  }

  .p2p-buysell-switch {
    width: 100%;
    margin-top: 15px;
  }

  .p2p-buysell-switch button {
    width: 100%;
  }

  .p2p-filter-bar {
    padding: 18px;
  }

  .p2p-tabs-bar {
    flex-direction: column;
    align-items: start;
  }

  .p2p-profile-stats-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/P2P/p2p.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;yCAWyC;;AAEzC;;yCAEyC;;AAEzC;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,kDAAkD;EAClD,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;yCAGyC;;AAEzC;;EAEE,oDAAoD;EACpD;;IAEE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,MAAM;IACN,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,8FAA8F;EAC9F;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;IAC5B,WAAW;IACX;;;;;+CAK2C;EAC7C;;EAEA,sEAAsE;EACtE;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,qCAAqC;EACvC;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV;;;uBAGmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,+BAA+B;IAC/B,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;IAClC,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,4BAA4B;IAC5B,8FAA8F;EAChG;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,0BAA0B;IAC1B,2DAA2D;IAC3D,6BAA6B;EAC/B;;EAEA,kGAAkG;EAClG;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV;;;;;0BAKsB;EACxB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA,gEAAgE;EAChE;IACE,oBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA,kDAAkD;AAClD;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,iDAAiD;EACjD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;;CAOC;;AAED;EACE,2BAA2B;EAC3B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,oHAAoH;AACtH;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA,6CAA6C;AAC7C;;;EAGE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;;EAGE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;CAKC;;AAED;EACE,oCAAoC;AACtC;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;;;;;CAMC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yDAA6L;EAC7L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;CASC;;AAED;EACE,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;;;;;;CAMC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED,eAAe;AACf;;;;;;CAMC;;AAED,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;;;;CAIC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;;;CASC;;AAED;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;KAEK;;AAEL;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED,iCAAiC;AACjC;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;;;;;;;;;;CAcC;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;;;;CAQC;;AAED;EACE,iBAAiB;AACnB;;AAEA;;;;;;CAMC;;AAED;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;CAIC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;;CAOC;;AAED;EACE,iBAAiB;AACnB;;AAEA;;;;;;CAMC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;2CAE2C;;AAE3C;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;;;;CAKD;;EAEC;IACE,eAAe;EACjB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,gCAAgC;EAChC;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;;;;;;;CASD;;EAEC;;;;;;;CAOD;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;CAID;;;;;EAKC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;;;CAOD;;EAEC;;;;;CAKD;;EAEC,iCAAiC;EACjC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;AACD;;AAEA,wBAAwB;AACxB;EACE;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;CAID;AACD;;AAEA;;2CAE2C;;AAE3C,sCAAsC;AACtC;EACE;IACE,eAAe;EACjB;;EAEA;;;;;CAKD;;EAEC;IACE,SAAS;EACX;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;;;CAID;AACD;;AAEA,+CAA+C;AAC/C;EACE;IACE,cAAc;EAChB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC;;;;;;;;CAQD;;EAEC,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;;;;;CAMD;;EAEC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;;;;CAKD;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;;;;;;;CASD;;EAEC,4BAA4B;EAC5B;;;;;CAKD;;EAEC;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;CAID;;EAEC,oDAAoD;EACpD;;;;CAID;;EAEC;;;;;;;;;;;CAWD;;EAEC;;;;;;CAMD;;EAEC;;;;;CAKD;;EAEC;;;;;;;;;;CAUD;;EAEC;;;;;;;;;;;CAWD;;EAEC;;;;CAID;;EAEC;;;;;;;;CAQD;;EAEC;;;;CAID;;EAEC;;;;;;;;;;;;;;;;;CAiBD;;EAEC;;;;;CAKD;;EAEC;;;;;;;;CAQD;;EAEC;;;;;;CAMD;;EAEC;;;;;;;;;;;;CAYD;;EAEC;;;;CAID;;EAEC;;;;;;;;;CASD;;EAEC;;;;;;;CAOD;;EAEC;;;;;;;;CAQD;;EAEC;;;;CAID;;EAEC;IACE,6BAA6B;EAC/B;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;;;;CAID;;EAEC;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;;;;CAID;;EAEC;;;;CAID;;EAEC;IACE,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;;;;CAID;;EAEC;;;;CAID;;EAEC,6BAA6B;EAC7B;;;;;;CAMD;AACD;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;EAChB;;EAEA;;;;;CAKD;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;;;;;;CAMD;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;CAID;;EAEC;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;;;;;CAOD;;EAEC,kCAAkC;EAClC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;;;CAOD;;EAEC;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC,+BAA+B;EAC/B;;;;;CAKD;;EAEC;;;;CAID;;EAEC,4BAA4B;EAC5B;;;;;;;;CAQD;;EAEC,4BAA4B;EAC5B;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;;;;CAID;;EAEC,6BAA6B;EAC7B;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA,yCAAyC;AACzC;EACE;;;;CAID;;EAEC;;;;;CAKD;;EAEC;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;;;CAMD;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;;;CAID;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;;;CAOD;;EAEC;;;;;;;CAOD;;EAEC,qBAAqB;EACrB;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;;;;;;;;;;CAUC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;CAIC;;AAED;EACE,oCAAoC;EACpC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;;;CAKD;;EAEC;;;;CAID;;EAEC;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;CAID;;EAEC;;;;CAID;AACD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;;;;;;CAOC;;AAED;;KAEK;;AAEL,qBAAqB;AACrB;;;;KAIK;;AAEL;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,mBAAmB;AACnB;;;;;;;;;;;;;GAaG;;AAEH;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;2CAE2C;;AAE3C,yCAAyC;AACzC;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2FAA2F;IAC3F,wCAAwC;IACxC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,2FAA2F;IAC3F,oCAAoC;EACtC;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,uEAAuE;IACvE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;;;;CAKD;;AAED;;AAEA;;EAEE;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;;;;EAKA;;;;;CAKD;;EAEC;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,6FAA6F;IAC7F,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,6FAA6F;IAC7F,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;;;;;;;CAOD;;EAEC,kBAAkB;EAClB;IACE,iBAAiB;EACnB;;EAEA;;;;;;;CAOD;;EAEC;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,+CAA+C;EACjD;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;EACjD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iBAAiB;EACjB;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;EACf;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;CAID;;EAEC;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kDAAkD;EACpD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;AAEF;;AAEA;;2CAE2C;;AAE3C,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;;;;CASC;;AAED,0BAA0B;AAC1B;;EAEE,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;;IAEA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE;;;;;;;;CAQD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;AACD;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;CAIC;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;CAOC;;AAED;EACE,iBAAiB;AACnB;;AAEA;;;;;;CAMC;;AAED;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;;OAEK;AACP;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;;;CASC;;AAED;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;;AAGF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;;EAGA;IACE,eAAe;EACjB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;;;;;CASC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;CAYC;;AAED;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA;;EAEE;IACE,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,mBAAmB;IACnB,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;;;AAGA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;AAEF;;;;;;AAMA;;;EAGE;IACE,yBAAyB;EAC3B;;;EAGA;IACE,cAAc;EAChB;;EAEA;;;;CAID;;EAEC;IACE,cAAc;EAChB;;EAEA;;;;CAID;;EAEC;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;;;;CAID;;EAEC;;;;;CAKD;;;;AAID;;;AAGA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,8BAA8B;EAChC;AACF;;AAEA;;mDAEmD;;AAEnD;;;;;;;;;;;;;;CAcC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;CAOC;;AAED,mBAAmB;AACnB;;;;;;;;CAQC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED,yBAAyB;AACzB;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED,gBAAgB;AAChB;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED,uBAAuB;AACvB;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED,oBAAoB;AACpB;;;;;;;;;;;CAWC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED,0BAA0B;AAC1B;;;;;;;CAOC;;AAED,wBAAwB;AACxB;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED,kBAAkB;AAClB;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED,kBAAkB;AAClB;;;;;;;;CAQC;;AAED,cAAc;AACd;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED,cAAc;AACd;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;CAKC;;AAED,6BAA6B;AAC7B;EACE;;;;CAID;;EAEC;;;;CAID;;;AAGD;;AAEA;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA;EACE;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;;;;;;CAMD;;EAEC;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;;EAGA;IACE,SAAS;IACT,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;AACD;;AAEA;;mDAEmD;;AAEnD;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED,oBAAoB;AACpB;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED,aAAa;AACb;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED,gBAAgB;AAChB;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED,sBAAsB;AACtB;;;;;;CAMC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;CAUC;;AAED,uBAAuB;AACvB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;;;;;;;;;;;;;;;CAeC;;AAED;EACE,yBAAyB;AAC3B;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED,oBAAoB;AACpB;EACE,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED,6BAA6B;AAC7B;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE;;;;CAID;AACD;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;;;;CAID;AACD;;AAEA;EACE;;;;;;CAMD;;EAEC;;;;CAID;AACD;;AAEA,iCAAiC;AACjC;;;;CAIC;;AAED;;;;CAIC;;AAED,yBAAyB;AACzB;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED,uBAAuB;AACvB;;;;;CAKC;;AAED,+CAA+C;AAC/C;;;;;;;CAOC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;CAKC;;AAED,+CAA+C;AAC/C;;;;;;;;;;;;CAYC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;CASC;;AAED;EACE;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA,oCAAoC;AACpC;EACE;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;AACD;;AAEA;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;AACD;;AAEA;;mDAEmD;;AAEnD;;;;;;;;CAQC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED,qBAAqB;AACrB;;;;;;;;;CASC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED,wBAAwB;AACxB;EACE;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;;;;;;;CAOD;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;;;AAIF;;AAEA;;mDAEmD;;AAEnD;;;;;;;;;;CAUC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED,mCAAmC;AACnC;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;;CAKD;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA;;mDAEmD;;AAEnD;;;;;;CAMC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;mDAEmD;;AAEnD;;;;;;;;;;;CAWC;;AAED,wDAAwD;AACxD;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;;;;;;;;;;;;;CAcC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;;CAeC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;;CAeC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED,+BAA+B;AAC/B;;;;CAIC;;AAED;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;;;;;;;;;;;;;;CAcC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED,qBAAqB;AACrB;;;;;;;;;;;;CAYC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED,0BAA0B;AAC1B;;;;;;;CAOC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,eAAe;AACf;;;;;;;;;;;CAWC;;AAED;;;;CAIC;;AAED,2BAA2B;AAC3B;;;;;;CAMC;;AAED;;;;CAIC;;AAED,yBAAyB;AACzB;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED,iCAAiC;AACjC;;;;;;;;;;;;;CAaC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED,6BAA6B;AAC7B;;;;CAIC;;AAED;;;;CAIC;;AAED,yBAAyB;AACzB;;;;CAIC;;AAED;;;;;CAKC;;AAED,2BAA2B;AAC3B;;;;;;;CAOC;;AAED,iBAAiB;AACjB;;;;CAIC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;CAKC;;AAED,+BAA+B;AAC/B;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED,oBAAoB;AACpB;EACE;;;;;CAKD;AACD;;AAEA;EACE;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;AAC3C;;AAEA;EACE,6FAA6F;EAC7F,wCAAwC;AAC1C;;AAEA;EACE,+FAA+F;EAC/F,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;;2CAE2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;2CAE2C;;AAE3C,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;2CAE2C;;AAE3C,iCAAiC;AACjC;;;;;;;;;;;;;;;CAeC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED,+BAA+B;AAC/B;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED,sBAAsB;AACtB;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED,sBAAsB;AACtB;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED,kBAAkB;AAClB;;;;;;;;;;;;;;;;CAgBC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;;AAGD;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;CAKC;;AAED,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;;;;CAID;;EAEC;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;;;;;;CAMD;AACD;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;2CAE2C;;AAE3C;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;;KAEK;;AAEL;EACE,WAAW;AACb;;AAEA;;;;;;;;;;KAUK;;AAEL;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,yDAA6L;EAC7L,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE,kCAAkC;EAClC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;;;;;;;CAmBC;;AAED;EACE;;;;CAID;AACD;;AAEA;EACE;;;;;CAKD;AACD;;AAEA;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;;;AAID;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;;;;CAgBC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;;;;;;;CAUC;;AAED;EACE;;;;;CAKD;;EAEC;IACE,SAAS;IACT,4BAA4B;IAC5B,eAAe;EACjB;;;;EAIA;;;;CAID;;EAEC;;;;CAID;;AAED;;AAEA;;;;CAIC;;AAED,gCAAgC;AAChC;;;;;;;CAOC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;;EAEC;;;;;CAKD;AACD;;AAEA,yDAAyD;AACzD;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;AACD;;AAEA,4BAA4B;AAC5B;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;;CAKD;AACD;;AAEA,iBAAiB;AACjB;;;;;;;;CAQC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;CAUC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;CAYC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED,oCAAoC;AACpC;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;;;;;;;;CAcC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;;;;;;;;;;CAuBC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;;;;;;;CAaC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;CAWC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;;;;CAYC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;;CAUC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;CAaC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;;;;CAYC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;;;CAeC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;;;;;;CAUC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;;;;;;CAcC;;AAED;EACE;;;;;;;CAOD;AACD;;AAEA;;;;;;;;;;;;;CAaC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;;;;CAQC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;EACE;;;;CAID;AACD;;AAEA;;;;;;;;CAQC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;CAMC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;CAMC;;AAED;EACE;;;;CAID;;EAEC;;;;CAID;;AAED;;AAEA;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;;CAKD;;EAEC;;;;CAID;AACD;;AAEA;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;CAYC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;CAWC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;CAMC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED,wBAAwB;AACxB;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;;;;;;;CAgBC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED,6BAA6B;AAC7B;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED,0BAA0B;AAC1B;;;;;;CAMC;;AAED;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;;CASC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;;;;CAaC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;CAaC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED,sCAAsC;AACtC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;;AAEhB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;;;CAIC;;AAED;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED,kBAAkB;AAClB;;;;;;;;;;CAUC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;CAIC;;AAED;;;;;;;;;;;;;;;;CAgBC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;CAUC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;EACE;;;;;CAKD;AACD;;AAEA;;;;;;;;;CASC;;AAED;EACE;;;;;;CAMD;AACD;;AAEA;;;;;;;;;;;;;;CAcC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;CAUC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;CAIC;;AAED;;;;;;CAMC;;AAED;EACE;;;;CAID;AACD;;AAEA;;;;;;;;;;;;;CAaC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED,8BAA8B;AAC9B;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;CAMC;;AAED;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE;;;;CAID;;EAEC;IACE,2DAA2D;EAC7D;;;AAGF;;;AAGA;;EAEE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;EAEC;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;CAID;;;EAGC;;;;;CAKD;;EAEC;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;AAEF;;AAEA;EACE;;;;CAID;;EAEC;;;;CAID;;EAEC;;;;;CAKD;;AAED;;;AAGA;;EAEE;;;;CAID;;EAEC;;;;CAID;;EAEC;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;;EAGA;;;;;;;;CAQD;AACD;;;AAGA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uHAAuH;EACvH,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;EAGE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gDAAgD;AAClD;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;;;EAME,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;;;EAGE,oCAAoC;EACpC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;EAGE,wCAAwC;EACxC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;EAGE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,eAAe;EACjB;;;;EAIA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA,qBAAqB;;EAErB;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;AACF;;AAEA,2EAA2E;AAC3E;EACE,2BAA2B;EAC3B,kCAA0B;UAA1B,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wEAAwE;AACxE;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;;;;;;;;;;EAWE,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oEAAoE;AACpE;;;;CAIC;;AAED,eAAe;AACf;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;CASC;;AAED;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED,gBAAgB;AAChB;;;;;CAKC;;AAED;;;;;;;CAOC;;AAED;;;;;;;CAOC;;AAED,eAAe;AACf;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;;;CAOC;;AAED;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;;;CAgBC;;AAED;;;;;;;CAOC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED,SAAS;AACT;;;;;;;;CAQC;;AAED;;;;;;;;;;;CAWC;;AAED;;;;;CAKC;;AAED,WAAW;AACX;;;;;;;;;CASC;;AAED;;;;;;CAMC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED,yBAAyB;AACzB;;;;;CAKC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;CAKC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;CAIC;;AAED,aAAa;AACb;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED,eAAe;AACf;;;;;CAKC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;CAYC;;AAED;;;;;CAKC;;AAED;;;;;;;;;CASC;;AAED,oBAAoB;AACpB;;;;CAIC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;CASC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED,oBAAoB;AACpB;;;;;;;CAOC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;;;CAQC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;CAMC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;;;CAUC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;;;;;CAUC;;AAED;;;;CAIC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;CAKC;;AAED;;;;;;;;;;;;;;;;;CAiBC;;AAED,cAAc;;AAEd;;;;;;;;;CASC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;;;;;;;;;CAaC;;AAED;;;;;;;CAOC;;AAED;;;;;;CAMC;;AAED;;;;;;;;;;;;;;CAcC;;AAED,wBAAwB;AACxB;;;;;;;;;;;;;CAaC;;AAED;;;;;CAKC;;AAED;;;;;;;;CAQC;;AAED;;;;;;;CAOC;;AAED;;;;;;;;CAQC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;;CAKC;;AAED;;;;;CAKC;;AAED;;;;CAIC;;AAED;;;;CAIC;;AAED;;;;;;CAMC;;AAED;EACE;;;;;CAKD;;EAEC;;;;CAID;;EAEC;;;;;;;;CAQD;;EAEC;;;;;CAKD;;EAEC;;;;;;;CAOD;AACD;;AAEA;;+EAE+E;;AAE/E;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,OAAO;EACP,cAAc;EACd,QAAQ;EACR,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA;;EAEE,8FAA8F;EAC9F,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE;IACE,oCAAoC;IACpC,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;;CAID;;EAEC;;;;;;CAMD;;EAEC;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,2CAA2C;EAC3C,uCAAuC;EACvC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;+EAE+E;AAC/E;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;;;AAIA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,2BAA2B;AAC3B;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;AAEF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ====================================\n   P2P Module Styles\n   All styles are scoped with .p2p- prefix\n   to avoid conflicts with other project CSS\n   \n   Theme Color: #ffdc88 (Yellow/Gold - Dark Theme), #F4B609 (Yellow - Light Theme)\n   Color Palette:\n   - Primary (Dark): #ffdc88\n   - Primary (Light): #F4B609\n   - Primary Dark: #f4b609\n   - Primary Light: #bd83cb\n   ==================================== */\n\n/* ====================================\n   P2P Layout Styles\n   ==================================== */\n\n.p2p-layout-wrapper {\n  display: flex;\n  background-color: #181A20;\n  background-size: cover;\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.p2p-main-content {\n  flex: 1;\n  margin-left: 320px;\n  transition: margin-left 0.3s ease;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.p2p-main-content.p2p-mobile {\n  margin-left: 0;\n}\n\n.p2p-mobile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background-color: rgb(23 26 32);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.p2p-hamburger {\n  width: 20px;\n  height: 30px;\n  background-color: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.p2p-hamburger:hover {\n  background-color: rgba(166, 95, 255, 0.2);\n}\n\n.p2p-hamburger-line {\n  width: 20px;\n  height: 2px;\n  background-color: #fff;\n  border-radius: 2px;\n}\n\n.p2p-mobile-logo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-mobile-logo-icon {\n  width: 32px;\n  height: 32px;\n  background-color: #ffdc88;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-mobile-logo-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.p2p-page-title {\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.p2p-page-content {\n  padding: 30px 32px 20px;\n  max-width: 100%;\n  /* margin: 0 auto; */\n  color: #fff;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.p2p-spacer {\n  width: 40px;\n}\n\n/* ====================================\n   P2P Desktop Split Scroll (Header & Sidebar Fixed, Only Right Content Scrolls)\n   Matching user_profile/dashboard split scroll behavior\n   ==================================== */\n\n@media (min-width: 992px) {\n\n  /* Lock viewport so header and window never scroll */\n  html:has(.p2p-layout-wrapper),\n  body:has(.p2p-layout-wrapper) {\n    overflow: hidden !important;\n    height: 100% !important;\n  }\n\n  .p2p-layout-wrapper {\n    justify-content: flex-start;\n    align-items: stretch;\n    gap: 0;\n    width: 100%;\n    max-width: 100%;\n    height: calc(100vh - 70px);\n    height: calc(100dvh - 70px);\n    min-height: calc(100vh - 70px);\n    min-height: calc(100dvh - 70px);\n    max-height: calc(100vh - 70px);\n    max-height: calc(100dvh - 70px);\n    overflow: hidden;\n    position: relative;\n  }\n\n  /* Left sidebar: in-flow column matching row height, stays fixed without scrolling with page */\n  .p2p-sidebar {\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    bottom: auto !important;\n    align-self: stretch;\n    height: 100% !important;\n    max-height: none !important;\n    min-height: 0 !important;\n    flex: 0 0 324px !important;\n    width: 324px !important;\n    max-width: 324px !important;\n    min-width: 324px !important;\n    display: flex;\n    flex-direction: column;\n    overflow: visible !important;\n    overscroll-behavior: contain;\n    z-index: 10;\n    transition:\n      width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n      min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n      max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n      flex-basis 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n      padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  /* Collapsed rail state (matches dashboard page profile-sidebar.css) */\n  .p2p-sidebar.p2p-sidebar--collapsed {\n    flex: 0 0 76px !important;\n    width: 76px !important;\n    min-width: 76px !important;\n    max-width: 76px !important;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-sidebar-nav {\n    width: 100% !important;\n    padding: 20px 0px 32px 0px !important;\n  }\n\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-nav-item {\n    justify-content: center !important;\n    padding: 14px 10px !important;\n    gap: 0 !important;\n  }\n\n  .p2p-sidebar .p2p-nav-label,\n  .p2p-sidebar .p2p-back-link-text {\n    overflow: hidden;\n    white-space: nowrap;\n    min-width: 0;\n    max-width: 260px;\n    opacity: 1;\n    transition:\n      max-width 0.42s cubic-bezier(0.4, 0, 0.2, 1),\n      opacity 0.32s ease,\n      margin 0.32s ease;\n  }\n\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-nav-label,\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-back-link-text {\n    max-width: 0 !important;\n    opacity: 0 !important;\n    margin: 0 !important;\n    pointer-events: none !important;\n    display: none !important;\n  }\n\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-sidebar-footer {\n    padding: 16px 0px !important;\n  }\n\n  .p2p-sidebar.p2p-sidebar--collapsed .p2p-back-link {\n    justify-content: center !important;\n    padding: 12px 0px !important;\n    gap: 0 !important;\n  }\n\n  .p2p-sidebar-nav {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n    min-height: 0;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1), padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .p2p-sidebar-footer {\n    position: relative !important;\n    bottom: auto !important;\n    left: auto !important;\n    margin-top: auto;\n    flex-shrink: 0;\n    width: 100% !important;\n    max-width: none !important;\n    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));\n    transition: padding 0.4s ease;\n  }\n\n  /* Collapse control button on rail edge — matches Dashboard page (.profile-sidebar-collapse-btn) */\n  .p2p-sidebar-collapse-btn {\n    position: absolute;\n    right: -18px;\n    top: 40px;\n    z-index: 668;\n    width: 40px;\n    height: 40px;\n    border-radius: 50px;\n    border: 1px solid #646464;\n    background: #1d1d1d;\n    display: none;\n    color: #f4f4f4;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    padding: 0;\n    transition:\n      color 0.15s ease,\n      background-color 0.15s ease,\n      border-color 0.15s ease,\n      box-shadow 0.15s ease,\n      transform 0.15s ease;\n  }\n\n  .p2p-sidebar-collapse-btn:hover {\n    color: #fff;\n    background-color: #2a2a2a;\n  }\n\n  .p2p-sidebar-collapse-btn i {\n    font-size: 16px;\n    line-height: 1;\n  }\n\n  body.light_theme .p2p-sidebar-collapse-btn {\n    color: #64748b;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n  }\n\n  body.light_theme .p2p-sidebar-collapse-btn:hover {\n    color: #1e293b;\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n  }\n\n  @media (min-width: 992px) {\n    .p2p-sidebar-collapse-btn {\n      display: flex;\n    }\n  }\n\n  /* Right-side main content: own independent vertical scrollbar */\n  .p2p-main-content {\n    flex: 1 1 0% !important;\n    margin-left: 0 !important;\n    min-width: 0;\n    min-height: 0;\n    height: 100% !important;\n    max-height: 100% !important;\n    width: auto !important;\n    max-width: none !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    scroll-behavior: smooth;\n  }\n}\n\n/* Custom sleek scrollbar for right-side content */\n.p2p-main-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.p2p-main-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.p2p-main-content::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n}\n\n.p2p-main-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\nbody.light_theme .p2p-main-content::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n}\n\nbody.light_theme .p2p-main-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.25);\n}\n\n@media (max-width: 991.98px) {\n  .p2p-layout-wrapper {\n    min-height: calc(100vh - 70px);\n    height: auto;\n    overflow: visible;\n  }\n\n  .p2p-main-content {\n    margin-left: 0 !important;\n    min-height: auto;\n    height: auto;\n    overflow: visible;\n  }\n\n  .p2p-sidebar {\n    position: fixed !important;\n    top: 0 !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    width: 280px !important;\n    z-index: 10000000 !important;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n\n  .p2p-sidebar.p2p-open {\n    transform: translateX(0);\n    background: #000;\n  }\n\n  body.light_theme .p2p-sidebar.p2p-open {\n    background: #fff;\n  }\n\n  .p2p-sidebar-close {\n    display: flex;\n  }\n}\n\n/* ====================================\n     P2P Sidebar Styles\n     ==================================== */\n\n.p2p-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 998;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n\nh4.p2p-profile-tab {\n  background-color: transparent;\n  border: none;\n  cursor: default;\n  padding: 0px;\n  color: #cfcfcf;\n}\n\nh4.p2p-profile-tab:hover {\n  background-color: transparent;\n}\n\n.p2p-sidebar-overlay.p2p-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\nnav.p2p-sidebar-nav.mt-5 {\n  margin: 0px !important;\n}\n\n.p2p-sidebar {\n  position: fixed;\n  left: 0;\n  top: 70px;\n  bottom: 0;\n  width: 320px;\n  background: transparent;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s ease;\n  overflow-y: auto;\n}\n\n.p2p-sidebar.p2p-closed {\n  transform: translateX(-100%);\n}\n\n/* [UNUSED]\n.p2p-sidebar-logo {\n  padding: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n*/\n\n/* [UNUSED]\n.p2p-sidebar-logo a {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-logo-icon {\n  width: 38px;\n  height: 38px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-logo-text {\n  font-size: 22px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.5px;\n}\n*/\n\n.p2p-sidebar-nav {\n  padding: 20px 0px 32px 20px;\n  width: 250px;\n  flex: 1 1;\n}\n\n.p2p-nav-item {\n  border: 1px solid #ffffff00;\n  padding: 14px 20px;\n  gap: 14px !important;\n  color: #fff;\n  font-weight: 500;\n  box-shadow: 0px 1px 3px #00000000;\n  border-radius: 14px !important;\n  font-size: 14px;\n  margin: 0px;\n  line-height: 1.35;\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  transition: background-color 0.15s ease, color 0.15s ease, padding 0.4s cubic-bezier(0.4, 0, 0.2, 1), gap 0.35s ease;\n}\n\n.p2p-nav-item:hover {\n  color: #fff;\n}\n\n.p2p-nav-item.active {\n  background-color: #2b313d52;\n  border: 1px solid #dbdbdd00;\n  box-shadow: 0px 1px 3px #00000011;\n  color: #fff;\n}\n\nbody.light_theme .p2p-nav-item.active {\n  background-color: #f2f3f7;\n  border: 1px solid #dbdbdd;\n  color: #020202;\n}\n\n.p2p-nav-item.active .p2p-nav-icon {\n  color: #020202;\n}\n\n.p2p-nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  flex-shrink: 0;\n}\n\n.p2p-nav-icon img {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  display: block;\n  transition: filter 0.2s ease, opacity 0.2s ease;\n}\n\n/* In dark theme, SVG icons invert to white */\nbody.dark_theme .p2p-nav-icon img,\nbody[data-theme=\"dark\"] .p2p-nav-icon img,\nhtml[data-theme=\"dark\"] .p2p-nav-icon img {\n  filter: brightness(0) invert(1);\n  opacity: 0.85;\n}\n\nbody.dark_theme .p2p-nav-item.active .p2p-nav-icon img,\nbody[data-theme=\"dark\"] .p2p-nav-item.active .p2p-nav-icon img,\nhtml[data-theme=\"dark\"] .p2p-nav-item.active .p2p-nav-icon img {\n  filter: brightness(0) invert(1);\n  opacity: 1;\n}\n\n/* In light theme, inactive icons stay slate, active icon becomes dark */\nbody.light_theme .p2p-nav-icon img {\n  opacity: 0.85;\n}\n\nbody.light_theme .p2p-nav-item.active .p2p-nav-icon img {\n  filter: brightness(0);\n  opacity: 1;\n}\n\n.p2p-sidebar-close {\n  position: absolute;\n  top: 16px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  transition: background 0.2s ease;\n}\n\n.p2p-sidebar-close:hover {\n  background: rgba(255, 220, 136, 0.2);\n}\n\n.p2p-sidebar-footer {\n  padding: 16px;\n  /* border-top: 1px solid rgba(255, 255, 255, 0.04); */\n}\n\n.p2p-back-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #9ca3af;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.p2p-back-link:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n/* Sidebar Scrollbar */\n.p2p-sidebar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.p2p-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.p2p-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n/* [UNUSED]\n.selectpaymetpop.modal.fade .modal-dialog {\n  width: 480px;\n  min-width: 480px;\n}\n*/\n\n.p2p-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* ====================================\n     P2P Dashboard Styles\n     ==================================== */\n\n.p2p-dashboard-container {\n  max-width: 100%;\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n/* Buy/Sell Toggle */\n/* [UNUSED]\n.p2p-buy-sell-toggle {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-toggle-wrapper {\n  display: flex;\n  background: #2B313C;\n  border-radius: 6px;\n  padding: 4px;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-toggle-btn {\n  padding: 7px 48px;\n  border: none;\n  width: 136px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: transparent;\n  color: #87909F;\n\n}\n*/\n\n.p2p-dashboard-container input:focus {\n  border: 1px solid #ffffff00 !important;\n}\n\n.p2p-dashboard-container select:focus-visible {\n  outline: none !important;\n}\n\n.binance-chat-input input:focus {\n  border: none !important;\n}\n\n.p2p-layout-wrapper button:disabled {\n  background-color: #181a1f81 !important;\n  color: #fff;\n}\n\n/* [UNUSED]\n.p2p-toggle-btn.p2p-active-buy {\n  background: #5EBA89;\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-toggle-btn.p2p-active-sell {\n  background: #E45561;\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-toggle-btn.p2p-active-buy:hover {\n  background: #5EBA89;\n}\n*/\n\n/* [UNUSED]\n.p2p-toggle-btn:hover:not(.p2p-active-buy):not(.p2p-active-sell) {\n  color: #fff;\n  background: rgba(34, 197, 94, 0.1);\n}\n*/\n\n/* Filter Section */\n.p2p-filter-section {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: flex-end;\n  margin-bottom: 20px;\n  padding: 0 8px;\n}\n\n.p2p-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 150px;\n}\n\n.p2p-filter-label {\n  font-size: 12px;\n  color: #c9c9c9;\n  /* text-transform: uppercase; */\n  letter-spacing: 0.5px;\n}\n\n.p2p-filter-select {\n  padding: 12px 16px;\n  background: #2B313C;\n  border: 1px solid #2B313C;\n  border-radius: 8px;\n  color: #A2A9B6;\n  font-size: 13px;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23888' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  padding-right: 40px;\n}\n\n.p2p-filter-select:focus {\n  outline: none;\n  border-color: #ffdc88;\n}\n\n.p2p-find-orders-btn {\n  padding: 12px 32px;\n  background: #2b313c;\n  border: 1px solid #2b313c;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.p2p-find-orders-btn:hover {\n  background: rgba(255, 220, 136, 0.1);\n  border-color: #ffdc88;\n}\n\n/* Table Section */\n.p2p-orders-table-wrapper {\n  background: #2B313C;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #2B313C;\n}\n\n.p2p-orders-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.p2p-orders-table thead {\n  background: #2B313C;\n}\n\n.p2p-orders-table th {\n  padding: 10px 10px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 400;\n  color: #949AA4;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-orders-table th:last-child {\n  text-align: right;\n}\n\n/* [UNUSED]\n.p2p-trade-fee-badge {\n  background: rgba(255, 220, 136, 0.15);\n  color: #F3BB2B;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  margin-left: 8px;\n}\n*/\n\n.p2p-orders-table tbody tr {\n  border-bottom: 1px solid #1e1e2d;\n  transition: background 0.2s ease;\n  cursor: pointer;\n}\n\n.p2p-orders-table tbody tr:hover {\n  background: rgba(255, 220, 136, 0.05);\n}\n\n.p2p-orders-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.p2p-orders-table td {\n  padding: 20px;\n  vertical-align: middle;\n}\n\n/* Advertiser Cell */\n/* [UNUSED]\n.p2p-advertiser-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-advertiser-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-advertiser-info h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 4px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-advertiser-stats {\n  font-size: 12px;\n  color: #aaa;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-advertiser-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-star-icon {\n  color: #fbbf24;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-rating-value {\n  font-size: 12px;\n  color: #a8b4c4;\n  font-weight: 500;\n}\n*/\n\n/* Price Cell */\n/* [UNUSED]\n.p2p-price-value {\n  font-size: 16px;\n  font-weight: 500;\n  color: #eaecef;\n}\n*/\n\n/* Limit Cell */\n.p2p-limit-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* [UNUSED]\n.p2p-limit-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-limit-label {\n  font-size: 12px;\n  color: #aaa;\n  min-width: 55px;\n}\n*/\n\n/* [UNUSED]\n.p2p-limit-value {\n  font-size: 13px;\n  color: #eaecef;\n}\n*/\n\n/* Payment Cell */\n.p2p-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-payment-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #eaecef;\n}\n\n/* Trade Cell */\n/* [UNUSED]\n.p2p-trade-cell {\n  text-align: right;\n}\n*/\n\n/* [UNUSED]\n.p2p-buy-btn {\n  padding: 10px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-buy-btn:hover {\n  background: #16a34a;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-btn {\n  padding: 10px 24px;\n  background: #ef4444;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-btn:hover {\n  background: #dc2626;\n}\n*/\n\n/* Pagination */\n.p2p-pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 0px 10px;\n  background: none;\n  border-top: none;\n  flex-wrap: wrap;\n}\n\n.p2p-pagination-info {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-pagination-buttons,\n.p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n/* [UNUSED]\n.p2p-page-current {\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e5e5e5;\n  background: rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n}\n*/\n\n.p2p-page-btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1a1a24;\n  border: 1px solid #2a2a3a;\n  border-radius: 6px;\n  color: #888;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-page-btn:hover {\n  border-color: #ffdc88;\n  color: #fff;\n}\n\n.p2p-page-btn.p2p-active {\n  background: #363c47;\n  border-color: #363c47;\n  color: #fff;\n}\n\n.p2p-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.p2p-page-dots {\n  color: #aaa;\n  padding: 0 8px;\n}\n\n/* Expanded Row */\n/* .p2p-expanded-row {\n    background: #0d0d14 !important;\n  } */\n\n/* [UNUSED]\n.p2p-expanded-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  padding: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-left {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-user-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-user-details h5 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-user-details p {\n  font-size: 13px;\n  color: #aaa;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-stats {\n  display: flex;\n  gap: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-stat-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #a8b4c4;\n}\n*/\n\n/* [UNUSED]\n.p2p-stat-label {\n  font-size: 12px;\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-payments h6 {\n  font-size: 13px;\n  color: #888;\n  margin: 0 0 12px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-payment-badge {\n  padding: 6px 13px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #bd83cb;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-remarks h6 {\n  font-size: 13px;\n  color: #888;\n  margin: 0 0 8px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-remarks p {\n  font-size: 13px;\n  color: #ccc;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-right {\n  background: transparent;\n  border-radius: 12px;\n  padding: 0;\n  min-width: 320px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-form-group {\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-form-group.has-error .p2p-input-header {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.08);\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-form-group.has-error .p2p-expanded-input-wrapper {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-form-group.has-error .p2p-payment-selector-full,\n.p2p-expanded-form-group.has-error .p2p-payment-selector {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-input-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0;\n  padding: 16px 20px 8px;\n  background: #1a1a22;\n  border-radius: 12px 12px 0 0;\n  border: 1px solid #2a2a3a;\n  border-bottom: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-input-header label {\n  font-size: 13px;\n  color: #888;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-input-range {\n  font-size: 12px;\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper {\n  display: flex;\n  align-items: center;\n  background: #1a1a22;\n  border: 1px solid #2a2a3a;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n  padding: 0 20px 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper:focus-within {\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper.p2p-input-error {\n  border-color: #ef4444 !important;\n  background: rgba(239, 68, 68, 0.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper.p2p-input-error:focus-within {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-selector-full.p2p-input-error,\n.p2p-payment-selector.p2p-input-error {\n  border-color: #ef4444 !important;\n  background: rgba(239, 68, 68, 0.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper input {\n  flex: 1;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 32px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper input:focus {\n  outline: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper input::placeholder {\n  color: #444;\n}\n*/\n\n/* Remove number input spinners */\n/* [UNUSED]\n.p2p-expanded-input-wrapper input[type=\"number\"]::-webkit-outer-spin-button,\n.p2p-expanded-input-wrapper input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-wrapper input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n*/\n\n/* [UNUSED]\n.p2p-input-currency {\n  padding: 0;\n  color: #888;\n  font-size: 14px;\n  font-weight: 500;\n  background: transparent;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-input-error {\n  font-size: 12px;\n  color: #ef4444;\n  margin-top: 6px;\n  padding-left: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-price-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #888;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-price-info svg {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-selector-full {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 16px 20px;\n  background: #f59e0b0d;\n  border: 1px solid #2a2a3a;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-selector-full:hover {\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-selector-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-indicator {\n  width: 4px;\n  height: 16px;\n  background: #f59e0b;\n  border-radius: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-selector-full svg {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-expanded-form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cancel-btn {\n  flex: 1;\n  padding: 14px 24px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-cancel-btn:hover {\n  background: rgba(255, 220, 136, 0.1);\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-confirm-buy-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-confirm-buy-btn:hover {\n  background: #16a34a;\n}\n*/\n\n/* [UNUSED]\n.p2p-confirm-sell-btn {\n  width: 100%;\n  padding: 16px 24px;\n  background: #ef4444;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-confirm-sell-btn:hover {\n  background: #dc2626;\n}\n*/\n\n/* Mobile Card View */\n.p2p-mobile-orders-list {\n  display: none;\n}\n\n.p2p-mobile-order-card {\n  background: #12121a;\n  border: 1px solid #1e1e2d;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.p2p-mobile-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.binance-chat-input .send-btn {\n  padding: 0px;\n}\n\n.p2p-mobile-card-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* [UNUSED]\n.p2p-mobile-card-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #fff;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n*/\n\n.p2p-mobile-card-user-info h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.p2p-mobile-card-user-info p {\n  font-size: 12px;\n  color: #aaa;\n  margin: 0 0 2px 0;\n}\n\n/* [UNUSED]\n.p2p-mobile-card-user-info .p2p-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #a8b4c4;\n}\n*/\n\n.p2p-mobile-card-price {\n  text-align: right;\n}\n\n/* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n*/\n\n.p2p-mobile-card-price .p2p-currency {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.p2p-mobile-card-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-mobile-detail-label {\n  font-size: 11px;\n  color: #aaa;\n}\n\n.p2p-mobile-detail-value {\n  font-size: 13px;\n  color: #fff;\n}\n\n.p2p-mobile-card-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.p2p-mobile-payment-badge {\n  padding: 6px 10px;\n  background: rgba(255, 220, 136, 0.1);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #bd83cb;\n}\n\n/* [UNUSED]\n.p2p-mobile-card-action {\n  width: 100%;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-buy-btn {\n  width: 100%;\n  padding: 12px;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-buy-btn:hover {\n  background: #16a34a;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-sell-btn {\n  width: 100%;\n  padding: 12px;\n  background: #ef4444;\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-sell-btn:hover {\n  background: #dc2626;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-expanded-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n*/\n\n/* Payment Modal */\n.p2p-modal-content {\n  background: #373E4B;\n  border: 1px solid #373E4B;\n  border-radius: 10px;\n}\n\n/* [UNUSED]\n.p2p-modal-header {\n  border-bottom: 1px solid #404754;\n  padding: 20px 24px;\n}\n*/\n\n/* [UNUSED]\n.payment_search_box {\n  margin-bottom: 20px;\n}\n*/\n\n/* [UNUSED]\n.payment_search_box input {\n  width: 100%;\n  padding: 14px 16px;\n  background: #4B515D;\n  border: 1px solid #4B515D;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-modal-title {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n*/\n\n.p2p-modal-body {\n  padding: 0px 24px;\n}\n\n/* [UNUSED]\n.p2p-modal-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: #4B515D;\n  border: 1px solid #4B515D;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option:hover {\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option.p2p-selected {\n  background: rgba(255, 220, 136, 0.15);\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option span {\n  color: #fff;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  display: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option.p2p-selected input[type=\"checkbox\"] {\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.button.p2p-submit-button {\n  background-color: #fff;\n  border: none;\n  border-radius: 50px;\n  font-size: 15px;\n  margin-top: 12px;\n}\n*/\n\n/* ====================================\n     Responsive Styles\n     ==================================== */\n\n@media (max-width: 991.98px) {\n  .p2p-sidebar {\n    transform: translateX(-100%);\n  }\n\n  .p2p-sidebar.p2p-open {\n    transform: translateX(0);\n    background: #000;\n  }\n\n  .p2p-sidebar-close {\n    display: flex;\n  }\n}\n\n@media (min-width: 992px) {\n  .p2p-sidebar-overlay {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .p2p-filter-section {\n    flex-wrap: wrap;\n  }\n\n  .p2p-filter-group {\n    min-width: calc(50% - 8px);\n  }\n\n  .p2p-find-orders-btn {\n    width: 100%;\n  }\n\n  .p2p-orders-table th:nth-child(2),\n  .p2p-orders-table td:nth-child(2) {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-toggle-btn {\n    padding: 10px 32px;\n    font-size: 14px;\n  }\n*/\n\n  .p2p-filter-group {\n    min-width: 100%;\n  }\n\n\n  .p2p-orders-table-wrapper {\n    overflow-x: auto;\n  }\n\n  .p2p-orders-table {\n    min-width: 600px;\n  }\n\n  /* [UNUSED]\n.p2p-expanded-content {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-right {\n    min-width: 100%;\n    padding: 0;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-left {\n    padding: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-header {\n    padding: 14px 16px 6px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-input-wrapper {\n    padding: 0 16px 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-input-wrapper input {\n    font-size: 26px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-selector-full {\n    padding: 14px 16px;\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-confirm-buy-btn,\n  .p2p-confirm-sell-btn {\n    padding: 14px 20px;\n    font-size: 14px;\n  }\n*/\n\n  .p2p-pagination-wrapper {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 640px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  /* Mobile expanded row styling */\n  .p2p-expanded-row {\n    display: block;\n  }\n\n  .p2p-expanded-row td {\n    padding: 0 !important;\n  }\n\n  /* [UNUSED]\n.p2p-expanded-content {\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    background: #0d0d14;\n    border-radius: 12px;\n    margin: 8px 0;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-left {\n    order: 2;\n    border-top: 1px solid #2a2a3a;\n    padding-top: 16px;\n    margin-top: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-right {\n    order: 1;\n  }\n*/\n}\n\n@media (max-width: 576px) {\n  /* [UNUSED]\n.p2p-buy-sell-toggle {\n    margin-bottom: 16px;\n  }\n*/\n\n\n\n\n  /* [UNUSED]\n.p2p-toggle-wrapper {\n    width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-toggle-btn {\n    flex: 1;\n    padding: 10px 16px;\n  }\n*/\n\n  .p2p-filter-section {\n    gap: 12px;\n    padding: 0;\n  }\n\n  .p2p-orders-table th,\n  .p2p-orders-table td {\n    padding: 12px;\n  }\n\n  /* [UNUSED]\n.p2p-advertiser-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-advertiser-info h4 {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-buy-btn,\n  .p2p-sell-btn {\n    padding: 8px 16px;\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-stats {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-form-actions {\n    flex-direction: column;\n  }\n*/\n\n  .p2p-pagination-wrapper.p2p-mobile {\n    background: transparent;\n    border: none;\n    margin-top: 16px;\n  }\n\n  /* P2P Expanded Form Mobile Styles */\n  /* [UNUSED]\n.p2p-expanded-content {\n    padding: 12px;\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-right {\n    min-width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-form-group {\n    margin-bottom: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-header {\n    padding: 12px 14px 4px;\n    border-radius: 10px 10px 0 0;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-header label {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-range {\n    font-size: 11px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-input-wrapper {\n    padding: 0 14px 12px;\n    border-radius: 0 0 10px 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-input-wrapper input {\n    font-size: 22px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-currency {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-price-info {\n    font-size: 11px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-selector-full {\n    padding: 12px 14px;\n    font-size: 13px;\n    border-radius: 0 0 10px 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-indicator {\n    width: 3px;\n    height: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-form-actions {\n    margin-top: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-confirm-buy-btn,\n  .p2p-confirm-sell-btn {\n    padding: 12px 16px;\n    font-size: 13px;\n    border-radius: 8px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-input-error {\n    font-size: 11px;\n    padding-left: 14px;\n  }\n*/\n\n  /* Expanded left section mobile */\n  /* [UNUSED]\n.p2p-expanded-left {\n    padding: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-user-details h5 {\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-user-details p {\n    font-size: 11px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-stats {\n    gap: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-stat-item {\n    min-width: calc(50% - 6px);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-stat-value {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-stat-label {\n    font-size: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-payments h6,\n  .p2p-expanded-remarks h6 {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-payment-badge {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-expanded-remarks p {\n    font-size: 12px;\n  }\n*/\n}\n\n/* Extra small devices */\n@media (max-width: 400px) {\n  /* [UNUSED]\n.p2p-expanded-input-wrapper input {\n    font-size: 20px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-input-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-selector-full {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-stat-item {\n    min-width: 100%;\n  }\n*/\n}\n\n/* ====================================\n     ENHANCED MOBILE RESPONSIVENESS - P2P Dashboard\n     ==================================== */\n\n/* Tablet breakpoint (992px - 768px) */\n@media (max-width: 992px) and (min-width: 769px) {\n  .p2p-dashboard-container {\n    padding: 0 12px;\n  }\n\n  /* [UNUSED]\n.p2p-toggle-btn {\n    padding: 12px 36px;\n    font-size: 14px;\n  }\n*/\n\n  .p2p-filter-section {\n    gap: 12px;\n  }\n\n  .p2p-filter-group {\n    min-width: calc(33.333% - 12px);\n  }\n\n  .p2p-orders-table th,\n  .p2p-orders-table td {\n    padding: 16px 12px;\n    font-size: 13px;\n  }\n\n  /* [UNUSED]\n.p2p-price-value {\n    font-size: 15px;\n  }\n*/\n}\n\n/* Mobile landscape and small tablets (768px) */\n@media (max-width: 768px) {\n  .p2p-dashboard-container {\n    padding: 0 8px;\n  }\n\n  /* Hide desktop table at this breakpoint too */\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .p2p-filter-section {\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 0 4px;\n  }\n\n  .p2p-filter-group {\n    min-width: 100%;\n    flex: none;\n  }\n\n  .p2p-filter-select {\n    padding: 14px 16px;\n    font-size: 15px;\n    border-radius: 10px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 14px;\n    width: 100%;\n    font-size: 15px;\n    border-radius: 10px;\n    margin-top: 4px;\n  }\n\n  /* [UNUSED]\n.p2p-buy-sell-toggle {\n    margin-bottom: 20px;\n    padding: 0 4px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-toggle-wrapper {\n    width: 100%;\n    border-radius: 10px;\n    padding: 5px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-toggle-btn {\n    flex: 1;\n    padding: 14px 20px;\n    font-size: 15px;\n    font-weight: 600;\n    border-radius: 8px;\n  }\n*/\n\n  /* Mobile order cards improved */\n  .p2p-mobile-order-card {\n    padding: 16px;\n    border-radius: 14px;\n    margin-bottom: 0;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-avatar {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n*/\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 13px;\n    color: #7d8087;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n    font-size: 20px;\n    font-weight: 700;\n  }\n*/\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-details {\n    gap: 16px;\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 8px 12px;\n    font-size: 12px;\n    border-radius: 6px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 9px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    margin-top: 12px;\n  }\n*/\n\n  /* Expanded section mobile */\n  /* [UNUSED]\n.p2p-mobile-expanded-section {\n    padding-top: 20px;\n    margin-top: 20px;\n  }\n*/\n\n  .p2p-payment-method-header.mobileview {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .mobileview .p2p-payment-method-actions {\n    width: auto;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-right {\n    padding: 0;\n  }\n*/\n\n  /* Keep same design as desktop - card style inputs */\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-form-group {\n    margin-bottom: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 16px 8px;\n    background: #1a1a2200;\n    border-radius: 10px 10px 0 0;\n    border: 1px solid #424251;\n    border-bottom: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-header label {\n    font-size: 13px;\n    color: #ffffff;\n    margin: 0;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-range {\n    font-size: 11px;\n    color: #adabab;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    display: flex;\n    align-items: center;\n    background: #1a1a2200;\n    border: 1px solid #424251;\n    border-top: none;\n    border-radius: 0 0 10px 10px;\n    padding: 0 16px 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 26px;\n    font-weight: 500;\n    padding: 0;\n    width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input:focus {\n    outline: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-currency {\n    color: #888;\n    font-size: 14px;\n    font-weight: 500;\n    background: transparent;\n    padding: 0;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-price-info {\n    font-size: 11px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-payment-selector-full,\n  .p2p-mobile-expanded-section .p2p-payment-selector {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 16px;\n    background: #1a1a2200;\n    border: 1px solid #424251;\n    border-radius: 10px;\n    color: #888;\n    font-size: 14px;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-payment-selector-full:hover,\n  .p2p-mobile-expanded-section .p2p-payment-selector:hover {\n    border-color: #3a3a4a;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-payment-indicator {\n    width: 3px;\n    height: 16px;\n    background: #22c55e;\n    border-radius: 2px;\n    margin-right: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-form-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-cancel-btn {\n    flex: 1;\n    padding: 14px;\n    background: transparent;\n    border: 1px solid #2a2a3a;\n    border-radius: 10px;\n    color: #8b8b8b;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.05);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    flex: 2;\n    padding: 14px;\n    font-size: 15px;\n    font-weight: 600;\n    border-radius: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-error {\n    font-size: 11px;\n    color: #ef4444;\n    margin-top: 6px;\n    padding-left: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-available-balance {\n    display: block;\n    font-size: 12px;\n    color: #aaa;\n    margin-top: 6px;\n    padding-left: 2px;\n  }\n*/\n\n  /* [UNUSED]\n.payment_method_pop {\n    padding-right: 0px !important;\n  }\n*/\n\n  .modal.fade {\n    padding-right: 0px !important;\n  }\n\n  /* Pagination mobile */\n  .p2p-pagination-wrapper {\n    padding: 16px;\n    margin-top: 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n  }\n\n  .p2p-pagination-info {\n    font-size: 13px;\n    order: 2;\n  }\n\n  /* [UNUSED]\n.p2p-pagination-controls {\n    order: 1;\n  }\n*/\n\n  .p2p-page-btn {\n    width: 36px;\n    height: 36px;\n    font-size: 13px;\n  }\n\n  /* Modal mobile */\n  .p2p-modal-content {\n    margin: 16px;\n    max-height: calc(100vh - 32px);\n  }\n\n  /* [UNUSED]\n.p2p-modal-header {\n    padding: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-modal-title {\n    font-size: 16px;\n  }\n*/\n\n  .p2p-modal-body {\n    padding: 16px;\n    max-height: calc(100vh - 150px);\n    overflow-y: auto;\n  }\n\n  /* [UNUSED]\n.p2p-payment-option {\n    padding: 14px 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-option span {\n    font-size: 14px;\n  }\n*/\n\n  /* Available balance mobile */\n  /* [UNUSED]\n.p2p-available-balance {\n    font-size: 12px;\n    margin-top: 8px;\n    display: block;\n  }\n*/\n}\n\n/* Mobile portrait (576px and below) */\n@media (max-width: 576px) {\n  .p2p-dashboard-container {\n    padding: 0 4px;\n  }\n\n  /* [UNUSED]\n.p2p-toggle-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n*/\n\n  .p2p-filter-label {\n    font-size: 11px;\n  }\n\n  .p2p-filter-select {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 12px;\n    font-size: 14px;\n  }\n\n  .p2p-mobile-order-card {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 14px;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .p2p-mobile-card-user {\n    gap: 10px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n*/\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 14px;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 12px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n    font-size: 18px;\n  }\n*/\n\n  .p2p-mobile-card-details {\n    gap: 10px;\n    margin-bottom: 14px;\n    padding-bottom: 14px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-payments {\n    gap: 6px;\n    margin-bottom: 14px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 12px;\n    font-size: 14px;\n    border-radius: 8px;\n  }\n*/\n\n  /* Expanded section small mobile */\n  /* [UNUSED]\n.p2p-mobile-expanded-section {\n    padding-top: 16px;\n    margin-top: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-header {\n    padding: 12px 14px 6px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    padding: 0 14px 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    font-size: 22px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-payment-selector-full {\n    padding: 12px 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-form-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-cancel-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    flex: none;\n    width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    order: -1;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-error {\n    font-size: 11px;\n    margin-top: 6px;\n    padding-left: 14px;\n  }\n*/\n\n  /* Verification button mobile */\n  /* [UNUSED]\n.p2p-mobile-verification-btn {\n    padding: 12px;\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-verification-btn i {\n    font-size: 16px;\n  }\n*/\n\n  /* Trade restricted mobile */\n  /* [UNUSED]\n.p2p-mobile-condition-info {\n    font-size: 11px;\n    padding: 10px;\n    flex-direction: column;\n    text-align: center;\n    gap: 4px;\n  }\n*/\n\n  /* Pagination small mobile */\n  .p2p-pagination-wrapper.p2p-mobile {\n    padding: 12px 0;\n  }\n\n  .p2p-page-btn {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  /* Modal small mobile */\n  .p2p-modal-content {\n    margin: 8px;\n    border-radius: 12px;\n  }\n\n  /* [UNUSED]\n.p2p-payment-option {\n    padding: 12px 14px;\n  }\n*/\n\n  /* No payment methods state */\n  /* [UNUSED]\n.p2p-no-payment-methods {\n    padding: 24px 16px;\n    text-align: center;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods i {\n    font-size: 40px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods p {\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-add-payment-btn {\n    padding: 12px 20px;\n    font-size: 13px;\n  }\n*/\n}\n\n/* Extra small mobile (400px and below) */\n@media (max-width: 400px) {\n  /* [UNUSED]\n.p2p-toggle-wrapper {\n    padding: 4px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-toggle-btn {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n*/\n\n  .p2p-filter-select {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-find-orders-btn {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .p2p-mobile-order-card {\n    padding: 12px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 12px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n*/\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 13px;\n  }\n\n  .p2p-mobile-card-user-info p {\n    font-size: 11px;\n    max-width: 120px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n    font-size: 16px;\n  }\n*/\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 11px;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-buy-btn,\n  .p2p-mobile-sell-btn {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-header {\n    padding: 7px 12px 5px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-header label {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-range {\n    font-size: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper {\n    padding: 0 12px 10px;\n    gap: 5px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-expanded-input-wrapper input {\n    font-size: 18px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-input-currency {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-payment-selector-full {\n    padding: 10px 12px;\n    font-size: 12px;\n    margin-top: 14px;\n\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-expanded-section .p2p-cancel-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-buy-btn,\n  .p2p-mobile-expanded-section .p2p-confirm-sell-btn {\n    padding: 10px;\n    font-size: 12px;\n  }\n*/\n\n  /* Rating on mobile */\n  /* [UNUSED]\n.p2p-mobile-card-user-info .p2p-rating {\n    font-size: 11px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-card-user-info .p2p-rating span:first-child {\n    font-size: 10px;\n    letter-spacing: -1px;\n  }\n*/\n}\n\n/* ====================================\n     P2P My Ads Page Styles\n     ==================================== */\n\n.p2p-myads-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.p2p-myads-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #d1d5db;\n  margin: 0 0 4px 0;\n}\n\n.p2p-myads-subtitle {\n  font-size: 13px;\n  color: #52525b;\n  margin: 0;\n}\n\n.p2p-create-ad-btn {\n  padding: 10px 20px;\n  /* background: rgba(30, 58, 138, 0.4); */\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 8px;\n  /* color: #93c5fd; */\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-create-ad-btn:hover {\n  background-color: #e7b641;\n}\n\n.p2p-payment-method-header {\n  gap: 12px;\n}\n\n/* Stats Cards Grid */\n.p2p-myads-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n  background-color: #373F4D;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 12px 0px;\n}\n\n.p2p-myads-stat-card {\n  background: #373F4D;\n  border-radius: 0px;\n  border: none;\n  padding: 3px 20px;\n  transition: border-color 0.2s ease;\n  border-right: 1px solid #454C59;\n}\n\n.p2p-myads-stat-card:hover {\n  border-right: 1px solid #454C59;\n}\n\n.p2p-filter-section.myadsfillter {\n  padding: 0px;\n}\n\n.p2p-myads-stats-grid .p2p-myads-stat-card:last-child {\n  border-right: none;\n}\n\n.p2p-dashboard-container.p2p-profile-container {\n  background-color: #2B313C;\n  border-radius: 10px;\n}\n\n.p2p-profile-container .p2p-profile-header {\n  background: none;\n  border-radius: 12px;\n  border: none;\n  padding: 36px;\n  margin-bottom: 0px;\n}\n\n.p2p-profile-container .p2p-myads-stats-grid {\n  grid-template-columns: repeat(2, 1fr);\n  background-color: transparent;\n  border-radius: 0px;\n  gap: 20px;\n  padding: 20px 36px;\n  overflow: inherit;\n  border-bottom: 1px solid #454C59;\n  border-top: 1px solid #454C59;\n}\n\n.p2p-profile-container .p2p-myads-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  justify-content: space-between;\n  background: none;\n  border-radius: 0px;\n  border-right: none;\n  padding: 6px 0px;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-profile-container .p2p-myads-stat-card-label {\n  color: #fff;\n  font-size: 13px;\n  border-bottom: none;\n}\n\n.p2p-profile-container .p2p-myads-stat-card:nth-child(5) {\n  border-bottom: none;\n}\n\n.p2p-profile-container .p2p-myads-stat-card:last-child {\n  border-bottom: none;\n}\n\n.p2p-profile-tabs.paymentprofiletabs {\n  padding: 0px 36px 36px;\n}\n\n.p2p-profile-container .p2p-empty-state-card {\n  background: none;\n  border-radius: 0px;\n}\n\n.p2p-profile-container .p2p-empty-state-card i {\n  font-size: 30px;\n  color: #fff;\n  margin-bottom: 0px;\n}\n\n.myadsfillter .p2p-filter-select {\n  background: #373F4D;\n  border: 1px solid #373F4D;\n}\n\n.myadsfillter .p2p-find-orders-btn {\n  background: #373F4D;\n  border: 1px solid #373F4D;\n}\n\n.p2p-myads-container {\n  background-color: #2B313C;\n  padding: 24px;\n  border-radius: 12px;\n}\n\n.p2p-myads-stat-card-label {\n  color: #A2A9B6;\n  font-size: 13px;\n  padding-bottom: 3px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid #454C59;\n  letter-spacing: 0.3px;\n}\n\n.p2p-myads-stat-card-value {\n  font-size: 16px;\n  font-weight: 400;\n  color: #e5e5e5;\n}\n\n/* Legacy stats (keep for backwards compatibility) */\n/* [UNUSED]\n.p2p-myads-stats {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 20px;\n  padding: 16px 20px;\n  background: #0d0d14;\n  border-radius: 10px;\n  border: 1px solid #1e1e2d;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-stat-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #a1a1aa;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-stat-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n*/\n\n.p2p-loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  min-height: 200px;\n}\n\n.p2p-loading-container .spinner-border {\n  width: 32px;\n  height: 32px;\n}\n\n@media (max-width: 768px) {\n  .p2p-loading-container {\n    padding: 40px 16px;\n    min-height: 150px;\n  }\n\n  .p2p-loading-container .spinner-border {\n    width: 28px;\n    height: 28px;\n  }\n}\n\n/* My Ads Table Specific Styles */\n.p2p-myads-asset-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.p2p-myads-side-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.p2p-myads-side-badge.buy {\n  background: #5EBA89;\n  color: #fff;\n}\n\n.p2p-myads-side-badge.sell {\n  background: rgba(239, 68, 68, 0.08);\n  color: #fca5a5;\n}\n\n.p2p-myads-asset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-empty-state-card .p2p-myads-action-btn {\n  padding: 10px 12px;\n}\n\n.p2p-myads-asset-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #d1d5db;\n}\n\n.p2p-myads-asset-fiat {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n/* [UNUSED]\n.p2p-myads-price {\n  font-size: 14px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-price-currency {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-volume {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-volume-remaining {\n  font-size: 14px;\n  font-weight: 500;\n  color: #a1a1aa;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-volume-total {\n  font-size: 11px;\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-myads-limits {\n  font-size: 13px;\n  color: #9ca3af;\n}\n*/\n\n.p2p-myads-status {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* [UNUSED]\n.p2p-myads-date {\n  font-size: 12px;\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-badge-more {\n  padding: 4px 8px;\n  background: rgba(107, 114, 128, 0.2);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n*/\n\n/* Empty State */\n.p2p-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.p2p-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.p2p-empty-state p {\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.p2p-create-ad-btn-small {\n  padding: 10px 20px;\n  background: rgba(30, 41, 59, 0.4);\n  border: 1px solid rgba(51, 65, 85, 0.5);\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* [UNUSED]\n.payment_method_pop.modal.fade .modal-dialog {\n  min-width: 540px;\n}\n*/\n\n.p2p-create-ad-btn-small:hover {\n  border-color: rgba(71, 85, 105, 0.8);\n  color: #d1d5db;\n  background: rgba(30, 41, 59, 0.6);\n}\n\n.p2p-empty-state-mobile {\n  text-align: center;\n  padding: 40px 20px;\n  background: #373F4D;\n  border-radius: 12px;\n  border: 1px solid #373F4D;\n}\n\n/* Pagination */\n.p2p-pagination-buttons,\n.p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  /* [UNUSED]\n.p2p-myads-stats {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-myads-stat-item {\n    min-width: calc(33% - 12px);\n  }\n*/\n\n  .p2p-pagination-wrapper {\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-title {\n    font-size: 18px;\n  }\n\n  /* [UNUSED]\n.p2p-myads-stats {\n    padding: 12px 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-myads-stat-value {\n    font-size: 16px;\n  }\n*/\n}\n\n/* My Ads Actions */\n.p2p-myads-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.p2p-myads-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: #a1a1aa;\n}\n\n.p2p-myads-action-btn i {\n  font-size: 14px;\n}\n\n.p2p-myads-action-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Online/Offline Status */\n.p2p-myads-status-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-myads-online-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  width: fit-content;\n}\n\n.p2p-myads-online-badge.online {\n  background: rgba(255, 255, 255, 0.08);\n  color: #d1d5db;\n}\n\n.p2p-myads-online-badge.offline {\n  background: rgba(255, 255, 255, 0.04);\n  color: #6b7280;\n}\n\n.p2p-myads-online-badge.small {\n  padding: 2px 6px;\n  font-size: 10px;\n}\n\n.p2p-myads-online-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #6b7280;\n}\n\n.p2p-myads-online-badge.online .p2p-myads-online-dot {\n  background: #4ade80;\n  animation: p2p-pulse 2s ease-in-out infinite;\n}\n\n.p2p-myads-online-badge.offline .p2p-myads-online-dot {\n  background: #6b7280;\n  animation: none;\n}\n\n@keyframes p2p-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* [UNUSED]\n.p2p-mobile-status-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n*/\n\n/* .p2p-row-expanded {\n    background: rgba(255, 220, 136, 0.03) !important;\n  } */\n\n/* Expanded Content */\n/* .p2p-myads-expanded-content {\n    padding: 20px 24px;\n    background: #0a0a0f;\n    border-top: 1px solid #1e1e2d;\n  } */\n\n.p2p-myads-expanded-section {\n  margin-bottom: 24px;\n}\n\n.p2p-myads-expanded-section:last-child {\n  margin-bottom: 0;\n}\n\n.p2p-myads-expanded-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #9ca3af;\n  margin: 0 0 12px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-myads-expanded-count {\n  font-size: 11px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.p2p-myads-expanded-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.p2p-myads-expanded-grid.mobile {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.p2p-myads-expanded-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-myads-expanded-label {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-myads-expanded-value {\n  font-size: 13px;\n  color: #a1a1aa;\n  font-weight: 500;\n}\n\n.p2p-myads-expanded-value.small {\n  font-size: 11px;\n  word-break: break-all;\n}\n\n.p2p-myads-expanded-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* Payment Details Cards */\n.p2p-myads-payment-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.p2p-myads-payment-card {\n  background: #2f3641;\n  border: 1px solid #454C59;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.p2p-myads-payment-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #454C59;\n}\n\n.p2p-myads-payment-type {\n  font-size: 14px;\n  font-weight: 600;\n  color: #bd83cb;\n}\n\n.p2p-myads-payment-type-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n  border-radius: 4px;\n}\n\n.p2p-myads-payment-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-myads-payment-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.p2p-myads-payment-label {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.p2p-myads-payment-value {\n  font-size: 12px;\n  color: #a1a1aa;\n  text-align: right;\n  word-break: break-all;\n}\n\n.p2p-myads-payment-qr {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #454C59;\n}\n\n.p2p-myads-payment-qr img {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n  background: #fff;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.p2p-myads-no-details {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Closure Information */\n.p2p-myads-closure-info {\n  background: rgba(107, 114, 128, 0.1);\n  border: 1px solid rgba(107, 114, 128, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.p2p-myads-closure-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.p2p-myads-closure-icon {\n  font-size: 16px;\n}\n\n.p2p-myads-closure-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\n.p2p-myads-closure-date {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-myads-closure-reason {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(107, 114, 128, 0.2);\n}\n\n.p2p-myads-closure-reason-label {\n  font-size: 12px;\n  color: #6b7280;\n  margin-right: 8px;\n}\n\n.p2p-myads-closure-reason-text {\n  font-size: 13px;\n  color: #a1a1aa;\n  line-height: 1.5;\n}\n\n/* Mobile Card Actions */\n.p2p-mobile-card-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-actions .p2p-myads-action-btn {\n  flex: 1;\n  padding: 10px 16px;\n  font-size: 13px;\n}\n\n/* Mobile Expanded Details */\n.p2p-mobile-expanded-details {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-details {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1024px) {\n  .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-myads-payment-details {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-actions {\n    flex-direction: column;\n  }\n\n  .p2p-myads-action-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .p2p-myads-expanded-content {\n    padding: 16px;\n  }\n\n  .p2p-myads-expanded-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n  }\n}\n\n/* Close Ad Modal */\n/* .p2p-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  padding: 20px;\n  backdrop-filter: blur(5px);\n} */\n\n.p2p-close-ad-modal {\n  background: #12121a;\n  border: 1px solid #1e1e2d;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n@keyframes p2p-modal-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.p2p-close-ad-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #d1d5db;\n  margin: 0;\n}\n\n.p2p-close-ad-modal-close {\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.p2p-close-ad-modal-close:hover {\n  color: #e5e5e5;\n}\n\n.p2p-close-ad-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n}\n\n/* Warning Banner */\n.p2p-close-ad-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(120, 113, 108, 0.1);\n  border: 1px solid rgba(120, 113, 108, 0.2);\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.p2p-close-ad-warning-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.p2p-close-ad-warning-content strong {\n  display: block;\n  font-size: 14px;\n  color: #d6d3d1;\n  margin-bottom: 4px;\n}\n\n.p2p-close-ad-warning-content p {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Ad Summary */\n.p2p-close-ad-summary {\n  background: #0a0a0f;\n  border: 1px solid #1e1e2d;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.p2p-close-ad-summary-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-summary-pair {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-close-ad-summary-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.p2p-close-ad-summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.p2p-close-ad-summary-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-close-ad-summary-value {\n  font-size: 14px;\n  color: #d1d5db;\n  font-weight: 500;\n}\n\n/* Reason Input Group */\n.p2p-close-ad-reason-group {\n  margin-bottom: 0;\n}\n\n.p2p-close-ad-reason-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #9ca3af;\n  margin-bottom: 10px;\n}\n\n.p2p-optional-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(107, 114, 128, 0.2);\n  color: #6b7280;\n  border-radius: 4px;\n}\n\n.p2p-close-ad-reason-input {\n  width: 100%;\n  background: #0a0a0f;\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 14px;\n  color: #e5e5e5;\n  resize: vertical;\n  min-height: 80px;\n  transition: border-color 0.2s;\n}\n\n.p2p-close-ad-reason-input:focus {\n  outline: none;\n  border-color: #ffdc88;\n}\n\n.p2p-close-ad-reason-input.error {\n  border-color: #ef4444;\n}\n\n.p2p-close-ad-reason-input::placeholder {\n  color: #4b5563;\n}\n\n.p2p-close-ad-reason-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.p2p-close-ad-error {\n  font-size: 12px;\n  color: #ef4444;\n}\n\n.p2p-close-ad-char-count {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: auto;\n}\n\n/* Modal Footer */\n.p2p-close-ad-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-close-ad-btn-cancel,\n.p2p-close-ad-btn-confirm {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-close-ad-btn-cancel {\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  color: #9ca3af;\n}\n\n.p2p-close-ad-btn-cancel:hover:not(:disabled) {\n  background: rgba(107, 114, 128, 0.1);\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.p2p-close-ad-btn-confirm {\n  background: rgba(153, 27, 27, 0.8);\n  border: 1px solid rgba(185, 28, 28, 0.5);\n  color: #fecaca;\n}\n\n.p2p-close-ad-btn-confirm:hover:not(:disabled) {\n  background: rgba(153, 27, 27, 1);\n  color: #fff;\n}\n\n.p2p-close-ad-btn-cancel:disabled,\n.p2p-close-ad-btn-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n@media (max-width: 576px) {\n  .p2p-modal-overlay {\n    padding: 16px;\n  }\n\n  .p2p-close-ad-modal {\n    max-width: 100%;\n  }\n\n  .p2p-close-ad-modal-header {\n    padding: 16px 20px;\n  }\n\n  .p2p-close-ad-modal-body {\n    padding: 20px;\n  }\n\n  .p2p-close-ad-modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .p2p-close-ad-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ====================================\n     P2P My Ads - ENHANCED Mobile Responsive\n     ==================================== */\n\n/* MyAds Header - Mobile Premium Design */\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    padding: 0 4px;\n    margin-bottom: 20px;\n  }\n\n  .p2p-myads-header>div {\n    margin-bottom: 4px;\n  }\n\n  .p2p-myads-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #f5f5f5;\n    margin-bottom: 6px;\n  }\n\n  .p2p-myads-subtitle {\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  .p2p-create-ad-btn {\n    width: 100%;\n    padding: 14px 24px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 10px;\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%);\n    border: 1px solid rgba(34, 197, 94, 0.3);\n    color: #4ade80;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n  }\n\n  .p2p-create-ad-btn:hover {\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.3) 0%, rgba(34, 197, 94, 0.2) 100%);\n    border-color: rgba(34, 197, 94, 0.5);\n  }\n}\n\n/* Stats Grid - Mobile Premium */\n@media (max-width: 768px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    margin-bottom: 20px;\n    padding: 20px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 14px 12px;\n    border-radius: 0px;\n    /* background: linear-gradient(145deg, #12121a00 0%, #0d0d1400 100%); */\n    /* border: 1px solid #2c2c2c; */\n    text-align: left;\n  }\n\n  .p2p-profile-container .p2p-myads-stat-card {\n    border: none;\n    border-bottom: 1px solid #454C59;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 10px;\n    margin-bottom: 6px;\n    color: #6b7280;\n    letter-spacing: 0.3px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 18px;\n    font-weight: 700;\n    color: #f5f5f5;\n  }\n\n  /* [UNUSED]\n.selectpaymetpop.modal.fade .modal-dialog {\n    width: 100%;\n    min-width: 100%;\n  }\n*/\n\n}\n\n@media (max-width: 480px) {\n\n  .modal.fade .modal-dialog {\n    min-width: 100%;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n\n\n\n  /* [UNUSED]\n.selectpaymetpop.modal.fade .modal-dialog {\n    width: 100%;\n    min-width: 100%;\n  }\n*/\n\n  .myadsheading .p2p-mobile-card-user-info h4 {\n    font-size: 12px;\n    margin: 0px 0px 1px;\n  }\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-myads-stat-card {\n    padding: 12px 10px;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 9px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 16px;\n  }\n}\n\n/* Mobile Order Cards - Premium Design */\n@media (max-width: 768px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 0 4px;\n  }\n\n  .p2p-mobile-order-card {\n    border: 1px solid rgb(54 54 54);\n    border-radius: 16px;\n    padding: 18px;\n    transition: all 0.2s ease;\n  }\n\n  .p2p-mobile-order-card:hover {\n    border-color: rgb(54 54 54);\n  }\n\n  /* Card Header */\n  .p2p-mobile-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-card-user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .p2p-myads-side-badge {\n    padding: 6px 12px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n  }\n\n  .p2p-myads-side-badge.buy {\n    background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.08) 100%);\n    color: #4ade80;\n    border: 1px solid rgba(34, 197, 94, 0.2);\n  }\n\n  .p2p-myads-side-badge.sell {\n    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.08) 100%);\n    color: #f87171;\n    border: 1px solid rgba(239, 68, 68, 0.2);\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #f5f5f5;\n    margin: 0 0 4px 0;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-status-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n*/\n\n  /* Price Display */\n  .p2p-mobile-card-price {\n    text-align: right;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n    font-size: 20px;\n    font-weight: 700;\n    color: #f5f5f5;\n    line-height: 1.2;\n  }\n*/\n\n  .p2p-mobile-card-price .p2p-currency {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 500;\n  }\n\n  /* Card Details Grid */\n  .p2p-mobile-card-details {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 14px;\n    margin-bottom: 16px;\n    padding: 16px;\n    background: rgba(0, 0, 0, 0);\n    border-radius: 12px;\n  }\n\n  .p2p-mobile-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 11px;\n    color: #6b7280;\n    letter-spacing: 0.5px;\n    font-weight: 500;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 13px;\n    color: #e5e5e5;\n    font-weight: 500;\n  }\n\n  /* Payment Badges */\n  .p2p-mobile-card-payments {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 6px 12px;\n    background: rgba(255, 220, 136, 0.1);\n    border: 1px solid rgba(255, 220, 136, 0.2);\n    border-radius: 6px;\n    font-size: 12px;\n    color: #bd83cb;\n    font-weight: 500;\n  }\n\n  /* Action Buttons */\n  .p2p-mobile-card-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 0;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    flex: 1;\n    padding: 12px 14px;\n    font-size: 13px;\n    font-weight: 500;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #a1a1aa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n    color: #e5e5e5;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn i {\n    font-size: 16px;\n  }\n\n  /* Online/Offline Badge */\n  .p2p-myads-online-badge {\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 600;\n  }\n\n  .p2p-myads-online-badge.online {\n    background: rgb(34 197 94 / 0%);\n    border: 1px solid rgb(34 197 94 / 0%);\n    color: #4ade80;\n  }\n\n  .p2p-myads-online-badge.offline {\n    background: rgba(107, 114, 128, 0.1);\n    border: 1px solid rgba(107, 114, 128, 0.2);\n    color: #9ca3af;\n  }\n\n  .p2p-myads-online-badge.small {\n    padding: 3px 8px;\n    font-size: 10px;\n  }\n\n  .p2p-myads-online-dot {\n    width: 6px;\n    height: 6px;\n  }\n\n  /* Expanded Details */\n  .p2p-mobile-expanded-details {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-section {\n    margin-bottom: 20px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-title {\n    font-size: 12px;\n    color: #6b7280;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    background: rgba(0, 0, 0, 0);\n    padding: 0px;\n    border-radius: 10px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-item {\n    text-align: center;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-label {\n    font-size: 11px;\n    color: #828289;\n    margin-bottom: 0px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-value {\n    font-size: 12px;\n    color: #eaecef;\n    font-weight: 500;\n  }\n\n  /* Payment Details Cards */\n  .p2p-mobile-expanded-details .p2p-myads-payment-details {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-card {\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 12px;\n    padding: 14px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-header {\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-type {\n    font-size: 14px;\n    color: #bd83cb;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-payment-qr img {\n    width: 70px;\n    height: 70px;\n  }\n\n  /* Closure Info */\n  .p2p-mobile-expanded-details .p2p-myads-closure-info {\n    background: rgba(107, 114, 128, 0.08);\n    border: 1px solid rgba(107, 114, 128, 0.15);\n    border-radius: 10px;\n    padding: 14px;\n  }\n\n  /* Empty State Mobile */\n  .p2p-empty-state-mobile {\n    text-align: center;\n    padding: 48px 24px;\n    background: #373F4D;\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    margin: 0 4px;\n  }\n\n  .p2p-empty-state-mobile .p2p-empty-icon {\n    font-size: 56px;\n    margin-bottom: 16px;\n    opacity: 0.6;\n  }\n\n  .p2p-empty-state-mobile p {\n    font-size: 16px;\n    color: #6b7280;\n    margin-bottom: 20px;\n  }\n\n  .p2p-empty-state-mobile .p2p-create-ad-btn-small {\n    padding: 14px 28px;\n    font-size: 14px;\n    border-radius: 10px;\n  }\n\n  /* Pagination Mobile */\n  .p2p-pagination-wrapper.p2p-mobile {\n    padding: 16px 4px;\n    margin-top: 16px;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    background: transparent;\n    border: none;\n  }\n\n  .p2p-pagination-wrapper .p2p-pagination-info {\n    font-size: 13px;\n    color: #6b7280;\n    order: 2;\n  }\n\n  .p2p-pagination-wrapper .p2p-pagination-buttons {\n    order: 1;\n  }\n\n  .p2p-page-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-mobile-order-card {\n    padding: 14px;\n    border-radius: 14px;\n  }\n\n  .p2p-mobile-card-header {\n    margin-bottom: 14px;\n  }\n\n  .p2p-mobile-card-user {\n    gap: 10px;\n  }\n\n  .p2p-myads-side-badge {\n    padding: 5px 10px;\n    font-size: 10px;\n  }\n\n  .p2p-mobile-card-user-info h4 {\n    font-size: 15px;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n    font-size: 18px;\n  }\n*/\n\n  .p2p-mobile-card-details {\n    gap: 12px;\n    padding: 14px 0px 0px;\n  }\n\n  .p2p-mobile-detail-label {\n    font-size: 10px;\n  }\n\n  .p2p-mobile-detail-value {\n    font-size: 12px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 5px 10px;\n    font-size: 11px;\n  }\n\n  .p2p-mobile-card-actions {\n    flex-wrap: wrap;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    padding: 10px 12px;\n    font-size: 12px;\n    min-width: calc(50% - 5px);\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 380px) {\n  .p2p-mobile-card-header {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 12px;\n  }\n\n\n  .p2p-mobile-card-user {\n    width: 100%;\n  }\n\n  .p2p-mobile-card-price {\n    width: 100%;\n    text-align: left;\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    flex: 1;\n    min-width: auto;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-mobile-expanded-details .p2p-myads-expanded-item {\n    flex-direction: row;\n    justify-content: space-between;\n    text-align: left;\n  }\n}\n\n/* Close Ad Modal - Mobile Enhanced */\n@media (max-width: 576px) {\n  .p2p-close-ad-modal {\n    border-radius: 20px 20px 0 0;\n    max-height: 90vh;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    max-width: 100%;\n    animation: slideUp 0.3s ease-out;\n  }\n\n  @keyframes slideUp {\n    from {\n      transform: translateY(100%);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  .p2p-modal-overlay {\n    padding: 0;\n    align-items: center;\n  }\n\n  .p2p-close-ad-modal-header {\n    padding: 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  }\n\n  .p2p-close-ad-modal-title {\n    font-size: 18px;\n  }\n\n  .p2p-close-ad-modal-body {\n    padding: 20px;\n    max-height: calc(90vh - 180px);\n    overflow-y: auto;\n  }\n\n  .p2p-close-ad-warning {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  .p2p-close-ad-warning-content strong {\n    font-size: 14px;\n  }\n\n  .p2p-close-ad-warning-content p {\n    font-size: 12px;\n  }\n\n  .p2p-close-ad-summary {\n    border-radius: 12px;\n    padding: 14px;\n  }\n\n  .p2p-close-ad-summary-header {\n    margin-bottom: 14px;\n    padding-bottom: 10px;\n  }\n\n  .p2p-close-ad-summary-pair {\n    font-size: 15px;\n  }\n\n  .p2p-myads-container {\n    padding: 15px;\n  }\n\n  .p2p-myads-title {\n    font-size: 17px;\n  }\n\n  .p2p-close-ad-summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .p2p-close-ad-summary-label {\n    font-size: 10px;\n  }\n\n  .p2p-close-ad-summary-value {\n    font-size: 13px;\n  }\n\n  .p2p-close-ad-reason-input {\n    min-height: 70px;\n    font-size: 14px;\n  }\n\n  .p2p-close-ad-modal-footer {\n    padding: 16px 20px 24px;\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  .p2p-close-ad-btn-cancel,\n  .p2p-close-ad-btn-confirm {\n    padding: 8px 15px;\n    font-size: 12px;\n    border-radius: 7px;\n  }\n\n  .p2p-close-ad-modal {\n    max-width: 90%;\n    margin: 0 auto;\n  }\n\n}\n\n/* ====================================\n     P2P My Ads - Mobile Responsive\n     ==================================== */\n\n/* Mobile Header */\n@media (max-width: 768px) {\n  .p2p-myads-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .p2p-myads-title {\n    font-size: 20px;\n  }\n\n  .p2p-myads-header .p2p-create-ad-btn {\n    width: 100%;\n    text-align: center;\n    padding: 12px 20px;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n/* Mobile Filter Header - Hidden on desktop */\n.p2p-mobile-filter-header {\n  display: none;\n}\n\n/* Mobile Filter Toggle Button */\n.p2p-mobile-filter-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #373f4d;\n  border: 1px solid #373f4d;\n  border-radius: 10px;\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-mobile-filter-toggle:hover {\n  background: #373f4d;\n  border: 1px solid #373f4d;\n}\n\n.p2p-mobile-filter-toggle.active {\n  background: #373f4d;\n  border-color: #22c55e;\n  color: #22c55e;\n}\n\n.p2p-mobile-filter-toggle i {\n  font-size: 18px;\n}\n\n.p2p-mobile-filter-toggle span {\n  flex: 1;\n  text-align: left;\n}\n\n.p2p-mobile-active-filters {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-active-filter-tag {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n/* [UNUSED]\n.p2p-filter-badge {\n  background: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  margin-left: 4px;\n}\n*/\n\n/* Mobile Filter Section */\n@media (max-width: 768px) {\n\n  /* Show mobile filter header */\n  .p2p-mobile-filter-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n    padding: 0 4px;\n  }\n\n  .p2p-mobile-filter-toggle {\n    flex: 1;\n  }\n\n  /* Hide filter section by default on mobile */\n  .p2p-filter-section {\n    display: none;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    padding: 16px;\n    background: #12121a;\n    border: 1px solid #2a2a3a;\n    border-radius: 12px;\n    margin-bottom: 16px;\n    animation: slideDown 0.2s ease-out;\n  }\n\n  @keyframes slideDown {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .p2p-filter-section.show {\n    display: grid;\n  }\n\n  .p2p-filter-group {\n    min-width: unset;\n  }\n\n  .p2p-filter-section .p2p-find-orders-btn {\n    grid-column: 1 / -1;\n    width: 100%;\n    background: #f3bb2b;\n    color: #181a20;\n    border: none;\n  }\n\n  .p2p-filter-section .p2p-find-orders-btn:hover {\n    background: #16a34a;\n  }\n}\n\n@media (max-width: 480px) {\n  .p2p-filter-section.show {\n    grid-template-columns: 1fr;\n  }\n\n  button.p2p-myads-action-btn {\n    padding: 5px 10px !important;\n  }\n\n  .p2p-profile-section-desc {\n    font-size: 12px !important;\n  }\n\n  .p2p-mobile-filter-header {\n    flex-wrap: wrap;\n  }\n\n  .p2p-mobile-filter-toggle {\n    width: 100%;\n    flex: none;\n    justify-content: flex-start;\n  }\n\n  .p2p-mobile-active-filters {\n    width: 100%;\n    margin-top: 8px;\n  }\n}\n\n@media (max-width: 400px) {\n  .p2p-mobile-filter-toggle {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .p2p-active-filter-tag {\n    font-size: 11px;\n    padding: 3px 8px;\n  }\n}\n\n/* Hide mobile filter header on desktop */\n@media (min-width: 769px) {\n  .p2p-mobile-filter-header {\n    display: none !important;\n  }\n\n  .p2p-filter-section {\n    display: flex !important;\n  }\n}\n\n/* Mobile Stats Cards */\n@media (max-width: 768px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 12px 14px;\n  }\n\n  .p2p-myads-stat-card-label {\n    font-size: 10px;\n    margin-bottom: 6px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n}\n\n@media (max-width: 400px) {\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n  }\n\n  .p2p-myads-stat-card {\n    padding: 10px 12px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 14px;\n  }\n}\n\n/* Legacy Mobile Stats Bar */\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-myads-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    padding: 14px 16px;\n    text-align: center;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-myads-stat-item {\n    align-items: center;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-myads-stat-value {\n    font-size: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-myads-stat-label {\n    font-size: 10px;\n  }\n*/\n}\n\n/* Mobile Card Improvements */\n@media (max-width: 991px) {\n  .p2p-orders-table-wrapper {\n    display: none;\n  }\n\n  .p2p-mobile-orders-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n}\n\n@media (min-width: 992px) {\n  .p2p-mobile-orders-list {\n    display: none;\n  }\n}\n\n.p2p-mobile-order-card {\n  background: #12121a00;\n  border: 1px solid #2c2c2c;\n  border-radius: 12px;\n  padding: 16px;\n  transition: border-color 0.2s;\n}\n\n.p2p-mobile-order-card:hover {\n  border-color: rgba(55, 65, 81, 0.5);\n}\n\n.p2p-mobile-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* [UNUSED]\nbutton.p2p-mobile-view-btn i {\n  color: #535c6b;\n}\n*/\n\n.p2p-mobile-card-user-info h4 {\n  font-size: 13px;\n  font-weight: 500;\n  color: #d1d5db;\n  margin: 0px 0px 2px;\n}\n\n.p2p-mobile-card-user-info p {\n  margin: 0;\n}\n\n/* [UNUSED]\n.p2p-mobile-status-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n*/\n\n.p2p-mobile-card-price {\n  text-align: right;\n}\n\n/* [UNUSED]\n.p2p-mobile-card-price .p2p-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #a1a1aa;\n}\n*/\n\n.p2p-mobile-card-price .p2p-currency {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.p2p-mobile-card-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 0px;\n  border: none;\n}\n\n.p2p-mobile-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-mobile-detail-label {\n  font-size: 11px;\n  color: #52525b;\n  letter-spacing: 0.3px;\n}\n\n.p2p-mobile-detail-value {\n  font-size: 13px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.p2p-mobile-card-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.p2p-mobile-payment-badge {\n  padding: 4px 8px;\n  background: rgba(55, 65, 81, 0.3);\n  border-radius: 4px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.p2p-mobile-card-actions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  padding-top: 14px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-card-actions .p2p-myads-action-btn {\n  flex: unset;\n  padding: 10px 8px;\n  font-size: 12px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n@media (max-width: 400px) {\n  .p2p-mobile-card-actions {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  /* .p2p-mobile-card-actions .p2p-myads-action-btn:first-child {\n      grid-column: 1 / -1;\n    } */\n}\n\n.p2p-myads-action-btn {\n  min-height: 32px;\n}\n\n/* Mobile Expanded Details */\n.p2p-mobile-expanded-details {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1e1e2d;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n  grid-template-columns: repeat(1, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 480px) {\n  .p2p-mobile-expanded-details .p2p-myads-expanded-grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-details {\n  grid-template-columns: 1fr;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-card {\n  padding: 12px;\n}\n\n.p2p-mobile-expanded-details .p2p-myads-payment-qr img {\n  width: 60px;\n  height: 60px;\n}\n\n/* Mobile Pagination */\n/* Mobile Pagination */\n.p2p-pagination-wrapper.p2p-mobile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  margin-top: 8px;\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-info {\n  font-size: 11px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-buttons,\n.p2p-pagination-wrapper.p2p-mobile .p2p-pagination-controls {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n/* [UNUSED]\n.p2p-pagination-wrapper.p2p-mobile .p2p-page-current {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n  background: rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n}\n*/\n\n.p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {\n  min-width: 36px;\n  height: 36px;\n  font-size: 13px;\n}\n\n@media (max-width: 991px) {\n  .p2p-pagination-wrapper:not(.p2p-mobile) {\n    display: none;\n  }\n\n  .p2p-payment-method-qr {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n\n\n}\n\n@media (min-width: 992px) {\n  .p2p-pagination-wrapper.p2p-mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 400px) {\n  .p2p-pagination-wrapper.p2p-mobile .p2p-page-btn {\n    min-width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n}\n\n/* Mobile Empty State */\n.p2p-empty-state-mobile {\n  text-align: center;\n  padding: 48px 20px;\n  background: #373F4D;\n  border-radius: 12px;\n  border: 1px solid #373F4D;\n}\n\n.p2p-empty-state-mobile .p2p-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.p2p-empty-state-mobile p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 20px 0;\n}\n\n/* Touch-friendly improvements */\n@media (max-width: 768px) {\n  .p2p-myads-action-btn {\n    min-height: 32px;\n    min-width: 44px;\n  }\n\n  .p2p-filter-select {\n    min-height: 44px;\n    font-size: 14px;\n  }\n\n  .p2p-page-btn {\n    min-width: 36px;\n    min-height: 36px;\n  }\n\n  .p2p-close-ad-reason-input {\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n  }\n\n\n  .p2p-close-ad-reason-input {\n    font-size: 13px;\n  }\n}\n\n/* ====================================\n     P2P Profile Page Styles\n     ==================================== */\n\n.p2p-profile-header {\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-profile-header-inner {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 24px;\n}\n\n.p2p-profile-user {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.p2p-profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #e5e5e5;\n  position: relative;\n}\n\n.p2p-profile-online-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 14px;\n  height: 14px;\n  background: #4ade80;\n  border-radius: 50%;\n  border: 2px solid #12121a;\n}\n\n.p2p-profile-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.p2p-profile-name {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #e5e5e5;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-profile-verified-badge {\n  display: inline-flex;\n  align-items: center;\n  color: #bd83cb;\n  font-size: 18px;\n}\n\n.p2p-profile-verified-badge i {\n  font-size: inherit;\n}\n\n.p2p-profile-edit-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 4px;\n  transition: color 0.2s;\n}\n\n.p2p-profile-edit-btn:hover {\n  color: #e5e5e5;\n}\n\n.p2p-profile-badges {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.p2p-profile-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-profile-badge.verified {\n  color: #4ade80;\n}\n\n.p2p-profile-funding {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n/* [UNUSED]\n.p2p-profile-funding-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-profile-eye-btn {\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-profile-funding-value {\n  color: #9ca3af;\n  font-size: 16px;\n}\n*/\n\n/* Profile Tabs */\n.p2p-profile-tabs {\n  margin-bottom: 24px;\n  overflow-x: auto;\n}\n\n.p2p-profile-tabs-inner {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.p2p-profile-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.p2p-profile-tab:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #d1d5db;\n}\n\n.p2p-profile-tab.active {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n\n.p2p-profile-tab i {\n  font-size: 15px;\n}\n\n/* Section Header */\n.p2p-profile-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.p2p-profile-section-desc {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Payment Methods Grid */\n.p2p-payment-methods-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.p2p-payment-method-card {\n  background: rgba(18, 18, 26, 0.6);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  overflow: hidden;\n}\n\n.p2p-payment-method-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: none;\n  background: rgb(13 13 20 / 14%);\n}\n\n.p2p-payment-method-title {\n  margin: 0;\n  color: #d1d5db;\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-payment-method-type-badge {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #9ca3af;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n/* [UNUSED]\n.closebtn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: #888;\n  font-size: 16px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  padding: 2px 4px;\n}\n*/\n\n.p2p-payment-method-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.p2p-payment-method-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid;\n}\n\n.p2p-payment-method-btn.edit {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n}\n\n.p2p-payment-method-btn.edit:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e5e5;\n}\n\n.p2p-payment-method-btn.delete {\n  background: rgba(127, 29, 29, 0.15);\n  border-color: rgba(153, 27, 27, 0.25);\n  color: #fca5a5;\n}\n\n.p2p-payment-method-btn.delete:hover {\n  background: rgba(127, 29, 29, 0.25);\n}\n\n.p2p-payment-method-body {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-payment-method-field {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.p2p-payment-method-label {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.p2p-payment-method-value {\n  color: #d1d5db;\n  font-size: 13px;\n  text-align: right;\n  word-break: break-all;\n}\n\n.p2p-payment-method-qr {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-payment-method-qr img {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  background: #fff;\n  border-radius: 6px;\n  padding: 4px;\n}\n\n.p2p-payment-method-qr span {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Empty State Card */\n.p2p-empty-state-card {\n  background: none;\n  border-radius: 12px;\n  /* border: 1px solid rgba(255, 255, 255, 0.06); */\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.p2p-empty-state-card i {\n  font-size: 48px;\n  color: #52525b;\n  margin-bottom: 16px;\n  display: block;\n}\n\n.p2p-empty-state-card p {\n  color: #6b7280;\n  font-size: 14px;\n  margin: 0 0 20px 0;\n}\n\n\n@media (max-width: 991px) {\n\n  .p2p-order-status-badge {\n    background-color: #333b47 !important;\n    color: #878787 !important;\n    border-color: #333b47 !important;\n  }\n\n  .p2p-order-status-badge.status_complete {\n    color: #dddada !important;\n  }\n\n\n\n  .p2p-profile-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 14px;\n  }\n\n  .p2p-profile-name-row {\n    margin-bottom: 0px;\n  }\n\n  .p2p-payment-method-card {\n    background: rgb(18 18 26 / 0%);\n    border: 1px solid #413f3f;\n  }\n\n  .p2p-payment-method-body {\n    padding: 12px 15px;\n  }\n\n  button.p2p-myads-action-btn {\n    width: fit-content;\n    align-items: end;\n  }\n\n  .rightalien {\n    text-align: right;\n  }\n\n  .p2p-mobile-card-details {\n    grid-template-columns: 1fr;\n  }\n\n\n  .p2p-mobile-detail-item {\n    flex-direction: row;\n    gap: 12px;\n    justify-content: space-between;\n  }\n\n  .p2p-mobile-card-details {\n    padding: 14px 0px 0px;\n  }\n\n  .p2p-mobile-payment-badge {\n    padding: 3px 7px;\n    margin-left: 4px;\n  }\n\n}\n\n\n@media (max-width: 768px) {\n  .p2p-empty-state-card {\n    padding: 32px 16px;\n    border-radius: 10px;\n  }\n\n  .p2p-empty-state-card i {\n    font-size: 40px;\n    margin-bottom: 12px;\n  }\n\n  .p2p-empty-state-card p {\n    font-size: 13px;\n    margin-bottom: 16px;\n  }\n\n  .p2p-mobile-card-price {\n    justify-content: end;\n  }\n\n}\n\n\n\n\n\n@media (max-width: 991px) {\n\n\n  .p2p-layout-wrapper {\n    background-color: #181a20;\n  }\n\n\n  .p2p-mobile-detail-label {\n    color: #828289;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-view-btn {\n    color: #eaecef;\n  }\n*/\n\n  .p2p-mobile-detail-value {\n    color: #eaecef;\n  }\n\n  /* [UNUSED]\n.p2p-mobile-view-btn {\n    color: #eaecef !important;\n  }\n*/\n\n  .p2p-mobile-detail-value {\n    font-size: 12px;\n    letter-spacing: 0.3px;\n  }\n\n  /* [UNUSED]\nspan.p2p-mobile-detail-value.valueprice {\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-card-avatar {\n    width: 36px;\n    height: 36px;\n  }\n*/\n\n\n\n}\n\n\n@media (max-width: 400px) {\n  .p2p-empty-state-card {\n    padding: 24px 12px;\n  }\n\n  .p2p-empty-state-card i {\n    font-size: 36px;\n  }\n\n  .p2p-empty-state-card p {\n    font-size: 12px;\n  }\n}\n\n/* Add Payment Modal */\n.p2p-add-payment-modal {\n  background: #12121a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n.p2p-add-payment-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.p2p-add-payment-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0;\n}\n\n.p2p-modal-close-btn {\n  background: transparent;\n  border: none;\n  color: #6b7280;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.p2p-modal-close-btn:hover {\n  color: #e5e5e5;\n}\n\n.p2p-add-payment-modal-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.p2p-add-payment-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  justify-content: flex-end;\n}\n\n/* Payment Type List */\n.p2p-payment-type-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-payment-type-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-payment-type-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.p2p-payment-type-name {\n  font-size: 14px;\n  color: #d1d5db;\n  font-weight: 500;\n}\n\n.p2p-payment-type-item i {\n  color: #6b7280;\n  font-size: 18px;\n}\n\n/* Payment Form */\n.p2p-payment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.p2p-payment-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-payment-form-label {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.p2p-required {\n  color: #ef4444;\n  margin-left: 4px;\n}\n\n.p2p-payment-form-input {\n  padding: 12px 14px;\n  background: rgba(10, 10, 15, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #e5e5e5;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.p2p-payment-form-input:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.p2p-payment-form-input::placeholder {\n  color: #52525b;\n}\n\n.p2p-payment-file-input {\n  position: relative;\n}\n\n.p2p-payment-file-input input[type=\"file\"] {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.p2p-payment-file-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  background: rgba(10, 10, 15, 0.8);\n  border: 1px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-payment-file-label:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #9ca3af;\n}\n\n.p2p-payment-file-label i {\n  font-size: 20px;\n}\n\n/* Modal Buttons */\n.p2p-modal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.p2p-modal-btn.primary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #e5e5e5;\n}\n\n.p2p-modal-btn.primary:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.p2p-modal-btn.secondary {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #9ca3af;\n}\n\n.p2p-modal-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.04);\n  color: #d1d5db;\n}\n\n.p2p-modal-btn.danger {\n  background: rgba(153, 27, 27, 0.8);\n  color: #fecaca !important;\n}\n\n.p2p-modal-btn.danger:hover {\n  background: rgba(153, 27, 27, 1);\n}\n\n/* Delete Modal */\n.p2p-delete-modal {\n  background: #12121a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 400px;\n  padding: 32px 24px;\n  text-align: center;\n  animation: p2p-modal-slide-in 0.2s ease-out;\n}\n\n.p2p-delete-modal-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n  background: rgba(127, 29, 29, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-delete-modal-icon i {\n  font-size: 28px;\n  color: #fca5a5;\n}\n\n.p2p-delete-modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.p2p-delete-modal-desc {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.p2p-delete-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n/* Profile Mobile Responsive */\n@media (max-width: 768px) {\n  .p2p-profile-header-inner {\n    flex-direction: column;\n  }\n\n  .p2p-profile-funding {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .p2p-profile-tabs-inner {\n    gap: 8px;\n  }\n\n  .p2p-profile-tab {\n    padding: 8px 14px;\n    font-size: 12px;\n  }\n\n  .p2p-profile-section-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .p2p-payment-methods-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-payment-method-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .p2p-payment-method-actions {\n    width: 100%;\n  }\n\n  .p2p-payment-method-btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .p2p-add-payment-modal,\n  .p2p-delete-modal {\n    margin: 16px;\n    max-height: calc(100vh - 32px);\n  }\n}\n\n/* ============================================\n     P2P ORDER DETAILS STYLES\n     ============================================ */\n\n/* [UNUSED]\n.p2p-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  color: #a8b4c4;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 0;\n  margin-bottom: 20px;\n  transition: color 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-back-btn:hover {\n  color: #bd83cb;\n}\n*/\n\n/* [UNUSED]\n.p2p-back-btn i {\n  font-size: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-header {\n  background: linear-gradient(135deg, #12121a 0%, #0d0d14 100%);\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  color: #22c55e;\n}\n*/\n\n.p2p-order-status-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Timer Styles */\n/* [UNUSED]\n.p2p-order-timer {\n  text-align: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-timer.expired {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 12px;\n  padding: 12px 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-label {\n  display: block;\n  color: #6b7280;\n  font-size: 12px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-expired {\n  color: #ef4444;\n  font-size: 16px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-display {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-unit {\n  text-align: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-digits {\n  display: flex;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-digit {\n  background: linear-gradient(180deg, #1a1a24 0%, #0d0d14 100%);\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  font-family: 'SF Mono', 'Monaco', monospace;\n  min-width: 42px;\n  text-align: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-unit-label {\n  display: block;\n  color: #6b7280;\n  font-size: 11px;\n  margin-top: 4px;\n  text-transform: uppercase;\n}\n*/\n\n/* [UNUSED]\n.p2p-timer-separator {\n  color: #6b7280;\n  font-size: 28px;\n  font-weight: 700;\n  margin-top: -20px;\n}\n*/\n\n/* Order Info Row */\n/* [UNUSED]\n.p2p-order-info-row {\n  display: flex;\n  gap: 32px;\n  padding-top: 20px;\n  border-top: 1px solid #1e1e2d;\n  flex-wrap: wrap;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-label {\n  color: #6b7280;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-value {\n  color: #e5e5e5;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-value.clickable {\n  color: #a8b4c4;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-value.clickable:hover {\n  color: #bd83cb;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-info-value i {\n  font-size: 14px;\n}\n*/\n\n/* Order Content Layout */\n/* [UNUSED]\n.p2p-order-content {\n  display: grid;\n  grid-template-columns: minmax(300px, 1fr) minmax(400px, 480px);\n  gap: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-main {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 520px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n*/\n\n/* Order Cards */\n/* [UNUSED]\n.p2p-order-card {\n  background: #12121a;\n  border-radius: 12px;\n  border: 1px solid #1e1e2d;\n  padding: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-card-title {\n  margin: 0 0 16px 0;\n  color: #e5e5e5;\n  font-size: 16px;\n  font-weight: 600;\n}\n*/\n\n/* Order Summary Grid */\n/* [UNUSED]\n.p2p-order-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-summary-item {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  text-align: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-summary-item.highlight {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n*/\n\n/* [UNUSED]\n.p2p-summary-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #e5e5e5;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-summary-value.green {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-summary-label {\n  color: #6b7280;\n  font-size: 12px;\n}\n*/\n\n/* Payment Warning */\n/* [UNUSED]\n.p2p-payment-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-warning i {\n  color: #fbbf24;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-warning span {\n  color: #fbbf24;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n/* Payment Method Badges */\n/* [UNUSED]\n.p2p-payment-method-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n*/\n\n/* Payment Detail Card */\n/* [UNUSED]\n.p2p-payment-detail-card {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-card:last-child {\n  margin-bottom: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-type-badge {\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr img {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  border: 2px solid #2a2a3a;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr img:hover {\n  transform: scale(1.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr span {\n  color: #6b7280;\n  font-size: 11px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-list {\n  display: flex;\n  flex-direction: column;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #1e1e2d;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-row:last-child {\n  border-bottom: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-label {\n  color: #6b7280;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-value {\n  color: #a8b4c4;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-value:hover {\n  color: #bd83cb;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail-value i {\n  font-size: 14px;\n  opacity: 0.7;\n}\n*/\n\n/* Order Actions */\n/* [UNUSED]\n.p2p-order-action-text {\n  color: #9ca3af;\n  font-size: 14px;\n  margin: 0 0 16px 0;\n  line-height: 1.6;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-action-text .highlight {\n  color: #22c55e;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-actions .p2p-confirm-buy-btn {\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-actions .p2p-cancel-btn {\n  min-width: 140px;\n}\n*/\n\n/* Order Remarks */\n/* [UNUSED]\n.p2p-order-remarks {\n  color: #9ca3af;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0;\n  white-space: pre-wrap;\n}\n*/\n\n/* User Card */\n/* [UNUSED]\n.p2p-order-user-card {\n  display: flex;\n  flex-direction: column;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-avatar.buyer {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-avatar span {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-online-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #22c55e;\n  border: 2px solid #12121a;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-user-info h4 {\n  margin: 0 0 2px 0;\n  color: #e5e5e5;\n  font-size: 15px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-role {\n  color: #6b7280;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-role.buyer {\n  color: #22c55e;\n}\n*/\n\n/* Chat Card */\n/* [UNUSED]\n.p2p-chat-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 300px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header h4 {\n  margin: 0;\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-expand-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  color: #888;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-expand-btn:hover {\n  background: #1a1a24;\n  color: #e5e5e5;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-preview {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-preview .p2p-chat-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #c9d1d9;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble {\n  background: #1a1a24;\n  border-radius: 12px;\n  padding: 10px 14px;\n  max-width: 85%;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble p {\n  margin: 0;\n  color: #d1d5db;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-time {\n  display: block;\n  color: #6b7280;\n  font-size: 10px;\n  margin-top: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input-wrapper {\n  display: flex;\n  gap: 8px;\n  background: #0d0d14;\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input::placeholder {\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-preview .p2p-chat-send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-preview .p2p-chat-send-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);\n}\n*/\n\n/* Order Details Responsive */\n@media (max-width: 1200px) {\n  /* [UNUSED]\n.p2p-order-content {\n    grid-template-columns: minmax(280px, 1fr) minmax(350px, 420px);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-main {\n    max-width: 100%;\n  }\n*/\n\n\n}\n\n@media (max-width: 1024px) {\n  /* [UNUSED]\n.p2p-order-content {\n    display: block;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-main {\n    max-width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-sidebar {\n    display: flex;\n    flex-direction: column;\n  }\n*/\n}\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-order-header {\n    padding: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-header-top {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-title {\n    font-size: 22px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-timer {\n    width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-timer-display {\n    justify-content: center;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-timer-digit {\n    padding: 8px 10px;\n    font-size: 20px;\n    min-width: 36px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-info-row {\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-info-item {\n    min-width: calc(50% - 8px);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-card {\n    padding: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-summary-value {\n    font-size: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-actions {\n    flex-direction: column;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-actions .p2p-confirm-buy-btn,\n  .p2p-order-actions .p2p-cancel-btn {\n    width: 100%;\n    min-width: unset;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-sidebar {\n    grid-template-columns: 1fr;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-detail-header {\n    flex-direction: column;\n    gap: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-qr {\n    align-self: flex-start;\n  }\n*/\n\n  .p2p-main-content.p2p-mobile .p2p-mobile-card-actions .p2p-myads-action-btn {\n    min-width: 100%;\n  }\n\n}\n\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-order-title-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n*/\n\n  .p2p-mobile-card-actions .p2p-myads-action-btn {\n    padding: 5px 8px;\n    font-size: 11px;\n  }\n\n  .p2p-profile-header {\n    padding: 16px;\n    margin-bottom: 15px;\n  }\n\n  .p2p-profile-header-inner.mobileview {\n    gap: 15px;\n  }\n\n\n  .p2p-payment-method-title {\n    margin: 0;\n    font-size: 13px;\n    gap: 4px;\n  }\n\n  .p2p-payment-method-header.mobileview {\n    padding: 12px 15px;\n  }\n\n  /* [UNUSED]\n.p2p-order-summary-grid {\n    grid-template-columns: 1fr;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-timer-digit {\n    padding: 6px 8px;\n    font-size: 18px;\n    min-width: 32px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-timer-separator {\n    font-size: 22px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-detail-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n*/\n}\n\n/* ============================================\n     P2P ORDERS LIST STYLES\n     ============================================ */\n\n/* [UNUSED]\n.p2p-orders-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-orders-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #e5e5e5;\n}\n*/\n\n/* [UNUSED]\n.p2p-orders-count {\n  background: rgba(255, 220, 136, 0.1);\n  color: #a8b4c4;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n*/\n\n/* Order Type Cell */\n/* [UNUSED]\n.p2p-order-type-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-type {\n  font-weight: 600;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-type.buy {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-type.sell {\n  color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-crypto {\n  color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-date {\n  color: #6b7280;\n  font-size: 12px;\n}\n*/\n\n/* Order ID */\n/* [UNUSED]\n.p2p-order-id {\n  color: #a8b4c4;\n  font-size: 13px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-id:hover {\n  color: #bd83cb;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-id i {\n  font-size: 14px;\n  opacity: 0.7;\n}\n*/\n\n/* Amount Cell */\n/* [UNUSED]\n.p2p-amount-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-fiat-amount {\n  color: #eaecef;\n  font-weight: 600;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-crypto-amount {\n  color: #9ca3af;\n  font-size: 13px;\n}\n*/\n\n/* Counterparty Cell */\n/* [UNUSED]\n.p2p-counterparty-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-counterparty-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffdc88 0%, #f4b609 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-counterparty-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n*/\n\n/* [UNUSED]\n.p2p-counterparty-avatar span {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-counterparty-name {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 500;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n*/\n\n/* Order Status Badge */\n.p2p-order-status-badge {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  background-color: #333b47 !important;\n  color: #878787 !important;\n  border-color: #333b47 !important;\n}\n\n/* Order Action Button */\n/* [UNUSED]\n.p2p-order-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: rgb(255 220 136 / 0%);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n  border-radius: 6px;\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n*/\n\n.p2p-order-status-badge.status_complete {\n  color: #dddada !important;\n}\n\n/* [UNUSED]\n.p2p-order-action-btn:hover {\n  background: rgba(255, 220, 136, 0.2);\n  border-color: rgba(255, 220, 136, 0.4);\n}\n*/\n\n/* [UNUSED]\n.p2p-order-action-btn i {\n  font-size: 15px;\n}\n*/\n\n/* [UNUSED]\n.p2p-unread-badge {\n  color: #f59e0b;\n  font-weight: 600;\n  font-size: 12px;\n}\n*/\n\n/* Table Row Hover */\n.p2p-orders-table tbody tr {\n  cursor: pointer;\n  transition: background 0.2s;\n  background: none !important;\n  border: none;\n}\n\n.volumedatails {\n  width: 100%;\n  background-color: #2F3641;\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid #454C59;\n}\n\n.volumedatails .p2p-myads-expanded-item {\n  flex-direction: row;\n  gap: 12px;\n}\n\n.p2p-orders-table tbody tr:hover {\n  background: #2B313C;\n}\n\n/* Mobile Order Card Footer */\n/* [UNUSED]\n.p2p-mobile-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  margin-top: 12px;\n  border-top: 1px solid #1e1e2d;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-id-mobile {\n  color: #eaecef;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-id-mobile:hover {\n  color: #a8b4c4;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-id-mobile i {\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-view-btn {\n  background: transparent;\n  border: none;\n  color: #a8b4c4;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-view-btn i {\n  font-size: 16px;\n}\n*/\n\n/* Mobile Card Click Effect */\n.p2p-mobile-order-card {\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.p2p-mobile-order-card:hover {\n  border-color: rgba(255, 220, 136, 0.3);\n  background: rgba(255, 220, 136, 0.02);\n}\n\n/* Orders Page Responsive */\n@media (max-width: 1200px) {\n  /* [UNUSED]\n.p2p-counterparty-name {\n    max-width: 100px;\n  }\n*/\n}\n\n@media (max-width: 992px) {\n\n  .p2p-orders-table th:nth-child(2),\n  .p2p-orders-table td:nth-child(2) {\n    display: none;\n  }\n\n  /* [UNUSED]\n.p2p-counterparty-name {\n    max-width: 80px;\n  }\n*/\n}\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-orders-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-orders-title {\n    font-size: 20px;\n  }\n*/\n}\n\n/* Order Details - Value Colors */\n/* [UNUSED]\n.p2p-summary-value.red {\n  color: #ef4444 !important;\n}\n*/\n\n/* [UNUSED]\n.p2p-summary-value.green {\n  color: #22c55e !important;\n}\n*/\n\n/* Order Expired Notice */\n/* [UNUSED]\n.p2p-order-expired-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 8px;\n  color: #ef4444;\n  font-size: 14px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-expired-notice i {\n  font-size: 20px;\n}\n*/\n\n/* Cancel Button Icon */\n/* [UNUSED]\n.p2p-cancel-btn i {\n  font-size: 16px;\n  margin-right: 4px;\n}\n*/\n\n/* User Payment Method Styles for Sell Orders */\n/* [UNUSED]\n.p2p-user-payment-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-type-badge {\n  background: linear-gradient(135deg, #ffdc88, #f4b609);\n  color: #fff;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e2e8f0;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-detail {\n  font-size: 12px;\n  color: #94a3b8;\n}\n*/\n\n/* [UNUSED]\n.p2p-no-payment-methods {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  text-align: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-no-payment-methods i {\n  font-size: 48px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-no-payment-methods p {\n  font-size: 16px;\n  font-weight: 500;\n  color: #e2e8f0;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-no-payment-methods span {\n  font-size: 13px;\n  color: #94a3b8;\n}\n*/\n\n/* [UNUSED]\n.p2p-add-payment-btn {\n  margin-top: 16px;\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #ffdc88, #f4b609);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-add-payment-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(255, 220, 136, 0.3);\n}\n*/\n\n/* Full Payment Option Card (for Sell Orders) */\n/* [UNUSED]\n.p2p-payment-option-full {\n  display: block;\n  background: rgba(30, 41, 59, 0.5);\n  border: 1px solid rgba(148, 163, 184, 0.15);\n  border-radius: 12px;\n  padding: 0;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option-full:hover {\n  border-color: rgba(255, 220, 136, 0.4);\n  background: rgba(30, 41, 59, 0.7);\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-option-full.p2p-selected {\n  border-color: #bd83cb;\n  background: rgba(255, 220, 136, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-user-payment-card {\n  padding: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-payment-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-user-payment-header .p2p-payment-name {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-payment-header input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #bd83cb;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-payment-details {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-field-label {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-field-value {\n  font-size: 14px;\n  color: #e2e8f0;\n  font-weight: 500;\n  word-break: break-all;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr-preview {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(148, 163, 184, 0.1);\n  display: flex;\n  justify-content: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-qr-preview img {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  object-fit: contain;\n  background: #fff;\n  padding: 4px;\n}\n*/\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-option-full {\n    border-radius: 10px;\n    margin-bottom: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-user-payment-card {\n    padding: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-user-payment-header {\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-user-payment-header .p2p-payment-name {\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-field-label {\n    font-size: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-field-value {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-qr-preview img {\n    width: 70px;\n    height: 70px;\n  }\n*/\n}\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-user-payment-details {\n    grid-template-columns: 1fr;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-user-payment-card {\n    padding: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-qr-preview img {\n    width: 60px;\n    height: 60px;\n  }\n*/\n}\n\n/* No Payment Methods State Mobile */\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-no-payment-methods {\n    padding: 24px 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods i {\n    font-size: 36px;\n    margin-bottom: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods p {\n    font-size: 14px;\n    margin-bottom: 6px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods span {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-add-payment-btn {\n    padding: 12px 20px;\n    font-size: 13px;\n    margin-top: 14px;\n  }\n*/\n}\n\n@media (max-width: 400px) {\n  /* [UNUSED]\n.p2p-no-payment-methods i {\n    font-size: 32px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-no-payment-methods p {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-add-payment-btn {\n    padding: 10px 16px;\n    font-size: 12px;\n    width: 100%;\n  }\n*/\n}\n\n/* ============================================\n     P2P ORDER PROGRESS BAR STYLES\n     ============================================ */\n\n/* [UNUSED]\n.p2p-order-progress-container {\n  background: rgba(20, 22, 30, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-progress {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  z-index: 1;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(40, 45, 55, 0.8);\n  border: 2px solid rgba(100, 110, 130, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-step.active .p2p-progress-icon {\n  background: rgba(212, 168, 83, 0.15);\n  border-color: #d4a853;\n  color: #d4a853;\n  box-shadow: 0 0 20px rgba(212, 168, 83, 0.2);\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-step.completed .p2p-progress-icon {\n  background: rgba(74, 157, 110, 0.15);\n  border-color: #4a9d6e;\n  color: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-align: center;\n  max-width: 80px;\n  line-height: 1.3;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-step.active .p2p-progress-label {\n  color: #d4a853;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-step.completed .p2p-progress-label {\n  color: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-line {\n  flex: 1;\n  height: 2px;\n  background: rgba(100, 110, 130, 0.2);\n  margin: 0 -10px;\n  margin-bottom: 30px;\n  transition: background 0.3s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-progress-line.completed {\n  background: linear-gradient(90deg, #4a9d6e, #4a9d6e);\n}\n*/\n\n/* Quick Order Info */\n/* [UNUSED]\n.p2p-order-quick-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-info-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-label {\n  font-size: 12px;\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-value.highlight-green {\n  color: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-value.highlight-red {\n  color: #c75b5b;\n}\n*/\n\n/* [UNUSED]\n.p2p-quick-divider {\n  width: 1px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.08);\n}\n*/\n\n/* Progress Responsive */\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-order-progress-container {\n    padding: 20px 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-progress-icon {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-progress-label {\n    font-size: 10px;\n    max-width: 60px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-quick-info {\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-quick-value {\n    font-size: 14px;\n  }\n*/\n}\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-order-progress {\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: center;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-progress-line {\n    display: none;\n  }\n*/\n\n  .p2p-payment-type-item {\n    padding: 7px 12px;\n  }\n\n  .p2p-payment-type-name {\n    font-size: 12px;\n  }\n\n\n\n  /* [UNUSED]\n.p2p-progress-step {\n    flex: 0 0 calc(50% - 8px);\n    padding: 12px;\n    background: rgba(30, 35, 45, 0.5);\n    border-radius: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-progress-label {\n    max-width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-quick-info {\n    flex-direction: column;\n    gap: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-quick-divider {\n    width: 100%;\n    height: 1px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-quick-info-item {\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n  }\n*/\n\n  .p2p-payment-form-input {\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n  .p2p-add-payment-modal-header {\n    padding: 10px 18px;\n  }\n\n  .p2p-add-payment-modal-title {\n    font-size: 15px;\n  }\n\n  .p2p-modal-btn {\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 12px;\n  }\n\n\n\n}\n\n/* ============================================\n     P2P MOBILE TABS FOR ORDER DETAILS\n     ============================================ */\n\n/* [UNUSED]\n.p2p-mobile-tabs {\n  display: none;\n  margin-bottom: 20px;\n  background: rgba(20, 22, 30, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 6px;\n  gap: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #8b8b9a;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-tab i {\n  font-size: 18px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-tab:hover {\n  background: rgba(255, 255, 255, 0.03);\n  color: #c9d1d9;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-tab.active {\n  background: rgba(74, 157, 110, 0.15);\n  color: #4a9d6e;\n}\n*/\n\n/* Show tabs on tablet and mobile */\n@media (max-width: 1024px) {\n  /* [UNUSED]\n.p2p-mobile-tabs {\n    display: flex;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-content {\n    display: block;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-main.mobile-hidden,\n  .p2p-order-sidebar.mobile-hidden {\n    display: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-main,\n  .p2p-order-sidebar {\n    max-width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-card {\n    height: calc(100vh - 380px);\n    min-height: 400px;\n    max-height: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 320px);\n  }\n*/\n}\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-mobile-tab {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-tab i {\n    font-size: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-card {\n    height: calc(100vh - 350px);\n    min-height: 350px;\n    max-height: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 280px);\n  }\n*/\n}\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-mobile-tabs {\n    padding: 4px;\n    gap: 4px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-tab {\n    padding: 10px 8px;\n    font-size: 12px;\n    gap: 6px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-mobile-tab i {\n    font-size: 15px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-card {\n    height: calc(100vh - 300px);\n    min-height: 300px;\n    max-height: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-order-sidebar:not(.mobile-hidden) .p2p-chat-card {\n    height: calc(100vh - 250px);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-messages {\n    padding: 12px;\n    gap: 10px;\n  }\n*/\n}\n\n/* ============================================\n     P2P CHAT USER HEADER STYLES\n     ============================================ */\n\n/* [UNUSED]\n.p2p-chat-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-avatar span {\n  color: #c9d1d9;\n  font-size: 16px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-status-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #4a9d6e;\n  border: 2px solid rgba(20, 22, 30, 1);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-details h4 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-user-role {\n  font-size: 12px;\n  color: #6b7280;\n}\n*/\n\n/* ============================================\n     P2P ORDER DETAILS - PREMIUM CHAT STYLES\n     ============================================ */\n\n/* [UNUSED]\n.p2p-chat-card {\n  display: flex;\n  flex-direction: column;\n  height: 550px;\n  min-height: 500px;\n  max-height: 700px;\n  padding: 0 !important;\n  overflow: hidden;\n  flex: 1;\n}\n*/\n\n/* Ensure chat card children have proper flex behavior */\n/* [UNUSED]\n.p2p-chat-card>* {\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-card .p2p-chat-messages {\n  flex: 1;\n  flex-shrink: 1;\n  min-height: 200px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: rgba(20, 20, 30, 0.8);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header h4 i {\n  font-size: 18px;\n  color: #8b8b9a;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-status.online {\n  color: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #4a9d6e;\n  animation: pulse 2s infinite;\n}\n*/\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* [UNUSED]\n.p2p-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: rgba(10, 10, 15, 0.5);\n  min-height: 0;\n  / * Important for flex child scrolling * /\n  scroll-behavior: smooth;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message {\n  display: flex;\n  gap: 10px;\n  max-width: 85%;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message.sent {\n  align-self: flex-end;\n  flex-direction: row-reverse;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message.received {\n  align-self: flex-start;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message.system {\n  align-self: center;\n  max-width: 90%;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-avatar {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3d4a5c, #2d3748);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #c9d1d9;\n  font-size: 13px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble {\n  background: rgba(30, 35, 45, 0.9);\n  border-radius: 16px;\n  padding: 12px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message.sent .p2p-chat-bubble {\n  background: linear-gradient(135deg, rgba(74, 157, 110, 0.2), rgba(74, 157, 110, 0.1));\n  border-color: rgba(74, 157, 110, 0.2);\n  border-radius: 16px 16px 4px 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-message.received .p2p-chat-bubble {\n  border-radius: 16px 16px 16px 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble.system {\n  background: rgba(139, 139, 154, 0.1);\n  border: 1px dashed rgba(139, 139, 154, 0.3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble.system i {\n  font-size: 18px;\n  color: #8b8b9a;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble p {\n  margin: 0;\n  color: #c9d1d9;\n  font-size: 14px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-bubble.system p {\n  color: #8b8b9a;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-time {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #6b7280;\n  font-size: 11px;\n  margin-top: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-time i {\n  font-size: 12px;\n  color: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image {\n  margin-bottom: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image img {\n  max-width: 200px;\n  max-height: 200px;\n  object-fit: cover;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image img:hover {\n  transform: scale(1.02);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image-preview {\n  position: relative;\n  padding: 12px 16px;\n  background: rgba(20, 20, 30, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image-preview img {\n  max-width: 120px;\n  max-height: 80px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-remove-image {\n  position: absolute;\n  top: 8px;\n  left: 120px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(199, 91, 91, 0.9);\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input-container {\n  padding: 12px 16px;\n  background: rgba(20, 20, 30, 0.9);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(30, 35, 45, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 24px;\n  padding: 6px 8px 6px 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-action-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #8b8b9a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-action-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #c9d1d9;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e5e5e5;\n  font-size: 14px;\n  outline: none;\n  padding: 8px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-input::placeholder {\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(74, 157, 110, 0.2);\n  border: none;\n  color: #6b7280;\n  cursor: not-allowed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-send-btn.active {\n  background: linear-gradient(135deg, #4a9d6e, #3d8a5f);\n  color: #fff;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-send-btn.active:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(74, 157, 110, 0.3);\n}\n*/\n\n/* Spin animation for loading */\n/* [UNUSED]\n.p2p-spin {\n  animation: p2p-spin 1s linear infinite;\n}\n*/\n\n@keyframes p2p-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Chat Load More Button */\n/* [UNUSED]\n.p2p-chat-load-more {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #8b8b9a;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-load-more:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #c9d1d9;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-load-more:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n*/\n\n/* Chat Empty State */\n/* [UNUSED]\n.p2p-chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 200px;\n  color: #6b7280;\n  text-align: center;\n  padding: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-empty i {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-empty p {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #8b8b9a;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-empty span {\n  font-size: 13px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n*/\n\n/* Chat Typing Indicator */\n/* [UNUSED]\n.p2p-chat-typing {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 4px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n  background: rgba(30, 35, 45, 0.9);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n*/\n\n/* [UNUSED]\n.p2p-typing-indicator span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #6b7280;\n  animation: typing-bounce 1.4s infinite ease-in-out;\n}\n*/\n\n/* [UNUSED]\n.p2p-typing-indicator span:nth-child(1) {\n  animation-delay: 0s;\n}\n*/\n\n/* [UNUSED]\n.p2p-typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n*/\n\n@keyframes typing-bounce {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n\n  30% {\n    transform: translateY(-6px);\n  }\n}\n\n/* Chat Error */\n/* [UNUSED]\n.p2p-chat-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: rgba(199, 91, 91, 0.1);\n  border-top: 1px solid rgba(199, 91, 91, 0.2);\n  color: #c75b5b;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-error i {\n  font-size: 16px;\n}\n*/\n\n/* Chat Connecting Status */\n/* [UNUSED]\n.p2p-chat-connecting {\n  display: flex;\n  align-items: center;\n  color: #d4a853;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-connecting i {\n  animation: p2p-spin 1s linear infinite;\n}\n*/\n\n/* Message Status Icons */\n/* [UNUSED]\n.p2p-msg-status {\n  font-size: 14px;\n  margin-left: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-msg-status.sending {\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-msg-status.sent {\n  color: #8b8b9a;\n}\n*/\n\n/* [UNUSED]\n.p2p-msg-status.delivered {\n  color: #8b8b9a;\n}\n*/\n\n/* [UNUSED]\n.p2p-msg-status.read {\n  color: #4a9d6e;\n}\n*/\n\n/* Chat Image Uploading Overlay */\n/* [UNUSED]\n.p2p-chat-image-uploading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image-uploading i {\n  font-size: 24px;\n  color: #fff;\n  animation: p2p-spin 1s linear infinite;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-image {\n  position: relative;\n}\n*/\n\n/* User Status Dot Variants */\n/* [UNUSED]\n.p2p-user-status-dot.online {\n  background: #4a9d6e;\n}\n*/\n\n/* [UNUSED]\n.p2p-user-status-dot.offline {\n  background: #6b7280;\n}\n*/\n\n/* Chat Status Variants */\n/* [UNUSED]\n.p2p-chat-status.offline {\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-chat-status.offline .p2p-status-dot {\n  background: #6b7280;\n  animation: none;\n}\n*/\n\n/* Chat Avatar with image */\n/* [UNUSED]\n.p2p-chat-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n*/\n\n/* Emoji Picker */\n/* [UNUSED]\n.p2p-emoji-container {\n  position: relative;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-picker {\n  position: absolute;\n  bottom: 45px;\n  left: 0;\n  width: 280px;\n  max-height: 220px;\n  background: rgba(25, 28, 38, 0.98);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  z-index: 100;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-grid {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 2px;\n  padding: 12px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-grid::-webkit-scrollbar {\n  width: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-grid::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.15s;\n}\n*/\n\n/* [UNUSED]\n.p2p-emoji-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: scale(1.15);\n}\n*/\n\n/* Premium Order Card Styling */\n/* [UNUSED]\n.p2p-order-card {\n  background: rgba(20, 22, 30, 0.7);\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-order-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #c9d1d9;\n  margin: 0 0 16px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n*/\n\n/* Chat Responsive */\n@media (max-width: 1024px) {\n  /* [UNUSED]\n.p2p-chat-card {\n    height: 480px;\n    min-height: 450px;\n  }\n*/\n}\n\n@media (max-width: 768px) {\n  /* [UNUSED]\n.p2p-chat-card {\n    height: 420px;\n    min-height: 400px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-emoji-picker {\n    width: 260px;\n    left: -50px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-emoji-grid {\n    grid-template-columns: repeat(7, 1fr);\n  }\n*/\n}\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-chat-card {\n    height: 380px;\n    min-height: 350px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-header {\n    padding: 12px 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-header h4 {\n    font-size: 14px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-emoji-picker {\n    width: 240px;\n    left: -20px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-emoji-grid {\n    grid-template-columns: repeat(6, 1fr);\n  }\n*/\n\n  /* [UNUSED]\n.p2p-chat-image img {\n    max-width: 150px;\n    max-height: 150px;\n  }\n*/\n}\n\n/* ====================================\n     BINANCE STYLE ORDER DETAILS\n     ==================================== */\n\n.binance-order-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.binance-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 16px;\n}\n\n.binance-loading p {\n  color: #848e9c;\n  font-size: 14px;\n}\n\n.binance-loading .spinner-border {\n  color: #fcd535;\n}\n\n/* Order Status Banners */\n.order-status-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px 24px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  animation: bannerSlideIn 0.3s ease-out;\n}\n\n@keyframes bannerSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.order-status-banner.success {\n  background: linear-gradient(135deg, rgba(14, 203, 129, 0.15) 0%, rgba(14, 203, 129, 0.05) 100%);\n  border: 1px solid rgba(14, 203, 129, 0.3);\n}\n\n.order-status-banner.cancelled {\n  background: linear-gradient(135deg, rgba(246, 70, 93, 0.15) 0%, rgba(246, 70, 93, 0.05) 100%);\n  border: 1px solid rgba(246, 70, 93, 0.3);\n}\n\n.order-status-banner.disputed {\n  background: linear-gradient(135deg, rgba(252, 213, 53, 0.15) 0%, rgba(252, 213, 53, 0.05) 100%);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n}\n\n.banner-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.order-status-banner.success .banner-icon {\n  background: rgba(14, 203, 129, 0.2);\n}\n\n.order-status-banner.cancelled .banner-icon {\n  background: rgba(246, 70, 93, 0.2);\n}\n\n.order-status-banner.disputed .banner-icon {\n  background: rgba(252, 213, 53, 0.2);\n}\n\n.banner-icon i {\n  font-size: 28px;\n}\n\n.order-status-banner.success .banner-icon i {\n  color: #0ecb81;\n}\n\n.order-status-banner.cancelled .banner-icon i {\n  color: #f6465d;\n}\n\n.order-status-banner.disputed .banner-icon i {\n  color: #fcd535;\n}\n\n.banner-content {\n  flex: 1;\n}\n\n.banner-content h3 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.order-status-banner.success .banner-content h3 {\n  color: #0ecb81;\n}\n\n.order-status-banner.cancelled .banner-content h3 {\n  color: #f6465d;\n}\n\n.order-status-banner.disputed .banner-content h3 {\n  color: #fcd535;\n}\n\n.banner-content p {\n  margin: 0;\n  font-size: 14px;\n  color: #848e9c;\n  line-height: 1.5;\n}\n\n/* Mobile responsive */\n@media (max-width: 480px) {\n  .order-status-banner {\n    padding: 16px;\n    gap: 12px;\n  }\n\n  .banner-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .banner-icon i {\n    font-size: 22px;\n  }\n\n  .banner-content h3 {\n    font-size: 16px;\n  }\n\n  .banner-content p {\n    font-size: 13px;\n  }\n}\n\n/* Mobile Tabs */\n.binance-mobile-tabs {\n  display: none;\n  background: #1e2329;\n  border-radius: 8px;\n  padding: 4px;\n  margin-bottom: 20px;\n  gap: 4px;\n}\n\n.binance-tab {\n  flex: 1;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.2s;\n}\n\n.binance-tab:hover {\n  color: #eaecef;\n}\n\n.binance-tab.active {\n  background: #2b3139;\n  color: #ffffff;\n}\n\n.binance-tab i {\n  font-size: 18px;\n}\n\n/* Main Layout */\n.binance-order-layout {\n  display: grid;\n  grid-template-columns: 1fr 420px;\n  gap: 24px;\n  align-items: start;\n}\n\n/* Left Side - Order Details */\n.binance-order-details {\n  background: #181a20;\n  border-radius: 12px;\n  padding: 32px;\n}\n\n.binance-order-header {\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.header-left {\n  flex: 1;\n}\n\n.binance-order-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #eaecef;\n  margin: 0 0 12px 0;\n}\n\n.binance-order-number {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.binance-order-number>span:first-child {\n  color: #848e9c;\n}\n\n.binance-order-number .order-id {\n  color: #eaecef;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.binance-order-number .order-id i {\n  color: #848e9c;\n  font-size: 16px;\n}\n\n.binance-order-number .order-id:hover i {\n  color: #fcd535;\n}\n\n/* Timer in Header */\n.binance-timer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  padding: 12px 16px;\n  /* background: rgba(252, 213, 53, 0.1); */\n  border: 1px solid rgb(43 49 57);\n  border-radius: 8px;\n  min-width: 120px;\n}\n\n.binance-timer .timer-label {\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.binance-timer .timer-value {\n  font-size: 24px;\n  font-weight: 700;\n  /* color: #fcd535; */\n  font-family: 'Roboto Mono', monospace;\n  letter-spacing: 1px;\n}\n\n.binance-timer.expired {\n  background: rgba(246, 70, 93, 0.1);\n  border-color: rgba(246, 70, 93, 0.3);\n}\n\n.binance-timer .timer-expired {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f6465d;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.binance-timer .timer-expired i {\n  font-size: 18px;\n}\n\n/* Progress Steps */\n.binance-progress-steps {\n  display: flex;\n  flex-direction: column;\n}\n\n.binance-step {\n  display: flex;\n  gap: 16px;\n}\n\n.step-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 32px;\n  flex-shrink: 0;\n}\n\n.step-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  background: #2b3139;\n  color: #848e9c;\n  border: 2px solid #2b3139;\n}\n\n.binance-step.completed .step-icon {\n  background: #0ecb81;\n  border-color: #0ecb81;\n  color: #181a20;\n}\n\n.binance-step.active .step-icon {\n  background: #fcd535;\n  border-color: #fcd535;\n  color: #181a20;\n}\n\n.step-line {\n  width: 2px;\n  flex: 1;\n  min-height: 24px;\n  background: #2b3139;\n  margin: 8px 0;\n}\n\n.binance-step.completed .step-line {\n  background: #0ecb81;\n}\n\n.step-content {\n  flex: 1;\n  padding-bottom: 24px;\n}\n\n.step-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n  margin: 4px 0 8px 0;\n}\n\n.binance-step.pending .step-content h4 {\n  color: #848e9c;\n}\n\n/* Collapsible Step Header */\n.step-header-clickable {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 4px 0;\n  margin: -4px 0;\n}\n\n.step-header-clickable h4 {\n  margin: 0;\n}\n\n.step-header-clickable i {\n  font-size: 20px;\n  color: #848e9c;\n  transition: transform 0.2s;\n}\n\n.step-header-clickable:hover i {\n  color: #eaecef;\n}\n\n/* Step Dropdown Content */\n.step-dropdown-content {\n  margin-top: 16px;\n  padding: 16px;\n  background: #1e2329;\n  border-radius: 8px;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Order Info Grid */\n.order-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.order-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.order-info-row .info-label {\n  font-size: 14px;\n  color: #848e9c;\n}\n\n.order-info-row .info-value {\n  font-size: 14px;\n  color: #eaecef;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-info-row .info-value.highlight {\n  color: #fcd535;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.order-info-row .info-value.copyable {\n  cursor: pointer;\n}\n\n.order-info-row .info-value.copyable i {\n  color: #848e9c;\n  font-size: 14px;\n  transition: color 0.2s;\n}\n\n.order-info-row .info-value.copyable:hover i {\n  color: #fcd535;\n}\n\n.step-desc {\n  font-size: 14px;\n  color: #848e9c;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n}\n\n/* Payment Card */\n.binance-payment-card {\n  background: #1e2329;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 16px;\n}\n\n.payment-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.payment-type {\n  background: rgba(252, 213, 53, 0.15);\n  color: #fcd535;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.payment-qr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.payment-qr img {\n  width: 50px;\n  height: 50px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.payment-qr span {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.payment-qr:hover span {\n  color: #fcd535;\n}\n\n.payment-details-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.payment-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.payment-row .label {\n  font-size: 14px;\n  color: #848e9c;\n}\n\n.payment-row .value {\n  font-size: 14px;\n  color: #eaecef;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.payment-row .value i {\n  color: #848e9c;\n  font-size: 16px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.payment-row .value i {\n  opacity: 1;\n  /* color: #fcd535; */\n}\n\n.payment-row.highlight .value.amount {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.payment-row .value.amount.green {\n  color: #0ecb81;\n}\n\n.payment-row .value.amount.red {\n  color: #f6465d;\n}\n\n.payment-row .value.amount i {\n  opacity: 1;\n}\n\n.payment-row.buyer-info {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid #2b3139;\n}\n\n.payment-row .value.name {\n  background: #2b3139;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: default;\n}\n\n/* Action Buttons */\n.binance-action-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.binance-btn {\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n}\n\n.binance-btn.primary {\n  background: #fcd535;\n  color: #181a20;\n}\n\n.binance-btn.primary:hover {\n  background: #e5c32e;\n}\n\n.binance-btn.primary:disabled {\n  background: #5c5424;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n.binance-btn i {\n  margin-right: 6px;\n}\n\n/* Appeal Button */\n.binance-btn.appeal {\n  background: transparent;\n  border: 1px solid #f0b90b;\n  color: #f0b90b;\n}\n\n.binance-btn.appeal:hover:not(:disabled) {\n  background: rgba(240, 185, 11, 0.1);\n}\n\n.binance-btn.appeal.disabled,\n.binance-btn.appeal:disabled {\n  border-color: #848e9c;\n  color: #848e9c;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.binance-btn.appeal-submit {\n  background: #f0b90b;\n  color: #181a20;\n}\n\n.binance-btn.appeal-submit:hover:not(:disabled) {\n  background: #d9a80a;\n}\n\n.binance-btn.appeal-submit:disabled {\n  background: #5c5424;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n/* Appeal Modal */\n.appeal-modal {\n  max-width: 500px;\n}\n\n.appeal-modal .binance-modal-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f0b90b;\n}\n\n.appeal-info {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(240, 185, 11, 0.1);\n  border: 1px solid rgba(240, 185, 11, 0.2);\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.appeal-info i {\n  color: #f0b90b;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.appeal-info p {\n  color: #eaecef;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.appeal-form {\n  margin-bottom: 16px;\n}\n\n.appeal-form label {\n  display: block;\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.appeal-textarea {\n  width: 100%;\n  padding: 12px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  color: #eaecef;\n  font-size: 14px;\n  resize: vertical;\n  min-height: 120px;\n  font-family: inherit;\n}\n\n.appeal-textarea:focus {\n  outline: none;\n  border-color: #f0b90b;\n}\n\n.appeal-textarea::placeholder {\n  color: #5e6673;\n}\n\n.char-count {\n  text-align: right;\n  color: #848e9c;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.appeal-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 8px;\n}\n\n.appeal-warning i {\n  color: #ef4444;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.appeal-warning p {\n  color: #eaecef;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0 0 6px 0;\n}\n\n.appeal-warning ul {\n  margin: 0;\n  padding-left: 16px;\n  color: #848e9c;\n  font-size: 12px;\n}\n\n.appeal-warning li {\n  margin-bottom: 4px;\n}\n\n.appeal-modal .binance-modal-footer {\n  display: flex;\n  gap: 12px;\n}\n\n.appeal-modal .binance-modal-footer .binance-btn {\n  flex: 1;\n}\n\n/* ====================================\n     WELCOME P2P POPUP\n     ==================================== */\n.welcome-modal {\n  max-width: 480px;\n}\n\n.welcome-modal .binance-modal-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #fcd535;\n}\n\n.welcome-modal .binance-modal-header h3 i {\n  font-size: 24px;\n}\n\n/* Welcome Tabs */\n.welcome-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  background: #181a20;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.welcome-tab {\n  flex: 1;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: #848e9c;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.welcome-tab:hover {\n  color: #eaecef;\n}\n\n.welcome-tab.active {\n  background: #2b3139;\n  color: #fcd535;\n}\n\n/* Welcome Content */\n.welcome-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* How to Pay Steps */\n.welcome-step {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: #181a20;\n  border-radius: 12px;\n}\n\n.welcome-step .step-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  background: linear-gradient(135deg, #fcd535 0%, #f0b90b 100%);\n  color: #181a20;\n  font-size: 16px;\n  font-weight: 700;\n  border-radius: 50%;\n}\n\n.welcome-step .step-info h6 {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n}\n\n.welcome-step .step-info p {\n  color: #848e9c;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Things to Note */\n.welcome-note {\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  background: #181a20;\n  border-radius: 12px;\n}\n\n.welcome-note .note-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  background: rgba(252, 213, 53, 0.1);\n  border-radius: 10px;\n}\n\n.welcome-note .note-icon i {\n  font-size: 20px;\n  color: #fcd535;\n}\n\n.welcome-note .note-info h6 {\n  color: #eaecef;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n}\n\n.welcome-note .note-info p {\n  color: #848e9c;\n  font-size: 13px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Welcome Modal Footer */\n.welcome-modal .binance-modal-footer {\n  padding-top: 16px;\n}\n\n.welcome-modal .binance-modal-footer .binance-btn.full-width {\n  width: 100%;\n}\n\n/* ====================================\n     TIME WARNING & PAYMENT RECEIVED POPUPS\n     ==================================== */\n\n/* Time Warning Popup */\n.time-warning-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.warning-icon-large {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n  background: rgba(245, 158, 11, 0.15);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.warning-icon-large i {\n  font-size: 40px;\n  color: #f59e0b;\n}\n\n.time-warning-content h4 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.time-warning-content p {\n  font-size: 14px;\n  color: #9ca3af;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.time-warning-actions {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 20px;\n  text-align: left;\n}\n\n.warning-action-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 13px;\n  color: #d1d5db;\n}\n\n.warning-action-item:last-child {\n  margin-bottom: 0;\n}\n\n.warning-action-item i {\n  font-size: 16px;\n  color: #f59e0b;\n  flex-shrink: 0;\n}\n\n/* Payment Received Popup */\n.payment-received-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.success-icon-large {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n  background: rgba(34, 197, 94, 0.15);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-icon-large i {\n  font-size: 40px;\n  color: #22c55e;\n}\n\n.payment-received-content h4 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #e5e5e5;\n  margin: 0 0 12px 0;\n}\n\n.payment-received-content p {\n  font-size: 14px;\n  color: #9ca3af;\n  line-height: 1.6;\n  margin: 0 0 24px 0;\n}\n\n.payment-received-content p strong {\n  color: #e5e5e5;\n  font-weight: 600;\n}\n\n.payment-received-info {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin: 24px 0;\n}\n\n.info-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.info-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.payment-received-warning {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.payment-received-warning i {\n  font-size: 20px;\n  color: #ef4444;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.payment-received-warning p {\n  margin: 0;\n  font-size: 13px;\n  color: #fca5a5;\n  line-height: 1.6;\n}\n\n.payment-received-warning p strong {\n  color: #fee2e2;\n  font-weight: 600;\n}\n\n/* ====================================\n     P2P TRADE RESTRICTIONS & BALANCE\n     ==================================== */\n\n/* Verification Required Button */\n/* [UNUSED]\n.p2p-verification-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: rgba(252, 213, 53, 0.15);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n  border-radius: 6px;\n  color: #fcd535;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-verification-btn:hover {\n  background: rgba(252, 213, 53, 0.25);\n  border-color: #fcd535;\n}\n*/\n\n/* [UNUSED]\n.p2p-verification-btn i {\n  font-size: 16px;\n}\n*/\n\n/* Trade Restricted Container */\n/* [UNUSED]\n.p2p-trade-restricted {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-trade-restricted .p2p-buy-btn.disabled,\n.p2p-trade-restricted .p2p-sell-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n*/\n\n/* Condition Tooltip */\n/* [UNUSED]\n.p2p-condition-tooltip {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: help;\n}\n*/\n\n/* [UNUSED]\n.p2p-condition-tooltip i {\n  font-size: 18px;\n  color: #848e9c;\n  transition: color 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-condition-tooltip:hover i {\n  color: #fcd535;\n}\n*/\n\n/* [UNUSED]\n.p2p-tooltip-content {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  right: 0;\n  min-width: 240px;\n  padding: 12px;\n  background: #1e2329;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(8px);\n  transition: all 0.2s;\n  z-index: 100;\n}\n*/\n\n/* [UNUSED]\n.p2p-condition-tooltip:hover .p2p-tooltip-content {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n*/\n\n/* [UNUSED]\n.p2p-tooltip-content span {\n  display: block;\n  font-size: 13px;\n  color: #eaecef;\n  line-height: 1.4;\n}\n*/\n\n/* [UNUSED]\n.p2p-tooltip-content .p2p-tooltip-sub {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #f6465d;\n}\n*/\n\n/* Sell with Balance */\n/* [UNUSED]\n.p2p-sell-with-balance {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-balance-info {\n  font-size: 11px;\n  color: #848e9c;\n  pointer-events: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-available-balance {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-top: 4px;\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-fee-display {\n  display: block;\n  font-size: 11px;\n  color: #F3BB2B;\n  margin-top: 4px;\n}\n*/\n\n/* Mobile Styles */\n/* [UNUSED]\n.p2p-mobile-verification-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 16px;\n  background: rgba(252, 213, 53, 0.15);\n  border: 1px solid rgba(252, 213, 53, 0.3);\n  border-radius: 8px;\n  color: #fcd535;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-verification-btn i {\n  font-size: 18px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-trade-restricted {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-trade-restricted .p2p-mobile-buy-btn.disabled,\n.p2p-mobile-trade-restricted .p2p-mobile-sell-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-condition-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(248, 113, 113, 0.1);\n  border-radius: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-condition-info i {\n  font-size: 16px;\n  color: #f6465d;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-condition-info span {\n  font-size: 12px;\n  color: #f6465d;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-sell-with-balance {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-balance-info {\n  font-size: 12px;\n  color: #848e9c;\n  text-align: center;\n  pointer-events: none;\n}\n*/\n\n\n.binance-btn.secondary {\n  background: transparent;\n  color: #848e9c;\n  border: 1px solid #2b3139;\n}\n\n.binance-btn.secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.binance-expired-notice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: rgba(246, 70, 93, 0.1);\n  border: 1px solid rgba(246, 70, 93, 0.3);\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.binance-expired-notice i {\n  color: #f6465d;\n  font-size: 18px;\n}\n\n.binance-expired-notice span {\n  color: #f6465d;\n  font-size: 14px;\n}\n\n/* Chat Section */\n.binance-chat-section {\n  position: sticky;\n  top: 24px;\n}\n\n.binance-chat-card {\n  background: #181a20;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 650px;\n}\n\n.binance-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.chat-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.chat-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #2b3139;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #eaecef;\n  font-size: 18px;\n  position: relative;\n  overflow: hidden;\n}\n\n.chat-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.chat-avatar .status-dot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #848e9c;\n  border: 2px solid #181a20;\n}\n\n.chat-avatar .status-dot.online {\n  background: #0ecb81;\n}\n\n.chat-user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.chat-username {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.chat-username .verified {\n  color: #11cb81;\n  font-size: 16px;\n}\n\n.chat-user-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.chat-user-meta .online-status {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.chat-user-meta .online-status i {\n  font-size: 8px;\n}\n\n.chat-user-meta .online-status.online {\n  color: #0ecb81;\n}\n\n.chat-user-meta .divider {\n  color: #2b3139;\n}\n\n.chat-user-meta .user-role {\n  background: rgba(132, 142, 156, 0.15);\n  color: #848e9c;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n/* [UNUSED]\n.chat-user-meta .trades-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n*/\n\n/* [UNUSED]\n.chat-user-meta .trades-link:hover {\n  color: #eaecef;\n}\n*/\n\n/* [UNUSED]\n.chat-menu-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n*/\n\n/* [UNUSED]\n.chat-menu-btn:hover {\n  background: #2b3139;\n  color: #eaecef;\n}\n*/\n\n/* Chat Notice */\n.binance-chat-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #2b3139;\n  border-bottom: 1px solid #3a3f47;\n  position: relative;\n}\n\n.binance-chat-notice i {\n  color: #ffdc88;\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.binance-chat-notice p {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n  margin: 0;\n  flex: 1;\n}\n\n.notice-close {\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  padding: 4px;\n  line-height: 1;\n}\n\n.notice-close:hover {\n  color: #eaecef;\n}\n\n/* Chat Messages */\n.binance-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: #0b0e11;\n  min-height: 0;\n}\n\n.binance-chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.binance-chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.binance-chat-messages::-webkit-scrollbar-thumb {\n  background: #2b3139;\n  border-radius: 4px;\n}\n\n.load-more-btn {\n  background: #2b3139;\n  border: none;\n  color: #848e9c;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  margin: 0 auto 8px;\n}\n\n.load-more-btn:hover {\n  background: #3a3f47;\n  color: #eaecef;\n}\n\n.chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  color: #848e9c;\n  gap: 8px;\n}\n\n.chat-empty i {\n  font-size: 48px;\n  opacity: 0.3;\n}\n\n.chat-empty p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Chat Messages */\n.chat-message {\n  display: flex;\n  max-width: 85%;\n}\n\n.chat-message.sent {\n  margin-left: auto;\n  justify-content: flex-end;\n}\n\n.chat-message.received {\n  margin-right: auto;\n}\n\n.chat-message.system {\n  max-width: 100%;\n  justify-content: center;\n  margin: 12px 0;\n}\n\n.system-bubble {\n  background: rgba(30, 35, 41, 0.8);\n  padding: 8px 20px;\n  border-radius: 20px;\n  text-align: center;\n  border: 1px dashed rgba(132, 142, 156, 0.3);\n}\n\n.system-bubble p {\n  margin: 0;\n  font-size: 12px;\n  color: #848e9c;\n  font-style: italic;\n}\n\n.message-bubble {\n  padding: 10px 14px;\n  border-radius: 12px;\n  max-width: 100%;\n}\n\n.chat-message.sent .message-bubble {\n  background: #0ecb81;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-message.received .message-bubble {\n  background: #2b3139;\n  border-bottom-left-radius: 4px;\n}\n\n.message-bubble p {\n  margin: 0;\n  font-size: 14px;\n  color: #eaecef;\n  word-wrap: break-word;\n  line-height: 1.4;\n}\n\n.chat-message.sent .message-bubble p {\n  color: #181a20;\n}\n\n.message-image {\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.message-image img {\n  max-width: 200px;\n  max-height: 200px;\n  border-radius: 8px;\n  cursor: pointer;\n  object-fit: cover;\n}\n\n.image-uploading {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.image-uploading i {\n  color: #fff;\n  font-size: 24px;\n}\n\n.message-meta {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.message-time {\n  font-size: 11px;\n  color: rgba(234, 236, 239, 0.5);\n}\n\n.chat-message.sent .message-time {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status {\n  font-size: 14px;\n}\n\n.msg-status.sending {\n  color: rgba(24, 26, 32, 0.4);\n}\n\n.msg-status.sent {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status.delivered {\n  color: rgba(24, 26, 32, 0.6);\n}\n\n.msg-status.read {\n  color: #1890ff;\n}\n\n/* Typing Indicator */\n.typing-bubble {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n  background: #2b3139;\n  border-radius: 12px;\n  border-bottom-left-radius: 4px;\n}\n\n.typing-bubble span {\n  width: 8px;\n  height: 8px;\n  background: #848e9c;\n  border-radius: 50%;\n  animation: typingBounce 1.4s infinite ease-in-out;\n}\n\n.typing-bubble span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typing-bubble span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-bubble span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typingBounce {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n\n  30% {\n    transform: translateY(-6px);\n  }\n}\n\n/* Chat Error */\n.chat-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(246, 70, 93, 0.1);\n  color: #f6465d;\n  font-size: 12px;\n}\n\n.chat-error i {\n  font-size: 16px;\n}\n\n/* Image Preview */\n.image-preview {\n  padding: 12px 16px;\n  background: #1e2329;\n  border-top: 1px solid #2b3139;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.image-preview img {\n  max-height: 80px;\n  border-radius: 8px;\n}\n\n.image-preview button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  padding: 6px;\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n  background: rgb(252 212 53 / 62%);\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chat Input */\n.binance-chat-input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #1e2329;\n  border-top: 1px solid #2b3139;\n}\n\n.binance-chat-input input[type=\"text\"] {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #eaecef;\n  font-size: 14px;\n  padding: 8px 0;\n}\n\n.binance-chat-input input[type=\"text\"]::placeholder {\n  color: #5e6673;\n}\n\n.input-action {\n  width: 36px;\n  height: 36px;\n  padding: 0px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  transition: all 0.2s;\n}\n\n.input-action:hover {\n  color: #eaecef;\n}\n\n.input-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.input-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.emoji-container {\n  position: relative;\n}\n\n.emoji-picker {\n  position: absolute;\n  bottom: 48px;\n  right: 0;\n  width: 280px;\n  background: #1e2329;\n  border: 1px solid #2b3139;\n  border-radius: 12px;\n  padding: 12px;\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 100;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.emoji-picker::-webkit-scrollbar {\n  width: 4px;\n}\n\n.emoji-picker::-webkit-scrollbar-thumb {\n  background: #2b3139;\n  border-radius: 4px;\n}\n\n.emoji-picker button {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.emoji-picker button:hover {\n  background: #2b3139;\n  transform: scale(1.1);\n}\n\n.send-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #2b3139;\n  border: none;\n  color: #5e6673;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: all 0.2s;\n}\n\n.send-btn.active {\n  background: #0ecb81;\n  color: #181a20;\n}\n\n.send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Spinning animation */\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ====================================\n     BINANCE MODAL STYLES\n     ==================================== */\n\n.binance-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(5px);\n}\n\n.binance-modal {\n  background: #1e2329;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.2s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.binance-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #2b3139;\n}\n\n.binance-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\n.modal-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  padding: 0px;\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  transition: all 0.2s;\n}\n\n.modal-close-btn:hover {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.binance-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Cancel Warning */\n.cancel-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(246, 70, 93, 0.1);\n  border: 1px solid rgba(246, 70, 93, 0.2);\n  border-radius: 8px;\n  margin-bottom: 24px;\n}\n\n.cancel-warning>i {\n  color: #f6465d;\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.cancel-warning p {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n}\n\n.cancel-warning span {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.4;\n}\n\n/* Cancel Reasons */\n.cancel-reasons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.reason-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n  margin-bottom: 8px;\n}\n\n.reason-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.reason-option:hover {\n  border-color: #3a3f47;\n}\n\n.reason-option.selected {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.reason-radio {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #3a3f47;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.reason-option.selected .reason-radio {\n  background: #fcd535;\n  border-color: #fcd535;\n}\n\n.reason-radio i {\n  color: #181a20;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.reason-option span {\n  font-size: 14px;\n  color: #eaecef;\n}\n\n/* Custom Reason Input */\n.custom-reason-input {\n  margin-top: 12px;\n  position: relative;\n}\n\n.custom-reason-input textarea {\n  width: 100%;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  color: #eaecef;\n  font-size: 14px;\n  resize: none;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.custom-reason-input textarea:focus {\n  border-color: #fcd535;\n}\n\n.custom-reason-input textarea::placeholder {\n  color: #5e6673;\n}\n\n.custom-reason-input .char-count {\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  font-size: 11px;\n  color: #5e6673;\n}\n\n/* Modal Footer */\n.binance-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #2b3139;\n}\n\n.binance-modal-footer .binance-btn {\n  flex: 1;\n}\n\n.binance-btn.danger {\n  background: #f6465d;\n  color: #fff;\n}\n\n.binance-btn.danger:hover {\n  background: #d83a4f;\n}\n\n.binance-btn.danger:disabled {\n  background: #5e3a40;\n  color: #848e9c;\n  cursor: not-allowed;\n}\n\n.binance-btn.full-width {\n  width: 100%;\n}\n\n/* Confirm Checklist */\n.confirm-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.checklist-item {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.checklist-item i.success {\n  color: #0ecb81;\n  font-size: 20px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.checklist-item span {\n  font-size: 14px;\n  color: #eaecef;\n  line-height: 1.5;\n}\n\n.checklist-item strong {\n  color: #fcd535;\n}\n\n/* Payment Proof Section */\n.payment-proof-section {\n  margin-bottom: 20px;\n}\n\n.payment-proof-section label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #eaecef;\n  margin-bottom: 4px;\n}\n\n.payment-proof-section label .required {\n  color: #f6465d;\n  margin-left: 2px;\n}\n\n.proof-desc {\n  font-size: 12px;\n  color: #848e9c;\n  margin: 0 0 12px 0;\n}\n\n.proof-upload-area {\n  border: 2px dashed #2b3139;\n  border-radius: 8px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.proof-upload-area:hover {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.upload-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  color: #848e9c;\n}\n\n.upload-placeholder i {\n  font-size: 36px;\n}\n\n.upload-placeholder span {\n  font-size: 13px;\n}\n\n.proof-preview {\n  position: relative;\n  display: inline-block;\n}\n\n.proof-preview img {\n  max-width: 200px;\n  max-height: 150px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.remove-proof {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 24px;\n  padding: 0px;\n  height: 24px;\n  border-radius: 50%;\n  background: #f6465d;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/* Modal Warning */\n.modal-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(252, 213, 53, 0.1);\n  border: 1px solid rgba(252, 213, 53, 0.2);\n  border-radius: 8px;\n}\n\n.modal-warning i {\n  color: #fcd535;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.modal-warning p {\n  margin: 0;\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n}\n\n/* Release Warning */\n.release-warning {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #2b3139;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.release-warning>i {\n  color: #848e9c;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.release-warning p {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  color: #eaecef;\n}\n\n.release-warning span {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.4;\n}\n\n/* Release Confirm Checkbox */\n.release-confirm-checkbox {\n  margin-top: 20px;\n}\n\n.checkbox-container {\n  display: flex;\n  gap: 12px;\n  cursor: pointer;\n  padding: 12px 16px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.checkbox-container:hover {\n  border-color: #3a3f47;\n}\n\n.checkbox-container.checked {\n  border-color: #fcd535;\n  background: rgba(252, 213, 53, 0.05);\n}\n\n.checkbox-box {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #3a3f47;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.checkbox-container.checked .checkbox-box {\n  background: #fcd535;\n  border-color: #fcd535;\n}\n\n.checkbox-box i {\n  color: #181a20;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkbox-container span {\n  font-size: 14px;\n  color: #eaecef;\n  line-height: 1.4;\n}\n\n.checkbox-container span strong {\n  color: #fcd535;\n}\n\n/* Mobile Modal */\n@media (max-width: 480px) {\n  .binance-modal-overlay {\n    padding: 0;\n    /* align-items: flex-end; */\n  }\n\n  /* [UNUSED]\n.p2p-mobile-card-user-info .p2p-mobile-status-row {\n    flex-wrap: nowrap;\n  }\n*/\n\n  .binance-modal {\n    max-width: 100%;\n    max-height: 85vh;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .binance-modal-header {\n    padding: 16px 20px;\n  }\n\n  .binance-modal-body {\n    padding: 20px;\n  }\n\n  .binance-modal-footer {\n    padding: 16px 20px;\n  }\n\n  .reason-option {\n    padding: 10px 14px;\n  }\n}\n\n/* Mobile Hidden */\n.mobile-hidden {\n  display: block;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .binance-order-layout {\n    grid-template-columns: 1fr 380px;\n    gap: 20px;\n  }\n\n  /* [UNUSED]\n.p2p-buy-btn {\n    padding: 6px 12px;\n    white-space: nowrap;\n    font-size: 12px;\n  }\n*/\n}\n\n@media (max-width: 1024px) {\n  .binance-mobile-tabs {\n    display: flex;\n  }\n\n  .binance-order-layout {\n    display: block;\n  }\n\n  .mobile-hidden {\n    display: none !important;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 200px);\n    min-height: 500px;\n  }\n}\n\n@media (max-width: 768px) {\n  .binance-order-container {\n    padding: 16px;\n  }\n\n  .binance-order-details {\n    padding: 20px;\n  }\n\n  .binance-order-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .binance-timer {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .binance-timer .timer-value {\n    font-size: 20px;\n  }\n\n  .binance-order-title {\n    font-size: 20px;\n  }\n\n  .binance-action-buttons {\n    flex-direction: column;\n  }\n\n  .binance-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 180px);\n  }\n\n  .chat-username span {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .order-info-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n}\n\n@media (max-width: 480px) {\n  .binance-order-container {\n    padding: 12px;\n  }\n\n  .binance-order-details {\n    padding: 16px;\n  }\n\n  .binance-order-title {\n    font-size: 18px;\n  }\n\n  .step-content h4 {\n    font-size: 14px;\n  }\n\n  .binance-payment-card {\n    padding: 16px;\n  }\n\n  .payment-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .payment-row .value {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .payment-row .value i {\n    opacity: 1;\n  }\n\n  .binance-chat-card {\n    height: calc(100vh - 160px);\n    min-height: 400px;\n  }\n\n  .emoji-picker {\n    width: 240px;\n    grid-template-columns: repeat(6, 1fr);\n    right: -40px;\n  }\n\n  .message-image img {\n    max-width: 150px;\n    max-height: 150px;\n  }\n\n  .binance-timer {\n    padding: 8px 12px;\n  }\n\n  .binance-tab {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-page-content {\n    padding: 18px;\n  }\n\n  .order-info-row .info-label {\n    font-size: 12px;\n  }\n\n  .order-info-row .info-value {\n    font-size: 12px;\n  }\n\n  .payment-row.highlight .value.amount {\n    font-size: 14px;\n  }\n\n  .binance-expired-notice {\n    padding: 8px 12px;\n    margin-top: 10px;\n  }\n\n  .step-desc {\n    font-size: 12px;\n  }\n\n  .binance-chat-input {\n    gap: 2px;\n    padding: 8px 5px;\n  }\n\n  .p2p-mobile-header {\n    padding: 10px 15px;\n    margin-bottom: 10px;\n  }\n}\n\n/* ====================================\n     LIGHT THEME OVERRIDES\n     ==================================== */\n\nbody.light_theme .p2p-layout-wrapper {\n  background-color: #fff;\n}\n\nbody.light_theme .p2p-main-content {\n  color: #000;\n}\n\nbody.light_theme .p2p-page-content {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-header {\n  background-color: #fff;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-hamburger:hover {\n  background-color: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-hamburger-line {\n  background-color: #000;\n}\n\nbody.light_theme .p2p-mobile-logo-text {\n  color: #000;\n}\n\nbody.light_theme .p2p-page-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-dashboard-container h2,\nbody.light_theme .p2p-dashboard-container h3,\nbody.light_theme .p2p-dashboard-container h4,\nbody.light_theme .p2p-dashboard-container .p2p-section-header,\nbody.light_theme .p2p-dashboard-container .p2p-orders-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-profile-funding,\nbody.light_theme .p2p-profile-funding-label,\nbody.light_theme .p2p-profile-funding-value {\n  color: #333;\n}\n\nbody.light_theme .p2p-sidebar {\n  background: #fff;\n  border-right: 1px solid #e5e5e5;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-sidebar-logo {\n  border-bottom: 1px solid #e5e5e5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-logo-text {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-logo-icon {\n  background: #f5f5f5;\n}\n*/\n\nbody.light_theme .p2p-nav-item {\n  color: #4E4E4E;\n}\n\nbody.light_theme .p2p-sidebar-close {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .p2p-sidebar-close:hover {\n  background: rgba(244, 182, 9, 0.1);\n}\n\nbody.light_theme .p2p-sidebar-footer {\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-back-link {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #4E4E4E;\n}\n\nbody.light_theme .p2p-back-link:hover {\n  background: #e5e5e5;\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n}\n\nbody.light_theme .p2p-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\nbody.light_theme h4.p2p-profile-tab {\n  color: #000;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-toggle-wrapper {\n  background: #f5f5f5;\n}\n*/\n\n/* body.light_theme .p2p-toggle-btn {\n    color: #555;\n  } */\n\nbody.light_theme .p2p-filter-label {\n  color: #555;\n}\n\n/* body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active) {\n    color: #333;\n    border: 1px solid #d0d0d0;\n    background-color: #f5f5f5;\n  }\n  \n  body.light_theme .p2p-dashboard-container button:not(.p2p-find-orders-btn):not(.p2p-buy-btn):not(.p2p-sell-btn):not(.p2p-myads-action-btn):not(.p2p-modal-btn):not(.p2p-page-btn.p2p-active):hover {\n    background-color: #e8e8e8;\n    border-color: #c0c0c0;\n    color: #000;\n  } */\n\nbody.light_theme .p2p-filter-select {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right;\n}\n\nbody.light_theme .p2p-filter-section.myadsfillter .p2p-filter-select {\n  background: #e2e2e2;\n  border: 1px solid #d5d5d5;\n}\n\nbody.light_theme .p2p-filter-select:focus {\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-find-orders-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-find-orders-btn:hover {\n  background: rgba(244, 182, 9, 0.1);\n  border-color: #F4B609;\n}\n\nbody.light_theme .p2p-orders-table-wrapper {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table thead {\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-orders-table th {\n  color: #333;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table tbody tr {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-orders-table tbody tr:hover {\n  background: rgba(244, 182, 9, 0.05);\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-advertiser-info h4 {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-advertiser-stats {\n  color: #555;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-rating-value {\n  color: #4E4E4E;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-price-value {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-limit-label {\n  color: #555;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-limit-value {\n  color: #000;\n}\n*/\n\nbody.light_theme .p2p-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n  color: #000;\n}\n\nbody.light_theme .p2p-pagination-wrapper {\n  background: #f5f5f5;\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-pagination-info {\n  color: #555;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-page-current {\n  color: #000;\n  background: rgba(244, 182, 9, 0.2);\n}\n*/\n\nbody.light_theme .p2p-page-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #333;\n}\n\nbody.light_theme .p2p-page-btn:hover {\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-page-btn.p2p-active {\n  background: #F4B609;\n  border-color: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-page-dots {\n  color: #555;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-order-action-btn {\n  color: #D1AA67;\n  border-color: rgba(184, 134, 11, 0.4);\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-order-action-btn:hover {\n  color: #9a7209;\n  background: rgba(244, 182, 9, 0.1);\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-order-action-text {\n  color: #555;\n}\n*/\n\nbody.light_theme .p2p-dashboard-container a:not(.p2p-nav-item) {\n  color: #D1AA67;\n}\n\nbody.light_theme .p2p-dashboard-container a:not(.p2p-nav-item):hover {\n  color: #9a7209;\n}\n\nbody.light_theme .p2p-empty-state-card {\n  color: #555;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-content {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-user-details h5 {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-user-details p {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-stat-value {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-stat-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-payments h6 {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-remarks h6 {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-remarks p {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-input-header {\n  border: 1px solid #e5e5e5;\n  background: #ececec;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-input-header label {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-selector-left {\n  color: #666;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-fee-breakdown-box {\n  background: rgb(236 236 236);\n  border: 1px solid #2a2a3a1a;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-fee-breakdown-row span:last-child {\n  color: #6f6f6f;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option-full {\n  background: rgb(213 213 213 / 50%);\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option-full:hover {\n  background-color: rgb(213 213 213 / 50%);\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-user-payment-header .p2p-payment-name {\n  color: #6e6e6e;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-field-label {\n  color: #646464;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-field-value {\n  color: #848484;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-input-wrapper {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-input-wrapper:focus-within {\n  border-color: #F4B609;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-input-wrapper input {\n  color: #000;\n  background: transparent;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-input-wrapper input::placeholder {\n  color: #999;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-expanded-input-error {\n  color: #dc3545;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-price-info {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-selector-full {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-selector-full:hover {\n  border-color: #F4B609;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-cancel-btn {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-cancel-btn:hover {\n  border-color: #F4B609;\n}\n*/\n\nbody.light_theme .p2p-mobile-order-card {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n}\n\nbody.light_theme .p2p-mobile-card-user-info h4 {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-card-user-info p {\n  color: #aaa;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-mobile-card-price .p2p-value {\n  color: #000;\n}\n*/\n\nbody.light_theme .p2p-mobile-card-price .p2p-currency {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-mobile-card-details {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-mobile-detail-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-mobile-detail-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-mobile-payment-badge {\n  background: rgba(244, 182, 9, 0.1);\n  color: #000;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-mobile-expanded-section {\n  border-top: 1px solid #e5e5e5;\n}\n*/\n\nbody.light_theme .p2p-modal-content {\n  background: #ffffffad;\n  border: 2px solid #F3F4F6;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-modal-title {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option:hover {\n  border-color: #F4B609;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option.p2p-selected {\n  background: rgba(244, 182, 9, 0.1);\n  border-color: #F4B609;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-option span {\n  color: #000;\n}\n*/\n\nbody.light_theme .p2p-dashboard-container {\n  color: #000;\n}\n\nbody.light_theme .p2p-profile-header {\n  background: #ececec;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-profile-name {\n  color: #000;\n}\n\nbody.light_theme .p2p-dashboard-container.p2p-profile-container {\n  background-color: #f0f0f0;\n}\n\nbody.light_theme .p2p-myads-stat-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-myads-stat-card-label {\n  color: #555;\n}\n\nbody.light_theme .p2p-myads-stat-card-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-profile-section-desc {\n  color: #555;\n}\n\nbody.light_theme .p2p-payment-methods-grid {\n  gap: 16px;\n}\n\nbody.light_theme .p2p-payment-method-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-payment-method-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-method-label {\n  color: #555;\n}\n\nbody.light_theme .p2p-payment-method-value {\n  color: #000;\n}\n\nbody.light_theme .p2p-empty-state-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #555;\n}\n\nbody.light_theme .p2p-add-payment-modal {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-add-payment-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-add-payment-modal-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-close-btn {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-modal-close-btn:hover {\n  background: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-type-item {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-type-item:hover {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.05);\n}\n\nbody.light_theme .p2p-payment-type-name {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-label {\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-input {\n  background: #f5f5f5 !important;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-form-input:focus {\n  border-color: #F4B609;\n  outline: none;\n}\n\nbody.light_theme .p2p-payment-file-label {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-payment-file-label:hover {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.05);\n}\n\nbody.light_theme .p2p-modal-btn.primary {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-btn.primary:hover {\n  background: #e5a608;\n}\n\nbody.light_theme .p2p-modal-btn.secondary {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .p2p-modal-btn.secondary:hover {\n  border-color: #F4B609;\n  background: #f5f5f5;\n}\n\nbody.light_theme .p2p-delete-modal {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n\nbody.light_theme .p2p-delete-modal-title {\n  color: #000;\n}\n\nbody.light_theme .p2p-delete-modal-desc {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-modal-btn.danger {\n  background: #dc3545;\n  color: #fff;\n}\n\nbody.light_theme .p2p-myads-action-btn {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .p2p-myads-action-btn:hover {\n  background: #e5a608;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-order-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-order-card-title {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-order-summary-item {\n  background: #f5f5f5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-summary-value {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-summary-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-detail-card {\n  background: #f5f5f5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-detail-header {\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-detail-value {\n  color: #000;\n}\n*/\n\nbody.light_theme .binance-modal {\n  background: #fff;\n}\n\nbody.light_theme .binance-modal-header {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-modal-header h3 {\n  color: #000;\n}\n\nbody.light_theme .modal-close-btn {\n  color: #aaa;\n}\n\nbody.light_theme .modal-close-btn:hover {\n  background: #f5f5f5;\n  color: #000;\n}\n\n/* [UNUSED]\nbody.light_theme .binance-order-info {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n}\n*/\n\nbody.light_theme .info-label {\n  color: #aaa;\n}\n\nbody.light_theme .info-value {\n  color: #000;\n}\n\nbody.light_theme .payment-row {\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .payment-row .label {\n  color: #aaa;\n}\n\nbody.light_theme .payment-row .value {\n  color: #000;\n}\n\n/* [UNUSED]\nbody.light_theme .binance-chat-container {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n}\n*/\n\nbody.light_theme .binance-chat-header {\n  background: #f5f5f5;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-chat-header h4 {\n  color: #000;\n}\n\n/* [UNUSED]\nbody.light_theme .binance-message {\n  background: #f5f5f5;\n  color: #000;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .binance-message.own {\n  background: rgba(244, 182, 9, 0.1);\n}\n*/\n\nbody.light_theme .binance-chat-input {\n  background: #ececec;\n  border-top: 1px solid #e5e5e5;\n}\n\nbody.light_theme .binance-chat-section.mobile-hidden .binance-chat-input input {\n  background: #f5f5f500;\n  border: 1px solid #e5e5e500;\n}\n\nbody.light_theme .binance-chat-input input {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .binance-chat-input input::placeholder {\n  color: #999;\n}\n\nbody.light_theme .binance-btn.primary {\n  background: #F4B609;\n  color: #000;\n}\n\nbody.light_theme .binance-btn.primary:hover {\n  background: #e5a608;\n}\n\nbody.light_theme .chat-username {\n  color: #636363;\n}\n\nbody.light_theme .system-bubble {\n  background: rgb(222 222 222);\n}\n\nbody.light_theme .cancel-warning {\n  background: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\nbody.light_theme .cancel-warning p {\n  color: #000;\n}\n\nbody.light_theme .cancel-warning span {\n  color: #aaa;\n}\n\nbody.light_theme .appeal-info {\n  background: rgba(244, 182, 9, 0.1);\n  border: 1px solid rgba(244, 182, 9, 0.2);\n}\n\nbody.light_theme .appeal-info p {\n  color: #000;\n}\n\nbody.light_theme .appeal-form label {\n  color: #000;\n}\n\nbody.light_theme .appeal-textarea {\n  background: #f5f5f5;\n  border: 1px solid #e5e5e5;\n  color: #000;\n}\n\nbody.light_theme .appeal-textarea::placeholder {\n  color: #999;\n}\n\nbody.light_theme .binance-tab {\n  color: #aaa;\n}\n\nbody.light_theme .binance-tab.active {\n  color: #F4B609;\n  border-bottom-color: #F4B609;\n}\n\nbody.light_theme .step-desc {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-loading-container {\n  color: #aaa;\n}\n\n/* P2P Create Post Styles */\n/* [UNUSED]\n.p2p-create-post-container {\n  display: grid;\n  grid-template-columns: 1fr 200px;\n  gap: 24px;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n*/\n\n@media (max-width: 1023px) {\n  /* [UNUSED]\n.p2p-create-post-container {\n    grid-template-columns: 1fr;\n  }\n*/\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-container {\n    gap: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-form-card {\n  background: #2B313C;\n  border-radius: 12px;\n  border: 1px solid #2B313C;\n  padding: 32px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  position: relative;\n  border-radius: 12px;\n  padding: 32px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  position: relative;\n}\n*/\n\n@media (max-width: 1023px) {\n  /* [UNUSED]\n.p2p-create-post-form-card {\n    padding: 24px;\n  }\n*/\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-form-card {\n    border-radius: 12px;\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-header {\n  margin-bottom: 32px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-header {\n    margin-bottom: 20px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 8px 0;\n}\n*/\n\n\n\n/* [UNUSED]\n.p2p-create-post-subtitle {\n  color: #949AA4;\n  font-size: 14px;\n  margin: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-subtitle {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin-bottom: 32px;\n  gap: 0;\n  width: 100%;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-stepper {\n    margin-bottom: 20px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-step-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 400;\n  background: transparent;\n  border: 1px solid #ffffff60;\n  color: #ffffff60;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-step-circle {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-step-circle.active {\n  background: #F3BB2B;\n  border-color: #F3BB2B;\n  color: #000;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-step-circle.completed {\n  background: #F3BB2B;\n  border-color: #F3BB2B;\n  color: #000;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-step-line {\n  width: 310px;\n  height: 1px;\n  background: #ffffff60;\n  transition: all 0.3s ease;\n}\n*/\n\n@media (max-width: 1023px) {\n  /* [UNUSED]\n.p2p-create-post-step-line {\n    width: 80px;\n  }\n*/\n}\n\n@media (max-width: 480px) {\n  /* [UNUSED]\n.p2p-create-post-step-line {\n    width: 60px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-step-line.completed {\n  background: #F3BB2B;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 20px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-section-title {\n    font-size: 14px;\n    margin-bottom: 16px;\n  }\n*/\n\n  .p2p-nav-item {\n    gap: 10px;\n    padding: 10px 12px 10px 20px;\n    font-size: 13px;\n  }\n\n\n\n  /* [UNUSED]\n.pricehigh_box_item_title {\n    font-size: 18px;\n  }\n*/\n\n  /* [UNUSED]\n.pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n*/\n\n}\n\n/* [UNUSED]\n.p2p-create-post-section-icon {\n  color: #ffdc88;\n}\n*/\n\n/* Buy/Sell tabs - Create Post */\n/* [UNUSED]\n.p2p-create-post-tabs-container {\n  display: flex;\n  gap: 0;\n  margin-bottom: 32px;\n  border-bottom: 1px solid #2a2a3a;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-tab-btn {\n  background: transparent;\n  border: none;\n  color: #888;\n  font-size: 16px;\n  font-weight: 400;\n  padding: 14px 20px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-tab-btn.active {\n  color: #fff;\n  font-weight: 500;\n  border-bottom: 2px solid #fff;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-tabs-container {\n    margin-bottom: 24px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-tab-btn {\n    font-size: 14px;\n    padding: 12px 16px;\n  }\n*/\n}\n\n/* Market price info box (USDT/INR block) - Create Post */\n/* [UNUSED]\n.p2p-create-post-info-box {\n  background: #373f4d;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-loading {\n  text-align: center;\n  padding: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-loading span {\n  color: #666;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-pair {\n  color: #9ca3af;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-row {\n  color: #6b7280;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-row:last-child {\n  margin-bottom: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-bullet {\n  margin-right: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-market-error {\n  color: #d97706;\n  font-size: 13px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-info-box {\n    padding: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-market-pair {\n    font-size: 13px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-market-row {\n    font-size: 12px;\n  }\n*/\n}\n\n/* Section spacing (steps) */\n/* [UNUSED]\n.p2p-create-post-section-spacing {\n  margin-top: 32px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-section-spacing {\n    margin-top: 24px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-field-error-with-margin {\n  margin-top: -12px;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-select-with-icon {\n  padding-left: 36px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-section-title-inline {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-section-icon-inline {\n  color: #F3BB2B;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-section-title-inline {\n    font-size: 14px;\n    margin-bottom: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-payment-required-error {\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  flex-shrink: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-checkbox {\n    width: 18px;\n    height: 18px;\n  }\n*/\n}\n\n/* Preview Card */\n/* [UNUSED]\n.p2p-preview-card {\n  background: #12121a;\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  position: sticky;\n  top: 20px;\n}\n*/\n\n@media (max-width: 991px) {\n  /* [UNUSED]\n.p2p-preview-card {\n    position: relative;\n    top: 0;\n  }\n*/\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card {\n    border-radius: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-header-buy {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-header-sell {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-header {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-header-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-ad-label {\n  color: #888;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-title {\n    font-size: 18px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-badge {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badge-buy {\n  color: #22c55e;\n  background: rgba(34, 197, 94, 0.2);\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badge-sell {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.2);\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-price-block {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  text-align: center;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-price-block {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-price-label {\n  color: #666;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-price-value {\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -1px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-price-value-buy {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-price-value-sell {\n  color: #ef4444;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-price-value {\n    font-size: 28px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-price-fiat {\n  font-size: 16px;\n  color: #888;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-market {\n  color: #666;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-details {\n  padding: 20px 24px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-details {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-grid-item {\n  background: #0d0d14;\n  padding: 12px;\n  border-radius: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-grid-label {\n  color: #666;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-grid-value {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-grid-value-muted {\n  color: #888;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-payment-time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-payment-time-label {\n  color: #666;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-payment-time-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-block {\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-section-label {\n  color: #666;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badges-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badge-pm {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-empty-pm {\n  color: #666;\n  font-size: 12px;\n  padding: 6px 12px;\n  background: #0d0d14;\n  border-radius: 6px;\n  border: 1px dashed #2a2a3a;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badge-kyc {\n  padding: 6px 12px;\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  border-radius: 6px;\n  color: #4ade80;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-badge-days {\n  padding: 6px 12px;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 6px;\n  color: #fbbf24;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-remarks {\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n  border-left: 3px solid #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-remarks-title {\n  color: #666;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-remarks-text {\n  color: #aaa;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #1e1e2d;\n  background: #0a0a0f;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-preview-card-footer {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-preview-card-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-footer-fee {\n  color: #666;\n  font-size: 11px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-card-footer-note {\n  color: #888;\n  font-size: 11px;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-preview-toggle {\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  border: 1px solid #2a2a3a;\n}\n*/\n\n@media (max-width: 991px) {\n  /* [UNUSED]\n.p2p-mobile-preview-toggle {\n    display: flex;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-mobile-preview-toggle-text {\n  color: #888;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-highlight-buy {\n  color: #22c55e;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-preview-highlight-sell {\n  color: #ef4444;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-mobile-preview-view {\n  color: #ffdc88;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-mobile-preview-wrap {\n  margin-bottom: 16px;\n}\n*/\n\n/* Sell modal (Add Payment Method) */\n/* [UNUSED]\n.p2p-sell-modal .modal-content {\n  background: #12121a;\n  border: 1px solid #2a2a3a;\n  border-radius: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal .modal-header {\n  border-bottom: 1px solid #2a2a3a;\n  padding: 20px 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal .modal-header .modal-title {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal .modal-body {\n  padding: 24px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-tips {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-tips-icon {\n  color: #f59e0b;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-tips-text {\n  color: #d4a574;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-label {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 8px;\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-spinner-wrap {\n  text-align: center;\n  padding: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-methods-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-sell-modal-methods-grid {\n    grid-template-columns: 1fr;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-sell-modal-method-card {\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-method-card:hover {\n  border-color: #ffdc88;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-method-card.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-method-name {\n  color: #fff;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-method-badge {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-back-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #2a2a3a;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-back-btn {\n  background: transparent;\n  border: none;\n  color: #888;\n  cursor: pointer;\n  padding: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-back-title {\n  color: #ffdc88;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-kyc-warning {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  color: #d4a574;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-input-wrap {\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-input.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-input-bg {\n  width: 100%;\n  padding: 12px 16px;\n  background: #1a1a2e;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-small {\n  color: #666;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-zone {\n  border: 2px dashed #2a2a3a;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-zone.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-zone.disabled .p2p-sell-modal-file-input {\n  cursor: not-allowed;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-preview {\n  max-width: 100px;\n  max-height: 100px;\n  border-radius: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-placeholder-icon {\n  color: #666;\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-file-placeholder-text {\n  color: #888;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-warning-box {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-top: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-warning-text {\n  color: #f87171;\n  font-size: 12px;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-label-optional {\n  color: #666;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-label-required {\n  color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-btn-cancel {\n  flex: 1;\n  padding: 12px 20px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-btn-confirm {\n  flex: 1;\n  padding: 12px 20px;\n  background: #ffdc88;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-btn-confirm:disabled,\n.p2p-sell-modal-btn-confirm.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n*/\n\n/* [UNUSED]\n.p2p-sell-modal-spinner-lg {\n  text-align: center;\n  padding: 40px;\n}\n*/\n\n/* [UNUSED]\n.p2p-buyer-modal-desc {\n  color: #888;\n  margin-bottom: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-buyer-modal-spinner-wrap {\n  text-align: center;\n  padding: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-confirm-post-fee {\n  color: #F3BB2B;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input-group {\n  margin-bottom: 10px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-input-group {\n    margin-bottom: 10px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-label {\n  display: block;\n  color: #A2A9B6;\n  font-size: 13px;\n  margin-bottom: 5px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-label {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-select-wrap {\n  position: relative;\n  width: 100%;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-select-wrap .p2p-create-post-select-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-select-wrap .p2p-create-post-select-icon img {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-select-wrap .p2p-create-post-select-icon-fiat {\n  font-size: 16px;\n  font-weight: 600;\n  color: #F3BB2B;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-select {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 12px 44px 12px 36px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  color: #A2A9B6;\n  font-size: 13px;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23888' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 12px 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-select {\n    padding: 12px 40px 12px 14px;\n    font-size: 13px;\n    background-position: right 12px center;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-select.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input {\n  width: 100%;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-input {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-input.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input-with-suffix {\n  display: flex;\n  align-items: center;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input-with-suffix.error {\n  border: 1px solid #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input-inner {\n  flex: 1;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  min-width: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-input-inner {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.pricehigh_box {\n  width: 100%;\n  background-color: #373D4B;\n  padding: 24px;\n  border-radius: 12px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  justify-content: space-between;\n}\n*/\n\n/* [UNUSED]\n.pricehigh_box_item_title {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 24px;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.pricehigh_box_item_container {\n  gap: 90px;\n}\n*/\n\n/* [UNUSED]\n.helpguide {\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.helpguide i {\n  font-size: 16px;\n}\n*/\n\n/* [UNUSED]\n.btnnextback {\n  margin-top: 24px;\n  gap: 24px;\n}\n*/\n\n/* [UNUSED]\n.btnnextback button {\n  font-size: 16px;\n  color: #fff;\n  padding: 16px 20px;\n  width: 100%;\n  border-radius: 4px;\n  border: none;\n  background-color: #3C424C;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.btnnextback button.nextbtn {\n  background-color: #5EBA89;\n}\n*/\n\n/* [UNUSED]\n.btnnextback button.backbtn {\n  width: 40%;\n}\n*/\n\n/* [UNUSED]\n.pricehigh_box_item_title span {\n  font-size: 12px;\n  font-weight: 300;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-input-suffix {\n  padding: 14px 16px;\n  color: #b9b9b9;\n  font-size: 14px;\n  border-left: 1px solid #585858;\n  white-space: nowrap;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-input-suffix {\n    padding: 12px 10px;\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-available-text {\n  color: #22c55e;\n  font-size: 12px;\n  margin-left: 8px;\n  margin-right: 8px;\n  display: inline;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-tab-btn:hover {\n  background-color: transparent;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-tab-btn.active {\n  color: #5a5a5a;\n  border-bottom: 2px solid #676464;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-available-text {\n    font-size: 10px;\n    display: none;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-fee-box {\n  background: linear-gradient(90deg, rgba(34, 197, 94, 0.1) 0%, transparent 100%);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  border-radius: 10px;\n  padding: 12px 16px;\n  color: #22c55e;\n  font-size: 14px;\n  margin-top: 20px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-fee-box {\n    padding: 10px 14px;\n    font-size: 13px;\n    margin-top: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-info-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 16px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-info-box {\n    padding: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-pair-text {\n  color: #f59e0b;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-pair-text {\n    font-size: 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-info-text {\n  color: #a8b4c4;\n  font-size: 13px;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-info-text {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-payment-method {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-payment-method {\n    padding: 12px 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-payment-method.active {\n  border-color: #ffdc88;\n  background: rgba(255, 220, 136, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-payment-method.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: #ffdc88;\n  flex-shrink: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-checkbox {\n    width: 18px;\n    height: 18px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-add-method-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #ffdc88;\n  background: transparent;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 8px 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-add-method-btn {\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-textarea {\n  width: 100%;\n  padding: 14px 16px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  min-height: 100px;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-textarea {\n    padding: 12px 14px;\n    font-size: 13px;\n    min-height: 80px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  color: #ccc;\n  font-size: 14px;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-checkbox-label {\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 32px;\n  flex-direction: row;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-button-group {\n    margin-top: 24px;\n    flex-direction: column-reverse;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-btn-primary {\n  flex: 1;\n  padding: 14px 24px;\n  background: #22c55e;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: auto;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-btn-primary {\n    flex: unset;\n    padding: 14px 20px;\n    font-size: 14px;\n    width: 100%;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-btn-secondary {\n  padding: 14px 24px;\n  background: transparent;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: auto;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-btn-secondary {\n    padding: 14px 20px;\n    font-size: 14px;\n    width: 100%;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-card {\n  background: #12121a;\n  border-radius: 16px;\n  border: 1px solid #1e1e2d;\n  position: sticky;\n  top: 20px;\n}\n*/\n\n@media (max-width: 1023px) {\n  /* [UNUSED]\n.p2p-create-post-preview-card {\n    position: relative;\n    top: 0;\n  }\n*/\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-card {\n    border-radius: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-header {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-title {\n  font-size: 16px;\n  color: #888;\n  margin: 0;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-title {\n    font-size: 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-highlight {\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-highlight.buy {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-highlight.sell {\n  color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-body {\n  padding: 24px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-body {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-row {\n    margin-bottom: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-label {\n  color: #aaa;\n  font-size: 14px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-label {\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: right;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-value {\n    font-size: 13px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  color: #a8b4c4;\n  font-size: 12px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-badge {\n    padding: 4px 10px;\n    font-size: 11px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #1e1e2d;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-remarks {\n    margin-top: 16px;\n    padding-top: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks-title {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-remarks-title {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.pricehigh_box_item_container {\n    gap: 24px;\n  }\n*/\n\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks-text {\n  color: #ccc;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-remarks-text {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-agreement-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 16px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  transition: all 0.2s ease;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-agreement-box {\n    padding: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-agreement-box.error {\n  background: rgba(239, 68, 68, 0.05);\n  border: 1px solid #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-helper-text {\n  color: #949AA4;\n  font-size: 12px;\n  margin-top: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-total-box {\n  margin-top: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-total-box .p2p-create-post-helper-text {\n  margin-top: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-box {\n  margin-top: 12px;\n  background: rgba(42, 42, 58, 0.5);\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  padding: 12px 14px;\n  max-width: 320px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  color: #949AA4;\n  padding: 4px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-row span:last-child {\n  color: #fff;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-total {\n  margin-top: 6px;\n  padding-top: 8px;\n  border-top: 1px solid #2a2a3a;\n  color: #F3BB2B;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-total span:last-child {\n  color: #F3BB2B;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-fee-breakdown-box .p2p-create-post-insufficient-funds {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(239, 68, 68, 0.3);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-total-required {\n  color: #F3BB2B;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-insufficient-funds {\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-fee-breakdown-box {\n    padding: 10px 12px;\n    margin-top: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-fee-breakdown-row {\n    font-size: 11px;\n  }\n*/\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-helper-text {\n    font-size: 11px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-mobile-preview-toggle {\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #0d0d14;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  border: 1px solid #2a2a3a;\n}\n*/\n\n@media (max-width: 1023px) {\n  /* [UNUSED]\n.p2p-create-post-mobile-preview-toggle {\n    display: flex;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-grid-two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-grid-two-col {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-payment-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-payment-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-field-error {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-field-error {\n    font-size: 11px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-header-gradient {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-header-gradient {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-header-gradient.buy {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-header-gradient.sell {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.05) 100%);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-price-section {\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n  text-align: center;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-price-section {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-price-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-price-value {\n  font-size: 32px;\n  font-weight: 700;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-price-value {\n    font-size: 28px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-price-value.buy {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-price-value.sell {\n  color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-price-currency {\n  font-size: 16px;\n  color: #888;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-market-price {\n  color: #aaa;\n  font-size: 11px;\n  margin-top: 4px;\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 20px 24px;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-stats-grid {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-stat-box {\n  background: #0d0d14;\n  padding: 12px;\n  border-radius: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-stat-label {\n  color: #aaa;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-stat-value {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-stat-value {\n    font-size: 15px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-stat-currency {\n  color: #888;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #1e1e2d;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-payment-time {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-time-label {\n  color: #aaa;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-time-value {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-methods {\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-methods-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-methods-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-method-badge {\n  padding: 6px 12px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.3);\n  border-radius: 6px;\n  color: #a8b4c4;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-payment-methods-empty {\n  color: #aaa;\n  font-size: 12px;\n  padding: 6px 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-counterparty-label {\n  color: #aaa;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-counterparty-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-counterparty-badge {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-counterparty-badge.kyc {\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-counterparty-badge.registered {\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  color: #f59e0b;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks-box {\n  padding: 12px;\n  background: #0d0d14;\n  border-radius: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks-label {\n  color: #aaa;\n  font-size: 11px;\n  display: block;\n  margin-bottom: 6px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-remarks-content {\n  color: #aaa;\n  font-size: 13px;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #1e1e2d;\n  background: #0a0a0f;\n}\n*/\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-preview-footer {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-preview-footer-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-footer-fee {\n  color: #aaa;\n  font-size: 11px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-preview-footer-available {\n  color: #888;\n  font-size: 11px;\n}\n*/\n\n/* Radio Button Styles */\n/* [UNUSED]\n.p2p-radio-group {\n  margin-top: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 5px solid #aaa;\n  border-radius: 50%;\n  margin: 0;\n  margin-right: 12px;\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-input:checked {\n  border-color: #D9D9D9;\n  background-color: transparent;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #222;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-input:hover {\n  border-color: #999;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-input:checked:hover {\n  border-color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-radio-text {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n*/\n\n/* Light Theme Radio Button */\n/* [UNUSED]\nbody.light_theme .p2p-radio-input {\n  border-color: #ccc;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-radio-input:checked {\n  border-color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-radio-input:checked::after {\n  background-color: #f5f5f5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-radio-input:hover {\n  border-color: #999;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-radio-input:checked:hover {\n  border-color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-radio-text {\n  color: #333;\n}\n*/\n\n/* Payment Method Styles */\n/* [UNUSED]\n.p2p-payment-methods-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n*/\n\n.p2p-payment-method-card {\n  background: #373f4d;\n  border: 1px solid #373f4d;\n  border-radius: 10px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n@media (min-width: 768px) {\n  .p2p-payment-method-card {\n    padding: 16px;\n  }\n}\n\n.p2p-payment-method-card.selected {\n  border-color: #ffdc88;\n  background: rgba(255, 220, 136, 0.1);\n}\n\n.p2p-payment-method-card.error {\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.p2p-payment-method-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n/* [UNUSED]\n.p2p-payment-method-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-name {\n  color: #ffdc88;\n  font-size: 14px;\n  font-weight: 600;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-name {\n    font-size: 15px;\n  }\n*/\n}\n\n.p2p-payment-method-type-badge {\n  color: #aaa;\n  font-size: 11px;\n  background: #373f4d;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* [UNUSED]\n.p2p-payment-method-fields-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-fields-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n*/\n}\n\n.p2p-payment-method-field {\n  font-size: 12px;\n}\n\n/* [UNUSED]\n.p2p-payment-method-field-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-field-value {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-qr-section {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #2a2a3a40;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-qr-image {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #fff;\n  padding: 4px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-qr-image {\n    width: 80px;\n    height: 80px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-payment-method-qr-label {\n  color: #aaa;\n  font-size: 11px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-methods-empty {\n  color: #888;\n  font-size: 13px;\n  padding: 20px;\n  text-align: center;\n  background: #373f4d;\n  border-radius: 10px;\n  border: 1px solid #373f4d;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-methods-empty.error {\n  border-color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin-bottom: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-item {\n    padding: 14px 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-payment-method-item.selected {\n  border-color: #FFFFFF60;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-item.error {\n  border-color: rgba(239, 68, 68, 0.5);\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-item-text {\n  color: #fff;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-item input[type=\"checkbox\"] {\n  display: none;\n  accent-color: #303234 !important;\n}\n*/\n\n/* [UNUSED]\n.p2p-payment-method-item.selected input[type=\"checkbox\"] {\n  display: block;\n}\n*/\n\n/* [UNUSED]\n.p2p-add-method-button {\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-add-method-button:hover {\n  background-color: transparent;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-item-text {\n    font-size: 14px;\n    color: #A2A9B6;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-payment-method-error {\n  color: #ef4444;\n  font-size: 11px;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-payment-method-error {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-add-method-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 300;\n  color: #fff;\n  background: transparent;\n  border: none;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 8px 0;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-add-method-button {\n    font-size: 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-add-method-button-icon {\n  font-size: 18px;\n}\n*/\n\n/* Light Theme Payment Method Styles */\nbody.light_theme .p2p-payment-method-card {\n  background: #ececec;\n  border-color: #E0E0E0;\n}\n\nbody.light_theme .p2p-payment-method-btn.delete {\n  color: #ae4e4e;\n}\n\nbody.light_theme button.p2p-profile-edit-btn:hover {\n  background-color: transparent;\n  color: #9b9b9b;\n  ;\n}\n\nbody.light_theme .p2p-payment-method-card.selected {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.1);\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-name {\n  color: #F4B609;\n}\n*/\n\nbody.light_theme .p2p-payment-method-type-badge {\n  color: #aaa;\n  background: #E8E8E8;\n}\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-field-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-field-value {\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-qr-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-methods-empty {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-item {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-item.selected {\n  border-color: #F4B609;\n  background: rgba(244, 182, 9, 0.1);\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-payment-method-item-text {\n  color: #333;\n}\n*/\n\n/* Step 3 Styles */\n/* [UNUSED]\n.p2p-create-post-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 16px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-section-title {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-section-icon {\n  color: #F3BB2B;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  background: #373F4D;\n  border: 1px solid #ffffff40;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 13px;\n  outline: none;\n  min-height: 80px;\n  resize: vertical;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  font-family: inherit;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-textarea {\n    padding: 14px 16px;\n    font-size: 14px;\n    min-height: 130px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-step3-section {\n  margin-top: 24px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-step3-section {\n    margin-top: 32px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #ccc;\n  font-size: 13px;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-checkbox-label {\n    font-size: 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-checkbox-label-wrap {\n  flex-wrap: wrap;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-checkbox-label-no-margin {\n  margin-bottom: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #f3bb2b;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-checkbox {\n    width: 20px;\n    height: 20px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-registered-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 0;\n  margin-top: 8px;\n  width: 100%;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-registered-input-wrapper {\n    margin-left: 8px;\n    margin-top: 0;\n    width: auto;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-registered-input {\n  width: 80px;\n  padding: 8px 12px;\n  background: #373F4D;\n  border: 1px solid #373F4D;\n  border-radius: 10px;\n  color: #a1a1a1;\n  text-align: center;\n  font-size: 13px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-registered-input.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-registered-label {\n  color: #D0D0D0;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-input {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #D9D9D9;\n  background-color: #000 !important;\n  border-radius: 50%;\n  margin: 0;\n  margin-right: 12px;\n  position: relative;\n  cursor: pointer;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-input:checked {\n  border-color: #fff;\n  background-color: transparent !important;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-step3-section .p2p-create-post-radio-group {\n  flex-direction: row;\n  gap: 48px;\n}\n*/\n\n/* [UNUSED]\n.p2p-layout-wrapper .p2p-create-post-radio-input:focus {\n  border: 5px solid #ffffff !important;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop .modal-content {\n  background-color: #373E4B;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi li {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  position: relative;\n  font-weight: 300;\n  font-size: 13px;\n  color: #ffffff9e;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi li span {\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi li span.text-danger {\n  color: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi li span.text-success {\n  color: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop.btnnextback button {\n  background-color: #474D59;\n}\n*/\n\n/* [UNUSED]\n.userprofile_pop ul.list_upi li::before {\n  position: absolute;\n  left: -15px;\n  top: 0px;\n  content: \"\";\n  width: 10px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-input:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #222;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-input:hover {\n  border-color: #999;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-input:checked:hover {\n  border-color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-radio-text {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-agreement-box {\n  background: #0d0d14;\n  border-radius: 10px;\n  padding: 12px;\n  margin-top: 16px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-agreement-box {\n    padding: 16px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-agreement-text {\n  font-size: 12px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-agreement-text {\n    font-size: 14px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-field-error {\n  color: #ef4444;\n  font-size: 11px;\n  margin-top: 4px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-field-error {\n    font-size: 12px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-field-error-agreement {\n  margin-top: -12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n*/\n\n@media (min-width: 768px) {\n  /* [UNUSED]\n.p2p-create-post-button-group {\n    margin-top: 32px;\n  }\n*/\n}\n\n/* [UNUSED]\n.p2p-create-post-btn-secondary {\n  flex: 1;\n  padding: 12px 20px;\n  background: #0d0d14;\n  border: 1px solid #2a2a3a;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-secondary:hover {\n  background: #1a1a2a;\n  border-color: #3a3a4a;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary {\n  flex: 1;\n  padding: 12px 20px;\n  background: #22c55e;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary:hover {\n  background: #20b855;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary-sell {\n  background: #ef4444;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary-sell:hover {\n  background: #dc2626;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary-buy {\n  background: #22c55e;\n}\n*/\n\n/* [UNUSED]\n.p2p-create-post-btn-primary-buy:hover {\n  background: #20b855;\n}\n*/\n\n/* Light Theme Step 3 Styles */\n/* [UNUSED]\nbody.light_theme .p2p-create-post-section-title {\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-section-icon {\n  color: #F4B609;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-textarea {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-checkbox-label {\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-registered-input {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-registered-label {\n  color: #aaa;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-radio-input {\n  border-color: #ccc;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-radio-input:checked {\n  border-color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-radio-input:checked::after {\n  background-color: #f5f5f5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-radio-text {\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-agreement-box {\n  background: #f5f5f5;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-btn-secondary {\n  background: #f5f5f5;\n  border-color: #E0E0E0;\n  color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.light_theme .p2p-create-post-btn-secondary:hover {\n  background: #E8E8E8;\n}\n*/\n\n/* P2P My Ads Table Styles */\n.p2p-orders-table td {\n  padding: 12px 10px;\n}\n\n.p2p-orders-table td.p2p-myads-actions-cell {\n  text-align: right;\n}\n\n.p2p-row-expanded {\n  background: rgba(255, 220, 136, 0.03) !important;\n}\n\n.p2p-myads-asset-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-myads-side-badge {\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.p2p-myads-asset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-asset-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-table-cell-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-myads-table-cell-content-gap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-myads-price-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e5e5;\n}\n\n.p2p-myads-volume-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-limits-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-payment-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.p2p-payment-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  background: rgba(255, 220, 136, 0.1);\n  border: 1px solid rgba(255, 220, 136, 0.2);\n}\n\n.p2p-payment-badge-count {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  background: #5EBA8920;\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.2);\n}\n\n.p2p-myads-status-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.p2p-myads-status {\n  font-size: 13px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  display: inline-block;\n}\n\n.p2p-myads-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.p2p-myads-action-btn {\n  padding: 3px 12px;\n  min-height: 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  color: #a1a1aa;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.p2p-myads-action-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.p2p-myads-action-btn-view {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.p2p-myads-action-btn-view.active {\n  background: rgba(255, 220, 136, 0.2);\n}\n\n.p2p-myads-action-btn-view:hover {\n  background: rgba(255, 220, 136, 0.15);\n  border-color: rgba(255, 220, 136, 0.3);\n  color: #e5e5e5;\n}\n\n.p2p-myads-action-btn-view.active:hover {\n  background: rgba(255, 220, 136, 0.2);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.p2p-myads-action-btn-close {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.p2p-myads-action-btn-close:hover {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.p2p-myads-action-btn-icon {\n  font-size: 14px;\n}\n\n.p2p-myads-action-btn-icon-online {\n  color: #4ade80;\n}\n\n/* Expanded Row Styles */\n.p2p-myads-expanded-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.p2p-myads-expanded-section {\n  margin-bottom: 20px;\n}\n\n.p2p-myads-expanded-title {\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-expanded-title-count {\n  font-size: 12px;\n  color: #6b7280;\n  margin-left: 6px;\n  font-weight: 400;\n}\n\n.p2p-myads-expanded-content-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-myads-expanded-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n}\n\n.p2p-myads-expanded-item-label {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.p2p-myads-expanded-item-value {\n  font-size: 14px;\n  color: #e5e5e5;\n  font-weight: 500;\n}\n\n.p2p-myads-expanded-item-value-small {\n  font-size: 12px;\n  color: #e5e5e5;\n  font-family: monospace;\n}\n\n.p2p-myads-fee-value {\n  color: #F3BB2B;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n/* [UNUSED]\n.p2p-orders-fee-value {\n  color: #F3BB2B;\n  font-weight: 500;\n  font-size: 12px;\n}\n*/\n\n.p2p-myads-expanded-payments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.p2p-payment-badge-expanded {\n  font-size: 12px;\n  padding: 6px 10px;\n}\n\n.p2p-myads-expanded-section-border {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.p2p-myads-expanded-title-large {\n  margin-bottom: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e5e5;\n}\n\n.p2p-myads-online-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.p2p-myads-online-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.p2p-myads-online-badge.online .p2p-myads-online-dot {\n  background: #4ade80;\n}\n\n.p2p-myads-online-badge.offline .p2p-myads-online-dot {\n  background: #6b7280;\n}\n\n/* Light Theme Table Styles */\nbody.light_theme .p2p-myads-asset-name {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-price-text,\nbody.light_theme .p2p-myads-volume-text,\nbody.light_theme .p2p-myads-limits-text {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-status {\n  background: rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .p2p-myads-action-btn {\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.1);\n  color: #aaa;\n}\n\nbody.light_theme .p2p-myads-action-btn:hover {\n  background: rgba(0, 0, 0, 0.08);\n  border-color: rgba(0, 0, 0, 0.15);\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-action-btn-view.active {\n  background: rgba(244, 182, 9, 0.2);\n}\n\nbody.light_theme .p2p-myads-action-btn-view:hover {\n  background: rgba(244, 182, 9, 0.15);\n  border-color: rgba(244, 182, 9, 0.3);\n}\n\nbody.light_theme .p2p-myads-expanded-title {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-item {\n  background: rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .p2p-myads-expanded-item-label {\n  color: #aaa;\n}\n\nbody.light_theme .p2p-myads-expanded-item-value {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-item-value-small {\n  color: #333;\n}\n\nbody.light_theme .p2p-myads-expanded-section-border {\n  border-top-color: rgba(0, 0, 0, 0.1);\n}\n\nbody.light_theme .p2p-row-expanded {\n  background: rgba(244, 182, 9, 0.03) !important;\n}\n\n@media (max-width: 1200px) {\n\n  /* [UNUSED]\n.p2p-create-post-container {\n    grid-template-columns: 1fr 80px;\n  }\n*/\n\n  .p2p-myads-stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  }\n\n\n}\n\n\n@media (max-width:767px) {\n\n  /* [UNUSED]\n.payment_method_pop.modal.fade .modal-dialog {\n    min-width: 100%;\n  }\n*/\n\n  /* [UNUSED]\n.userprofile_pop ul.list_upi li {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.userprofile_pop ul.list_upi {\n    gap: 10px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-container {\n    grid-template-columns: 1fr 0px;\n    gap: 0px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-payment-method-item {\n    margin-bottom: 5px;\n    padding: 8px 12px;\n  }\n*/\n\n  /* [UNUSED]\n.pricehigh_box_item_title {\n    font-size: 18px;\n  }\n*/\n\n  /* [UNUSED]\n.pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n*/\n\n\n  /* [UNUSED]\n.btnnextback button {\n    font-size: 13px;\n    padding: 10px 15px;\n  }\n*/\n\n  .p2p-profile-container .p2p-profile-header {\n    padding: 20px;\n  }\n\n  .p2p-profile-tabs.paymentprofiletabs {\n    padding: 0px 15px 20px;\n  }\n\n  .rightalien {\n    text-align: center;\n  }\n\n  .p2p-profile-container .p2p-empty-state-card i {\n    font-size: 26px;\n  }\n\n  .p2p-profile-name {\n    font-size: 18px;\n  }\n\n  .p2p-myads-stat-card {\n    border-right: none;\n    padding: 10px 5px;\n  }\n\n  .p2p-empty-state-mobile {\n    margin: 0px;\n  }\n\n  .p2p-empty-state-mobile .p2p-create-ad-btn-small {\n    padding: 10px 24px;\n    font-size: 12px;\n    margin: 0 auto;\n  }\n\n  .p2p-filter-section.myadsfillter {\n    background: #3f4856;\n    padding: 20px;\n  }\n\n}\n\n@media (max-width: 767px) {\n  /* [UNUSED]\n.p2p-create-post-title {\n    font-size: 18px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-radio-text {\n    font-size: 12px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-create-post-radio-input {\n    width: 16px;\n    height: 16px;\n  }\n*/\n\n}\n\n\n@media (max-width: 660px) {\n\n  /* [UNUSED]\n.pricehigh_box_item_title {\n    font-size: 18px;\n  }\n*/\n\n  /* [UNUSED]\n.pricehigh_box_item_title span {\n    font-size: 10px;\n  }\n*/\n\n  .p2p-myads-stat-card-value {\n    font-size: 13px;\n  }\n\n  .p2p-profile-container .p2p-myads-stats-grid {\n    gap: 10px;\n    padding: 10px 15px;\n  }\n\n  .p2p-profile-container .p2p-myads-stat-card-label {\n    font-size: 11px;\n    text-align: left;\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n  }\n\n  .p2p-myads-stat-card-value {\n    font-size: 11px;\n  }\n\n\n  /* [UNUSED]\n.pricehigh_box {\n    padding: 15px;\n    margin-top: 15px;\n    align-items: start;\n    gap: 12px;\n    flex-direction: column;\n  }\n*/\n}\n\n\n/* ==================== 1. HERO SECTION ==================== */\n.p2p-hero-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(136deg, rgb(240 249 255 / 75%) 0%, rgba(255, 255, 255, 1) 52%, rgb(239 246 255 / 77%) 100%);\n  padding: 40px 90px;\n  border-radius: 16px;\n  margin-bottom: 30px;\n  min-height: 350px;\n}\n\nbody.dark_theme .p2p-hero-section,\nbody[data-theme=\"dark\"] .p2p-hero-section,\nhtml[data-theme=\"dark\"] .p2p-hero-section {\n  background: linear-gradient(135deg, #1e2329 0%, #181a20 100%);\n  border: 1px solid #2b313a;\n}\n\n.p2p-hero-content {\n  max-width: 50%;\n}\n\n.p2p-hero-title {\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 16px;\n}\n\n.p2p-hero-title-dark {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-hero-title-dark,\nbody[data-theme=\"dark\"] .p2p-hero-title-dark,\nhtml[data-theme=\"dark\"] .p2p-hero-title-dark {\n  color: #ffffff;\n}\n\n.p2p-hero-title-gold {\n  color: #D1AA67;\n}\n\n.p2p-hero-desc {\n  font-size: 18px;\n  line-height: 140%;\n  color: #6B7280;\n  margin-bottom: 24px;\n}\n\nbody.dark_theme .p2p-hero-desc,\nbody[data-theme=\"dark\"] .p2p-hero-desc,\nhtml[data-theme=\"dark\"] .p2p-hero-desc {\n  color: #848e9c;\n}\n\n.p2p-hero-actions {\n  display: flex;\n  gap: 16px;\n}\n\n.p2p-hero-btn {\n  padding: 16px 32px;\n  min-width: 210px;\n  border-radius: 50px;\n  font-size: 16px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.p2p-hero-buy-btn {\n  background-color: #1a1a1a;\n  color: #ffffff;\n}\n\nbody.dark_theme .p2p-hero-buy-btn,\nbody[data-theme=\"dark\"] .p2p-hero-buy-btn,\nhtml[data-theme=\"dark\"] .p2p-hero-buy-btn {\n  background-color: #d1aa67;\n}\n\n.p2p-hero-sell-btn {\n  background-color: #e5e7eb;\n  color: #4b5563;\n}\n\nbody.dark_theme .p2p-hero-sell-btn,\nbody[data-theme=\"dark\"] .p2p-hero-sell-btn,\nhtml[data-theme=\"dark\"] .p2p-hero-sell-btn {\n  background-color: #2b313a;\n  color: #eaecef;\n}\n\n.p2p-hero-image img {\n  object-fit: contain;\n}\n\n.p2p-hero-image {\n  max-width: 320px;\n}\n\n/* ==================== 2. MAIN TRADING CARD & TABS ==================== */\n.p2p-trading-card {\n  background-color: transparent;\n  margin-bottom: 30px;\n}\n\nbody.dark_theme .p2p-trading-card,\nbody[data-theme=\"dark\"] .p2p-trading-card,\nhtml[data-theme=\"dark\"] .p2p-trading-card {\n  background-color: transparent;\n}\n\n.p2p-tabs-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #E4E4E4;\n  border-radius: 16px 16px 0px 0px;\n  padding: 24px 32px;\n  margin-bottom: 4px;\n  background-color: #F9F9F9;\n}\n\nbutton.p2p-switch-btn.sellbtn {\n  color: #EC6072;\n}\n\nbutton.p2p-switch-btn.sellbtn.active-sell {\n  color: #fff;\n}\n\nbutton.p2p-switch-btn.buybtn {\n  color: #2BC287;\n}\n\nbody.dark_theme .p2p-tabs-bar,\nbody[data-theme=\"dark\"] .p2p-tabs-bar,\nhtml[data-theme=\"dark\"] .p2p-tabs-bar {\n  background-color: #1e2026;\n  border-color: #2b313a;\n}\n\n.p2p-token-tabs {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n}\n\n.p2p-token-tab {\n  background: none;\n  border: none;\n  font-size: 18px;\n  position: relative;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n  color: #5F5F5F;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-token-tab:hover,\nbody[data-theme=\"dark\"] .p2p-token-tab:hover,\nhtml[data-theme=\"dark\"] .p2p-token-tab:hover {\n  color: #ffffff;\n}\n\n.p2p-token-tab.active {\n  color: #D1AA67;\n}\n\n.p2p-token-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -46px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #D1AA67;\n}\n\n.p2p-token-more-btn {\n  background: none;\n  border: none;\n  color: #6b7280;\n  font-size: 14px;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-token-more-btn,\nbody[data-theme=\"dark\"] .p2p-token-more-btn,\nhtml[data-theme=\"dark\"] .p2p-token-more-btn {\n  color: #848e9c;\n}\n\n.p2p-buysell-switch {\n  display: flex;\n  background-color: #ffffff;\n  border-radius: 30px;\n  padding: 4px;\n  border: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-buysell-switch,\nbody[data-theme=\"dark\"] .p2p-buysell-switch,\nhtml[data-theme=\"dark\"] .p2p-buysell-switch {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-switch-btn {\n  padding: 14px 48px;\n  border-radius: 50px;\n  font-size: 15px;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\nbody.dark_theme .p2p-switch-btn,\nbody[data-theme=\"dark\"] .p2p-switch-btn,\nhtml[data-theme=\"dark\"] .p2p-switch-btn {\n  color: #848e9c;\n}\n\nbutton.p2p-switch-btn.buybtn.active-buy {\n  color: #fff;\n}\n\nbody button.p2p-switch-btn.active-buy {\n  background-color: #2BC287;\n  color: #ffffff;\n  box-shadow: inset 2px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.p2p-switch-btn.active-sell {\n  background-color: #EC6072;\n  color: #ffffff;\n  box-shadow: inset 2px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n/* ==================== 3. FILTER CONTROLS BAR ==================== */\n.p2p-filter-bar {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  margin-bottom: 24px;\n  border: 1px solid #e5e7eb;\n  border-radius: 0px 0px 16px 16px;\n  padding: 24px;\n  background-color: #F9F9F9;\n}\n\nbody.dark_theme .p2p-filter-bar,\nbody[data-theme=\"dark\"] .p2p-filter-bar,\nhtml[data-theme=\"dark\"] .p2p-filter-bar {\n  background-color: #1e2026;\n  border-color: #2b313a;\n}\n\n.p2p-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.p2p-filter-group label {\n  font-size: 18px;\n  color: #5F5F5F;\n}\n\nbody.dark_theme .p2p-filter-group label,\nbody[data-theme=\"dark\"] .p2p-filter-group label,\nhtml[data-theme=\"dark\"] .p2p-filter-group label {\n  color: #848e9c;\n}\n\n.p2p-amount-input-wrap {\n  display: flex;\n  background-color: #F0F0F0;\n  min-height: 48px;\n  border: 1px solid #e5e7eb;\n  border-radius: 50px;\n  padding: 8px 16px;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbody.dark_theme .p2p-amount-input-wrap,\nbody[data-theme=\"dark\"] .p2p-amount-input-wrap,\nhtml[data-theme=\"dark\"] .p2p-amount-input-wrap {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-amount-input-wrap input {\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  color: #5F5F5F;\n  font-size: 15px;\n}\n\nbody.dark_theme .p2p-amount-input-wrap input,\nbody[data-theme=\"dark\"] .p2p-amount-input-wrap input,\nhtml[data-theme=\"dark\"] .p2p-amount-input-wrap input {\n  color: #ffffff;\n}\n\nbody.dark_theme .p2p-amount-input-wrap input::placeholder,\nbody[data-theme=\"dark\"] .p2p-amount-input-wrap input::placeholder,\nhtml[data-theme=\"dark\"] .p2p-amount-input-wrap input::placeholder {\n  color: #5f6672;\n}\n\n.p2p-custom-select-container {\n  position: relative;\n  display: inline-block;\n  width: 140px;\n}\n\n.p2p-custom-select-container.full-width-dropdown {\n  width: 100%;\n}\n\n.p2p-custom-select-header {\n  background-color: #F0F0F0;\n  border: 1px solid #e5e7eb;\n  border-radius: 50px;\n  padding: 8px 30px 8px 12px;\n  width: 100%;\n  font-size: 14px;\n  min-height: 48px;\n  color: #707070;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\nbody.dark_theme .p2p-custom-select-header,\nbody[data-theme=\"dark\"] .p2p-custom-select-header,\nhtml[data-theme=\"dark\"] .p2p-custom-select-header {\n  background-color: #181a20;\n  border-color: #2b313a;\n  color: #eaecef;\n}\n\n.p2p-custom-select-header i {\n  position: absolute;\n  right: 12px;\n  transition: transform 0.3s;\n}\n\n.p2p-custom-select-header i.open {\n  transform: rotate(180deg);\n}\n\n.p2p-custom-select-list {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  margin: 0;\n  padding: 8px 0;\n  list-style: none;\n  z-index: 100;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 200px;\n  overflow-y: auto;\n}\n\nbody.dark_theme .p2p-custom-select-list,\nbody[data-theme=\"dark\"] .p2p-custom-select-list,\nhtml[data-theme=\"dark\"] .p2p-custom-select-list {\n  background-color: #1e2026;\n  border-color: #2b313a;\n}\n\n.p2p-custom-select-item {\n  padding: 8px 16px;\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\nbody.dark_theme .p2p-custom-select-item,\nbody[data-theme=\"dark\"] .p2p-custom-select-item,\nhtml[data-theme=\"dark\"] .p2p-custom-select-item {\n  color: #eaecef;\n}\n\n.p2p-custom-select-item:hover,\n.p2p-custom-select-item.selected {\n  background-color: #1a56db;\n  color: #ffffff;\n}\n\nbody.dark_theme .p2p-custom-select-item:hover,\nbody.dark_theme .p2p-custom-select-item.selected,\nbody[data-theme=\"dark\"] .p2p-custom-select-item:hover,\nbody[data-theme=\"dark\"] .p2p-custom-select-item.selected,\nhtml[data-theme=\"dark\"] .p2p-custom-select-item:hover,\nhtml[data-theme=\"dark\"] .p2p-custom-select-item.selected {\n  background-color: #2b313a;\n  color: #f0b90b;\n}\n\n.p2p-currency-select {\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-left: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-currency-select,\nbody[data-theme=\"dark\"] .p2p-currency-select,\nhtml[data-theme=\"dark\"] .p2p-currency-select {\n  border-color: #2b313a;\n}\n\n.p2p-currency-dropdown {\n  width: 95px;\n}\n\n.p2p-currency-dropdown .p2p-custom-select-header {\n  border: none;\n  background: transparent;\n  min-height: auto;\n  font-weight: 600;\n  padding: 0px 19px 0px 12px;\n}\n\n.p2p-filter-input-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F0F0F0;\n  border: 1px solid #e5e7eb;\n  border-radius: 50px;\n  padding: 8px 12px;\n  width: 56px;\n  height: 56px;\n}\n\n.p2p-filter-input-wrap img {\n  height: 18px;\n}\n\nbody.dark_theme .p2p-filter-input-wrap,\nbody[data-theme=\"dark\"] .p2p-filter-input-wrap,\nhtml[data-theme=\"dark\"] .p2p-filter-input-wrap {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\nbody.dark_theme .p2p-filter-input-wrap img,\nbody[data-theme=\"dark\"] .p2p-filter-input-wrap img,\nhtml[data-theme=\"dark\"] .p2p-filter-input-wrap img {\n  filter: brightness(0) invert(1);\n  opacity: 0.75;\n}\n\n.p2p-filter-input-wrap input {\n  border: none;\n  outline: none;\n  background: transparent;\n  width: 100%;\n}\n\nbody.dark_theme .p2p-filter-input-wrap input,\nbody[data-theme=\"dark\"] .p2p-filter-input-wrap input,\nhtml[data-theme=\"dark\"] .p2p-filter-input-wrap input {\n  color: #fff;\n}\n\n.p2p-icon-btn,\n.p2p-refresh-btn {\n  background-color: #F0F0F0;\n  border: 1px solid rgb(95 95 95 / 20%);\n  border-radius: 50px;\n  padding: 17px 12px;\n  font-weight: 500;\n  min-width: 160px;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #5F5F5F;\n}\n\nbody.dark_theme .p2p-icon-btn,\nbody[data-theme=\"dark\"] .p2p-icon-btn,\nhtml[data-theme=\"dark\"] .p2p-icon-btn,\nbody.dark_theme .p2p-refresh-btn,\nbody[data-theme=\"dark\"] .p2p-refresh-btn,\nhtml[data-theme=\"dark\"] .p2p-refresh-btn {\n  background-color: #181a20;\n  border-color: #2b313a;\n  color: #eaecef;\n}\n\nbody.dark_theme .p2p-refresh-btn:hover,\nbody[data-theme=\"dark\"] .p2p-refresh-btn:hover,\nhtml[data-theme=\"dark\"] .p2p-refresh-btn:hover {\n  background-color: #2b313a;\n  color: #ffffff;\n}\n\n.p2p-filter-refresh {\n  margin-left: auto;\n}\n\n/* ==================== 4. ADVERTISERS TABLE & PAGINATION ==================== */\n.p2p-table-container {\n  overflow-x: auto;\n  border-radius: 14px;\n  background-color: #f9f9f9;\n}\n\nbody.dark_theme .p2p-table-container,\nbody[data-theme=\"dark\"] .p2p-table-container,\nhtml[data-theme=\"dark\"] .p2p-table-container {\n  background-color: #1e2026;\n  border: 1px solid #2b313a;\n}\n\n.p2p-table {\n  width: 100%;\n}\n\n.p2p-table th {\n  text-align: left;\n  padding: 16px;\n  font-size: 15px;\n  color: #9CA3AF;\n  background-color: #E2E2E2;\n  font-weight: 500;\n}\n\nbody.dark_theme .p2p-table th,\nbody[data-theme=\"dark\"] .p2p-table th,\nhtml[data-theme=\"dark\"] .p2p-table th {\n  background-color: #181a20 !important;\n  color: #848e9c !important;\n  border-bottom: 1px solid #2b313a !important;\n}\n\n.p2p-table tbody tr {\n  background-color: #F9F9F9;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\nbody.dark_theme .p2p-table tbody tr,\nbody[data-theme=\"dark\"] .p2p-table tbody tr,\nhtml[data-theme=\"dark\"] .p2p-table tbody tr {\n  background-color: #1e2026 !important;\n  box-shadow: none !important;\n  border-bottom: 1px solid #2b313a !important;\n}\n\nbody.dark_theme .p2p-table tbody tr:hover,\nbody[data-theme=\"dark\"] .p2p-table tbody tr:hover,\nhtml[data-theme=\"dark\"] .p2p-table tbody tr:hover {\n  background-color: #23272e !important;\n}\n\n.p2p-table td {\n  padding: 18px;\n  background-color: #F9F9F9;\n  border-bottom: 1px solid #E4E4E4;\n}\n\nbody.dark_theme .p2p-table td,\nbody[data-theme=\"dark\"] .p2p-table td,\nhtml[data-theme=\"dark\"] .p2p-table td {\n  background-color: transparent !important;\n  border-bottom: 1px solid #2b313a !important;\n  color: #eaecef !important;\n}\n\n.p2p-table td:first-child {\n  border-radius: 8px 0 0 8px;\n}\n\n.p2p-table td:last-child {\n  border-radius: 0 8px 8px 0;\n}\n\n.p2p-adv-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-adv-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: #fff;\n}\n\n.p2p-adv-avatar.dark-avatar {\n  background-color: #454545;\n}\n\nbody.dark_theme .p2p-adv-avatar.dark-avatar,\nbody[data-theme=\"dark\"] .p2p-adv-avatar.dark-avatar,\nhtml[data-theme=\"dark\"] .p2p-adv-avatar.dark-avatar {\n  background-color: #2b313a;\n  color: #ffffff;\n}\n\n.p2p-adv-info h4 {\n  margin: 0 0 2px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-adv-info h4,\nbody[data-theme=\"dark\"] .p2p-adv-info h4,\nhtml[data-theme=\"dark\"] .p2p-adv-info h4 {\n  color: #fff;\n}\n\n.p2p-adv-info span {\n  font-size: 12px;\n  color: #6b7280;\n}\n\nbody.dark_theme .p2p-adv-info span,\nbody[data-theme=\"dark\"] .p2p-adv-info span,\nhtml[data-theme=\"dark\"] .p2p-adv-info span {\n  color: #848e9c;\n}\n\n.p2p-price-cell {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-price-cell,\nbody[data-theme=\"dark\"] .p2p-price-cell,\nhtml[data-theme=\"dark\"] .p2p-price-cell {\n  color: #fff;\n}\n\n.p2p-limit-val {\n  font-size: 16px;\n  color: #374151;\n  margin-bottom: 0px;\n  font-weight: 500;\n}\n\nbody.dark_theme .p2p-limit-val,\nbody[data-theme=\"dark\"] .p2p-limit-val,\nhtml[data-theme=\"dark\"] .p2p-limit-val {\n  color: #ffffff;\n}\n\n.p2p-limit-range {\n  font-size: 14px;\n  color: #9CA3AF;\n}\n\nbody.dark_theme .p2p-limit-range,\nbody[data-theme=\"dark\"] .p2p-limit-range,\nhtml[data-theme=\"dark\"] .p2p-limit-range {\n  color: #848e9c;\n}\n\n.p2p-payment-badges {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.p2p-payment-tag {\n  background-color: #F3F4F6;\n  color: #374151;\n  font-size: 13px;\n  padding: 6px 12px;\n  border-radius: 6px;\n}\n\nbody.dark_theme .p2p-payment-tag,\nbody[data-theme=\"dark\"] .p2p-payment-tag,\nhtml[data-theme=\"dark\"] .p2p-payment-tag {\n  background-color: #2b313a;\n  color: #eaecef;\n  border: 1px solid #373d48;\n}\n\n.p2p-action-btn {\n  padding: 12px 32px;\n  border-radius: 50px;\n  border: none;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n}\n\n.p2p-action-btn.btn-buy {\n  background-color: #2BC287;\n}\n\n.p2p-action-btn.btn-sell {\n  background-color: #EC6072;\n}\n\nbody.dark_theme .p2p-page-num,\nbody[data-theme=\"dark\"] .p2p-page-num,\nhtml[data-theme=\"dark\"] .p2p-page-num,\nbody.dark_theme .p2p-page-arrow,\nbody[data-theme=\"dark\"] .p2p-page-arrow,\nhtml[data-theme=\"dark\"] .p2p-page-arrow {\n  color: #848e9c;\n}\n\nbody.dark_theme .p2p-page-num.active,\nbody[data-theme=\"dark\"] .p2p-page-num.active,\nhtml[data-theme=\"dark\"] .p2p-page-num.active {\n  background-color: #2b313a !important;\n  color: #f0b90b !important;\n}\n\n.p2p-pagination-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin: 24px 0px;\n}\n\n.p2p-page-num,\n.p2p-page-arrow {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.p2p-page-num.active {\n  background-color: #f3f4f6;\n  color: #111827;\n  font-weight: 600;\n}\n\nbody.dark_theme .p2p-page-num.active,\nbody[data-theme=\"dark\"] .p2p-page-num.active {\n  background-color: #374151;\n  color: #fff;\n}\n\n.p2p-page-dots {\n  color: #6b7280;\n}\n\n/* ==================== 5. TRADING TUTORIAL SECTION ==================== */\n.p2p-tutorial-section {\n  margin: 60px 0px 40px;\n  background-color: #FAFAFA;\n  padding: 42px;\n  border-radius: 24px;\n}\n\nbody.dark_theme .p2p-tutorial-section,\nbody[data-theme=\"dark\"] .p2p-tutorial-section,\nhtml[data-theme=\"dark\"] .p2p-tutorial-section {\n  background-color: #1e2026;\n  border: 1px solid #2b313a;\n}\n\n.p2p-section-header {\n  margin-bottom: 24px;\n}\n\n.p2p-section-header h2 {\n  font-size: 40px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\nbody.dark_theme .p2p-section-header h2,\nbody[data-theme=\"dark\"] .p2p-section-header h2,\nhtml[data-theme=\"dark\"] .p2p-section-header h2 {\n  color: #ffffff;\n}\n\n.p2p-section-header p {\n  color: #6b7280;\n  font-size: 18px;\n  margin-top: 5px;\n}\n\nbody.dark_theme .p2p-section-header p,\nbody[data-theme=\"dark\"] .p2p-section-header p,\nhtml[data-theme=\"dark\"] .p2p-section-header p {\n  color: #848e9c;\n}\n\n.p2p-tutorial-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  padding-top: 8px;\n}\n\n.p2p-tutorial-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f3f4f6;\n}\n\nbody.dark_theme .p2p-tutorial-card,\nbody[data-theme=\"dark\"] .p2p-tutorial-card,\nhtml[data-theme=\"dark\"] .p2p-tutorial-card {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-tut-img-wrap {\n  height: 188px;\n  background: #F1E5D0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\nbody.dark_theme .p2p-tut-img-wrap,\nbody[data-theme=\"dark\"] .p2p-tut-img-wrap,\nhtml[data-theme=\"dark\"] .p2p-tut-img-wrap {\n  background: linear-gradient(135deg, #3a2e13 0%, #2a210d 100%);\n}\n\n.p2p-tut-img-wrap img {\n  max-height: 100%;\n}\n\n.p2p-tut-content {\n  padding: 20px;\n}\n\n.p2p-tut-content h4 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\nbody.dark_theme .p2p-tut-content h4,\nbody[data-theme=\"dark\"] .p2p-tut-content h4,\nhtml[data-theme=\"dark\"] .p2p-tut-content h4 {\n  color: #ffffff;\n}\n\n.p2p-tut-content p {\n  font-size: 16px;\n  color: #6B7280;\n  margin-bottom: 16px;\n  min-height: 40px;\n}\n\nbody.dark_theme .p2p-tut-content p,\nbody[data-theme=\"dark\"] .p2p-tut-content p,\nhtml[data-theme=\"dark\"] .p2p-tut-content p {\n  color: #848e9c;\n}\n\n.p2p-tut-link {\n  color: #D1AA67;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: color 0.2s, transform 0.2s;\n}\n\n.p2p-tut-link:hover {\n  color: #b89350;\n  text-decoration: underline;\n  transform: translateX(3px);\n}\n\n/* ==================== 6. FAQ ACCORDION SECTION ==================== */\n.p2p-faq-section {\n  margin-bottom: 40px;\n}\n\n.p2p-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-accordion-item {\n  background-color: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\nbody.dark_theme .p2p-accordion-item,\nbody[data-theme=\"dark\"] .p2p-accordion-item,\nhtml[data-theme=\"dark\"] .p2p-accordion-item {\n  background-color: #1e2026;\n  border-color: #2b313a;\n}\n\n.p2p-accordion-button {\n  width: 100%;\n  text-align: left;\n  padding: 28px;\n  background: none;\n  border: none;\n  font-size: 22px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\nh2.p2p-accordion-header {\n  margin: 0px;\n}\n\nbody.dark_theme .p2p-accordion-button,\nbody[data-theme=\"dark\"] .p2p-accordion-button,\nhtml[data-theme=\"dark\"] .p2p-accordion-button {\n  color: #ffffff;\n}\n\n.p2p-acc-icon {\n  color: #9ca3af;\n  font-size: 20px;\n  width: 38px;\n  height: 38px;\n  min-width: 38;\n  background-color: #F3F4F6;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.dark_theme .p2p-acc-icon,\nbody[data-theme=\"dark\"] .p2p-acc-icon,\nhtml[data-theme=\"dark\"] .p2p-acc-icon {\n  background-color: #2b313a;\n  color: #848e9c;\n}\n\n.p2p-accordion-body {\n  padding: 0 28px 20px;\n  color: #35373a;\n  font-size: 18px;\n  line-height: 1.5;\n}\n\nbody.dark_theme .p2p-accordion-body,\nbody[data-theme=\"dark\"] .p2p-accordion-body,\nhtml[data-theme=\"dark\"] .p2p-accordion-body {\n  color: #848e9c;\n}\n\n/* ==================== 6. BUY/SELL MODAL ==================== */\n.p2p-modal-overlay {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  height: 100dvh !important;\n  background-color: rgb(0 0 0 / 42%);\n  backdrop-filter: blur(4px);\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 999999999 !important;\n}\n\nbody.light_theme .p2p-modal-overlay {\n  background-color: rgb(255 255 255 / 42%);\n}\n\n.p2p-modal-content {\n  background-color: #0000005e;\n  border-radius: 24px;\n  width: 1150px;\n  backdrop-filter: blur(8px);\n  border: 2px solid #bdbdbd;\n  max-width: 95vw;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\nbody.dark_theme .p2p-modal-content,\nbody[data-theme=\"dark\"] .p2p-modal-content {\n  background-color: rgb(0 0 0 / 30%);\n  border: 2px solid #181818;\n}\n\n.p2p-modal-body {\n  display: flex;\n  flex-direction: row;\n}\n\n/* Left Side: Seller Info */\n.p2p-modal-left {\n  width: 35%;\n  padding: 40px 35px 30px 10px;\n  border-right: 1px solid #F3F4F6;\n}\n\nbody.dark_theme .p2p-modal-left,\nbody[data-theme=\"dark\"] .p2p-modal-left {\n  border-right-color: #333;\n}\n\n.p2p-modal-seller-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.p2p-modal-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #8B4513;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.p2p-modal-seller-info h3 {\n  margin: 0 0 8px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-modal-seller-info h3,\nbody[data-theme=\"dark\"] .p2p-modal-seller-info h3 {\n  color: #fff;\n}\n\n.p2p-modal-badges {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.p2p-badge-green {\n  font-size: 9px;\n  color: #10B981;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-weight: 400;\n}\n\n.p2p-modal-last-online {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.p2p-modal-stats-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.p2p-modal-stat-box {\n  flex: 1;\n  flex-direction: column;\n  background-color: #F2F2F250;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: start;\n  gap: 3px;\n  border: 1px solid #E5E7EB;\n}\n\n.d-flex.twop2p {\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.p2p-modal-stat-box p {\n  margin-bottom: 0px;\n  color: #6B7280;\n}\n\nbody.dark_theme .p2p-modal-stat-box,\nbody[data-theme=\"dark\"] .p2p-modal-stat-box {\n  background-color: rgb(0 0 0 / 50%);\n  border-color: #272727;\n}\n\n.p2p-stat-icon {\n  color: #D1AA67;\n  font-size: 14px;\n  background-color: #D1AA6720;\n  padding: 1px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n}\n\n.p2p-stat-val strong {\n  display: block;\n  font-size: 20px;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-stat-val strong,\nbody[data-theme=\"dark\"] .p2p-stat-val strong {\n  color: #fff;\n}\n\n.p2p-stat-val p {\n  margin: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.p2p-modal-about,\n.p2p-modal-remarks,\n.p2p-modal-payments {\n  margin-bottom: 24px;\n}\n\n.p2p-modal-about h4,\n.p2p-modal-remarks h4,\n.p2p-modal-payments h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 12px;\n}\n\nbody.dark_theme .p2p-modal-left h4,\nbody[data-theme=\"dark\"] .p2p-modal-left h4 {\n  color: #fff;\n}\n\n.p2p-modal-about p {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #4b5563;\n}\n\nbody.dark_theme .p2p-modal-about p,\nbody[data-theme=\"dark\"] .p2p-modal-about p {\n  color: #ccc;\n}\n\n.p2p-remarks-box {\n  background-color: #F5F6F7;\n  border-radius: 8px;\n  padding: 16px;\n  font-size: 13px;\n  color: #6b7280;\n}\n\nbody.dark_theme .p2p-remarks-box,\nbody[data-theme=\"dark\"] .p2p-remarks-box {\n  background-color: #2a2a36;\n}\n\n.p2p-payment-icons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.p2p-pay-icon {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px 9px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  font-size: 11px;\n  color: #374151;\n  background: #fff;\n  font-weight: 500;\n}\n\nbody.dark_theme .p2p-pay-icon,\nbody[data-theme=\"dark\"] .p2p-pay-icon {\n  background-color: #1a1a24;\n  border-color: #444;\n  color: #ccc;\n}\n\n.p2p-payment-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e5e7eb;\n  border-radius: 50%;\n  color: #6b7280;\n  font-size: 16px;\n}\n\nbody.dark_theme .p2p-payment-more,\nbody[data-theme=\"dark\"] .p2p-payment-more {\n  border-color: #444;\n}\n\n/* Right Side: Transaction Details */\n.p2p-modal-right {\n  width: 65%;\n  padding: 40px;\n  position: relative;\n}\n\n.p2p-modal-close {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6b7280;\n  cursor: pointer;\n  z-index: 10;\n}\n\n.p2p-modal-action-header {\n  margin-bottom: 24px;\n}\n\n.p2p-action-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-token-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #26A17B;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.p2p-action-title h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-action-title h2,\nbody[data-theme=\"dark\"] .p2p-action-title h2 {\n  color: #fff;\n}\n\n.p2p-price-secure-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.p2p-price-rate {\n  font-size: 14px;\n  color: #b0b0b0;\n  background-color: #ecfdf512;\n  padding: 7px 15px;\n  border-radius: 6px;\n}\n\nbody.light_theme .p2p-price-rate {\n  color: #6b7280;\n  background-color: #ECFDF550;\n}\n\n.p2p-secure-badge {\n  background-color: #ECFDF5;\n  color: #059669;\n  padding: 8px 15px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #D1FAE5;\n}\n\nbody.dark_theme .p2p-secure-badge,\nbody[data-theme=\"dark\"] .p2p-secure-badge {\n  background-color: rgba(16, 185, 129, 0.1);\n}\n\n.p2p-secure-badge span {\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.p2p-input-group {\n  margin-bottom: 24px;\n}\n\n.p2p-input-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\nbody.dark_theme .p2p-input-group label,\nbody[data-theme=\"dark\"] .p2p-input-group label {\n  color: #ccc;\n}\n\n.p2p-amount-box {\n  display: flex;\n  align-items: center;\n  background-color: #F2F2F250;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 12px 16px;\n}\n\nbody.dark_theme .p2p-amount-box,\nbody[data-theme=\"dark\"] .p2p-amount-box {\n  background-color: rgb(0 0 0 / 50%);\n  border-color: #272727;\n}\n\n.p2p-currency-symbol,\n.p2p-token-circle-sm {\n  font-size: 18px;\n  color: #6b7280;\n  margin-right: 12px;\n}\n\n.p2p-token-circle-sm {\n  color: #26A17B;\n}\n\n.p2p-amount-box input {\n  flex: 1 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 22px;\n  font-weight: 700;\n  color: #707070;\n}\n\nbody.dark_theme .p2p-amount-box input,\nbody[data-theme=\"dark\"] .p2p-amount-box input {\n  color: #fff;\n}\n\n.p2p-currency-dropdown-sm {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background-color: #ffffff85;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #374151;\n  cursor: pointer;\n  border: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-currency-dropdown-sm,\nbody[data-theme=\"dark\"] .p2p-currency-dropdown-sm {\n  background-color: #374151;\n  border-color: #444;\n  color: #fff;\n}\n\n.p2p-limit-hint {\n  font-size: 12px;\n  color: #9CA3AF;\n  font-weight: 300;\n  margin-top: 8px;\n}\n\n.p2p-limit-hint span {\n  color: #10B981;\n  font-weight: 600;\n}\n\n.p2p-payment-select-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #F9F9F9;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-payment-select-box,\nbody[data-theme=\"dark\"] .p2p-payment-select-box {\n  background-color: rgb(0 0 0 / 50%);\n  border-color: #272727;\n}\n\n.p2p-pay-sel-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.p2p-pay-sel-left i {\n  color: #D1AA67;\n  font-size: 18px;\n  background-color: #D1AA6720;\n  width: 32px;\n  height: 32px;\n  line-height: 14px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.dark_theme .p2p-pay-sel-left,\nbody[data-theme=\"dark\"] .p2p-pay-sel-left {\n  color: #ccc;\n}\n\n.p2p-payment-dropdown-list {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  overflow: hidden;\n}\n\nbody.dark_theme .p2p-payment-dropdown-list,\nbody[data-theme=\"dark\"] .p2p-payment-dropdown-list {\n  background-color: #2a2a36;\n  border-color: #444;\n}\n\n.p2p-payment-dropdown-item {\n  padding: 12px 16px;\n  font-size: 15px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.p2p-payment-dropdown-item i {\n  color: #D1AA67;\n  font-size: 18px;\n  background-color: #D1AA6720;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n}\n\n.p2p-payment-dropdown-item:hover {\n  background-color: #f3f4f6;\n}\n\nbody.dark_theme .p2p-payment-dropdown-item,\nbody[data-theme=\"dark\"] .p2p-payment-dropdown-item {\n  color: #ccc;\n}\n\nbody.dark_theme .p2p-payment-dropdown-item:hover,\nbody[data-theme=\"dark\"] .p2p-payment-dropdown-item:hover {\n  background-color: #374151;\n}\n\n\n.p2p-escrow-info {\n  display: flex;\n  gap: 16px;\n  background: #F2F2F280;\n  padding: 22px;\n  border-radius: 12px;\n  margin-bottom: 22px;\n}\n\nbody.dark_theme .p2p-escrow-info,\nbody[data-theme=\"dark\"] .p2p-escrow-info {\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.p2p-escrow-info i {\n  color: #10B981;\n  font-size: 24px;\n}\n\n.p2p-escrow-info strong {\n  display: block;\n  font-size: 14px;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\nbody.dark_theme .p2p-escrow-info strong,\nbody[data-theme=\"dark\"] .p2p-escrow-info strong {\n  color: #fff;\n}\n\n.p2p-escrow-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.p2p-terms-check {\n  margin-bottom: 24px;\n}\n\n.p2p-terms-check label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.p2p-terms-check a {\n  color: #10B981;\n  text-decoration: underline;\n}\n\n.p2p-submit-buy-btn {\n  width: 100%;\n  background-color: #2BC287;\n  color: #ffffff;\n  border: none;\n  border-radius: 30px;\n  padding: 16px;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.p2p-submit-buy-btn:hover {\n  background-color: #21a16e;\n}\n\n@media (max-width: 991px) {\n\n  .p2p-post-ad-header h2 {\n    font-size: 26px;\n  }\n\n\n\n  .p2p-hero-content {\n    max-width: 100%;\n    margin-bottom: 24px;\n  }\n\n  .p2p-tutorial-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-filter-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  /* Modal Responsive */\n\n  .p2p-modal-left {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .p2p-modal-right {\n    width: 100%;\n    border-radius: 0 0 24px 24px;\n  }\n}\n\n/* ==================== 7. TRADING REQUIREMENT MODAL ==================== */\n.p2p-req-modal-content {\n  background-color: #ffffff50;\n  backdrop-filter: blur(8px);\n  border-radius: 16px;\n  width: 620px;\n  max-width: 90vw;\n  box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  border: 3px solid #E1E1E150;\n  position: relative;\n}\n\nbody.dark_theme .p2p-req-modal-content,\nbody[data-theme=\"dark\"] .p2p-req-modal-content {\n  background-color: rgb(0 0 0 / 30%);\n  border: 3px solid #e1e1e112;\n}\n\n.p2p-req-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px;\n}\n\n.p2p-req-modal-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-req-modal-header h2,\nbody[data-theme=\"dark\"] .p2p-req-modal-header h2 {\n  color: #fff;\n}\n\n.p2p-modal-close-req {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #111827;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-modal-close-req,\nbody[data-theme=\"dark\"] .p2p-modal-close-req {\n  color: #fff;\n}\n\n.p2p-req-modal-body {\n  padding: 0 24px;\n}\n\n.p2p-req-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.p2p-req-item:last-child {\n  border-bottom: none;\n}\n\nbody.dark_theme .p2p-req-item,\nbody[data-theme=\"dark\"] .p2p-req-item {\n  border-bottom-color: #333;\n}\n\n.p2p-req-text {\n  font-size: 16px;\n  color: #636363;\n}\n\nbody.dark_theme .p2p-req-text,\nbody[data-theme=\"dark\"] .p2p-req-text {\n  color: #ccc;\n}\n\n.p2p-req-verify-btn {\n  background-color: #D1AA67;\n  color: #fff;\n  border: none;\n  padding: 7px 32px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.p2p-req-done {\n  color: #10B981;\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-req-modal-footer {\n  display: flex;\n  gap: 12px;\n  padding: 24px;\n}\n\n.p2p-req-cancel-btn {\n  flex: 1;\n  background-color: #E2E8F0;\n  color: #4b5563;\n  border: none;\n  padding: 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-req-cancel-btn,\nbody[data-theme=\"dark\"] .p2p-req-cancel-btn {\n  background-color: #374151;\n  color: #ccc;\n}\n\n.p2p-req-get-verified-btn {\n  flex: 1;\n  background-color: #333333;\n  color: #fff;\n  border: none;\n  padding: 12px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-req-get-verified-btn,\nbody[data-theme=\"dark\"] .p2p-req-get-verified-btn {\n  background-color: #444;\n}\n\n/* ==================== 8. P2P TUTORIAL MODAL ==================== */\n.p2p-tutorial-modal-content {\n  width: 720px !important;\n  max-width: 92vw !important;\n  max-height: 85vh !important;\n  display: flex !important;\n  flex-direction: column !important;\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n  border: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-tutorial-modal-content,\nbody[data-theme=\"dark\"] .p2p-tutorial-modal-content {\n  background-color: rgb(26 26 26 / 20%);\n  border: 1px solid #232323;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);\n}\n\n.p2p-tut-modal-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-tut-modal-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  color: #D1AA67;\n  background: rgba(209, 170, 103, 0.12);\n  padding: 3px 10px;\n  border-radius: 20px;\n  width: fit-content;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.p2p-tut-modal-body {\n  overflow-y: auto !important;\n  max-height: calc(85vh - 165px) !important;\n  padding: 18px 24px !important;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.p2p-tut-modal-intro {\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: #4b5563;\n  background: #f9fafb;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border-left: 3px solid #D1AA67;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-tut-modal-intro,\nbody[data-theme=\"dark\"] .p2p-tut-modal-intro {\n  background: rgb(255 255 255 / 5%);\n  color: #d1d5db;\n}\n\n.p2p-tut-modal-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-tut-step-card {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: #fcfcfd;\n  border: 1px solid #edf0f3;\n  transition: all 0.2s ease;\n}\n\n.p2p-tut-step-card:hover {\n  border-color: #d1aa67;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\nbody.dark_theme .p2p-tut-step-card,\nbody[data-theme=\"dark\"] .p2p-tut-step-card {\n  background: rgb(51 51 51 / 10%);\n  border-color: #242424;\n}\n\nbody.dark_theme .p2p-tut-step-card:hover,\nbody[data-theme=\"dark\"] .p2p-tut-step-card:hover {\n  background: #252533;\n  border-color: #d1aa67;\n}\n\n.p2p-tut-step-num {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #d1aa67 0%, #b88f4c 100%);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 6px rgba(209, 170, 103, 0.35);\n}\n\n.p2p-tut-step-content {\n  flex: 1;\n}\n\n.p2p-tut-step-content h4 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 6px 0;\n}\n\nbody.dark_theme .p2p-tut-step-content h4,\nbody[data-theme=\"dark\"] .p2p-tut-step-content h4 {\n  color: #f3f4f6;\n}\n\n.p2p-tut-step-content p {\n  font-size: 13.5px;\n  line-height: 1.55;\n  color: #6b7280;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-tut-step-content p,\nbody[data-theme=\"dark\"] .p2p-tut-step-content p {\n  color: #9ca3af;\n}\n\n.p2p-tut-safety-box {\n  background: #fdfaf3;\n  border: 1px solid #fae8c8;\n  border-radius: 12px;\n  padding: 14px 16px;\n}\n\nbody.dark_theme .p2p-tut-safety-box,\nbody[data-theme=\"dark\"] .p2p-tut-safety-box {\n  background: #252016;\n  border-color: #4a3c20;\n}\n\n.p2p-tut-safety-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #b88f4c;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.p2p-tut-safety-box ul {\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.p2p-tut-safety-box li {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6b7280;\n}\n\nbody.dark_theme .p2p-tut-safety-box li,\nbody[data-theme=\"dark\"] .p2p-tut-safety-box li {\n  color: #c7c1b5;\n}\n\n.p2p-tut-gotit-btn {\n  background-color: #D1AA67 !important;\n  color: #fff !important;\n}\n\n.p2p-tut-gotit-btn:hover {\n  background-color: #b88f4c !important;\n}\n\n/* ==================== 8. P2P ORDER DETAILS PAGE ==================== */\n.p2p-order-details-container {\n  max-width: 100%;\n}\n\n/* Top Header */\n.p2p-od-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n}\n\n.p2p-od-header-left h2 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\n.p2p-od-header-left p {\n  color: #6b7280;\n  font-size: 17px;\n  margin: 12px 0 12px;\n}\n\n.p2p-od-escrow-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #D1AA67;\n  font-size: 15px;\n  font-weight: 500;\n\n}\n\n.p2p-od-header-right {\n  display: flex;\n  gap: 16px;\n  background-color: #1e2026;\n  padding: 22px;\n  border: 1px solid #303030;\n  border-radius: 15px;\n  box-shadow: 0px 1px 3px rgb(0 0 0 / 5%);\n}\n\nbody.light_theme .p2p-od-header-right {\n  background-color: #F5F6F7;\n  border: 1px solid #EAEAEA;\n}\n\n.p2p-od-timer-box,\n.p2p-od-info-box {\n  padding: 0px;\n}\n\n.p2p-od-timer-box {\n  width: 240px;\n  border-right: 1px solid #434343;\n  margin-right: 20px;\n}\n\nbody.light_theme .p2p-od-timer-box {\n  border-right: 1px solid #EAEAEA;\n}\n\n.p2p-od-box-label {\n  display: block;\n  font-size: 14px;\n  color: #6B6F75;\n  margin-bottom: 2px;\n}\n\n.p2p-od-timer-val {\n  font-size: 28px;\n  font-weight: 700;\n  color: #111827;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.p2p-od-timer-val span {\n  margin: 0 2px;\n}\n\n.p2p-od-timer-val small {\n  font-size: 12px;\n  color: #6B6F75;\n  font-weight: 400;\n}\n\n.p2p-od-info-box {\n  display: flex;\n  gap: 32px;\n}\n\n.p2p-od-info-col {\n  min-width: 240px;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #434343;\n  padding-right: 20px;\n  padding-left: 20px;\n}\n\nbody.light_theme .p2p-od-info-col {\n  border-right: 1px solid #EAEAEA;\n}\n\n.p2p-od-info-col:last-child {\n  border-right: none;\n}\n\n.p2p-od-info-col strong {\n  font-size: 16px;\n  color: #18181B;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-od-info-col i {\n  color: #6b7280;\n  cursor: pointer;\n}\n\n/* Stepper */\n.p2p-od-stepper-container {\n  display: flex;\n  align-items: center;\n  background: #F5F6F7;\n  border: 1px solid #EAEAEA;\n  padding: 32px;\n  border-radius: 14px;\n  margin-bottom: 32px;\n}\n\n.p2p-od-step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-od-step-circle {\n  width: 48px;\n  height: 48px;\n  background: #3A3939;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.p2p-od-step.current .p2p-od-step-text-only {\n  width: 48px;\n  min-width: 48px;\n  height: 48px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  display: flex;\n  border: 3px solid #F1F1F1;\n  font-size: 18px;\n  font-weight: 700;\n  color: #6B6F75;\n  margin-right: 8px;\n}\n\n.p2p-od-step.pending .p2p-od-step-text-only {\n  width: 48px;\n  min-width: 48px;\n  height: 48px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  display: flex;\n  border: 3px solid #F1F1F1;\n  font-size: 18px;\n  font-weight: 700;\n  color: #6B6F75;\n  margin-right: 8px;\n}\n\n.p2p-od-step-text h4 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.p2p-od-step.pending .p2p-od-step-text h4 {\n  color: #9ca3af;\n}\n\n.p2p-od-step-text p {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: #6B6F75;\n}\n\n.p2p-od-step-line {\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n  margin: 0 24px;\n}\n\n.p2p-od-step-line.dashed {\n  border-top: 1px dashed #d1d5db;\n  background: none;\n}\n\n/* Main Body Layout */\n.p2p-od-main-body {\n  display: flex;\n  gap: 24px;\n}\n\n.p2p-od-left-col {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.p2p-od-right-col {\n  flex: 1;\n}\n\n.p2p-od-card {\n  background: #F5F6F7;\n  border: 1px solid #EAEAEA;\n  border-radius: 14px;\n}\n\n.p2p-od-card h3 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #18181B;\n  margin: 0px;\n}\n\n.header_card_top {\n  padding: 28px;\n}\n\n.p2p-od-card.p2p-od-payment-card .p2p-od-payment-desc {\n  margin: 12px 0px 0px;\n}\n\n/* Order Details Grid */\n.p2p-od-details-grid {\n  display: flex;\n  justify-content: space-around;\n  gap: 18px;\n  border-top: 1px solid #353535;\n  padding: 28px;\n}\n\nbody.light_theme .p2p-od-details-grid {\n  border-top: 1px solid #EAEAEA;\n}\n\n.p2p-od-detail-item {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  gap: 4px;\n}\n\n.p2p-od-detail-item strong {\n  font-size: 17px;\n  color: #18181B;\n  font-weight: 700;\n}\n\n.p2p-od-detail-item span {\n  font-size: 15px;\n  color: #6B6F75;\n}\n\n.p2p-od-buy-tag {\n  color: #22C55E !important;\n  font-weight: 700;\n}\n\n.payment_method_bl {\n  width: 100%;\n  border-top: 1px solid #353535;\n  padding: 28px;\n}\n\nbody.light_theme .payment_method_bl {\n  border-top: 1px solid #EAEAEA;\n}\n\n/* Payment Card */\n.p2p-od-payment-desc {\n  font-size: 15px;\n  color: #6b7280;\n  margin-bottom: 16px;\n  line-height: 1.5;\n}\n\n.p2p-od-warning-note {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #FFF9E6;\n  border: 1px solid #FED7AA;\n  color: #C28E27;\n  padding: 20px;\n  font-weight: 500;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 32px;\n  margin-top: 4px;\n}\n\n.p2p-od-warning-icon {\n  font-size: 18px;\n}\n\n.p2p-od-payment-split {\n  display: flex;\n  gap: 82px;\n}\n\n.p2p-od-payment-options {\n  max-width: 254px;\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.p2p-od-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid #dfdfdf;\n  border-radius: 50px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  color: #374151;\n  background: none;\n  transition: all 0.2s;\n}\n\n.p2p-od-radio-label.active {\n  border-color: #D1AA67;\n  background: #fff;\n  color: #18181B;\n}\n\n.p2p-od-radio-label input[type=\"radio\"] {\n  display: none;\n}\n\n.p2p-od-radio-label i {\n  font-size: 18px;\n  color: #6b7280;\n}\n\n.p2p-od-radio-label.active i {\n  color: #D1AA67;\n}\n\n.radio-custom {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 50%;\n}\n\n.p2p-od-radio-label.active .radio-custom {\n  border: 4px solid #D1AA67;\n}\n\n.p2p-od-payment-details {\n  flex: 1 1;\n  background: #F1F1F1;\n  border: 1px solid #363636;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\nbody.light_theme .p2p-od-payment-details {\n  border: 1px solid #EAEAEA;\n}\n\n.p2p-od-pay-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n}\n\n.p2p-od-pay-row span {\n  color: #6b7280;\n}\n\n.p2p-od-pay-row strong {\n  color: #111827;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.p2p-od-pay-row i {\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n/* Next Step */\n.p2p-od-next-step h3 {\n  font-size: 24px;\n  color: #111827;\n  margin: 0 0 12px;\n  font-weight: 700;\n}\n\n.p2p-od-next-step p {\n  font-size: 17px;\n  color: #6B7280;\n  margin: 0 0 8px;\n}\n\n.p2p-od-subtext {\n  color: #6B7280;\n  font-size: 16px !important;\n  margin-bottom: 20px !important;\n}\n\n.p2p-od-action-btns {\n  display: flex;\n  gap: 16px;\n  margin: 24px 0px 5px;\n}\n\n.p2p-od-action-btns button {\n  border: none;\n  padding: 18px 32px;\n  border-radius: 30px;\n  font-weight: 700;\n  font-size: 18px;\n  width: 100%;\n}\n\n.p2p-od-paid-btn {\n  background: #D1AA67;\n  color: #fff;\n  cursor: pointer;\n}\n\n.p2p-od-cancel-btn {\n  background: #e5e7eb;\n  color: #4b5563;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n/* Description Card */\n.p2p-od-desc-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.p2p-od-desc-content ul {\n  margin: 0;\n  color: #bebebe;\n  font-size: 17px;\n  margin-top: 15px;\n  flex-direction: column;\n  gap: 6px;\n  display: flex;\n  line-height: 1.8;\n}\n\nbody.light_theme .p2p-od-desc-content ul {\n  color: #6b7280;\n}\n\n.p2p-od-desc-image {\n  width: 315px;\n}\n\n/* Right Column - Chat */\n.p2p-od-chat-card {\n  background: #F5F6F7;\n  border: 1px solid #EAEAEA;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.p2p-od-chat-header {\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.p2p-od-chat-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.p2p-od-chat-avatar {\n  width: 54px;\n  height: 54px;\n  background: #00D8FF;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.p2p-od-chat-info h4 {\n  margin: 0 0 4px;\n  font-size: 19px;\n  font-weight: 700;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.p2p-od-chat-info h4 i {\n  color: #22C55E;\n  font-size: 14px;\n}\n\n.p2ptop_right {\n  display: flex;\n  gap: 24px;\n}\n\n.p2p-od-chat-rating {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.p2p-od-chat-rating .stars {\n  color: #C28E27;\n  display: flex;\n  gap: 2px;\n}\n\n.p2p-od-chat-stats {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n\n.p2p-od-chat-stats>div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.p2p-od-chat-stats span {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.p2p-od-chat-stats strong {\n  font-size: 17px;\n  color: #111827;\n}\n\n.p2p-od-chat-badges {\n  display: flex;\n  gap: 12px;\n  justify-content: space-around;\n  margin-top: 10px;\n}\n\n.p2p-od-chat-badges span {\n  font-size: 12px;\n  color: #6B6F75;\n}\n\n.p2p-od-chat-body {\n  flex: 1;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n}\n\n.p2p-od-msg-row {\n  display: flex;\n  gap: 12px;\n}\n\n.p2p-od-msg-row.sent {\n  justify-content: flex-end;\n}\n\n.p2p-od-msg-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #00d8ff;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.p2p-od-msg-avatar.me {\n  background: #22C55E;\n}\n\n.p2p-od-msg-bubble {\n  background: #f3f4f6;\n  padding: 12px 16px;\n  border-radius: 0 12px 12px 12px;\n  font-size: 13px;\n  color: #374151;\n  max-width: 80%;\n}\n\n.p2p-od-msg-row.sent .p2p-od-msg-bubble {\n  background: #E8F5E9;\n  border-radius: 12px 0 12px 12px;\n}\n\n.p2p-od-msg-bubble p {\n  margin: 0 0 8px;\n  line-height: 1.5;\n}\n\n.p2p-od-msg-time {\n  font-size: 11px;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  justify-content: flex-end;\n}\n\n.p2p-od-msg-time i {\n  color: #10B981;\n}\n\n.p2p-od-msg-bubble.system-msg {\n  background: #E8F5E9;\n  border-radius: 12px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.p2p-od-chat-footer {\n  padding: 18px;\n  background-color: #fff;\n  /* border-top: 1px solid #e5e7eb; */\n  display: flex;\n  align-items: center;\n  border-radius: 12px;\n  gap: 12px;\n  width: 90%;\n  max-width: 100%;\n  margin: 20px auto;\n}\n\n.p2p-od-card.p2p-od-desc-card {\n  margin: 46px 0px 30px;\n  padding: 30px 48px;\n}\n\n.p2p-od-chat-footer input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 15px;\n}\n\n.p2p-od-chat-attach,\n.p2p-od-chat-send {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  font-size: 18px;\n}\n\n.p2p-od-chat-send {\n  color: #C28E27;\n}\n\n/* Dark Theme Overrides */\nbody.dark_theme .p2p-od-header-left h2,\nbody.dark_theme .p2p-od-timer-val,\nbody.dark_theme .p2p-od-info-col strong,\nbody.dark_theme .p2p-od-step.current .p2p-od-step-text-only,\nbody.dark_theme .p2p-od-step-text h4,\nbody.dark_theme .p2p-od-card h3,\nbody.dark_theme .p2p-od-detail-item strong,\nbody.dark_theme .p2p-od-pay-row strong,\nbody.dark_theme .p2p-od-next-step h3,\nbody.dark_theme .p2p-od-chat-info h4,\nbody.dark_theme .p2p-od-chat-stats strong {\n  color: #fff;\n}\n\nbody.dark_theme .p2p-od-stepper-container,\nbody.dark_theme .p2p-od-card,\nbody.dark_theme .p2p-od-chat-card {\n  background: #1e2026;\n  border-color: #303030;\n}\n\nbody.dark_theme .p2p-od-step-line,\nbody.dark_theme .p2p-od-step-line.dashed {\n  border-color: #444;\n  background: #444;\n}\n\nbody.dark_theme .p2p-od-step-line.dashed {\n  background: none;\n}\n\nbody.dark_theme .p2p-od-radio-label {\n  background: #2a2a36;\n  border-color: #444;\n  color: #ccc;\n}\n\nbody.dark_theme .p2p-od-radio-label.active {\n  background: #D1AA6710;\n  border-color: #D1AA67;\n}\n\nbody.dark_theme .p2p-od-payment-details,\nbody.dark_theme .p2p-od-msg-bubble {\n  background: #28292f;\n  color: #bfbfbf;\n}\n\nbody.dark_theme .p2p-od-msg-row.sent .p2p-od-msg-bubble {\n  background: #10B98120;\n}\n\nbody.dark_theme .p2p-od-msg-bubble.system-msg {\n  background: #10B98120;\n}\n\nbody.dark_theme .p2p-od-cancel-btn {\n  background: #333;\n  color: #ccc;\n}\n\nbody.dark_theme .p2p-od-chat-header,\nbody.dark_theme .p2p-od-chat-footer {\n  border-color: #333;\n}\n\nbody.dark_theme .p2p-od-chat-footer input {\n  color: #fff;\n}\n\n@media (max-width: 991px) {\n  .p2p-od-header-row {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  button.p2p-sidebar-collapse-btn {\n    background-color: transparent;\n    border: none;\n    color: #fff;\n    padding: 0px;\n  }\n\n  button.p2p-sidebar-collapse-btn i {\n    display: none;\n  }\n\n  .p2p-sidebar-nav {\n    padding: 20px 0px 32px 10px;\n  }\n\n  .p2p-od-main-body {\n    flex-direction: column;\n  }\n\n  .p2p-od-payment-split {\n    flex-direction: column;\n  }\n\n  .p2p-od-info-box {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .p2p-od-stepper-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .p2p-od-step-line {\n    display: none;\n  }\n}\n\n/* ==================== 9. CREATE P2P AD PAGE ==================== */\n/* [UNUSED]\n.p2p-cp-container {\n  max-width: 100%;\n}\n*/\n\n/* Top Header */\n/* [UNUSED]\n.p2p-cp-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-header-text h2 {\n  font-size: 40px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-header-text p {\n  color: #6b7280;\n  font-size: 18px;\n  margin: 0 0 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-escrow-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #D1AA67;\n  font-size: 15px;\n  font-weight: 400;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-header-stats {\n  display: flex;\n  gap: 32px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-stat {\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #99999920;\n  padding-right: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-stat:last-child {\n  border-right: none;\n  padding-right: 0px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-stat strong {\n  font-size: 15px;\n  color: #111827;\n  font-weight: 700;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-stat span {\n  font-size: 12px;\n  color: #9ca3af;\n}\n*/\n\n/* Main Layout */\n/* [UNUSED]\n.p2p-cp-main {\n  display: flex;\n  gap: 32px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-left {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n*/\n\n/* Form Steps */\n/* [UNUSED]\n.p2p-cp-step {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-step-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-step-num {\n  width: 28px;\n  height: 28px;\n  background: #111827;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-step-header h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n*/\n\n.text-muted {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.text-green {\n  color: #2BC287 !important;\n}\n\n.text-gold {\n  color: #D1AA67 !important;\n}\n\n/* Form Fields */\n/* [UNUSED]\n.p2p-cp-form-row {\n  display: grid;\n  gap: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-row.three-col {\n  grid-template-columns: 1fr 1fr 1fr;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-row.two-col {\n  grid-template-columns: 1fr 1fr;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-group label {\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 300;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-group select,\n.p2p-cp-form-group input[type=\"text\"],\n.p2p-cp-textarea-wrap textarea {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f9fafb;\n  font-size: 17px;\n  font-weight: 600;\n  color: #111827;\n  outline: none;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-group select:focus,\n.p2p-cp-form-group input[type=\"text\"]:focus,\n.p2p-cp-textarea-wrap textarea:focus {\n  border-color: #D1AA67;\n  background: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-select-wrapper {\n  position: relative;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-select-wrapper select.has-icon {\n  padding-left: 40px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-select-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-input-wrap input {\n  padding-right: 80px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-input-suffix {\n  position: absolute;\n  right: 16px;\n  color: #9ca3af;\n  font-size: 14px;\n  pointer-events: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-form-group small {\n  font-size: 12px;\n  color: #9ca3af;\n}\n*/\n\n/* Tabs */\n/* [UNUSED]\n.p2p-cp-tabs {\n  display: flex;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-tab {\n  flex: 1 1;\n  text-align: center;\n  padding: 14px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 400;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-tab.active {\n  background: #D1AA67;\n  color: #fff;\n}\n*/\n\n/* Notice */\n/* [UNUSED]\n.p2p-cp-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 13px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notice.yellow {\n  background: #FFF9ED;\n  color: #4B5563;\n  border: 1px solid #D1AA6720;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notice i {\n  font-size: 18px;\n  color: #D1AA67;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notice strong {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notice p {\n  margin: 0;\n}\n*/\n\n/* Payment Methods Grid */\n/* [UNUSED]\n.p2p-cp-pm-grid {\n  display: flex;\n  gap: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-pm-item {\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f9fafb;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-pm-item.active {\n  background: #FFFdf7;\n  border-color: #D1AA67;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-pm-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-pm-item i {\n  font-size: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-pm-add-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #D1AA67;\n  color: #fff;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-step-header h3 .text-muted {\n  font-weight: 600;\n}\n*/\n\n/* Textarea */\n/* [UNUSED]\n.p2p-cp-textarea-wrap {\n  position: relative;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-textarea-wrap textarea {\n  height: 120px;\n  resize: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-textarea-count {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n*/\n\n/* Conditions */\n/* [UNUSED]\n.p2p-cp-conditions {\n  display: flex;\n  gap: 32px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #4b5563;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-checkbox .check-box {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #D1AA67;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: transparent;\n  transition: all 0.2s;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-checkbox input[type=\"checkbox\"]:checked+.check-box {\n  background: #D1AA67;\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-days-input {\n  width: 50px;\n  padding: 4px 8px;\n  text-align: center;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  margin: 0 4px;\n}\n*/\n\n/* Important Notes */\n/* [UNUSED]\n.p2p-cp-notes {\n  margin-top: 20px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notes h4 {\n  font-size: 19px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notes ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notes li {\n  font-size: 14px;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-notes li i {\n  color: #D1AA67;\n}\n*/\n\n/* Ad Preview Card */\n/* [UNUSED]\n.p2p-cp-preview-card {\n  background: #f9fafb;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-header-section {\n  background: #0F172A;\n  padding: 24px;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-header span:first-child {\n  font-size: 16px;\n  font-weight: 700;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-badge-buy {\n  background: #14532D50;\n  color: #4ADE80;\n  border: 1px solid #14532D30;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-graphic {\n  margin: 10px 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-body {\n  padding: 32px;\n  background: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f3f4f6;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row.pm-row {\n  border-bottom: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row .label {\n  color: #6b7280;\n  font-size: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row .value {\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row .value strong {\n  font-size: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-preview-row .value small {\n  color: #9ca3af;\n}\n*/\n\n/* [UNUSED]\n.pm-icons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n*/\n\n/* [UNUSED]\n.pm-pill {\n  font-size: 12px;\n  color: #111827;\n  font-weight: 600;\n}\n*/\n\n/* [UNUSED]\n.pm-dots {\n  color: #9ca3af;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-remarks-box-preview {\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-remarks-box-preview h4 {\n  margin: 0 0 10px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-remarks-box-preview p {\n  margin: 0;\n  font-size: 13px;\n  background-color: #fff;\n  padding: 12px;\n  border-radius: 6px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-safe-notice {\n  display: flex;\n  gap: 12px;\n  background: #F0FDF4;\n  color: #6e6e6e;\n  padding: 16px;\n  border-radius: 8px;\n  font-size: 12px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-safe-notice i {\n  font-size: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-safe-notice p {\n  margin: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-agree-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: 13px;\n  color: #4b5563;\n  margin-top: 8px;\n  cursor: pointer;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-agree-check input {\n  display: none;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-agree-check .check-box {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #111827;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: transparent;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-agree-check input:checked+.check-box {\n  background: #111827;\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-submit-btn {\n  width: 100%;\n  background: #D1AA67;\n  color: #fff;\n  border: none;\n  padding: 18px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  margin-top: 12px;\n}\n*/\n\n/* Help Card */\n\n/* [UNUSED]\n.notes_help_bl.d-flex {\n  width: 100%;\n  justify-content: space-between;\n  gap: 32px;\n  border-top: 1px solid #F3F4F6;\n  margin-top: 30px;\n  padding-top: 50px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-help-card {\n  background: #F9FAFB;\n  width: 458px;\n  max-width: 100%;\n  border-radius: 16px;\n  padding: 32px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #F3F4F6;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-help-icon {\n  width: 48px;\n  height: 48px;\n  background: #111827;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: 16px;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-help-card h4 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #111827;\n  font-weight: 700;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-help-card p {\n  margin: 0 0 24px;\n  font-size: 14px;\n  color: #6b7280;\n}\n*/\n\n/* [UNUSED]\n.p2p-cp-help-btn {\n  background: #fff;\n  border: 1px solid #D48806;\n  color: #D48806;\n  padding: 10px 24px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n*/\n\n/* Dark Mode Overrides */\n/* [UNUSED]\nbody.dark_theme .p2p-cp-header-text h2,\nbody.dark_theme .p2p-cp-stat strong,\nbody.dark_theme .p2p-cp-step-header h3,\nbody.dark_theme .p2p-cp-form-group label,\nbody.dark_theme .p2p-cp-pm-name,\nbody.dark_theme .p2p-cp-notes h4,\nbody.dark_theme .p2p-cp-preview-row .value,\nbody.dark_theme .p2p-cp-remarks-box-preview h4,\nbody.dark_theme .p2p-cp-help-card h4,\nbody.dark_theme .pm-pill {\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-step-num {\n  background: #fff;\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-form-group select,\nbody.dark_theme .p2p-cp-form-group input[type=\"text\"],\nbody.dark_theme .p2p-cp-textarea-wrap textarea {\n  background: #1a1a24;\n  border-color: #333;\n  color: #fff;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-form-group select:focus,\nbody.dark_theme .p2p-cp-form-group input[type=\"text\"]:focus,\nbody.dark_theme .p2p-cp-textarea-wrap textarea:focus {\n  background: #2a2a36;\n  border-color: #D1AA67;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-tabs,\nbody.dark_theme .p2p-cp-pm-item,\nbody.dark_theme .p2p-cp-preview-card,\nbody.dark_theme .p2p-cp-help-card {\n  background: #1a1a24;\n  border-color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-preview-body {\n  background: #1a1a24;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-preview-row {\n  border-color: #333;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-remarks-box-preview {\n  background: #2a2a36;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-safe-notice {\n  background: #10B98120;\n  color: #10B981;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-agree-check .check-box {\n  border-color: #fff;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-agree-check input:checked+.check-box {\n  background: #fff;\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-help-icon {\n  background: #fff;\n  color: #111827;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-pm-item.active {\n  background: #D1AA6710;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-agree-check {\n  color: #ccc;\n}\n*/\n\n/* [UNUSED]\nbody.dark_theme .p2p-cp-days-input {\n  background: #1a1a24;\n  border-color: #333;\n  color: #fff;\n}\n*/\n\n@media (max-width: 991px) {\n  /* [UNUSED]\n.p2p-cp-header {\n    flex-direction: column;\n    gap: 24px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-cp-main {\n    flex-direction: column;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-cp-form-row.three-col,\n  .p2p-cp-form-row.two-col,\n  .p2p-cp-pm-grid {\n    grid-template-columns: 1fr;\n    display: grid;\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-cp-conditions {\n    flex-direction: column;\n    gap: 16px;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-cp-header-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    width: 100%;\n  }\n*/\n}\n\n/* ==========================================================================\n   P2P MY ORDERS PAGE (ORDERS LISTING - EXACT SCREENSHOT DESIGN)\n   ========================================================================== */\n\n.p2p-my-orders-container {\n  padding: 0px 5px 48px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.p2p-my-orders-header {\n  margin-bottom: 24px;\n}\n\n.p2p-my-orders-header h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1E2329;\n  letter-spacing: -0.5px;\n  margin-bottom: 6px;\n}\n\nbody.dark_theme .p2p-my-orders-header h2,\nbody[data-theme=\"dark\"] .p2p-my-orders-header h2 {\n  color: #ffffff;\n}\n\n.p2p-my-orders-header p {\n  font-size: 17px;\n  color: #707A8A;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-my-orders-header p,\nbody[data-theme=\"dark\"] .p2p-my-orders-header p {\n  color: #9ca3af;\n}\n\n/* 2. Top Navigation Tabs */\n.p2p-mo-top-nav {\n  display: flex;\n  gap: 36px;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 24px;\n}\n\nbody.dark_theme .p2p-mo-top-nav,\nbody[data-theme=\"dark\"] .p2p-mo-top-nav {\n  border-bottom-color: #2e2e3d;\n}\n\n.p2p-mo-top-tab {\n  background: none;\n  border: none;\n  padding: 13px 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #707A8A;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.p2p-mo-top-tab:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-mo-top-tab:hover,\nbody[data-theme=\"dark\"] .p2p-mo-top-tab:hover {\n  color: #ffffff;\n}\n\n.p2p-mo-top-tab.active {\n  color: #111827;\n  font-weight: 700;\n}\n\nbody.dark_theme .p2p-mo-top-tab.active,\nbody[data-theme=\"dark\"] .p2p-mo-top-tab.active {\n  color: #ffffff;\n}\n\n.p2p-mo-top-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  margin: 0 auto;\n  left: 0;\n  max-width: 50%;\n  right: 0;\n  height: 2.5px;\n  background-color: #111827;\n}\n\nbody.dark_theme .p2p-mo-top-tab.active::after,\nbody[data-theme=\"dark\"] .p2p-mo-top-tab.active::after {\n  background-color: #ffffff;\n}\n\n/* 3. Sub-filter Pills & Action Icons */\n.p2p-mo-subnav-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.p2p-mo-pill-group {\n  display: inline-flex;\n  background-color: #F0F0F0;\n  border-radius: 50px;\n  padding: 4px;\n  gap: 4px;\n}\n\nbody.dark_theme .p2p-mo-pill-group,\nbody[data-theme=\"dark\"] .p2p-mo-pill-group {\n  background-color: #20202c;\n}\n\n.p2p-mo-pill-btn {\n  background: transparent;\n  border: none;\n  padding: 8px 24px;\n  border-radius: 50px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #707A8A;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-mo-pill-btn,\nbody[data-theme=\"dark\"] .p2p-mo-pill-btn {\n  color: #9ca3af;\n}\n\n.p2p-mo-pill-btn:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-mo-pill-btn:hover,\nbody[data-theme=\"dark\"] .p2p-mo-pill-btn:hover {\n  color: #ffffff;\n}\n\n.p2p-mo-pill-btn.active {\n  background-color: #111827;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n}\n\nbody.dark_theme .p2p-mo-pill-btn.active,\nbody[data-theme=\"dark\"] .p2p-mo-pill-btn.active {\n  background-color: #323244;\n  color: #ffffff;\n}\n\n.p2p-mo-action-icons {\n  display: flex;\n  gap: 10px;\n}\n\n.p2p-mo-icon-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  background-color: #ffffff;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 17px;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-mo-icon-btn,\nbody[data-theme=\"dark\"] .p2p-mo-icon-btn {\n  background-color: #1c1c26;\n  border-color: #2b2b3a;\n  color: #9ca3af;\n}\n\n.p2p-mo-icon-btn:hover {\n  border-color: #D1AA67;\n  color: #D1AA67;\n  transform: translateY(-1px);\n}\n\n/* 4. Summary Stats Cards */\n.p2p-mo-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n  margin-bottom: 24px;\n}\n\n.p2p-mo-stat-card {\n  background-color: #F0F0F0;\n  border: 1px solid #EAECEF;\n  border-radius: 18px;\n  padding: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.p2p-mo-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);\n}\n\nbody.dark_theme .p2p-mo-stat-card,\nbody[data-theme=\"dark\"] .p2p-mo-stat-card {\n  background-color: #1e2026;\n  border-color: #2b2b3a;\n}\n\n.p2p-mo-stat-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #707A8A;\n  margin-bottom: 12px;\n}\n\nbody.dark_theme .p2p-mo-stat-header,\nbody[data-theme=\"dark\"] .p2p-mo-stat-header {\n  color: #9ca3af;\n}\n\n.p2p-mo-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.p2p-mo-dot.blue {\n  background-color: #3B82F6;\n}\n\n.p2p-mo-dot.green {\n  background-color: #10B981;\n}\n\n.p2p-mo-dot.red {\n  background-color: #EF4444;\n}\n\n.p2p-mo-dot.purple {\n  background-color: #8B5CF6;\n}\n\n.p2p-mo-stat-val {\n  font-size: 34px;\n  font-weight: 800;\n  color: #1E2329;\n  line-height: 1;\n  letter-spacing: -0.5px;\n}\n\nbody.dark_theme .p2p-mo-stat-val,\nbody[data-theme=\"dark\"] .p2p-mo-stat-val {\n  color: #ffffff;\n}\n\n.p2p-mo-stat-badge {\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n}\n\n.p2p-mo-stat-badge.yellow {\n  background-color: #FEFCE8;\n  color: #FCD535;\n}\n\n.p2p-mo-stat-badge.green {\n  background-color: #F0FDF4;\n  color: #0ECB81;\n}\n\n.p2p-mo-stat-badge.red {\n  background-color: #FEF2F2;\n  color: #F6465D;\n}\n\n.p2p-mo-stat-badge.purple {\n  background-color: #FAF5FF;\n  color: #A855F7;\n}\n\nbody.dark_theme .p2p-mo-stat-badge.yellow,\nbody[data-theme=\"dark\"] .p2p-mo-stat-badge.yellow {\n  background-color: rgba(217, 119, 6, 0.18);\n  color: #FBBF24;\n}\n\nbody.dark_theme .p2p-mo-stat-badge.green,\nbody[data-theme=\"dark\"] .p2p-mo-stat-badge.green {\n  background-color: rgba(16, 185, 129, 0.18);\n  color: #34D399;\n}\n\nbody.dark_theme .p2p-mo-stat-badge.red,\nbody[data-theme=\"dark\"] .p2p-mo-stat-badge.red {\n  background-color: rgba(239, 68, 68, 0.18);\n  color: #F87171;\n}\n\nbody.dark_theme .p2p-mo-stat-badge.purple,\nbody[data-theme=\"dark\"] .p2p-mo-stat-badge.purple {\n  background-color: rgba(139, 92, 246, 0.18);\n  color: #A78BFA;\n}\n\n/* 5. Second Filter Row */\n.p2p-mo-filter-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 22px;\n  flex-wrap: wrap;\n}\n\n.p2p-mo-filter-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.p2p-mo-select-wrap {\n  background-color: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 8px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  position: relative;\n}\n\nbody.dark_theme .p2p-mo-select-wrap,\nbody[data-theme=\"dark\"] .p2p-mo-select-wrap {\n  background-color: transparent;\n  border-color: #2b2b3a;\n}\n\n.p2p-mo-select-wrap label {\n  color: #9CA3AF;\n  font-size: 13.5px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.p2p-mo-native-select {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  cursor: pointer;\n  padding-right: 4px;\n  appearance: none;\n}\n\nbody.dark_theme .p2p-mo-native-select,\nbody[data-theme=\"dark\"] .p2p-mo-native-select {\n  color: #ffffff;\n  background-color: #1c1c26;\n}\n\n.p2p-mo-select-wrap i {\n  font-size: 16px;\n  color: #6b7280;\n  pointer-events: none;\n}\n\n.p2p-mo-date-wrap {\n  background-color: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 8px 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-mo-date-wrap,\nbody[data-theme=\"dark\"] .p2p-mo-date-wrap {\n  background-color: transparent;\n  border-color: #2b2b3a;\n  color: #ffffff;\n}\n\n.p2p-mo-date-wrap i {\n  color: #9CA3AF;\n  font-size: 16px;\n}\n\n.p2p-mo-filter-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.p2p-mo-search-box {\n  background-color: #FAFAFA;\n  border: 1px solid #EAECEF;\n  border-radius: 9px;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 250px;\n}\n\nbody.dark_theme .p2p-mo-search-box,\nbody[data-theme=\"dark\"] .p2p-mo-search-box {\n  background-color: transparent;\n  border-color: #2b2b3a;\n}\n\n.p2p-mo-search-box i {\n  color: #9CA3AF;\n  font-size: 16px;\n}\n\n.p2p-mo-search-box input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 15px;\n  color: #111827;\n  width: 100%;\n}\n\nbody.dark_theme .p2p-mo-search-box input,\nbody[data-theme=\"dark\"] .p2p-mo-search-box input {\n  color: #ffffff;\n}\n\n.p2p-mo-search-box input::placeholder {\n  color: #9CA3AF;\n}\n\n.p2p-mo-reset-btn {\n  background-color: #1E2329;\n  color: #ffffff;\n  border: none;\n  border-radius: 9px;\n  padding: 10px 28px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.p2p-mo-reset-btn:hover {\n  background-color: #374151;\n}\n\nbody.dark_theme .p2p-mo-reset-btn,\nbody[data-theme=\"dark\"] .p2p-mo-reset-btn {\n  background-color: #2E2E3E;\n  color: #ffffff;\n}\n\nbody.dark_theme .p2p-mo-reset-btn:hover,\nbody[data-theme=\"dark\"] .p2p-mo-reset-btn:hover {\n  background-color: #3E3E52;\n}\n\n/* 6. Orders Table Card */\n.p2p-mo-table-card {\n  background-color: rgb(255 255 255 / 10%);\n  border: 1px solid #EAECEF;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);\n}\n\nbody.dark_theme .p2p-mo-table-card,\nbody[data-theme=\"dark\"] .p2p-mo-table-card {\n  background-color: #1e2026;\n  border-color: #2b2b3a;\n}\n\n.p2p-mo-table-responsive {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.p2p-mo-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.p2p-mo-table th {\n  padding: 18px 24px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6C6969;\n  border-bottom: 1px solid #EFEFEF;\n  background-color: #ffffff;\n  white-space: nowrap;\n}\n\nbody.dark_theme .p2p-mo-table th,\nbody[data-theme=\"dark\"] .p2p-mo-table th {\n  background-color: #1c1c26;\n  color: #9CA3AF;\n  border-bottom-color: #2b2b3a;\n}\n\n.p2p-mo-table td {\n  padding: 20px 24px;\n  font-size: 14px;\n  border-bottom: 1px solid #F3F4F6;\n  vertical-align: middle;\n}\n\nbody.dark_theme .p2p-mo-table td,\nbody[data-theme=\"dark\"] .p2p-mo-table td {\n  border-bottom-color: #262635;\n}\n\n.p2p-mo-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.p2p-mo-table tbody tr:hover td {\n  background-color: rgba(0, 0, 0, 0.012);\n}\n\nbody.dark_theme .p2p-mo-table tbody tr:hover td,\nbody[data-theme=\"dark\"] .p2p-mo-table tbody tr:hover td {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n/* Row elements */\n.p2p-mo-type-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.p2p-mo-type-line {\n  font-size: 15px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.p2p-mo-side.buy {\n  color: #2BC287;\n}\n\n.p2p-mo-side.sell {\n  color: #EC6072;\n}\n\n.p2p-mo-asset {\n  color: #111827;\n  font-weight: 700;\n}\n\nbody.dark_theme .p2p-mo-asset,\nbody[data-theme=\"dark\"] .p2p-mo-asset {\n  color: #ffffff;\n}\n\n.p2p-mo-date-line {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12.5px;\n  color: #9CA3AF;\n}\n\n.p2p-mo-date-line i {\n  font-size: 13px;\n}\n\n.p2p-mo-order-id-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-mo-order-num {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1E2329;\n  text-decoration: underline;\n  cursor: pointer;\n  letter-spacing: -0.2px;\n}\n\nbody.dark_theme .p2p-mo-order-num,\nbody[data-theme=\"dark\"] .p2p-mo-order-num {\n  color: #ffffff;\n}\n\n.p2p-mo-copy-btn {\n  background: none;\n  border: none;\n  color: #9CA3AF;\n  cursor: pointer;\n  padding: 0;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n\n.p2p-mo-copy-btn:hover {\n  color: #D1AA67;\n}\n\n.p2p-mo-price-val {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-mo-price-val,\nbody[data-theme=\"dark\"] .p2p-mo-price-val {\n  color: #ffffff;\n}\n\n.p2p-mo-amount-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.p2p-mo-fiat-val {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-mo-fiat-val,\nbody[data-theme=\"dark\"] .p2p-mo-fiat-val {\n  color: #ffffff;\n}\n\n.p2p-mo-crypto-val {\n  font-size: 12.5px;\n  color: #9CA3AF;\n}\n\n.p2p-mo-counterparty-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.p2p-mo-user-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-mo-user-name,\nbody[data-theme=\"dark\"] .p2p-mo-user-name {\n  color: #ffffff;\n}\n\n.p2p-mo-chat-pill {\n  display: inline-block;\n  background-color: #ffffff;\n  border: 1px solid #EAECEF;\n  border-radius: 4px;\n  padding: 1px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #707A8A;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-mo-chat-pill,\nbody[data-theme=\"dark\"] .p2p-mo-chat-pill {\n  background-color: #242432;\n  border-color: #353548;\n  color: #D1D5DB;\n}\n\n.p2p-mo-chat-pill:hover {\n  border-color: #D1AA67;\n  color: #D1AA67;\n}\n\n.p2p-mo-status-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.p2p-mo-status-badge {\n  display: inline-block;\n  padding: 4px 14px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  font-weight: 500;\n}\n\n.p2p-mo-status-badge.cancelled {\n  background-color: #FFEDF1;\n  color: #F6465D;\n}\n\n.p2p-mo-status-badge.completed {\n  background-color: #D1FAE5;\n  color: #10B981;\n}\n\n.p2p-mo-status-badge.processing {\n  background-color: #FEF3C7;\n  color: #D97706;\n}\n\n.p2p-mo-status-badge.appeal {\n  background-color: #EDE9FE;\n  color: #8B5CF6;\n}\n\nbody.dark_theme .p2p-mo-status-badge.cancelled,\nbody[data-theme=\"dark\"] .p2p-mo-status-badge.cancelled {\n  background-color: rgba(239, 68, 68, 0.18);\n  color: #F87171;\n}\n\nbody.dark_theme .p2p-mo-status-badge.completed,\nbody[data-theme=\"dark\"] .p2p-mo-status-badge.completed {\n  background-color: rgba(16, 185, 129, 0.18);\n  color: #34D399;\n}\n\nbody.dark_theme .p2p-mo-status-badge.processing,\nbody[data-theme=\"dark\"] .p2p-mo-status-badge.processing {\n  background-color: rgba(217, 119, 6, 0.18);\n  color: #FBBF24;\n}\n\nbody.dark_theme .p2p-mo-status-badge.appeal,\nbody[data-theme=\"dark\"] .p2p-mo-status-badge.appeal {\n  background-color: rgba(139, 92, 246, 0.18);\n  color: #A78BFA;\n}\n\n.p2p-mo-appeal-link {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.p2p-mo-appeal-link:hover {\n  color: #111827;\n  text-decoration: underline;\n}\n\nbody.dark_theme .p2p-mo-appeal-link,\nbody[data-theme=\"dark\"] .p2p-mo-appeal-link {\n  color: #9CA3AF;\n}\n\nbody.dark_theme .p2p-mo-appeal-link:hover,\nbody[data-theme=\"dark\"] .p2p-mo-appeal-link:hover {\n  color: #ffffff;\n}\n\n.p2p-mo-empty-row {\n  text-align: center;\n  padding: 60px 20px !important;\n}\n\n.p2p-mo-empty-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #9CA3AF;\n}\n\n.p2p-mo-empty-content i {\n  font-size: 40px;\n}\n\n.p2p-mo-empty-content p {\n  font-size: 14.5px;\n  margin: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .p2p-mo-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .p2p-my-orders-container {\n    padding: 20px 16px 36px;\n  }\n\n  .p2p-mo-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-mo-filter-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .p2p-mo-filter-left,\n  .p2p-mo-filter-right {\n    width: 100%;\n  }\n\n  .p2p-mo-search-box {\n    width: 100%;\n  }\n}\n\n/* ==========================================================================\n   P2P POST NORMAL AD (3-STEP MULTI-STEP FORM & CONFIRMATION MODAL)\n   ========================================================================== */\n\n.p2p-post-ad-page {\n  padding: 0px 5px 50px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.p2p-post-ad-header {\n  margin-bottom: 28px;\n}\n\n.p2p-post-ad-header h2 {\n  font-size: 48px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -1px;\n  margin-bottom: 6px;\n}\n\nbody.dark_theme .p2p-post-ad-header h2,\nbody[data-theme=\"dark\"] .p2p-post-ad-header h2 {\n  color: #ffffff;\n}\n\n.p2p-post-ad-header p {\n  font-size: 22px;\n  color: #514535;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-post-ad-header p,\nbody[data-theme=\"dark\"] .p2p-post-ad-header p {\n  color: #9CA3AF;\n}\n\n/* 2. Stepper Bar (Exact Match with Screenshot) */\n.p2p-post-stepper-wrap {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  width: 100%;\n  margin-bottom: 36px;\n}\n\n.p2p-stepper-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;\n}\n\n.p2p-stepper-node-wrap {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 38px;\n}\n\n.p2p-stepper-spacer {\n  flex: 1;\n}\n\n.p2p-stepper-line-half {\n  flex: 1;\n  height: 2px;\n  background-color: #E2E8F0;\n  position: relative;\n  overflow: hidden;\n}\n\nbody.dark_theme .p2p-stepper-line-half,\nbody[data-theme=\"dark\"] .p2p-stepper-line-half {\n  background-color: #2D2D3E;\n}\n\n.p2p-stepper-line-fill {\n  height: 100%;\n  background-color: #CAA368;\n  transition: width 0.3s ease;\n}\n\n.p2p-stepper-circle {\n  width: 48px;\n  height: 48px;\n  min-width: 48px;\n  border-radius: 50%;\n  background-color: #EEF1F5;\n  color: #3F3F3F;\n  font-size: 18px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.25s ease;\n  z-index: 2;\n}\n\nbody.dark_theme .p2p-stepper-circle,\nbody[data-theme=\"dark\"] .p2p-stepper-circle {\n  background-color: #262636;\n  color: #9CA3AF;\n}\n\n.p2p-stepper-circle.gold {\n  background-color: #CAA368;\n  color: #ffffff;\n}\n\n.p2p-stepper-circle.step-3-circle {\n  background-color: #EEF2F6;\n  color: #1F2937;\n  font-weight: 700;\n}\n\nbody.dark_theme .p2p-stepper-circle.step-3-circle,\nbody[data-theme=\"dark\"] .p2p-stepper-circle.step-3-circle {\n  background-color: #262636;\n  color: #E2E8F0;\n}\n\n.p2p-stepper-label {\n  text-align: center;\n  margin-top: 22px;\n  padding: 0 8px;\n}\n\n.p2p-stepper-label h4 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #171C22;\n  margin: 0 0 7px 0;\n}\n\nbody.dark_theme .p2p-stepper-label h4,\nbody[data-theme=\"dark\"] .p2p-stepper-label h4 {\n  color: #ffffff;\n}\n\n.p2p-stepper-label p {\n  font-size: 18px;\n  color: #656565;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-stepper-label p,\nbody[data-theme=\"dark\"] .p2p-stepper-label p {\n  color: #9CA3AF;\n}\n\n/* Step 3 Notice Box */\n.p2p-post-notice-box {\n  background-color: #FFF9EB;\n  border: 1px solid #FDE6B5;\n  border-radius: 18px;\n  padding: 24px;\n  margin-bottom: 32px;\n}\n\nbody.dark_theme .p2p-post-notice-box,\nbody[data-theme=\"dark\"] .p2p-post-notice-box {\n  background-color: #262118;\n  border-color: #483A20;\n}\n\n.p2p-post-notice-box h4 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #1A1A1A;\n  margin: 0 0 6px;\n  line-height: 1.4;\n}\n\nbody.dark_theme .p2p-post-notice-box h4,\nbody[data-theme=\"dark\"] .p2p-post-notice-box h4 {\n  color: #FBBF24;\n}\n\n.p2p-post-notice-box p {\n  font-size: 17px;\n  color: #666666;\n  margin: 0;\n  line-height: 1.5;\n}\n\nbody.dark_theme .p2p-post-notice-box p,\nbody[data-theme=\"dark\"] .p2p-post-notice-box p {\n  color: #D1B888;\n}\n\n/* 4. Form Card */\n.p2p-post-form-card {\n  /* background-color: #ffffff; */\n  border: 1px solid #DEE3EB;\n  border-radius: 22px;\n  padding: 42px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);\n}\n\nbody.dark_theme .p2p-post-form-card,\nbody[data-theme=\"dark\"] .p2p-post-form-card {\n  background-color: #1e2026;\n  border-color: #272733;\n}\n\n/* Buy / Sell Pill Toggle */\n.p2p-post-pill-toggle {\n  display: inline-flex;\n  background-color: #F0F0F0;\n  border-radius: 50px;\n  padding: 5px;\n  margin-bottom: 24px;\n}\n\nbody.dark_theme .p2p-post-pill-toggle,\nbody[data-theme=\"dark\"] .p2p-post-pill-toggle {\n  background-color: #262636;\n}\n\n.p2p-post-toggle-btn {\n  background: transparent;\n  border: none;\n  border-radius: 50px;\n  padding: 12px 32px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #646464;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-post-toggle-btn,\nbody[data-theme=\"dark\"] .p2p-post-toggle-btn {\n  color: #9CA3AF;\n}\n\n.p2p-post-toggle-btn.active {\n  background-color: #111827;\n  color: #ffffff;\n  /* font-weight: 700; */\n  box-shadow: 0 3px 0px #d1aa67;\n}\n\nbody.dark_theme .p2p-post-toggle-btn.active,\nbody[data-theme=\"dark\"] .p2p-post-toggle-btn.active {\n  background-color: #374151;\n  color: #ffffff;\n}\n\n/* Form Row & Fields */\n.p2p-post-row {\n  display: flex;\n  gap: 20px;\n}\n\n.p2p-post-row.two-col>* {\n  flex: 1;\n}\n\n.p2p-post-field {\n  margin-bottom: 24px;\n}\n\n.p2p-post-field label {\n  display: block;\n  font-size: 18px;\n  font-weight: 500;\n  color: #171C22;\n  margin-bottom: 6px;\n}\n\nbody.dark_theme .p2p-post-field label,\nbody[data-theme=\"dark\"] .p2p-post-field label {\n  color: #D1D5DB;\n}\n\n.p2p-info-icon {\n  font-size: 14px;\n  color: #9CA3AF;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n/* Select Box */\n.p2p-post-select-box {\n  background-color: #F5F6F7;\n  border: 1.80px solid #DEE3EB;\n  border-radius: 14px;\n  padding: 15px 16px;\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  transition: border-color 0.2s ease;\n}\n\nbody.dark_theme .p2p-post-select-box,\nbody[data-theme=\"dark\"] .p2p-post-select-box {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-select-box select {\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  font-weight: 400;\n  color: #171C22;\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n}\n\nbody.dark_theme .p2p-post-select-box select,\nbody[data-theme=\"dark\"] .p2p-post-select-box select {\n  color: #ffffff;\n}\n\n.p2p-post-select-box i {\n  color: #6B7280;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.p2p-time-icon {\n  font-size: 18px !important;\n  color: #9CA3AF !important;\n}\n\n/* Coin Icons */\n.p2p-post-coin-icon {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.p2p-post-coin-icon.usdt {\n  background-color: #26A17B;\n}\n\n.p2p-post-coin-icon.inr {\n  background-color: #F59E0B;\n}\n\n/* Price Type Grid */\n.p2p-post-price-type-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.p2p-post-price-card {\n  border: 1.80px solid #E5E7EB;\n  border-radius: 14px;\n  padding: 15px 24px;\n  min-height: 72px;\n  background-color: #F8F9FA;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-post-price-card,\nbody[data-theme=\"dark\"] .p2p-post-price-card {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-price-card span {\n  font-size: 15px;\n  font-weight: 600;\n  color: #374151;\n}\n\nbody.dark_theme .p2p-post-price-card span,\nbody[data-theme=\"dark\"] .p2p-post-price-card span {\n  color: #D1D5DB;\n}\n\n.p2p-post-price-card.active {\n  background-color: #C9A86A;\n  border-color: #C9A86A;\n}\n\n.p2p-post-price-card.active span {\n  color: #ffffff;\n}\n\n.p2p-post-radio-circle {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #9CA3AF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-post-price-card.active .p2p-post-radio-circle {\n  border-color: #ffffff;\n}\n\n.p2p-post-radio-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #ffffff;\n}\n\n/* Fixed Price Stepper */\n.p2p-post-stepper-input {\n  background-color: #F5F6F7;\n  border: 1.80px solid #DEE3EB;\n  border-radius: 14px;\n  padding: 15px 16px;\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\nbody.dark_theme .p2p-post-stepper-input,\nbody[data-theme=\"dark\"] .p2p-post-stepper-input {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-step-btn {\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  font-weight: 300;\n  color: #6B7280;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.15s ease;\n}\n\n.p2p-post-step-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #111827;\n}\n\nbody.dark_theme .p2p-post-step-btn:hover,\nbody[data-theme=\"dark\"] .p2p-post-step-btn:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.p2p-post-num-input {\n  border: none;\n  background: transparent;\n  font-size: 36px;\n  font-weight: 700;\n  color: #171C22;\n  text-align: center;\n  width: 250px;\n  outline: none;\n}\n\nbody.dark_theme .p2p-post-num-input,\nbody[data-theme=\"dark\"] .p2p-post-num-input {\n  color: #ffffff;\n}\n\n.p2p-post-field-hint {\n  font-size: 18px;\n  color: #514535;\n  display: block;\n  margin: 15px 0px 20px;\n}\n\nbody.dark_theme .p2p-post-field-hint,\nbody[data-theme=\"dark\"] .p2p-post-field-hint {\n  color: #9CA3AF;\n}\n\n/* Price Summary Box */\n.p2p-post-summary-card {\n  background-color: #FDFBF7;\n  border: 1px solid #F5ECD8;\n  border-radius: 14px;\n  padding: 22px 28px;\n  display: flex;\n  gap: 40px;\n  margin-top: 24px;\n}\n\nbody.dark_theme .p2p-post-summary-card,\nbody[data-theme=\"dark\"] .p2p-post-summary-card {\n  background-color: #26272d;\n  border-color: #35332f;\n}\n\n.p2p-post-summary-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  width: 100%;\n}\n\n.p2p-post-summary-label {\n  font-size: 19px;\n  color: #514535;\n}\n\nbody.dark_theme .p2p-post-summary-label,\nbody[data-theme=\"dark\"] .p2p-post-summary-label {\n  color: #9CA3AF;\n}\n\n.p2p-post-summary-val {\n  font-size: 38px;\n  font-weight: 800;\n  color: #171C22;\n}\n\nbody.dark_theme .p2p-post-summary-val,\nbody[data-theme=\"dark\"] .p2p-post-summary-val {\n  color: #ffffff;\n}\n\n/* Step 2: Total Amount */\n.p2p-post-amount-wrap {\n  background-color: #F5F6F7;\n  border: 1.80px solid #DEE3EB;\n  border-radius: 14px;\n  padding: 15px 16px;\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\nbody.dark_theme .p2p-post-amount-wrap,\nbody[data-theme=\"dark\"] .p2p-post-amount-wrap {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-amount-wrap input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  font-weight: 400;\n  color: #171C22;\n  outline: none;\n}\n\nbody.dark_theme .p2p-post-amount-wrap input,\nbody[data-theme=\"dark\"] .p2p-post-amount-wrap input {\n  color: #ffffff;\n}\n\n.p2p-post-amount-curr {\n  font-size: 20px;\n  font-weight: 500;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-post-amount-curr,\nbody[data-theme=\"dark\"] .p2p-post-amount-curr {\n  color: #ffffff;\n}\n\n.p2p-post-amount-all {\n  background: none;\n  border: none;\n  color: #D1AA67;\n  font-weight: 500;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.p2p-post-amount-subtext {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n  font-size: 17px;\n  color: #6B7280;\n}\n\nbody.dark_theme .p2p-post-amount-subtext,\nbody[data-theme=\"dark\"] .p2p-post-amount-subtext {\n  color: #9CA3AF;\n}\n\n.p2p-post-avail {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Order Limits */\n.p2p-post-limits-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.p2p-post-limit-box {\n  flex: 1;\n  background-color: #F8F9FA;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 10px 16px;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.dark_theme .p2p-post-limit-box,\nbody[data-theme=\"dark\"] .p2p-post-limit-box {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-limit-label {\n  font-size: 15px;\n  color: #6B7280;\n  margin-bottom: 4px;\n}\n\nbody.dark_theme .p2p-post-limit-label,\nbody[data-theme=\"dark\"] .p2p-post-limit-label {\n  color: #9CA3AF;\n}\n\n.p2p-post-limit-box input {\n  border: none;\n  background: transparent;\n  font-size: 18px;\n  font-weight: 400;\n  color: #111827;\n  outline: none;\n  padding: 0;\n}\n\nbody.dark_theme .p2p-post-limit-box input,\nbody[data-theme=\"dark\"] .p2p-post-limit-box input {\n  color: #ffffff;\n}\n\n.p2p-post-limit-hint {\n  font-size: 15px;\n  color: #606060;\n  margin-top: 4px;\n}\n\n.p2p-post-limit-sep {\n  font-size: 18px;\n  color: #9CA3AF;\n}\n\n/* Textareas (Remarks & Auto Reply) */\n.p2p-post-textarea-wrap {\n  background-color: #F5F6F7;\n  border: 1.80px solid #DEE3EB;\n  border-radius: 14px;\n  padding: 15px 16px;\n  position: relative;\n}\n\nbody.dark_theme .p2p-post-textarea-wrap,\nbody[data-theme=\"dark\"] .p2p-post-textarea-wrap {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-textarea-wrap textarea {\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  resize: vertical;\n  min-height: 90px;\n  font-size: 20px;\n  font-weight: 400;\n  color: #171C22;\n  line-height: 1.5;\n}\n\nbody.dark_theme .p2p-post-textarea-wrap textarea,\nbody[data-theme=\"dark\"] .p2p-post-textarea-wrap textarea {\n  color: #ffffff;\n}\n\n.p2p-post-char-count {\n  display: block;\n  text-align: right;\n  font-size: 16px;\n  color: #9CA3AF;\n  margin-top: 6px;\n}\n\n/* Counterparty Conditions */\n.p2p-post-conditions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 4px;\n}\n\n.p2p-post-field label.p2p-post-checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  color: #374151;\n  font-weight: 400;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-post-checkbox-item,\nbody[data-theme=\"dark\"] .p2p-post-checkbox-item {\n  color: #D1D5DB;\n}\n\n.p2p-post-inline-num {\n  width: 60px;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  text-align: center;\n  background: #ffffff;\n  outline: none;\n}\n\nbody.dark_theme .p2p-post-inline-num,\nbody[data-theme=\"dark\"] .p2p-post-inline-num {\n  background: #222230;\n  border-color: #2E2E40;\n  color: #ffffff;\n}\n\n/* Status Radio Cards */\n.p2p-post-status-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.p2p-post-status-card {\n  border: 1px solid #E5E7EB;\n  border-radius: 18px;\n  padding: 16px 18px;\n  background-color: #F8F9FA;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-post-status-card,\nbody[data-theme=\"dark\"] .p2p-post-status-card {\n  background-color: #1f2026;\n  border-color: #2d2d33;\n}\n\n.p2p-post-status-card.active {\n  background-color: #FFF9EB;\n  border: 3px solid #D1AA67;\n}\n\nbody.dark_theme .p2p-post-status-card.active,\nbody[data-theme=\"dark\"] .p2p-post-status-card.active {\n  border-color: #C9A86A;\n  background-color: #262118;\n}\n\n.p2p-post-status-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.p2p-post-status-head strong {\n  font-size: 18px;\n  color: #1A1A1A;\n}\n\nbody.dark_theme .p2p-post-status-head strong,\nbody[data-theme=\"dark\"] .p2p-post-status-head strong {\n  color: #ffffff;\n}\n\n.p2p-post-status-dot.online {\n  color: #10B981;\n}\n\n.p2p-post-status-dot.offline {\n  color: #6B7280;\n}\n\n.p2p-post-status-dot.private {\n  color: #3B82F6;\n}\n\n.p2p-post-status-card p {\n  font-size: 16px;\n  color: #666666;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-post-status-card p,\nbody[data-theme=\"dark\"] .p2p-post-status-card p {\n  color: #9CA3AF;\n}\n\n/* 5. Help Strip */\n.p2p-post-help-strip {\n  background-color: #F0F4FC;\n  border-radius: 22px;\n  min-height: 120px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 36px 0px;\n}\n\nbody.dark_theme .p2p-post-help-strip,\nbody[data-theme=\"dark\"] .p2p-post-help-strip {\n  background-color: #1D232C;\n}\n\n.p2p-post-help-left {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  font-size: 18px;\n  color: #374151;\n}\n\n.p2p-post-help-left strong {\n  font-weight: 500;\n}\n\nbody.dark_theme .p2p-post-help-left,\nbody[data-theme=\"dark\"] .p2p-post-help-left {\n  color: #D1D5DB;\n}\n\n.p2p-post-guide-link {\n  color: #2563EB;\n  font-weight: 500;\n  font-size: 18px;\n  text-decoration: none;\n  margin-right: 5px;\n}\n\n.p2p-post-guide-link:hover {\n  text-decoration: underline;\n}\n\n/* 6. Bottom Action Bar */\n.p2p-post-bottom-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.p2p-post-fee-note {\n  font-size: 18px;\n  color: #4B5563;\n}\n\n.p2p-post-fee-note strong {\n  font-weight: 700;\n  color: #fff;\n}\n\nbody.light_theme .p2p-post-fee-note strong {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-post-fee-note,\nbody[data-theme=\"dark\"] .p2p-post-fee-note {\n  color: #9CA3AF;\n}\n\n.p2p-post-action-btns {\n  display: flex;\n  gap: 24px;\n}\n\n.p2p-post-cancel-btn,\n.p2p-post-prev-btn {\n  background-color: #DDDDDD;\n  color: #374151;\n  border: none;\n  border-radius: 50px;\n  padding: 14px 48px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nbody.dark_theme .p2p-post-cancel-btn,\nbody[data-theme=\"dark\"] .p2p-post-cancel-btn,\nbody.dark_theme .p2p-post-prev-btn,\nbody[data-theme=\"dark\"] .p2p-post-prev-btn {\n  background-color: #2B2B3A;\n  color: #D1D5DB;\n}\n\n.p2p-post-next-btn {\n  background-color: #1E2329;\n  color: #ffffff;\n  border: none;\n  border-radius: 50px;\n  padding: 14px 48px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.p2p-post-next-btn:hover {\n  background-color: #374151;\n}\n\n/* 7. Confirm to Post Modal */\n.p2p-post-confirm-modal {\n  background: rgba(255, 255, 255, 0.20);\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);\n  border-radius: 24px;\n  width: 700px;\n  max-width: 92vw;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.dark_theme .p2p-post-confirm-modal,\nbody[data-theme=\"dark\"] .p2p-post-confirm-modal {\n  background-color: rgb(0 0 0 / 30%);\n  border-color: #1b1b1b;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);\n}\n\n.p2p-pcm-header {\n  padding: 24px 18px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-bottom: 1px solid #F3F4F6;\n}\n\nbody.dark_theme .p2p-pcm-header,\nbody[data-theme=\"dark\"] .p2p-pcm-header {\n  border-bottom-color: #262636;\n}\n\n.p2p-pcm-title-wrap h3 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 4px;\n}\n\nbody.dark_theme .p2p-pcm-title-wrap h3,\nbody[data-theme=\"dark\"] .p2p-pcm-title-wrap h3 {\n  color: #ffffff;\n}\n\n.p2p-pcm-title-wrap p {\n  font-size: 13.5px;\n  color: #6B7280;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-pcm-title-wrap p,\nbody[data-theme=\"dark\"] .p2p-pcm-title-wrap p {\n  color: #9CA3AF;\n}\n\n.p2p-pcm-close-btn {\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #6B7280;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.p2p-pcm-close-btn:hover {\n  background-color: #F3F4F6;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-pcm-close-btn:hover,\nbody[data-theme=\"dark\"] .p2p-pcm-close-btn:hover {\n  background-color: #2B2B3A;\n  color: #ffffff;\n}\n\n.p2p-pcm-body {\n  padding: 12px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n.p2p-pcm-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px dotted #E5E7EB;\n}\n\nbody.dark_theme .p2p-pcm-row,\nbody[data-theme=\"dark\"] .p2p-pcm-row {\n  border-bottom-color: #1a1a1c;\n}\n\n.p2p-pcm-row.solid-divider {\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 4px;\n}\n\nbody.dark_theme .p2p-pcm-row.solid-divider,\nbody[data-theme=\"dark\"] .p2p-pcm-row.solid-divider {\n  border-bottom-color: #2E2E40;\n}\n\n.p2p-pcm-row:last-child {\n  border-bottom: none;\n}\n\n.p2p-pcm-label {\n  font-size: 13.5px;\n  color: #6B7280;\n}\n\nbody.dark_theme .p2p-pcm-label,\nbody[data-theme=\"dark\"] .p2p-pcm-label {\n  color: #9CA3AF;\n}\n\n.p2p-pcm-val {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-pcm-val,\nbody[data-theme=\"dark\"] .p2p-pcm-val {\n  color: #ffffff;\n}\n\n.p2p-pcm-status-pill.online {\n  background-color: #DCFCE7;\n  color: #16A34A;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\nbody.dark_theme .p2p-pcm-status-pill.online,\nbody[data-theme=\"dark\"] .p2p-pcm-status-pill.online {\n  background-color: rgba(16, 185, 129, 0.18);\n  color: #34D399;\n}\n\n.p2p-pcm-footer {\n  padding: 20px 28px 24px;\n  display: flex;\n  gap: 14px;\n}\n\n.p2p-pcm-cancel-btn {\n  flex: 1;\n  background-color: #E5E7EB;\n  color: #374151;\n  border: none;\n  border-radius: 50px;\n  padding: 15px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\nbody.dark_theme .p2p-pcm-cancel-btn,\nbody[data-theme=\"dark\"] .p2p-pcm-cancel-btn {\n  background-color: #2B2B3A;\n  color: #D1D5DB;\n}\n\n.p2p-pcm-submit-btn {\n  flex: 1;\n  background-color: #1E2329;\n  color: #ffffff;\n  border: none;\n  border-radius: 50px;\n  padding: 15px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.p2p-pcm-submit-btn:hover {\n  background-color: #374151;\n}\n\n/* 8. Successful Ad Posted Modal */\n.p2p-post-success-modal {\n  text-align: center;\n}\n\n.p2p-psm-body {\n  padding: 24px 20px 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.p2p-psm-thumb-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.p2p-psm-thumb-circle {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%);\n  border: 3px solid #10B981;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.25);\n  margin-bottom: 16px;\n  position: relative;\n  animation: p2pThumbBounce 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\nbody.dark_theme .p2p-psm-thumb-circle,\nbody[data-theme=\"dark\"] .p2p-psm-thumb-circle {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(16, 185, 129, 0.3) 100%);\n  border-color: #10B981;\n  box-shadow: 0 10px 25px rgba(16, 185, 129, 0.35);\n}\n\n@keyframes p2pThumbBounce {\n  0% {\n    transform: scale(0.4) rotate(-15deg);\n    opacity: 0;\n  }\n\n  60% {\n    transform: scale(1.1) rotate(5deg);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1) rotate(0deg);\n  }\n}\n\n.p2p-psm-headline {\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 6px;\n}\n\nbody.dark_theme .p2p-psm-headline,\nbody[data-theme=\"dark\"] .p2p-psm-headline {\n  color: #ffffff;\n}\n\n.p2p-psm-subheadline {\n  font-size: 14px;\n  color: #6B7280;\n  margin: 0;\n  max-width: 440px;\n  line-height: 1.5;\n}\n\nbody.dark_theme .p2p-psm-subheadline,\nbody[data-theme=\"dark\"] .p2p-psm-subheadline {\n  color: #9CA3AF;\n}\n\n.p2p-psm-summary-card {\n  width: 100%;\n  background: rgba(249, 250, 251, 0.75);\n  border-radius: 16px;\n  padding: 12px 20px;\n  border: 1px solid #E5E7EB;\n  margin-top: 8px;\n  box-sizing: border-box;\n  text-align: left;\n}\n\nbody.dark_theme .p2p-psm-summary-card,\nbody[data-theme=\"dark\"] .p2p-psm-summary-card {\n  background: rgba(26, 26, 36, 0.6);\n  border-color: #2E2E40;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .p2p-post-ad-page {\n    padding: 20px 16px 40px;\n  }\n\n  .p2p-post-stepper-wrap {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  /* [UNUSED]\n.p2p-stepper-line {\n    display: none;\n  }\n*/\n\n  /* [UNUSED]\n.p2p-stepper-step {\n    flex-direction: row;\n    gap: 12px;\n    text-align: left;\n  }\n*/\n\n  .p2p-post-form-card {\n    padding: 20px 18px;\n  }\n\n  .p2p-post-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .p2p-post-price-type-grid,\n  .p2p-post-status-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-post-summary-card {\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n/* ==========================================================================\n   P2P MY ADS PAGE STYLES\n   ========================================================================== */\n\n.p2p-my-ads-page {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0px 0px 50px;\n  /* background-color: #ffffff; */\n  color: #111827;\n  box-sizing: border-box;\n}\n\nbody[data-theme=\"dark\"] .p2p-my-ads-page {\n  color: #f3f4f6;\n}\n\n/* 1. Top Header */\n.p2p-my-ads-top-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.p2p-my-ads-header-info h2 {\n  font-size: 26px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -0.3px;\n  margin: 0 0 6px;\n}\n\nbody.dark_theme .p2p-my-ads-header-info h2,\nbody[data-theme=\"dark\"] .p2p-my-ads-header-info h2 {\n  color: #ffffff;\n}\n\n.p2p-my-ads-header-info p {\n  font-size: 15px;\n  color: #6b7280;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-my-ads-header-info p,\nbody[data-theme=\"dark\"] .p2p-my-ads-header-info p {\n  color: #9ca3af;\n}\n\n.p2p-post-new-ad-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #1e2026;\n  color: #ffffff;\n  border: none;\n  border-radius: 9999px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.p2p-post-new-ad-btn:hover {\n  background-color: #374151;\n  transform: translateY(-1px);\n}\n\n.p2p-post-new-ad-btn i {\n  font-size: 18px;\n  font-weight: 600;\n}\n\nbody.dark_theme .p2p-post-new-ad-btn,\nbody[data-theme=\"dark\"] .p2p-post-new-ad-btn {\n  background-color: #d1aa67;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-post-new-ad-btn:hover,\nbody[data-theme=\"dark\"] .p2p-post-new-ad-btn:hover {\n  background-color: #dfa724;\n}\n\n/* 2. Category Tabs Bar */\n.p2p-my-ads-tabs-bar {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 24px;\n  position: relative;\n}\n\nbody.dark_theme .p2p-my-ads-tabs-bar,\nbody[data-theme=\"dark\"] .p2p-my-ads-tabs-bar {\n  border-bottom-color: #262638;\n}\n\n.p2p-my-ads-tab-btn {\n  background: transparent;\n  border: none;\n  padding: 10px 2px 14px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #6B7280;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.15s ease;\n  outline: none;\n}\n\n.p2p-my-ads-tab-btn:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-my-ads-tab-btn,\nbody[data-theme=\"dark\"] .p2p-my-ads-tab-btn {\n  color: #9ca3af;\n}\n\nbody.dark_theme .p2p-my-ads-tab-btn:hover,\nbody[data-theme=\"dark\"] .p2p-my-ads-tab-btn:hover {\n  color: #ffffff;\n}\n\n.p2p-my-ads-tab-btn.active {\n  color: #111827;\n  font-weight: 700;\n}\n\nbody.dark_theme .p2p-my-ads-tab-btn.active,\nbody[data-theme=\"dark\"] .p2p-my-ads-tab-btn.active {\n  color: #ffffff;\n}\n\n.p2p-my-ads-tab-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  width: 50%;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #111827;\n}\n\nbody.dark_theme .p2p-my-ads-tab-btn.active::after,\nbody[data-theme=\"dark\"] .p2p-my-ads-tab-btn.active::after {\n  background-color: #d1aa67;\n}\n\n/* 3. Filter Controls Bar */\n.p2p-my-ads-filters-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 22px;\n}\n\n.p2p-my-ads-filters-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.p2p-my-ads-filter-dropdown {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  background-color: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 0 32px 0 15px;\n  gap: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.p2p-my-ads-filter-dropdown:hover {\n  border-color: #cbd5e1;\n}\n\nbody.dark_theme .p2p-my-ads-filter-dropdown,\nbody[data-theme=\"dark\"] .p2p-my-ads-filter-dropdown {\n  background-color: transparent;\n  border-color: #2e2e42;\n}\n\n.p2p-filter-prefix {\n  font-size: 13.5px;\n  color: #6b7280;\n  font-weight: 400;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\nbody.dark_theme .p2p-filter-prefix,\nbody[data-theme=\"dark\"] .p2p-filter-prefix {\n  color: #9ca3af;\n}\n\n.p2p-my-ads-filter-dropdown select {\n  border: none;\n  background: transparent;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #111827;\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  padding: 0;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-my-ads-filter-dropdown select,\nbody[data-theme=\"dark\"] .p2p-my-ads-filter-dropdown select {\n  color: #ffffff;\n  background-color: #1a1a26;\n}\n\n.p2p-my-ads-filter-dropdown i {\n  position: absolute;\n  right: 10px;\n  color: #9ca3af;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n/* Date Range Box */\n.p2p-my-ads-date-range-box {\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0 12px;\n  gap: 8px;\n}\n\nbody.dark_theme .p2p-my-ads-date-range-box,\nbody[data-theme=\"dark\"] .p2p-my-ads-date-range-box {\n  background-color: transparent;\n  border-color: #2e2e42;\n}\n\n.p2p-my-ads-date-range-box input {\n  border: none;\n  background: transparent;\n  font-size: 15px;\n  font-weight: 500;\n  color: #111827;\n  outline: none;\n  width: 215px;\n  cursor: default;\n}\n\nbody.dark_theme .p2p-my-ads-date-range-box input,\nbody[data-theme=\"dark\"] .p2p-my-ads-date-range-box input {\n  color: #ffffff;\n}\n\n.p2p-date-icon {\n  color: #9ca3af;\n  font-size: 16px;\n}\n\n/* Reset Button */\n.p2p-my-ads-reset-btn {\n  height: 40px;\n  background-color: #F0F0F0;\n  border: 1px solid #E5E7EB;\n  border-radius: 9999px;\n  padding: 0 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.p2p-my-ads-reset-btn:hover {\n  background-color: #e5e7eb;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-my-ads-reset-btn,\nbody[data-theme=\"dark\"] .p2p-my-ads-reset-btn {\n  background-color: #262638;\n  color: #d1d5db;\n  border: 1px solid #373737;\n}\n\nbody.dark_theme .p2p-my-ads-reset-btn:hover,\nbody[data-theme=\"dark\"] .p2p-my-ads-reset-btn:hover {\n  background-color: #323248;\n  color: #ffffff;\n}\n\n/* Ad History Button */\n.p2p-ad-history-btn {\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #F0F0F0;\n  border: 1px solid #E5E7EB;\n  border-radius: 9999px;\n  padding: 0 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.p2p-ad-history-btn:hover {\n  background-color: #e5e7eb;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-ad-history-btn,\nbody[data-theme=\"dark\"] .p2p-ad-history-btn {\n  background-color: #262638;\n  color: #d1d5db;\n  border: 1px solid #373737;\n}\n\nbody.dark_theme .p2p-ad-history-btn:hover,\nbody[data-theme=\"dark\"] .p2p-ad-history-btn:hover {\n  background-color: #323248;\n  color: #ffffff;\n}\n\n.p2p-ad-history-btn i {\n  font-size: 15px;\n}\n\n/* 4. Batch Actions Bar */\n.p2p-my-ads-batch-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.p2p-my-ads-select-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #374151;\n  user-select: none;\n}\n\nbody.dark_theme .p2p-my-ads-select-all,\nbody[data-theme=\"dark\"] .p2p-my-ads-select-all {\n  color: #d1d5db;\n}\n\n.p2p-my-ads-select-all input[type=\"checkbox\"],\n.p2p-my-ads-table input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: 1px solid #d1d5db;\n  accent-color: #111827;\n  cursor: pointer;\n}\n\nbody.dark_theme .p2p-my-ads-select-all input[type=\"checkbox\"],\nbody.dark_theme .p2p-my-ads-table input[type=\"checkbox\"],\nbody[data-theme=\"dark\"] .p2p-my-ads-select-all input[type=\"checkbox\"],\nbody[data-theme=\"dark\"] .p2p-my-ads-table input[type=\"checkbox\"] {\n  accent-color: #f3ba2f;\n}\n\n.p2p-batch-publish-btn {\n  background-color: rgb(209 170 103 / 20%);\n  color: #111827;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.p2p-batch-publish-btn:hover {\n  background-color: #f5e4c8;\n}\n\nbody.dark_theme .p2p-batch-publish-btn,\nbody[data-theme=\"dark\"] .p2p-batch-publish-btn {\n  background-color: #433519;\n  color: #fdd87e;\n}\n\n.p2p-batch-offline-btn {\n  background-color: #ffffff;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.p2p-batch-offline-btn:hover {\n  background-color: #f9fafb;\n  border-color: #d1d5db;\n}\n\nbody.dark_theme .p2p-batch-offline-btn,\nbody[data-theme=\"dark\"] .p2p-batch-offline-btn {\n  background-color: #1a1a26;\n  border-color: #2e2e42;\n  color: #d1d5db;\n}\n\n/* 5. Ads Table */\n.p2p-my-ads-table-container {\n  width: 100%;\n  overflow-x: auto;\n  margin-bottom: 24px;\n}\n\n.p2p-my-ads-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.p2p-my-ads-table thead tr {\n  background-color: #F9FAFB;\n  border-top: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-my-ads-table thead tr,\nbody[data-theme=\"dark\"] .p2p-my-ads-table thead tr {\n  background-color: #1e1e2d;\n  border-bottom-color: #2a2a3e;\n}\n\n.p2p-my-ads-table th {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6B7280;\n  line-height: 1.4;\n  vertical-align: top;\n}\n\nbody.dark_theme .p2p-my-ads-table th,\nbody[data-theme=\"dark\"] .p2p-my-ads-table th {\n  color: #9ca3af;\n}\n\n.p2p-my-ads-table th.th-checkbox,\n.p2p-my-ads-table td.td-checkbox {\n  width: 36px;\n  padding-left: 14px;\n  padding-right: 0;\n  vertical-align: middle;\n}\n\n.p2p-my-ads-table th .th-sub {\n  font-size: 11px;\n  font-weight: 400;\n  color: #9ca3af;\n  display: block;\n}\n\n.p2p-my-ads-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background-color 0.15s ease;\n}\n\n.p2p-my-ads-table tbody tr:hover {\n  background-color: #fcfcfd;\n}\n\nbody.dark_theme .p2p-my-ads-table tbody tr,\nbody[data-theme=\"dark\"] .p2p-my-ads-table tbody tr {\n  border-bottom-color: #242436;\n}\n\nbody.dark_theme .p2p-my-ads-table tbody tr:hover,\nbody[data-theme=\"dark\"] .p2p-my-ads-table tbody tr:hover {\n  background-color: #1c1c2a;\n}\n\n.p2p-my-ads-table td {\n  padding: 16px 16px;\n  vertical-align: middle;\n  font-size: 14px;\n}\n\n.p2p-ad-number {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\nbody.dark_theme .p2p-ad-number,\nbody[data-theme=\"dark\"] .p2p-ad-number {\n  color: #ffffff;\n}\n\n.p2p-ad-subtext {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\nbody.dark_theme .p2p-ad-subtext,\nbody[data-theme=\"dark\"] .p2p-ad-subtext {\n  color: #9ca3af;\n}\n\n.p2p-amount-val {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\nbody.dark_theme .p2p-amount-val,\nbody[data-theme=\"dark\"] .p2p-amount-val {\n  color: #ffffff;\n}\n\n.p2p-price-val {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\nbody.dark_theme .p2p-price-val,\nbody[data-theme=\"dark\"] .p2p-price-val {\n  color: #ffffff;\n}\n\n/* Payment Methods */\n.p2p-payments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.p2p-pm-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.p2p-pm-bar {\n  width: 5px;\n  height: 13px;\n  border-radius: 2px;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.p2p-pm-text {\n  font-size: 13px;\n  font-weight: 400;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-pm-text,\nbody[data-theme=\"dark\"] .p2p-pm-text {\n  color: #e5e7eb;\n}\n\n/* Times */\n.p2p-updated-time {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\nbody.dark_theme .p2p-updated-time,\nbody[data-theme=\"dark\"] .p2p-updated-time {\n  color: #ffffff;\n}\n\n/* Status Pills */\n.p2p-status-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.p2p-status-pill.online {\n  background-color: #F0FDF4;\n  color: #10B981;\n  border: 1px solid #DCFCE7;\n}\n\nbody.dark_theme .p2p-status-pill.online,\nbody[data-theme=\"dark\"] .p2p-status-pill.online {\n  background-color: rgba(16, 185, 129, 0.15);\n  border-color: rgba(16, 185, 129, 0.35);\n  color: #34d399;\n}\n\n.p2p-status-pill.offline {\n  background-color: #f3f4f6;\n  color: #9ca3af;\n  border: 1px solid #e5e7eb;\n}\n\nbody.dark_theme .p2p-status-pill.offline,\nbody[data-theme=\"dark\"] .p2p-status-pill.offline {\n  background-color: rgba(156, 163, 175, 0.15);\n  border-color: rgba(156, 163, 175, 0.35);\n  color: #9ca3af;\n}\n\n/* 6. Footer / Pagination */\n.p2p-my-ads-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-top: 12px;\n}\n\n.p2p-my-ads-footer-left span {\n  font-size: 13px;\n  color: #6b7280;\n}\n\nbody.dark_theme .p2p-my-ads-footer-left span,\nbody[data-theme=\"dark\"] .p2p-my-ads-footer-left span {\n  color: #9ca3af;\n}\n\n.p2p-my-ads-pagination {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-pag-arrow-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  color: #9ca3af;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.p2p-pag-arrow-btn:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  color: #111827;\n}\n\n.p2p-pag-arrow-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\nbody.dark_theme .p2p-pag-arrow-btn,\nbody[data-theme=\"dark\"] .p2p-pag-arrow-btn {\n  background-color: #1a1a26;\n  border-color: #2e2e42;\n  color: #6b7280;\n}\n\n.p2p-pag-num-btn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n.p2p-pag-num-btn.active {\n  background-color: #1e2026;\n  border-color: #1e2026;\n  color: #ffffff;\n  font-weight: 600;\n}\n\nbody.dark_theme .p2p-pag-num-btn.active,\nbody[data-theme=\"dark\"] .p2p-pag-num-btn.active {\n  background-color: #ffffff;\n  border-color: #ffffff;\n  color: #111827;\n}\n\n.p2p-page-size-select {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 24px 0 10px;\n}\n\nbody.dark_theme .p2p-page-size-select,\nbody[data-theme=\"dark\"] .p2p-page-size-select {\n  background-color: #1a1a26;\n  border-color: #2e2e42;\n}\n\n.p2p-page-size-select select {\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\nbody.dark_theme .p2p-page-size-select select,\nbody[data-theme=\"dark\"] .p2p-page-size-select select {\n  color: #d1d5db;\n  background-color: #1a1a26;\n}\n\n.p2p-page-size-select i {\n  position: absolute;\n  right: 6px;\n  color: #9ca3af;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n/* Responsive */\n@media (max-width: 991px) {\n  .p2p-my-ads-page {\n    padding: 20px 16px 40px;\n  }\n\n  .p2p-my-ads-filters-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .p2p-my-ads-filters-left {\n    flex-wrap: wrap;\n  }\n}\n\n/* ==========================================================================\n   FIND AN AD MODAL (POPUP)\n   ========================================================================== */\n.p2p-fam-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: p2pFamFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nbody.light_theme .p2p-fam-overlay {\n  background-color: rgba(255, 255, 255, 0.45);\n}\n\n@keyframes p2pFamFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes p2pFamScaleUp {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.p2p-fam-card {\n  width: 100%;\n  max-width: 720px;\n  background: rgba(255, 255, 255, 0.20);\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);\n  border-radius: 24px;\n  padding: 24px 15px;\n  position: relative;\n  box-sizing: border-box;\n  animation: p2pFamScaleUp 0.24s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nbody.dark_theme .p2p-fam-card,\nbody[data-theme=\"dark\"] .p2p-fam-card {\n  background-color: #1e2026;\n  border: 1px solid #2b313a;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);\n}\n\n/* Header */\n.p2p-fam-header {\n  margin-bottom: 22px;\n}\n\n.p2p-fam-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.p2p-fam-title {\n  font-size: 22px;\n  color: #111827;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\nbody.dark_theme .p2p-fam-title,\nbody[data-theme=\"dark\"] .p2p-fam-title {\n  color: #ffffff;\n}\n\n.p2p-fam-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: all 0.15s ease;\n  padding: 0;\n}\n\n.p2p-fam-close-btn:hover {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-fam-close-btn:hover,\nbody[data-theme=\"dark\"] .p2p-fam-close-btn:hover {\n  background-color: #2b313a;\n  color: #ffffff;\n}\n\n.p2p-fam-subtitle {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #6b7280;\n  margin: 6px 0 0;\n  font-weight: 400;\n}\n\nbody.dark_theme .p2p-fam-subtitle,\nbody[data-theme=\"dark\"] .p2p-fam-subtitle {\n  color: #9ca3af;\n}\n\n/* Form Groups */\n.p2p-fam-field-group {\n  margin-bottom: 18px;\n}\n\n.p2p-fam-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e2329;\n  margin-bottom: 8px;\n}\n\nbody.dark_theme .p2p-fam-label,\nbody[data-theme=\"dark\"] .p2p-fam-label {\n  color: #e5e7eb;\n}\n\n.p2p-fam-row-two {\n  display: grid;\n  grid-template-columns: 1fr 1.35fr;\n  gap: 12px;\n}\n\n/* Dropdown wrap */\n.p2p-fam-dropdown-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.p2p-fam-dropdown-wrap.full-width {\n  width: 100%;\n}\n\n.p2p-fam-select-box {\n  width: 100%;\n  height: 48px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-family: inherit;\n  outline: none;\n}\n\nbody.dark_theme .p2p-fam-select-box,\nbody[data-theme=\"dark\"] .p2p-fam-select-box {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-fam-select-box:hover {\n  border-color: #cbd5e1;\n}\n\nbody.dark_theme .p2p-fam-select-box:hover,\nbody[data-theme=\"dark\"] .p2p-fam-select-box:hover {\n  border-color: #474d57;\n}\n\n.p2p-fam-select-box.active {\n  border-color: #2b2f38;\n}\n\nbody.dark_theme .p2p-fam-select-box.active,\nbody[data-theme=\"dark\"] .p2p-fam-select-box.active {\n  border-color: #f0b90b;\n}\n\n.p2p-fam-select-val {\n  font-size: 14.5px;\n  font-weight: 500;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-fam-select-val,\nbody[data-theme=\"dark\"] .p2p-fam-select-val {\n  color: #f3f4f6;\n}\n\n.p2p-fam-chevron {\n  color: #6b7280;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.p2p-fam-chevron.rotate {\n  transform: rotate(180deg);\n  border: none;\n  width: auto;\n}\n\n.p2p-fam-coin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.p2p-fam-coin-svg {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Dropdown Menu */\n.p2p-fam-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);\n  z-index: 60;\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 6px;\n  list-style: none;\n  margin: 0;\n  animation: p2pFamFadeIn 0.15s ease;\n}\n\nbody.dark_theme .p2p-fam-dropdown-menu,\nbody[data-theme=\"dark\"] .p2p-fam-dropdown-menu {\n  background-color: #1e2026;\n  border-color: #2b313a;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);\n}\n\n.p2p-fam-menu-item {\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.15s ease;\n}\n\nbody.dark_theme .p2p-fam-menu-item,\nbody[data-theme=\"dark\"] .p2p-fam-menu-item {\n  color: #d1d5db;\n}\n\n.p2p-fam-menu-item:hover {\n  background-color: #f3f4f6;\n}\n\nbody.dark_theme .p2p-fam-menu-item:hover,\nbody[data-theme=\"dark\"] .p2p-fam-menu-item:hover {\n  background-color: #2b313a;\n}\n\n.p2p-fam-menu-item.selected {\n  background-color: #f1f5f9;\n  font-weight: 600;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-fam-menu-item.selected,\nbody[data-theme=\"dark\"] .p2p-fam-menu-item.selected {\n  background-color: rgba(240, 185, 11, 0.12);\n  color: #f0b90b;\n}\n\n/* Amount & Currency Container */\n.p2p-fam-amount-box {\n  height: 48px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 0 12px 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: all 0.15s ease;\n}\n\nbody.dark_theme .p2p-fam-amount-box,\nbody[data-theme=\"dark\"] .p2p-fam-amount-box {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-fam-amount-box:focus-within {\n  border-color: #2b2f38;\n  box-shadow: 0 0 0 2px rgba(43, 47, 56, 0.08);\n}\n\nbody.dark_theme .p2p-fam-amount-box:focus-within,\nbody[data-theme=\"dark\"] .p2p-fam-amount-box:focus-within {\n  border-color: #f0b90b;\n  box-shadow: 0 0 0 2px rgba(240, 185, 11, 0.15);\n}\n\n.p2p-fam-amount-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14.5px;\n  color: #111827;\n  padding: 0;\n  font-weight: 500;\n  min-width: 0;\n}\n\nbody.dark_theme .p2p-fam-amount-input,\nbody[data-theme=\"dark\"] .p2p-fam-amount-input {\n  color: #ffffff;\n}\n\n.p2p-fam-amount-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.p2p-fam-currency-wrap {\n  position: relative;\n  margin-left: 8px;\n}\n\n.p2p-fam-currency-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  padding: 6px 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background-color 0.15s ease;\n}\n\n.p2p-fam-currency-btn:hover {\n  background-color: #f3f4f6;\n}\n\nbody.dark_theme .p2p-fam-currency-btn:hover,\nbody[data-theme=\"dark\"] .p2p-fam-currency-btn:hover {\n  background-color: #2b313a;\n}\n\n.p2p-fam-currency-code {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #111827;\n}\n\nbody.dark_theme .p2p-fam-currency-code,\nbody[data-theme=\"dark\"] .p2p-fam-currency-code {\n  color: #ffffff;\n}\n\n.p2p-fam-currency-menu {\n  right: 0;\n  left: auto;\n  min-width: 120px;\n}\n\n/* Submit Button */\n.p2p-fam-submit-btn {\n  width: 100%;\n  height: 50px;\n  background-color: #2b2f38;\n  color: #ffffff;\n  border: none;\n  border-radius: 9999px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 24px;\n  margin-bottom: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.18s ease;\n  box-shadow: 0 4px 12px rgba(43, 47, 56, 0.18);\n}\n\n.p2p-fam-submit-btn:hover {\n  background-color: #1a1c22;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(43, 47, 56, 0.25);\n}\n\n.p2p-fam-submit-btn:active {\n  transform: translateY(0);\n}\n\n/* 3-Step Process Guide */\n.p2p-fam-steps-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 24px;\n  border-radius: 16px;\n  background-color: rgb(0 0 0 / 10%);\n}\n\nbody.light_theme .p2p-fam-steps-container {\n  background-color: rgb(249 250 251 / 70%);\n}\n\n.p2p-fam-step-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 160px;\n}\n\n.p2p-fam-step-icon-wrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.p2p-fam-step-icon-wrap.step-1-bg {\n  background-color: #FFF8E7;\n}\n\n.p2p-fam-step-icon-wrap.step-2-bg {\n  background-color: #ECFDF5;\n}\n\n.p2p-fam-step-icon-wrap.step-3-bg {\n  background-color: #F3E8FF;\n}\n\nbody.dark_theme .p2p-fam-step-icon-wrap.step-1-bg,\nbody[data-theme=\"dark\"] .p2p-fam-step-icon-wrap.step-1-bg {\n  background-color: rgba(245, 158, 11, 0.15);\n}\n\nbody.dark_theme .p2p-fam-step-icon-wrap.step-2-bg,\nbody[data-theme=\"dark\"] .p2p-fam-step-icon-wrap.step-2-bg {\n  background-color: rgba(16, 185, 129, 0.15);\n}\n\nbody.dark_theme .p2p-fam-step-icon-wrap.step-3-bg,\nbody[data-theme=\"dark\"] .p2p-fam-step-icon-wrap.step-3-bg {\n  background-color: rgba(139, 92, 246, 0.15);\n}\n\n.p2p-fam-badge {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-fam-badge.step-1-badge {\n  background-color: #ffffff;\n  border: 1px solid #fde68a;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\nbody.dark_theme .p2p-fam-badge.step-1-badge,\nbody[data-theme=\"dark\"] .p2p-fam-badge.step-1-badge {\n  background-color: #1e2026;\n  border-color: rgba(245, 158, 11, 0.4);\n}\n\n.p2p-fam-badge.step-2-badge,\n.p2p-fam-badge.step-3-badge {\n  background-color: #10b981;\n  border: 4px solid #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\nbody.dark_theme .p2p-fam-badge.step-2-badge,\nbody[data-theme=\"dark\"] .p2p-fam-badge.step-2-badge,\nbody.dark_theme .p2p-fam-badge.step-3-badge,\nbody[data-theme=\"dark\"] .p2p-fam-badge.step-3-badge {\n  border-color: #1e2026;\n}\n\n.p2p-fam-step-arrow {\n  margin-top: 17px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.p2p-fam-step-title {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 4px;\n}\n\nbody.dark_theme .p2p-fam-step-title,\nbody[data-theme=\"dark\"] .p2p-fam-step-title {\n  color: #ffffff;\n}\n\n.p2p-fam-step-desc {\n  font-size: 11.5px;\n  line-height: 1.35;\n  color: #6b7280;\n  margin: 0;\n  max-width: 200px;\n}\n\nbody.dark_theme .p2p-fam-step-desc,\nbody[data-theme=\"dark\"] .p2p-fam-step-desc {\n  color: #9ca3af;\n}\n\n/* Modal Responsive */\n@media (max-width: 600px) {\n  .p2p-fam-card {\n    padding: 24px 20px 28px;\n    border-radius: 20px;\n  }\n\n  .p2p-fam-title {\n    font-size: 20px;\n  }\n\n  .p2p-fam-subtitle {\n    font-size: 12.5px;\n  }\n\n  .p2p-fam-row-two {\n    grid-template-columns: 1fr;\n  }\n\n  .p2p-fam-step-col {\n    width: 95px;\n  }\n\n  .p2p-fam-step-desc {\n    max-width: 90px;\n    font-size: 10.5px;\n  }\n\n  .p2p-fam-step-title {\n    font-size: 12px;\n  }\n\n  .p2p-fam-step-icon-wrap {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n/* ==========================================================================\n   P2P PROFILE PAGE\n   ========================================================================== */\n.p2p-profile-page-main {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0px 32px 48px;\n  box-sizing: border-box;\n}\n\n/* 1. Profile Hero Card (Dual-tone Curved Banner) */\n.p2p-profile-hero-card {\n  position: relative;\n  border-radius: 24px;\n  overflow: hidden;\n  background-color: #F0F0F0;\n  border: 1px solid #eef0f3;\n  box-shadow: 0 0px 20px rgba(0, 0, 0, 0.10);\n  margin-bottom: 24px;\n  min-height: 145px;\n}\n\nbody.dark_theme .p2p-profile-hero-card,\nbody[data-theme=\"dark\"] .p2p-profile-hero-card {\n  background-color: #1e202600;\n  border-color: #2b313a;\n}\n\n.p2p-profile-hero-curve {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.p2p-empty-state-card .p2p-myads-action-btn i {\n  margin: 0px;\n  font-size: 24px;\n}\n\n.p2p-profile-hero-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 42px;\n  min-height: 125px;\n  gap: 24px;\n  box-sizing: border-box;\n}\n\n/* Left user info (On black curved background) */\n.p2p-profile-hero-user {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.p2p-profile-hero-avatar {\n  position: relative;\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background-color: #2c3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  font-weight: 600;\n  color: #ffffff;\n  flex-shrink: 0;\n}\n\n.p2p-profile-hero-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.p2p-profile-hero-online-dot {\n  position: absolute;\n  bottom: 1px;\n  right: 1px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #10B981;\n  border: 3px solid #000000;\n}\n\n.p2p-profile-hero-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.p2p-profile-username-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.p2p-profile-username {\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  letter-spacing: -0.2px;\n  line-height: 1.2;\n}\n\n\n\n.p2p-profile-verified-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.p2p-profile-edit-btn {\n  background: transparent;\n  border: none;\n  padding: 2px 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  transition: opacity 0.15s ease;\n}\n\n.p2p-profile-edit-btn:hover {\n  opacity: 0.8;\n}\n\n.p2p-profile-badges-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.p2p-profile-badge-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #D1D5DB;\n}\n\n/* Right funding value (On white background) */\n.p2p-profile-funding-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n}\n\n.p2p-profile-funding-top {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #9CA3AF;\n  margin-bottom: 6px;\n}\n\nbody.dark_theme .p2p-profile-funding-top,\nbody[data-theme=\"dark\"] .p2p-profile-funding-top {\n  color: #9ca3af;\n}\n\n.p2p-profile-eye-toggle {\n  background: transparent;\n  border: none;\n  color: #848e9c;\n  cursor: pointer;\n  padding: 0;\n  font-size: 15px;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.15s ease;\n}\n\n.p2p-profile-eye-toggle:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-profile-eye-toggle:hover,\nbody[data-theme=\"dark\"] .p2p-profile-eye-toggle:hover {\n  color: #ffffff;\n}\n\n.p2p-profile-funding-val {\n  font-size: 28px;\n  font-weight: 700;\n  color: #070808;\n  letter-spacing: -0.3px;\n  margin-bottom: 2px;\n  line-height: 1.2;\n}\n\nbody.dark_theme .p2p-profile-funding-val,\nbody[data-theme=\"dark\"] .p2p-profile-funding-val {\n  color: #ffffff;\n}\n\n.p2p-profile-funding-usd {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #9CA3AF;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.p2p-profile-funding-usd:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-profile-funding-usd,\nbody[data-theme=\"dark\"] .p2p-profile-funding-usd {\n  color: #9ca3af;\n}\n\nbody.dark_theme .p2p-profile-funding-usd:hover,\nbody[data-theme=\"dark\"] .p2p-profile-funding-usd:hover {\n  color: #ffffff;\n}\n\n/* 2. Stats Grid (5 Cards Row) */\n.p2p-profile-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 22px;\n  margin: 42px 0px;\n}\n\n.p2p-profile-stat-card {\n  background-color: #F4F4F4;\n  border-radius: 18px;\n  padding: 24px;\n  border: 1px solid #E5E7EB;\n  display: flex;\n  flex-direction: column;\n  min-height: 150px;\n  justify-content: center;\n}\n\nbody.dark_theme .p2p-profile-stat-card,\nbody[data-theme=\"dark\"] .p2p-profile-stat-card {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-profile-stat-label {\n  font-size: 16px;\n  color: #6B7280;\n  font-weight: 400;\n  margin-bottom: 6px;\n  white-space: nowrap;\n}\n\nbody.dark_theme .p2p-profile-stat-label,\nbody[data-theme=\"dark\"] .p2p-profile-stat-label {\n  color: #9ca3af;\n}\n\n.p2p-profile-stat-value {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  line-height: 100%;\n  margin-top: 8px;\n}\n\n.p2p-profile-stat-num {\n  font-size: 26px;\n  font-weight: 700;\n  color: #374151;\n}\n\nbody.dark_theme .p2p-profile-stat-num,\nbody[data-theme=\"dark\"] .p2p-profile-stat-num {\n  color: #ffffff;\n}\n\n.p2p-profile-stat-unit {\n  font-size: 16px;\n  font-weight: 400;\n  color: #6B7280;\n}\n\nbody.dark_theme .p2p-profile-stat-unit,\nbody[data-theme=\"dark\"] .p2p-profile-stat-unit {\n  color: #9ca3af;\n}\n\n/* 3. Tabs Navigation */\n.p2p-profile-tabs-bar {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 24px;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n\nbody.dark_theme .p2p-profile-tabs-bar,\nbody[data-theme=\"dark\"] .p2p-profile-tabs-bar {\n  border-color: #2b313a;\n}\n\n.p2p-profile-tab-item {\n  background: transparent;\n  border: none;\n  font-size: 17px;\n  font-weight: 500;\n  color: #6B7280;\n  padding: 0 0 14px;\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n  font-family: inherit;\n  transition: color 0.15s ease;\n}\n\n.p2p-profile-tab-item:hover {\n  color: #111827;\n}\n\nbody.dark_theme .p2p-profile-tab-item,\nbody[data-theme=\"dark\"] .p2p-profile-tab-item {\n  color: #9ca3af;\n}\n\nbody.dark_theme .p2p-profile-tab-item:hover,\nbody[data-theme=\"dark\"] .p2p-profile-tab-item:hover {\n  color: #ffffff;\n}\n\n.p2p-profile-tab-item.active {\n  color: #111827;\n  font-weight: 600;\n}\n\nbody.dark_theme .p2p-profile-tab-item.active,\nbody[data-theme=\"dark\"] .p2p-profile-tab-item.active {\n  color: #ffffff;\n}\n\n.p2p-profile-tab-item.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background-color: #111827;\n}\n\n.p2p-profile-verified-badge i {\n  color: #F3C740;\n  font-size: 14px;\n}\n\nbody.dark_theme .p2p-profile-tab-item.active::after,\nbody[data-theme=\"dark\"] .p2p-profile-tab-item.active::after {\n  background-color: #d1aa67;\n}\n\n/* 4. Feedback Card (Matching Screenshot Content Box) */\n.p2p-profile-feedback-card {\n  background-color: #eff6ff;\n  border-radius: 16px;\n  padding: 26px 30px;\n  border: 1px solid rgba(219, 234, 254, 0.7);\n}\n\nbody.dark_theme .p2p-profile-feedback-card,\nbody[data-theme=\"dark\"] .p2p-profile-feedback-card {\n  background-color: rgb(0 0 0 / 0%);\n  border-color: rgb(88 88 88 / 25%);\n}\n\n.p2p-profile-feedback-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 14px;\n}\n\nbody.dark_theme .p2p-profile-feedback-title,\nbody[data-theme=\"dark\"] .p2p-profile-feedback-title {\n  color: #ffffff;\n}\n\n.p2p-profile-feedback-desc {\n  font-size: 14px;\n  line-height: 1.65;\n  color: #374151;\n  margin: 0 0 16px;\n}\n\nbody.dark_theme .p2p-profile-feedback-desc,\nbody[data-theme=\"dark\"] .p2p-profile-feedback-desc {\n  color: #d1d5db;\n}\n\n.p2p-profile-feedback-desc:last-child {\n  margin-bottom: 0;\n}\n\n/* Tab Panels */\n.p2p-profile-tab-panel {\n  padding: 8px 0;\n}\n\n.p2p-profile-empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  background-color: #f9fafb;\n  border-radius: 16px;\n  border: 1px dashed #e5e7eb;\n}\n\nbody.dark_theme .p2p-profile-empty-state,\nbody[data-theme=\"dark\"] .p2p-profile-empty-state {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-profile-empty-state i {\n  font-size: 40px;\n  color: #9ca3af;\n  margin-bottom: 12px;\n  display: inline-block;\n}\n\n.p2p-profile-empty-state.good-status i {\n  color: #10b981;\n}\n\n.p2p-profile-empty-state h4 {\n  font-size: 17px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 8px;\n}\n\nbody.dark_theme .p2p-profile-empty-state h4,\nbody[data-theme=\"dark\"] .p2p-profile-empty-state h4 {\n  color: #ffffff;\n}\n\n.p2p-profile-empty-state p {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\nbody.dark_theme .p2p-profile-empty-state p,\nbody[data-theme=\"dark\"] .p2p-profile-empty-state p {\n  color: #9ca3af;\n}\n\n/* Notifications Card */\n.p2p-profile-notifications-card {\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  padding: 24px 28px;\n}\n\nbody.dark_theme .p2p-profile-notifications-card,\nbody[data-theme=\"dark\"] .p2p-profile-notifications-card {\n  background-color: #181a20;\n  border-color: #2b313a;\n}\n\n.p2p-profile-notif-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 20px;\n}\n\nbody.dark_theme .p2p-profile-notif-title,\nbody[data-theme=\"dark\"] .p2p-profile-notif-title {\n  color: #ffffff;\n}\n\n.p2p-profile-notif-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\nbody.dark_theme .p2p-profile-notif-row,\nbody[data-theme=\"dark\"] .p2p-profile-notif-row {\n  border-color: #2b313a;\n}\n\n.p2p-profile-notif-row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.p2p-profile-notif-row h5 {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 4px;\n}\n\nbody.dark_theme .p2p-profile-notif-row h5,\nbody[data-theme=\"dark\"] .p2p-profile-notif-row h5 {\n  color: #ffffff;\n}\n\n.p2p-profile-notif-row p {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\nbody.dark_theme .p2p-profile-notif-row p,\nbody[data-theme=\"dark\"] .p2p-profile-notif-row p {\n  color: #9ca3af;\n}\n\n/* Switch Toggle */\n.p2p-profile-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.p2p-profile-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.p2p-profile-slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #cbd5e1;\n  transition: 0.2s;\n  border-radius: 24px;\n}\n\n.p2p-profile-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.2s;\n  border-radius: 50%;\n}\n\n.p2p-profile-switch input:checked+.p2p-profile-slider {\n  background-color: #10b981;\n}\n\n.p2p-profile-switch input:checked+.p2p-profile-slider:before {\n  transform: translateX(20px);\n}\n\n@media (max-width: 1440px) {\n\n  .p2p-hero-title {\n    font-size: 42px;\n  }\n\n  .p2p-section-header h2 {\n    font-size: 36px;\n  }\n\n  .p2p-post-ad-header h2 {\n    font-size: 42px;\n  }\n\n}\n\n@media (max-width: 1376px) {\n\n  .p2p-hero-section {\n    padding: 24px 50px;\n    min-height: 300px;\n  }\n\n  .p2p-section-header h2 {\n    font-size: 32px;\n  }\n\n  .p2p-accordion-button {\n    padding: 20px;\n    font-size: 18px;\n  }\n\n  .p2p-post-ad-header h2 {\n    font-size: 36px;\n  }\n\n  .p2p-post-summary-val {\n    font-size: 32px;\n  }\n\n\n  .p2p-od-payment-split {\n    gap: 38px;\n  }\n\n  .p2p-od-header-row {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n}\n\n@media (max-width: 1200px) {\n  .p2p-sidebar {\n    width: 280px !important;\n    max-width: 280px !important;\n    min-width: 280px !important;\n  }\n\n  .p2p-hero-title {\n    font-size: 36px;\n  }\n\n  .p2p-post-ad-header h2 {\n    font-size: 32px;\n  }\n\n  .p2p-stepper-label h4 {\n    font-size: 16px;\n  }\n\n  .p2p-stepper-label p {\n    font-size: 15px;\n  }\n\n  .p2p-post-ad-header p {\n    font-size: 18px;\n  }\n\n  .p2p-post-summary-val {\n    font-size: 24px;\n  }\n\n  .p2p-post-num-input {\n    font-size: 28px;\n  }\n\n  .p2p-profile-hero-content {\n    padding: 30px;\n  }\n\n  .p2p-profile-hero-avatar {\n    width: 66px;\n    font-size: 24px;\n    height: 66px;\n  }\n\n  .p2p-profile-username {\n    font-size: 26px;\n  }\n\n  .p2p-profile-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n}\n\n@media (max-width: 1024px) {\n\n  .p2p-hero-image {\n    max-width: 200px;\n  }\n\n  .p2p-profile-funding-val {\n    font-size: 20px;\n  }\n\n  .p2p-profile-funding-top {\n    font-size: 15px;\n  }\n\n  .p2p-profile-badge-item {\n    font-size: 15px;\n  }\n\n  .p2p-profile-username {\n    font-size: 22px;\n  }\n\n  .p2p-profile-hero-content {\n    padding: 24px;\n  }\n\n  .p2p-hero-section {\n    padding: 18px 32px;\n    min-height: 300px;\n  }\n\n  .p2p-hero-btn {\n    padding: 12px 32px;\n    min-width: 170px;\n    font-size: 14px;\n  }\n\n  .p2p-hero-desc {\n    font-size: 15px;\n    margin-bottom: 18px;\n  }\n\n  .p2p-tabs-bar {\n    padding: 15px 18px;\n  }\n\n  .p2p-token-tabs {\n    gap: 15px;\n  }\n\n  .p2p-token-tab {\n    font-size: 15px;\n  }\n\n  .p2p-switch-btn {\n    padding: 10px 36px;\n    font-size: 14px;\n  }\n\n  .p2p-token-tab.active::after {\n    bottom: -33px;\n  }\n\n  .p2p-filter-group label {\n    font-size: 14px;\n  }\n\n  .p2p-filter-group {\n    min-width: auto;\n  }\n\n  .p2p-amount-input-wrap input {\n    width: 100px;\n  }\n\n  .p2p-icon-btn,\n  .p2p-refresh-btn {\n    padding: 13px 12px;\n    min-width: 110px;\n    font-size: 13px;\n  }\n\n  .p2p-filter-input-wrap {\n    width: 48px;\n    height: 48px;\n  }\n\n  .p2p-section-header h2 {\n    font-size: 26px;\n  }\n\n}\n\n/* Responsive adjustments */\n@media (max-width: 991px) {\n\n  .p2p-hero-section {\n    padding: 30px 20px;\n  }\n\n  .p2p-sidebar-nav {\n    width: 220px;\n  }\n\n  .p2p-modal-body {\n    max-height: calc(100vh - 0px);\n  }\n\n  .p2p-post-ad-header h2 {\n    font-size: 26px;\n  }\n\n  .p2p-profile-stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .p2p-modal-left {\n    width: 100%;\n    padding: 20px 15px 20px 15px;\n  }\n\n  .p2p-od-header-right {\n    width: 100%;\n  }\n\n  .p2p-od-header-left h2 {\n    font-size: 28px;\n  }\n\n  .p2p-modal-right {\n    padding: 20px 15px;\n  }\n\n  .p2p-amount-box input {\n    font-size: 15px;\n  }\n\n  .p2p-submit-buy-btn {\n    padding: 12px;\n    font-size: 14px;\n  }\n\n  .p2p-escrow-info {\n    padding: 15px;\n    margin-bottom: 15px;\n  }\n\n  .p2p-page-content {\n    padding: 20px 12px 20px;\n  }\n\n}\n\n@media (max-width: 768px) {\n  .p2p-profile-page-main {\n    padding: 16px 16px 36px;\n  }\n\n  .p2p-profile-hero-content {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n  }\n\n  .p2p-profile-funding-wrap {\n    align-items: flex-start;\n    text-align: left;\n    margin-top: 12px;\n  }\n\n  .p2p-profile-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 767px) {\n\n  .p2p-req-modal-header h2 {\n    font-size: 18px;\n  }\n\n  .p2p-od-header-left h2 {\n    font-size: 22px;\n  }\n\n  .p2p-req-cancel-btn {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .p2p-my-orders-container {\n    padding: 0px 0px 16px;\n  }\n\n  .p2p-od-header-left p {\n    font-size: 14px;\n  }\n\n  .p2p-my-orders-header h2 {\n    font-size: 22px;\n  }\n\n  .p2p-post-notice-box h4 {\n    font-size: 16px;\n  }\n\n  .p2p-post-notice-box p {\n    font-size: 14px;\n  }\n\n  .p2p-post-textarea-wrap textarea {\n    font-size: 14px;\n  }\n\n  .p2p-post-char-count {\n    font-size: 13px;\n  }\n\n  .p2p-post-field label.p2p-post-checkbox-item {\n    font-size: 14px;\n  }\n\n  .p2p-post-confirm-modal {\n    border-radius: 20px 20px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .p2p-pcm-submit-btn {\n    padding: 10px 16px;\n    font-size: 14px;\n  }\n\n  .p2p-post-status-card p {\n    font-size: 13px;\n  }\n\n  .p2p-my-orders-header p {\n    font-size: 14px;\n  }\n\n  .p2p-mo-top-tab {\n    padding: 10px 0;\n    font-size: 13px;\n  }\n\n  .p2p-mo-top-nav {\n    gap: 18px;\n    margin-bottom: 15px;\n  }\n\n  .p2p-mo-pill-btn {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n\n  .p2p-mo-stat-val {\n    font-size: 24px;\n  }\n\n  .p2p-mo-stat-header {\n    font-size: 13px;\n    margin-bottom: 8px;\n  }\n\n  .p2p-od-escrow-badge {\n    font-size: 14px;\n  }\n\n  body.light_theme .p2p-profile-username {\n    color: #000;\n  }\n\n  body.light_theme .p2p-profile-badge-item {\n    color: #494949;\n  }\n\n  .p2p-my-ads-page {\n    padding: 0px 0px 20px;\n  }\n\n  .p2p-od-header-right {\n    padding: 18px;\n  }\n\n  .p2p-my-ads-header-info h2 {\n    font-size: 22px;\n  }\n\n  .p2p-post-new-ad-btn {\n    padding: 7px 13px;\n    gap: 2px;\n    white-space: nowrap;\n    font-size: 12px;\n  }\n\n  .p2p-my-ads-tab-btn {\n    font-size: 14px;\n  }\n\n  .p2p-my-ads-tabs-bar {\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n\n  .p2p-od-info-col strong {\n    font-size: 14px;\n  }\n\n  .p2p-od-stepper-container {\n    padding: 22px;\n    margin-bottom: 24px;\n  }\n\n  .p2p-od-step-circle {\n    width: 28px;\n    min-width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n\n  .p2p-od-step .p2p-od-step-text-only {\n    width: 28px;\n    min-width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n\n  .p2p-profile-page-main {\n    padding: 0px;\n  }\n\n  .p2p-modal-overlay {\n    align-items: end !important;\n  }\n\n  .p2p-profile-stat-card {\n    min-height: 100%;\n  }\n\n  .p2p-profile-tab-item {\n    font-size: 15px;\n  }\n\n  .p2p-profile-tabs-bar {\n    gap: 20px;\n    margin-bottom: 18px;\n  }\n\n  .p2p-profile-hero-curve {\n    display: none;\n  }\n\n  .p2p-profile-hero-avatar {\n    width: 48px;\n    font-size: 18px;\n    height: 48px;\n    min-width: 48px;\n  }\n\n  .p2p-req-modal-header {\n    padding: 18px 15px 16px;\n  }\n\n  .p2p-profile-hero-online-dot {\n    width: 16px;\n    height: 16px;\n    border: 2px solid #000000;\n  }\n\n  .p2p-profile-badge-item {\n    font-size: 13px;\n  }\n\n  .p2p-profile-stats-grid {\n    margin: 24px 0px;\n  }\n\n  .p2p-req-modal-body {\n    padding: 0 15px;\n  }\n\n  .p2p-req-modal-footer {\n    padding: 18px 15px;\n  }\n\n  .p2p-req-modal-content {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .p2p-modal-content {\n    border-radius: 18px 18px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n    margin: 0px;\n  }\n\n  .p2p-modal-right {\n    padding: 0px 0px;\n    position: inherit;\n  }\n\n  .p2p-modal-close {\n    top: 10px;\n    right: 10px;\n  }\n\n  .p2p-modal-avatar {\n    width: 36px;\n    min-width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n\n  .p2p-action-title h2 {\n    font-size: 18px;\n  }\n\n  .p2p-modal-action-header {\n    margin-bottom: 12px;\n    margin-top: 14px;\n  }\n\n  .p2p-price-rate {\n    font-size: 12px;\n  }\n\n  .p2p-req-text {\n    font-size: 14px;\n  }\n\n  .p2p-modal-left {\n    padding: 0px;\n  }\n\n  .p2p-modal-body {\n    flex-direction: column;\n  }\n\n  .p2p-modal-seller-info h3 {\n    font-size: 18px;\n    width: 90%;\n  }\n\n  .p2p-req-get-verified-btn {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .p2p-hero-title {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n\n  .p2p-hero-title br {\n    display: none;\n  }\n\n  .p2p-hero-section {\n    padding: 20px;\n    min-height: 100%;\n    margin-bottom: 20px;\n  }\n\n  .p2p-hero-btn {\n    padding: 10px 24px;\n    white-space: nowrap;\n    min-width: auto;\n  }\n\n  .p2p-token-tab {\n    font-size: 14px;\n  }\n\n  .p2p-token-tabs {\n    gap: 5px;\n  }\n\n  .p2p-filter-refresh {\n    width: 100%;\n  }\n\n  .p2p-tutorial-section {\n    margin: 30px 0px 30px;\n    padding: 24px;\n    border-radius: 18px;\n  }\n\n  .p2p-section-header h2 {\n    font-size: 22px;\n  }\n\n  .p2p-fam-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .p2p-section-header p {\n    font-size: 15px;\n  }\n\n  .p2p-fam-card {\n    padding: 24px;\n    border-radius: 20px 20px 0px 0px;\n    min-height: 25vh;\n    max-height: 85vh;\n    overflow: scroll;\n  }\n\n  .p2p-post-ad-page {\n    padding: 0px 0px 20px;\n  }\n\n  .p2p-post-ad-header h2 {\n    font-size: 22px;\n  }\n\n  .p2p-post-ad-header p {\n    font-size: 14px;\n  }\n\n  .p2p-stepper-label p {\n    font-size: 14px;\n  }\n\n  .p2p-stepper-label h4 {\n    font-size: 15px;\n  }\n\n  .p2p-stepper-circle {\n    width: 42px;\n    height: 42px;\n    min-width: 42px;\n    font-size: 15px;\n  }\n\n  .p2p-post-toggle-btn {\n    padding: 8px 22px;\n    font-size: 15px;\n  }\n\n  .p2p-post-toggle-btn.active {\n    box-shadow: 0 1px 0px #d1aa67;\n  }\n\n  .p2p-post-select-box select {\n    font-size: 15px;\n  }\n\n  .p2p-post-select-box {\n    border-radius: 10px;\n    padding: 12px 16px;\n    min-height: 54px;\n  }\n\n  .p2p-post-price-card {\n    border-radius: 12px;\n    padding: 12px 18px;\n    min-height: 54px;\n  }\n\n  .p2p-post-num-input {\n    font-size: 20px;\n    width: 150px;\n  }\n\n  .p2p-post-stepper-input {\n    border-radius: 12px;\n    padding: 12px 14px;\n    min-height: 54px;\n  }\n\n  .p2p-post-summary-label {\n    font-size: 15px;\n  }\n\n  .p2p-post-summary-card {\n    border-radius: 12px;\n    padding: 16px 22px;\n    margin-top: 18px;\n  }\n\n  .p2p-post-help-left {\n    font-size: 15px;\n  }\n\n  .p2p-post-guide-link {\n    white-space: nowrap;\n    font-size: 14px;\n  }\n\n  .p2p-post-help-strip {\n    margin: 18px 0px;\n  }\n\n  .p2p-post-next-btn {\n    padding: 9px 36px;\n    font-size: 14px;\n  }\n\n  .p2p-post-cancel-btn,\n  .p2p-post-prev-btn {\n    padding: 9px 36px;\n    font-size: 14px;\n  }\n\n  .p2p-post-field label {\n    font-size: 14px;\n  }\n\n  .p2p-post-field-hint {\n    font-size: 14px;\n  }\n\n  .p2p-post-amount-wrap input {\n    font-size: 15px;\n  }\n\n  .p2p-post-amount-all {\n    font-size: 14px;\n  }\n\n  .p2p-post-amount-wrap {\n    border-radius: 12px;\n    padding: 12px 16px;\n    min-height: 54px;\n  }\n\n  .p2p-post-amount-subtext {\n    font-size: 13px;\n  }\n\n  .p2p-post-limit-label {\n    font-size: 13px;\n  }\n\n  .p2p-post-limits-row {\n    flex-direction: column;\n  }\n\n  .p2p-post-limit-box {\n    width: 100%;\n  }\n\n  .p2p-post-fee-note {\n    font-size: 13px;\n  }\n\n  .p2p-post-action-btns {\n    gap: 12px;\n  }\n\n  .p2p-post-amount-curr {\n    font-size: 14px;\n  }\n\n  .p2p-tut-content p {\n    font-size: 15px;\n    margin-bottom: 12px;\n    min-height: 100%;\n  }\n\n  .p2p-tut-link {\n    font-size: 14px;\n  }\n\n  .p2p-accordion-button {\n    padding: 16px;\n    font-size: 15px;\n  }\n\n  .p2p-acc-icon {\n    font-size: 15px;\n    width: 28px;\n    height: 28px;\n    min-width: 28px;\n  }\n\n  .p2p-accordion-body {\n    padding: 0 20px 20px;\n    font-size: 14px;\n  }\n\n  .p2p-page-content {\n    padding: 10px 12px 20px;\n  }\n\n  .p2p-table th {\n    padding: 13px;\n    font-size: 13px;\n  }\n\n  .p2p-adv-avatar {\n    width: 28px;\n    min-width: 28px;\n    height: 28px;\n  }\n\n  .p2p-adv-info h4 {\n    font-size: 14px;\n  }\n\n  .p2p-price-cell {\n    font-size: 13px;\n  }\n\n  .p2p-limit-val {\n    font-size: 13px;\n  }\n\n  .p2p-limit-range {\n    font-size: 12px;\n  }\n\n  .p2p-section-header {\n    margin-bottom: 10px;\n  }\n\n  .p2p-payment-tag {\n    font-size: 12px;\n    padding: 4px 10px;\n    white-space: nowrap;\n  }\n\n  .p2p-action-btn {\n    padding: 7px 24px;\n  }\n\n  .p2p-table td {\n    padding: 13px;\n  }\n\n}\n\n@media (max-width: 580px) {\n\n  .p2p-hero-section {\n    flex-direction: column;\n  }\n\n  .p2p-token-tab {\n    font-size: 13px;\n    padding: 5px 7px;\n  }\n\n  .p2p-tabs-bar {\n    padding: 12px 14px;\n  }\n\n  .p2p-token-more-btn {\n    white-space: nowrap;\n    font-size: 12px;\n  }\n\n  .p2p-token-tab.active::after {\n    bottom: 0px;\n    height: 2px;\n  }\n\n  .p2p-buysell-switch {\n    width: 100%;\n    margin-top: 15px;\n  }\n\n  .p2p-buysell-switch button {\n    width: 100%;\n  }\n\n  .p2p-filter-bar {\n    padding: 18px;\n  }\n\n  .p2p-tabs-bar {\n    flex-direction: column;\n    align-items: start;\n  }\n\n  .p2p-profile-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
